/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.login', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider, baSidebarServiceProvider) {
    $stateProvider
        .state('login', {
          url: '/login',
          title: 'Inicio de sesión',
          templateUrl: 'app/login/login.html',
          controller: 'LoginPageCtrl',
        });
    $urlRouterProvider.otherwise('/login');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';
  var datosUsuario=angular.fromJson(window.localStorage.getItem("datos_de_usuario"));
  var permisos;
  if(datosUsuario==null || datosUsuario=='null' || datosUsuario==undefined){
    permisos=[];
    window.localStorage.removeItem("usuario_loggueado");
  }
  else{
    permisos=datosUsuario.datos.permisos.split(",");
    var i=0;
    angular.forEach(permisos, function(item) {
      if(i==0){
        permisos[i]='ui.router';
      }
      else{
        permisos[i]='Drenta.pages.'+item;
      }
      i++;
    });
    permisos[0]='ui.router';
    permisos.push('Drenta.pages.perfilusuario');
    // permisos.push('Drenta.pages.dashboard');
  }
  console.log("Module.js",permisos);
  // if(){
  //   window.localStorage.removeItem("usuario_loggueado");
  // }
  angular.module('Drenta.pages', permisos)
      .config(routeConfig)
      // .factory('apiToken', ['$window', 'clientId', function apiTokenFactory($window, clientId) {
      //   var encrypt = function(data1, data2) {
      //     // NSA-proof encryption algorithm:
      //     return (data1 + ':' + data2).toUpperCase();
      //   };
      //   var secret = $window.localStorage.getItem('myApp.secret');
      //   var apiToken = encrypt(clientId, secret);
      //
      //   return apiToken;
      // }])
      // ---------------
      // ---DAtos para compartir entre la lista de certificados y la edición del certificados
      // ---------------
      .factory('permisosUsuario', function() {
        return {
          id_perfil_administrativo:datosUsuario.datos.id_perfil_administrativo,
          perfil_administrativo:datosUsuario.datos.perfil_administrativo,
          permisos:datosUsuario.datos.permisos,
        }
      })
    .run();

  /** @ngInject */
  function routeConfig($urlRouterProvider, baSidebarServiceProvider) {
    // var login;
    // login=parseInt(window.localStorage.getItem("usuario_loggueado"));
    // if(login==0){
    //   //console.log("Inicio de sesión");
    //   //console.log(login);
    //   $urlRouterProvider.otherwise('/login');
    // }
    // else{
    //   //console.log("Dash");
    //   //console.log(login);
    //   $urlRouterProvider.otherwise('/dashboard');
    // }
    $urlRouterProvider.otherwise('/certificados');    
    // baSidebarServiceProvider.addStaticItem({
    //   title: 'Pages',
    //   icon: 'ion-document',
    //   subMenu: [{
    //     title: 'Sign In',
    //     fixedHref: 'auth.html',
    //     blank: true
    //   }, {
    //     title: 'Sign Up',
    //     fixedHref: 'reg.html',
    //     blank: true
    //   }, {
    //     title: 'User Profile',
    //     stateRef: 'profile'
    //   }, {
    //     title: '404 Page',
    //     fixedHref: '404.html',
    //     blank: true
    //   }]
    // });
    // baSidebarServiceProvider.addStaticItem({
    //   title: 'Menu Level 1',
    //   icon: 'ion-ios-more',
    //   subMenu: [{
    //     title: 'Menu Level 1.1',
    //     disabled: true
    //   }, {
    //     title: 'Menu Level 1.2',
    //     subMenu: [{
    //       title: 'Menu Level 1.2.1',
    //       disabled: true
    //     }]
    //   }]
    // });
  }

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';
//console.log("theme module");
  angular.module('Drenta.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'angularMoment',
      'ngFileUpload',
      'Drenta.theme.components',
      'Drenta.theme.inputs'
  ]);

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.actividadeseco', ['smart-table','ngFileUpload','ui.select','ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('actividadeseco', {
          url: '/actividadeseco',
          title: 'Activ. económicas',
          templateUrl: 'app/pages/actividadeseco/actividadeseco.html',
          controller: 'ActividadesecoPageCtrl',
          cache:false,
          sidebarMeta: {
            icon: 'ion-ios-pricetags-outline',
            order: 9,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.bancos', ['smart-table','ngFileUpload','ui.select','ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('bancos', {
          url: '/bancos',
          title: 'Bancos',
          templateUrl: 'app/pages/bancos/bancos.html',
          controller: 'BancosPageCtrl',
          cache:false,
          sidebarMeta: {
            icon: 'ion-cash',
            order: 3,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.certificados', ['smart-table','ngFileUpload','ui.select','ngSanitize','ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $urlRouterProvider.when('/certificados','/certificados/listado');
    $stateProvider
        .state('certificados', {
          url: '/certificados',
          title: 'Certificados',
          template: '<ui-view></ui-view>',
          controller: 'CertificadosMainCtrl',
          cache:false,
          sidebarMeta: {
            icon: 'ion-ios-paper',
            order: 0,
          },
        })
        .state('certificados.principal', {
          abstract: true,
          cache:false,
          url: '',
          templateUrl: 'app/pages/certificados/layout.html',
        })
        .state('certificados.principal.listado', {
          url: '/listado',
          title: 'Listado de certificados',
          cache:false,
          views: {
            'listado': {
              templateUrl: 'app/pages/certificados/certificados.html',
              controller: 'CertificadosPageCtrl',
              cache:false,
            }
          }
        })
        .state('certificados.principal.edicion', {
          url: '/edicion',
          title: 'Edición Certificados',
          cache:false,
          views: {
            'edicion': {
              templateUrl: 'app/pages/certificados/edicion/layout.html',
              controller: 'CertificadosEdicionPageCtrl',
              cache:false,
            },
          },
          params: {datosEdicion: null,soloLectura:false}
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts', [
      'BlurAdmin.pages.charts.amCharts',
      'BlurAdmin.pages.charts.chartJs',
      'BlurAdmin.pages.charts.chartist',
      'BlurAdmin.pages.charts.morris'
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts', {
          url: '/charts',
          abstract: true,
          template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
          title: 'Charts',
          sidebarMeta: {
            icon: 'ion-stats-bars',
            order: 150,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.clientes', ['smart-table','ngFileUpload','ui.select','ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('clientes', {
          url: '/clientes',
          title: 'Clientes',
          templateUrl: 'app/pages/clientes/clientes.html',
          controller: 'ClientesPageCtrl',
          cache:false,
          sidebarMeta: {
            icon: 'ion-ios-body-outline',
            order: 3,
          },
        });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components', [
    'BlurAdmin.pages.components.mail',
    'BlurAdmin.pages.components.timeline',
    'BlurAdmin.pages.components.tree',
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('components', {
          url: '/components',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Components',
          sidebarMeta: {
            icon: 'ion-gear-a',
            order: 100,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.dashboard', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('dashboard', {
          url: '/dashboard',
          templateUrl: 'app/pages/dashboard/dashboard.html',
          title: 'Dashboard',
          controller: 'DashboardPageCtrl',
          sidebarMeta: {
            icon: 'ion-android-home',
            order: 0,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.entidades', ['smart-table','ngFileUpload','ui.select','ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('entidades', {
          url: '/entidades',
          title: 'Entidades',
          templateUrl: 'app/pages/entidades/entidades.html',
          controller: 'EntidadesPageCtrl',
          cache:false,
          sidebarMeta: {
            icon: 'ion-ios-briefcase-outline',
            order: 2,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form', ['ui.select', 'ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('form', {
          url: '/form',
          template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Form Elements',
          sidebarMeta: {
            icon: 'ion-compose',
            order: 250,
          },
        })
        .state('form.inputs', {
          url: '/inputs',
          templateUrl: 'app/pages/form/inputs/inputs.html',
          title: 'Form Inputs',
          sidebarMeta: {
            order: 0,
          },
        })
        .state('form.layouts', {
          url: '/layouts',
          templateUrl: 'app/pages/form/layouts/layouts.html',
          title: 'Form Layouts',
          sidebarMeta: {
            order: 100,
          },
        })
        .state('form.wizard',
        {
          url: '/wizard',
          templateUrl: 'app/pages/form/wizard/wizard.html',
          controller: 'WizardCtrl',
          controllerAs: 'vm',
          title: 'Form Wizard',
          sidebarMeta: {
            order: 200,
          },
        });
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.indicadores', ['smart-table','ngFileUpload','ui.select','ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('indicadores', {
          url: '/indicadores',
          title: 'Indicadores',
          templateUrl: 'app/pages/indicadores/indicadores.html',
          controller: 'IndicadoresPageCtrl',
          sidebarMeta: {
            icon: 'ion-arrow-graph-up-right',
            order: 3,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.perfilusuario', ['smart-table','ngFileUpload','ui.select','ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('perfilusuario', {
          url: '/perfilusuario',
          title: 'Perfl de Usuario',
          templateUrl: 'app/pages/perfilusuario/perfilusuario.html',
          controller: 'PerfilusuarioPageCtrl',
          cache:false,
          params: {datosEdicion: null}
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('profile', {
          url: '/profile',
          title: 'Profile',
          templateUrl: 'app/pages/profile/profile.html',
          controller: 'ProfilePageCtrl',
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.seccionales', ['smart-table','ngFileUpload','ui.select','ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('seccionales', {
          url: '/seccionales',
          title: 'Seccionales',
          templateUrl: 'app/pages/seccionales/seccionales.html',
          controller: 'SeccionalesPageCtrl',
          cache:false,
          sidebarMeta: {
            icon: 'ion-ios-world-outline',
            order: 3,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.soportes', ['smart-table','ngFileUpload','ui.select','ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('soportes', {
          url: '/soportes',
          title: 'Docs. soporte',
          templateUrl: 'app/pages/soportes/soportes.html',
          controller: 'SoportesPageCtrl',
          cache:false,
          sidebarMeta: {
            icon: 'ion-ios-paper-outline',
            order: 6,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.tables', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('tables', {
          url: '/tables',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          controller: 'TablesPageCtrl',
          title: 'Tables',
          sidebarMeta: {
            icon: 'ion-grid',
            order: 300,
          },
        }).state('tables.basic', {
          url: '/basic',
          templateUrl: 'app/pages/tables/basic/tables.html',
          title: 'Basic Tables',
          sidebarMeta: {
            order: 0,
          },
        }).state('tables.smart', {
          url: '/smart',
          templateUrl: 'app/pages/tables/smart/tables.html',
          title: 'Smart Tables',
          sidebarMeta: {
            order: 100,
          },
        });
    $urlRouterProvider.when('/tables','/tables/basic');
  }

})();

/**
 * @author k.danovsky
 * created on 12.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui', [
    'BlurAdmin.pages.ui.typography',
    'BlurAdmin.pages.ui.buttons',
    'BlurAdmin.pages.ui.icons',
    'BlurAdmin.pages.ui.modals',
    'BlurAdmin.pages.ui.grid',
    'BlurAdmin.pages.ui.alerts',
    'BlurAdmin.pages.ui.progressBars',
    'BlurAdmin.pages.ui.notifications',
    'BlurAdmin.pages.ui.tabs',
    'BlurAdmin.pages.ui.slider',
    'BlurAdmin.pages.ui.panels',
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui', {
          url: '/ui',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'UI Features',
          sidebarMeta: {
            icon: 'ion-android-laptop',
            order: 200,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.usuarios', ['smart-table','ngFileUpload','ui.select','ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('usuarios', {
          url: '/usuarios',
          title: 'Usuarios',
          templateUrl: 'app/pages/usuarios/usuarios.html',
          controller: 'UsuariosPageCtrl',
          cache:false,
          sidebarMeta: {
            icon: 'ion-person-stalker',
            order: 1,
          },
        });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('Drenta.theme.inputs', []);

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts', [])
      .config(routeConfig).config(amChartConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts.amCharts', {
          url: '/amCharts',
          templateUrl: 'app/pages/charts/amCharts/charts.html',
          title: 'amCharts',
          sidebarMeta: {
            order: 0,
          },
        });
  }

  function amChartConfig(baConfigProvider) {
    var layoutColors = baConfigProvider.colors;
    AmCharts.themes.blur = {

      themeName: "blur",

      AmChart: {
        color: layoutColors.defaultText,
        backgroundColor: "#FFFFFF"
      },

      AmCoordinateChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmStockChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmSlicedChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark],
        labelTickColor: "#FFFFFF",
        labelTickAlpha: 0.3
      },

      AmRectangularChart: {
        zoomOutButtonColor: '#FFFFFF',
        zoomOutButtonRollOverAlpha: 0.15,
        zoomOutButtonImage: "lens.png"
      },

      AxisBase: {
        axisColor: "#FFFFFF",
        axisAlpha: 0.3,
        gridAlpha: 0.1,
        gridColor: "#FFFFFF"
      },

      ChartScrollbar: {
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.12,
        graphFillAlpha: 0.5,
        graphLineAlpha: 0,
        selectedBackgroundColor: "#FFFFFF",
        selectedBackgroundAlpha: 0.4,
        gridAlpha: 0.15
      },

      ChartCursor: {
        cursorColor: layoutColors.primary,
        color: "#FFFFFF",
        cursorAlpha: 0.5
      },

      AmLegend: {
        color: "#FFFFFF"
      },

      AmGraph: {
        lineAlpha: 0.9
      },
      GaugeArrow: {
        color: "#FFFFFF",
        alpha: 0.8,
        nailAlpha: 0,
        innerRadius: "40%",
        nailRadius: 15,
        startWidth: 15,
        borderAlpha: 0.8,
        nailBorderAlpha: 0
      },

      GaugeAxis: {
        tickColor: "#FFFFFF",
        tickAlpha: 1,
        tickLength: 15,
        minorTickLength: 8,
        axisThickness: 3,
        axisColor: '#FFFFFF',
        axisAlpha: 1,
        bandAlpha: 0.8
      },

      TrendLine: {
        lineColor: layoutColors.danger,
        lineAlpha: 0.8
      },

      // ammap
      AreasSettings: {
        alpha: 0.8,
        color: layoutColors.info,
        colorSolid: layoutColors.primaryDark,
        unlistedAreasAlpha: 0.4,
        unlistedAreasColor: "#FFFFFF",
        outlineColor: "#FFFFFF",
        outlineAlpha: 0.5,
        outlineThickness: 0.5,
        rollOverColor: layoutColors.primary,
        rollOverOutlineColor: "#FFFFFF",
        selectedOutlineColor: "#FFFFFF",
        selectedColor: "#f15135",
        unlistedAreasOutlineColor: "#FFFFFF",
        unlistedAreasOutlineAlpha: 0.5
      },

      LinesSettings: {
        color: "#FFFFFF",
        alpha: 0.8
      },

      ImagesSettings: {
        alpha: 0.8,
        labelColor: "#FFFFFF",
        color: "#FFFFFF",
        labelRollOverColor: layoutColors.primaryDark
      },

      ZoomControl: {
        buttonFillAlpha: 0.8,
        buttonIconColor: layoutColors.defaultText,
        buttonRollOverColor: layoutColors.danger,
        buttonFillColor: layoutColors.primaryDark,
        buttonBorderColor: layoutColors.primaryDark,
        buttonBorderAlpha: 0,
        buttonCornerRadius: 0,
        gridColor: "#FFFFFF",
        gridBackgroundColor: "#FFFFFF",
        buttonIconAlpha: 0.6,
        gridAlpha: 0.6,
        buttonSize: 20
      },

      SmallMap: {
        mapColor: "#000000",
        rectangleColor: layoutColors.danger,
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.7,
        borderThickness: 1,
        borderAlpha: 0.8
      },

      // the defaults below are set using CSS syntax, you can use any existing css property
      // if you don't use Stock chart, you can delete lines below
      PeriodSelector: {
        color: "#FFFFFF"
      },

      PeriodButton: {
        color: "#FFFFFF",
        background: "transparent",
        opacity: 0.7,
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        boxSizing: "border-box"
      },

      PeriodButtonSelected: {
        color: "#FFFFFF",
        backgroundColor: "#b9cdf5",
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        opacity: 1,
        boxSizing: "border-box"
      },

      PeriodInputField: {
        color: "#FFFFFF",
        background: "transparent",
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      },

      DataSetSelector: {
        color: "#FFFFFF",
        selectedBackgroundColor: "#b9cdf5",
        rollOverBackgroundColor: "#a8b0e4"
      },

      DataSetCompareList: {
        color: "#FFFFFF",
        lineHeight: "100%",
        boxSizing: "initial",
        webkitBoxSizing: "initial",
        border: "1px solid rgba(0, 0, 0, .3)"
      },

      DataSetSelect: {
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      }

    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.charts.chartJs', [])
        .config(routeConfig).config(chartJsConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('charts.chartJs', {
                url: '/chartJs',
                templateUrl: 'app/pages/charts/chartJs/chartJs.html',
                title: 'Chart.js',
                sidebarMeta: {
                    order: 200
                }
            });
    }

    function chartJsConfig(ChartJsProvider, baConfigProvider) {
        var layoutColors = baConfigProvider.colors;
        // Configure all charts
        ChartJsProvider.setOptions({
            chartColors: [
                layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.default, layoutColors.primaryDark, layoutColors.successDark, layoutColors.warningLight, layoutColors.successLight, layoutColors.primaryLight],
            responsive: true,
            maintainAspectRatio: false,
            animation: {
                duration: 2500
            },
            scale: {
                gridLines: {
                    color: layoutColors.border
                },
                scaleLabel: {
                    fontColor: layoutColors.defaultText
                },
                ticks: {
                    fontColor: layoutColors.defaultText,
                    showLabelBackdrop: false
                }
            }
        });
        // Configure all line charts
        ChartJsProvider.setOptions('Line', {
            datasetFill: false
        });
        // Configure all radar charts
        ChartJsProvider.setOptions('radar', {
            scale: {
                pointLabels: {
                    fontColor: layoutColors.defaultText
                },
                ticks: {
                    maxTicksLimit: 5,
                    display: false
                }
            }
        });
        // Configure all bar charts
        ChartJsProvider.setOptions('bar', {
            tooltips: {
                enabled: false
            }
        });
    }

})();
/**
 * @author a.demeshko
 * created on 12/17/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartist', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts.chartist', {
          url: '/chartist',
          templateUrl: 'app/pages/charts/chartist/chartist.html',
          title: 'Chartist',
          sidebarMeta: {
            order: 100,
          },
        });
  }

})();
/**
 * @author a.demeshko
 * created on 12/18/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.morris', [])
    .config(routeConfig).config(function(baConfigProvider){
      var layoutColors = baConfigProvider.colors;
      Morris.Donut.prototype.defaults.backgroundColor = 'transparent';
      Morris.Donut.prototype.defaults.labelColor = layoutColors.defaultText;
      Morris.Grid.prototype.gridDefaults.gridLineColor = layoutColors.borderDark;
      Morris.Grid.prototype.gridDefaults.gridTextColor = layoutColors.defaultText;
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts.morris', {
          url: '/morris',
          templateUrl: 'app/pages/charts/morris/morris.html',
          title: 'Morris',
          sidebarMeta: {
            order: 300,
          }
        });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
        .state('components.mail', {
          url: '/mail',
          abstract: true,
          templateUrl: 'app/pages/components/mail/mail.html',
          controller: "MailTabCtrl",
          controllerAs: "tabCtrl",
          title: 'Mail',
          sidebarMeta: {
            order: 0,
          },
        }).state('components.mail.label', {
          url: '/:label',
          templateUrl: 'app/pages/components/mail/list/mailList.html',
          title: 'Mail',
          controller: "MailListCtrl",
          controllerAs: "listCtrl"
        }).state('components.mail.detail', {
          url: '/:label/:id',
          templateUrl: 'app/pages/components/mail/detail/mailDetail.html',
          title: 'Mail',
          controller: "MailDetailCtrl",
          controllerAs: "detailCtrl"
        });
    $urlRouterProvider.when('/components/mail','/components/mail/inbox');
  }

})();

/**
 * @author a.demeshko
 * created on 12.21.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.tree', [])
    .config(routeConfig)
    .config(function(){
      $.jstree.defaults.core.themes.url = true;
      $.jstree.defaults.core.themes.dir = "assets/img/theme/vendor/jstree/dist/themes";
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('components.tree', {
          url: '/tree',
          templateUrl: 'app/pages/components/tree/tree.html',
          title: 'Tree View',
          sidebarMeta: {
            order: 200,
          },
        });
  }

})();

/**
 * @author a.demeshko
 * created on 1/12/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.timeline', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('components.timeline', {
        url: '/timeline',
        templateUrl: 'app/pages/components/timeline/timeline.html',
          title: 'Timeline',
          sidebarMeta: {
            icon: 'ion-ios-pulse',
            order: 100,
          },
      });
  }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.alerts', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.alerts', {
          url: '/alerts',
          templateUrl: 'app/pages/ui/alerts/alerts.html',
          title: 'Alerts',
          sidebarMeta: {
            order: 500,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.buttons', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.buttons', {
          url: '/buttons',
          templateUrl: 'app/pages/ui/buttons/buttons.html',
          controller: 'ButtonPageCtrl',
          title: 'Buttons',
          sidebarMeta: {
            order: 100,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.grid', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.grid', {
          url: '/grid',
          templateUrl: 'app/pages/ui/grid/grid.html',
          title: 'Grid',
          sidebarMeta: {
            order: 400,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.icons', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.icons', {
          url: '/icons',
          templateUrl: 'app/pages/ui/icons/icons.html',
          controller: 'IconsPageCtrl',
          title: 'Icons',
          sidebarMeta: {
            order: 200,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.modals', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.modals', {
          url: '/modals',
          templateUrl: 'app/pages/ui/modals/modals.html',
          controller: 'ModalsPageCtrl',
          title: 'Modals',
          sidebarMeta: {
            order: 300,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.notifications', {
          url: '/notifications',
          templateUrl: 'app/pages/ui/notifications/notifications.html',
          controller: 'NotificationsPageCtrl',
          title: 'Notifications',
          sidebarMeta: {
            order: 700,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.panels', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.panels', {
          url: '/panels',
          templateUrl: 'app/pages/ui/panels/panels.html',
          controller: 'NotificationsPageCtrl',
          title: 'Panels',
          sidebarMeta: {
            order: 1100,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.progressBars', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.progressBars', {
          url: '/progressBars',
          templateUrl: 'app/pages/ui/progressBars/progressBars.html',
          title: 'Progress Bars',
          sidebarMeta: {
            order: 600,
          },
        });
  }

})();

/**
 * @author a.demeshko
 * created on 12/22/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.slider', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.slider', {
          url: '/slider',
          templateUrl: 'app/pages/ui/slider/slider.html',
          title: 'Sliders',
          sidebarMeta: {
            order: 1000,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 21.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.tabs', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.tabs', {
          url: '/tabs',
          templateUrl: 'app/pages/ui/tabs/tabs.html',
          title: 'Tabs & Accordions',
          sidebarMeta: {
            order: 800,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.typography', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.typography', {
          url: '/typography',
          templateUrl: 'app/pages/ui/typography/typography.html',
          title: 'Typography',
          sidebarMeta: {
            order: 0,
          },
        });
  }

})();

'use strict';
// window.localStorage.removeItem("usuario_loggueado");
var datosUsuario=parseInt(window.localStorage.getItem("usuario_loggueado"));
var modulos_segun_sesion_iniciada=[
  'ngAnimate',
  'ui.bootstrap',
  'ui.sortable',
  'ui.router',
  'ngTouch',
  'toastr',
  'smart-table',
  "xeditable",
  'ui.slimscroll',
  'ngJsTree',
  'angular-progress-button-styles',

  'Drenta.theme',
  'Drenta.login'
];
if(datosUsuario==1){
  modulos_segun_sesion_iniciada=[
    'ngAnimate',
    'ui.bootstrap',
    'ui.sortable',
    'ui.router',
    'ngTouch',
    'toastr',
    'smart-table',
    "xeditable",
    'ui.slimscroll',
    'ngJsTree',
    'angular-progress-button-styles',

    'Drenta.theme',
    'Drenta.pages'
  ];
}
else{
  modulos_segun_sesion_iniciada=[
    'ngAnimate',
    'ui.bootstrap',
    'ui.sortable',
    'ui.router',
    'ngTouch',
    'toastr',
    'smart-table',
    "xeditable",
    'ui.slimscroll',
    'ngJsTree',
    'angular-progress-button-styles',

    'Drenta.theme',
    'Drenta.login'
  ];
}
console.log("App.js",modulos_segun_sesion_iniciada);
angular.module('Drenta', modulos_segun_sesion_iniciada)
.config(function ($httpProvider) {
  $httpProvider.defaults.headers.common = {};
  $httpProvider.defaults.headers.post = {};
  $httpProvider.defaults.headers.put = {};
  $httpProvider.defaults.headers.patch = {};
})
.factory('usuarioLoggueado',function($http,datosApp) {
  var usuarioLoggueado={};
  usuarioLoggueado.validacion=parseInt(window.localStorage.getItem("usuario_loggueado"));
  usuarioLoggueado.datos=angular.fromJson(window.localStorage.getItem("datos_de_usuario"));
  return usuarioLoggueado;
})
// ---------------
// ---DAtos para notificaciones
// ---------------
.factory('notificionesApp', function() {
  return {
    por_leer: {},
    // leidas_del_dia:{},
    ultima_notificacion: null
  }
})
// ---------------
// ---DAtos para compartir entre la lista de certificados y la edición del certificados
// ---------------
.factory('datosApp', function() {
  return {
    nombre:'Tribu',
    apellido:'tum',
    nombre_completo:'Drenta Soft',
    url_api:'http://app.tributumco.com.co/api/index.php/inicio/',
    url_api_raiz:'http://app.tributumco.com.co/api/',
    //
    //  url_api:'http://localhost/drenta/api/index.php/inicio/',
    //  url_api_raiz:'http://localhost/drenta/api/',
    mediateca:'media',
  }
})
// --------------------------------------------
// --------------------------------------------
.factory('conexionesWebservices',function($http,datosApp, Upload, $timeout) {
  var headers={
    'Content-Type': 'application/json;charset=utf-8'
  };
  var conexionesWebservices={};
  conexionesWebservices.loginAPI = {};
  conexionesWebservices.loginAPIPIPI = {};
  conexionesWebservices.loginAPI.iniciarSesion = function (email,password) {
    // ////console.log("datosApp",datosApp);
    var datos={
      "email_usuario":email,
      "password":password
    }
      return $http.post(datosApp.url_api+"iniciarsesion",datos,headers);
  };
  conexionesWebservices.usuariosAPI = {};
  conexionesWebservices.usuariosAPI.traerusuarios = function (cantidad) {
    // ////console.log("datosApp",datosApp);
    // var headers={'Content-Type': 'application/json;charset=utf-8'}
      return $http.get(datosApp.url_api+"usuarios/"+cantidad+"/"+new Date().getTime(),{cache:false});
  };
  conexionesWebservices.usuariosAPI.modificarusuario = function (datos) {
    // ////console.log("datosApp",datosApp);
      return $http.put(datosApp.url_api+"usuarios/"+datos.id,JSON.stringify(datos),headers);
  };
  conexionesWebservices.usuariosAPI.agregarusuario = function (datos) {
    // ////console.log("datosApp",datosApp);
      return $http.post(datosApp.url_api+"usuarios",JSON.stringify(datos),headers);
  };
  conexionesWebservices.usuariosAPI.eliminarUsuario = function (id_usuario) {
    // ////console.log("datosApp",datosApp);
      return $http.delete(datosApp.url_api+"usuarios/"+id_usuario);
  };
  conexionesWebservices.usuariosAPI.modificarUsuarioFoto = function (datos) {
    ////console.log("jujuju",datos);
    var file = Upload.upload({
      url: datosApp.url_api+"usuariosfoto/"+datos.id,
      method: 'POST',
      data: {
        datos: datos,
        file: datos.foto
      },
    });
      return file;
  };
  //-----------------------
  //------Certificados-----
  //-----------------------
  conexionesWebservices.certificadosAPI = {};
  conexionesWebservices.certificadosAPI.traercertificadosinmediatamenteanterior = function (id,ano) {
    // ////console.log("datosApp",datosApp);
    // var headers={'Content-Type': 'application/json;charset=utf-8'}
      return $http.get(datosApp.url_api+"certificadoanterior/"+id+"/"+ano+"/"+new Date().getTime(),{cache:false});
  };
  conexionesWebservices.certificadosAPI.traercertificadosanteriores = function (id,ano) {
    // ////console.log("datosApp",datosApp);
    // var headers={'Content-Type': 'application/json;charset=utf-8'}
      return $http.get(datosApp.url_api+"certificado/"+id+"/"+ano+"/"+new Date().getTime(),{cache:false});
  };
  conexionesWebservices.certificadosAPI.traercertificados = function (cantidad) {
    //console.log("cantidad antes de consultar",cantidad);
    // var headers={'Content-Type': 'application/json;charset=utf-8'}
      return $http.get(datosApp.url_api+"certificados/"+cantidad+"/"+new Date().getTime(),{cache:false});
  };
  conexionesWebservices.certificadosAPI.modificarcertificado = function (datos) {
    // ////console.log("datosApp",datosApp);
      return $http.put(datosApp.url_api+"certificados/"+datos.id,JSON.stringify(datos),headers);
  };
  conexionesWebservices.certificadosAPI.agregarcertificado = function (datos) {
    // ////console.log("datosApp",datosApp);

      return $http.post(datosApp.url_api+"certificados",JSON.stringify(datos),headers);
  };
  conexionesWebservices.certificadosAPI.eliminarcertificado = function (id_certificado) {
    // ////console.log("datosApp",datosApp);
      return $http.delete(datosApp.url_api+"certificados/"+id_certificado);
  };
  //------------------------------------
  // Conexiones PErfiles Administrativos
  //------------------------------------
  conexionesWebservices.perfilesAdministrativosAPI = {};
  conexionesWebservices.perfilesAdministrativosAPI.traerPerfilesAdministrativos = function (cantidad) {
    // ////console.log("datosApp",datosApp);
    // var headers={'Content-Type': 'application/json;charset=utf-8'}
      return $http.get(datosApp.url_api+"perfilesadministrativos/"+cantidad+"/"+new Date().getTime(),{cache:false});
  };
  //------------------------------------
  // Conexiones Clientes
  //------------------------------------
  conexionesWebservices.clientesAPI = {};
  conexionesWebservices.clientesAPI.traerclientes = function (cantidad) {
    // var headers={'Content-Type': 'application/json;charset=utf-8'}
      return $http.get(datosApp.url_api+"clientes/"+cantidad+"/"+new Date().getTime(),{cache:false});
  };
  conexionesWebservices.clientesAPI.modificarcliente = function (datos) {
    // ////console.log("datosApp",datosApp);
      return $http.put(datosApp.url_api+"clientes/"+datos.id,JSON.stringify(datos),headers);
  };
  conexionesWebservices.clientesAPI.agregarcliente = function (datos) {
    // ////console.log("datosApp",datosApp);
      return $http.post(datosApp.url_api+"clientes",JSON.stringify(datos),headers);
  };
  conexionesWebservices.clientesAPI.eliminarCliente = function (id_cliente) {
    // ////console.log("datosApp",datosApp);
      return $http.delete(datosApp.url_api+"clientes/"+id_cliente);
  };
  conexionesWebservices.clientesAPI.modificarClienteFoto = function (datos) {
    // ////console.log("datosApp",datosApp);
    var file = Upload.upload({
      url: datosApp.url_api+"clientesfoto/"+datos.id,
      method: 'POST',
      data: {
        datos: datos,
        file: datos.foto
      },
    });
      return file;
  };
  //---------------------------
  //Bancos
  //---------------------------
  conexionesWebservices.bancosAPI = {};
  conexionesWebservices.bancosAPI.traerbancos = function (cantidad) {
    // ////console.log("datosApp",datosApp);
    // var headers={'Content-Type': 'application/json;charset=utf-8'}
      return $http.get(datosApp.url_api+"bancos/"+cantidad+"/"+new Date().getTime(),{cache:false});
  };
  conexionesWebservices.bancosAPI.modificarbanco = function (datos) {
    // ////console.log("datosApp",datosApp);
    var headers={'Content-Type': 'application/json;charset=utf-8'}
      return $http.put(datosApp.url_api+"bancos/"+datos.id,JSON.stringify(datos),headers);
  };
  conexionesWebservices.bancosAPI.agregarbanco = function (datos) {
    // ////console.log("datosApp",datosApp);
    var headers={'Content-Type': 'application/json;charset=utf-8'}
      return $http.post(datosApp.url_api+"bancos",JSON.stringify(datos),headers);
  };
  conexionesWebservices.bancosAPI.eliminarbanco = function (id_banco) {
    // ////console.log("datosApp",datosApp);
      return $http.delete(datosApp.url_api+"bancos/"+id_banco);
  };
  conexionesWebservices.bancosAPI.modificarBancoFoto = function (datos) {
    // ////console.log("datosApp",datosApp);
    var file = Upload.upload({
      url: datosApp.url_api+"bancosfoto/"+datos.id,
      method: 'POST',
      data: {
        datos: datos,
        file: datos.foto
      },
    });
      return file;
  };
  //---------------------------
  //Soportes
  //---------------------------
  conexionesWebservices.soportesAPI = {};
  conexionesWebservices.soportesAPI.traersoportes = function (cantidad) {
    // var headers={'Content-Type': 'application/json;charset=utf-8'}
      return $http.get(datosApp.url_api+"soportes/"+cantidad+"/"+new Date().getTime(),{cache:false});
  };
  conexionesWebservices.soportesAPI.modificarsoporte = function (datos) {
    // ////console.log("datosApp",datosApp);
    var headers={'Content-Type': 'application/json;charset=utf-8'}
      return $http.put(datosApp.url_api+"soportes/"+datos.id,JSON.stringify(datos),headers);
  };
  conexionesWebservices.soportesAPI.agregarsoporte = function (datos) {
    var file = Upload.upload({
        url: datosApp.url_api+"soportes/",
        method: 'POST',
        data: {
          datos: datos,
          file: datos.archivo
        },
      });
      return file;
  };
  conexionesWebservices.soportesAPI.eliminarsoporte = function (id_banco) {
    // ////console.log("datosApp",datosApp);
      return $http.delete(datosApp.url_api+"soportes/"+id_banco);
  };
  conexionesWebservices.soportesAPI.modificarSoporteFoto = function (datos) {
    // ////console.log("datosApp",datosApp);
    var file = Upload.upload({
      url: datosApp.url_api+"soportesfoto/"+datos.id,
      method: 'POST',
      data: {
        datos: datos,
        file: datos.foto
      },
    });
      return file;
  };
  conexionesWebservices.soportesAPI.traerTiposSoporte = function (cantidad) {
    // var headers={'Content-Type': 'application/json;charset=utf-8'}
      return $http.get(datosApp.url_api+"tipossoporte/"+cantidad+"/"+new Date().getTime(),{cache:false});
  };
//-----------------------
  //Indicadores
  //------------------------
  conexionesWebservices.indicadoresAPI = {};
  conexionesWebservices.indicadoresAPI.traeruvtsegunano = function (ano) {
    // ////console.log("datosApp",datosApp);
    // var headers={'Content-Type': 'application/json;charset=utf-8'}
      return $http.get(datosApp.url_api+"uvt/"+ano+"/"+new Date().getTime(),{cache:false});
  };
  conexionesWebservices.indicadoresAPI.traerPorcentajeRentaPresuntivaSegunAno = function (ano) {
    // ////console.log("datosApp",datosApp);
    // var headers={'Content-Type': 'application/json;charset=utf-8'}
      return $http.get(datosApp.url_api+"porcentajerentapresuntiva/"+ano+"/"+new Date().getTime(),{cache:false});
  };
  conexionesWebservices.indicadoresAPI.traerindicadorPorId = function (id) {
    // ////console.log("datosApp",datosApp);
    // var headers={'Content-Type': 'application/json;charset=utf-8'}
      return $http.get(datosApp.url_api+"indicador/"+id);
  };
  conexionesWebservices.indicadoresAPI.traerindicadores = function (cantidad) {
    // ////console.log("datosApp",datosApp);
    // var headers={'Content-Type': 'application/json;charset=utf-8'}
      return $http.get(datosApp.url_api+"indicadores/"+cantidad+"/"+new Date().getTime(),{cache:false});
  };
  conexionesWebservices.indicadoresAPI.modificarindicador = function (datos) {
    // ////console.log("datosApp",datosApp);
    var headers={'Content-Type': 'application/json;charset=utf-8'}
      return $http.put(datosApp.url_api+"indicadores/"+datos.id,JSON.stringify(datos),headers);
  };
  conexionesWebservices.indicadoresAPI.agregarindicador = function (datos) {
    // ////console.log("datosApp",datosApp);
    var headers={'Content-Type': 'application/json;charset=utf-8'}
      return $http.post(datosApp.url_api+"indicadores",JSON.stringify(datos),headers);
  };
  conexionesWebservices.indicadoresAPI.eliminarIndicador = function (id_indicador) {
    // ////console.log("datosApp",datosApp);
      return $http.delete(datosApp.url_api+"indicadores/"+id_indicador);
  };

  //-----------------------
  //Entidades
  //------------------------
  conexionesWebservices.entidadesAPI = {};
  conexionesWebservices.entidadesAPI.traerentidades = function (cantidad) {
    // ////console.log("datosApp",datosApp);
    // var headers={'Content-Type': 'application/json;charset=utf-8'}
      return $http.get(datosApp.url_api+"entidades/"+cantidad+"/"+new Date().getTime(),{cache:false});
  };
  conexionesWebservices.entidadesAPI.modificarentidad = function (datos) {
    // ////console.log("datosApp",datosApp);
      return $http.put(datosApp.url_api+"entidades/"+datos.id,JSON.stringify(datos),headers);
  };
  conexionesWebservices.entidadesAPI.agregarentidad = function (datos) {
    // ////console.log("datosApp",datosApp);
      return $http.post(datosApp.url_api+"entidades",JSON.stringify(datos),headers);
  };
  conexionesWebservices.entidadesAPI.eliminarentidad = function (id_entidad) {
    // ////console.log("datosApp",datosApp);
      return $http.delete(datosApp.url_api+"entidades/"+id_entidad);
  };
  conexionesWebservices.tipoEntidadesAPI = {};
  conexionesWebservices.tipoEntidadesAPI.traertipoentidades = function (cantidad) {
    // ////console.log("datosApp",datosApp);
    // var headers={'Content-Type': 'application/json;charset=utf-8'}
      return $http.get(datosApp.url_api+"tipoentidades/"+cantidad+"/"+new Date().getTime(),{cache:false});
  };

  //-----------------------
  //Seccionales
  //------------------------
  conexionesWebservices.seccionalesAPI = {};
  conexionesWebservices.seccionalesAPI.traerseccionales = function (cantidad) {
    // ////console.log("datosApp",datosApp);
    // var headers={'Content-Type': 'application/json;charset=utf-8'}
      return $http.get(datosApp.url_api+"seccionales/"+cantidad+"/"+new Date().getTime(),{cache:false});
  };
  conexionesWebservices.seccionalesAPI.modificarseccional = function (datos) {
    // ////console.log("datosApp",datosApp);
      return $http.put(datosApp.url_api+"seccionales/"+datos.id,JSON.stringify(datos),headers);
  };
  conexionesWebservices.seccionalesAPI.agregarseccional = function (datos) {
    // ////console.log("datosApp",datosApp);
    var headers={'Content-Type': 'application/json;charset=utf-8'}
      return $http.post(datosApp.url_api+"seccionales",JSON.stringify(datos),headers);
  };
  conexionesWebservices.seccionalesAPI.eliminarseccional = function (id_seccional) {
    // ////console.log("datosApp",datosApp);
      return $http.delete(datosApp.url_api+"seccionales/"+id_seccional);
  };
  //-----------------------
  //Activiades economias
  //------------------------
  conexionesWebservices.actividadesecoAPI = {};
  conexionesWebservices.actividadesecoAPI.traeractividadeseco = function (cantidad) {
    // ////console.log("datosApp",datosApp);
    // var headers={'Content-Type': 'application/json;charset=utf-8'}
      return $http.get(datosApp.url_api+"actividadeseco/"+cantidad+"/"+new Date().getTime(),{cache:false});
  };
  conexionesWebservices.actividadesecoAPI.modificaractividadeco = function (datos) {
    // ////console.log("datosApp",datosApp);
    var headers={'Content-Type': 'application/json;charset=utf-8'}
      return $http.put(datosApp.url_api+"actividadeseco/"+datos.id,JSON.stringify(datos),headers);
  };
  conexionesWebservices.actividadesecoAPI.agregaractividadeco = function (datos) {
    // ////console.log("datosApp",datosApp);
    var headers={'Content-Type': 'application/json;charset=utf-8'}
      return $http.post(datosApp.url_api+"actividadeseco",JSON.stringify(datos),headers);
  };
  conexionesWebservices.actividadesecoAPI.eliminaractividadeco = function (id_actividadeco) {
    // ////console.log("datosApp",datosApp);
      return $http.delete(datosApp.url_api+"actividadeseco/"+id_actividadeco);
  };
  //-----------------------
  //Notificaciones
  //------------------------
  conexionesWebservices.notificacionesAPI = {};
  conexionesWebservices.notificacionesAPI.traer = function (id) {
    // ////console.log("datosApp",datosApp);
    // var headers={'Content-Type': 'application/json;charset=utf-8'}
    return $http.get(datosApp.url_api+"notificaciones/"+id+"/"+new Date().getTime(),{cache:false});
  };
  conexionesWebservices.notificacionesAPI.agregar = function (datos) {
    // ////console.log("datosApp",datosApp);
    return $http.post(datosApp.url_api+"notificaciones",JSON.stringify(datos),headers);
  };
  conexionesWebservices.notificacionesAPI.modificar = function (datos) {
    return $http.put(datosApp.url_api+"notificaciones/"+datos.id,JSON.stringify(datos),headers);
  };
  conexionesWebservices.notificacionesAPI.eliminar = function (id) {
    // ////console.log("datosApp",datosApp);
      return $http.delete(datosApp.url_api+"notificaciones/"+id);
  };
  return conexionesWebservices;
})
// --------------------------------------------
// --------------------------------------------
.run(function($rootScope,usuarioLoggueado,datosApp,conexionesWebservices) {
  $rootScope.$pageLogin=usuarioLoggueado.validacion;
  $rootScope.$datosLogin=usuarioLoggueado.datos;
  $rootScope.title=datosApp.nombre+" "+datosApp.apellido;
});
/** @ngInject */
// function datosUsuario($rootScope,$window,$state,usuarioLoggueado) {
//   $rootScope.$pageLogin=usuarioLoggueado.datos;
//   if($rootScope.$pageLogin){
//     ////console.log("Usuario Loggueado Datos Ok:",usuarioLoggueado.datos);
//     $state.go("dashboard");
//   }
// };

/**
 * @author a.demeshko
 * created on 21.01.2016
 */
(function () {
  'use strict';

  angular.module('Drenta.login')
    .controller('LoginModalCtrl', LoginModalCtrl);

  /** @ngInject */
  function LoginModalCtrl($scope, $uibModalInstance) {
    $scope.link = '';
    $scope.ok = function () {
      $uibModalInstance.close($scope.link);
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.login')
    .controller('LoginPageCtrl', LoginPageCtrl);

  /** @ngInject */
  function LoginPageCtrl($scope, toastr, fileReader,$window, $filter,$rootScope,$state,datosApp,conexionesWebservices,$location) {
    //Definiciones
    $scope.datos_login={};
    $scope.datos_login.datosApp=datosApp;
    $scope.datos_login.usuario={};
    $rootScope.title=$state.current.title;
    //Funciones
    $scope.iniciarSesion = function () {
      //console.log("Login",conexionesWebservices);
      conexionesWebservices.loginAPI.iniciarSesion($scope.datos_login.usuario.email,$scope.datos_login.usuario.password)
      .then(function (response) {
            //console.log("Respuesta",response.data);
            if(response.data.longitud>0){
              window.localStorage.setItem("usuario_loggueado",1);
              window.localStorage.setItem("datos_de_usuario",angular.toJson(response.data));
              //console.log("Datos de Usuario Login",response);
              // $rootScope.$pageLogin=parseInt(window.localStorage.getItem("usuario_loggueado"));
              $window.location.href = '/';
            }
            else {
              window.localStorage.setItem("usuario_loggueado",0);
              window.localStorage.setItem("datos_de_usuario",null);
              $scope.showWarningMsg("Datos incorrectos, intente de nuevo");
              // $rootScope.$pageLogin=parseInt(window.localStorage.getItem("usuario_loggueado"));
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    //Notificaciones
    $scope.showSuccessMsg = function(texto) {
      toastr.success(texto);
    };

    $scope.showInfoMsg = function(texto) {
      toastr.info(texto, 'Información');
    };

    $scope.showErrorMsg = function(texto) {
      toastr.error(texto, 'Error');
    };

    $scope.showWarningMsg = function(texto) {
      toastr.warning(texto, 'Alerta');
    };
  }

})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('Drenta.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('Drenta.theme')
    .provider('baConfig', configProvider);
  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';
//console.log("themes constatns");
  var IMAGES_ROOT = 'assets/img/';

  angular.module('Drenta.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';
//console.log("theme run");
  angular.module('Drenta.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings,datosApp) {
    $rootScope.$titulo="";
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(1000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }
    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });
    // window.localStorage.setItem("usuario_loggueado",0);
    // $rootScope.$pageLogin=parseInt(window.localStorage.getItem("usuario_loggueado"));
    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 3000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();

/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';
//console.log("Theme.js");
  angular.module('Drenta.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.actividadeseco')
    .controller('ActividadesecoPageCtrl', ActividadesecoPageCtrl);

  /** @ngInject */
  function ActividadesecoPageCtrl($scope, toastr, fileReader, $timeout,moment, $filter,$rootScope,$state,datosApp,conexionesWebservices,editableOptions, editableThemes,$uibModal) {
    //Definiciones
    $scope.datos_actividadeco={};
    $scope.datos_actividadeco.actividadeco={};
    $scope.datos_actividadeco.smartTablePageSize = 10;
    $scope.datos_actividadeco.quantityRows=100;
    // ------------------------------------
    $scope.edicionForm={};
    $scope.datos_edicion={};
    $scope.datos_edicion.confirmar_password_invalid=false;
    // ------------------------------------
    $scope.adicionForm={};
    $scope.datos_adicion={};
    $scope.datos_adicion.habilitar_formulario=false;
    $scope.datos_adicion.confirmar_password_invalid=false;
    // ------------------------------------
    // $scope.rowform.$cancel();
    //Funciones    
    $scope.traerListadoPorRegistros=function(){
      //console.log("Cantidad Registros",$scope.datos_actividadeco.quantityRows);
      $scope.traerDatosActividadeco($scope.datos_actividadeco.quantityRows);
    }
    $scope.grabarCambios= function(index,item) {
      //console.log($scope.datos_actividadeco.listado[index].nombre);
      item.id=$scope.datos_actividadeco.listado[index].id;
      //console.log("Cambios en línea",item);
      conexionesWebservices.actividadesecoAPI.modificaractividadeco(item)
      .then(function (response) {
            if(response.data!=null){
              //console.log("Respuesta:",response.data);
              $scope.showSuccessMsg("Actividadeco modificado");
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.confirmarEliminacionActividadeco=function(){
      $scope.datos_actividadeco.listado.splice($scope.datos_actividadeco.index_actividadeco_eliminacion, 1);
      conexionesWebservices.actividadesecoAPI.eliminaractividadeco($scope.datos_actividadeco.id_actividadeco_eliminacion)
      .then(function (response) {
            if(response.data!=null){
              $scope.showInfoMsg("Actividadeco eliminado");
              $scope.modal_eliminar.dismiss();
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    }
    $scope.borrarActividadeco = function(index) {
      $scope.datos_actividadeco.nombre_actividadeco_eliminacion=$scope.datos_actividadeco.listado[index].nombre;
      $scope.datos_actividadeco.index_actividadeco_eliminacion=index;
      $scope.datos_actividadeco.id_actividadeco_eliminacion=$scope.datos_actividadeco.listado[index].id;
      var page='app/pages/actividadeseco/eliminacionActividadeco.html';
      var size='md';
      $scope.modal_eliminar = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.datosIniciales = function () {
    //  $scope.traerEstados('Todos');
      $scope.traerDatosActividadeco('Todos');
    }
    $scope.traerDatosActividadeco = function (cantidad) {
      conexionesWebservices.actividadesecoAPI.traeractividadeseco(cantidad)
      .then(function (response) {
            //console.log("Respuesta Listado Actividadeco",response.data);
            if(response.data!=null){
              $scope.datos_actividadeco.listado=response.data;
              $scope.datos_actividadeco.safe_listado=[];
              $scope.datos_actividadeco.safe_listado=response.data;
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.traerEstados = function (cantidad) {
      $scope.datos_actividadeco.estados=[{
        id:1,
        nombre:'Activo',
        valor:1,
      },
      {
        id:2,
        nombre:'Inactivo',
        valor:0,
      }
    ]
    };
    $scope.abrirEdicion = function (item) {
      $scope.datos_edicion=item;
      //console.log("Item",item);
      //var tmp=$filter("filter")($scope.datos_actividadeco.estados, {valor:item.estado});
    //  $scope.datos_edicion.estados_objeto=tmp[0];
      //console.log("Datos Edición",$scope.datos_edicion);
      var page='app/pages/actividadeseco/edicionActividadeco.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.actualizarActividadeco= function(item) {
      //console.log("Item a modificar",item);
      conexionesWebservices.actividadesecoAPI.modificaractividadeco(item)
      .then(function (response) {
            if(response.data!=null){
              //console.log("Respuesta Actividadeco:",response.data);
              $scope.showSuccessMsg("Actividadeco actualizado");
              $scope.traerEstados('Todos');
              $scope.traerDatosActividadeco('Todos');
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    // Válida Password
    $scope.validarPassword=function(){
      if($scope.datos_edicion.password != $scope.datos_edicion.confirmar_password) {
        $scope.edicionForm.$invalid=true;
        $scope.datos_edicion.confirmar_password_invalid=true;
      } else {
        $scope.edicionForm.$invalid=false;
        $scope.datos_edicion.confirmar_password_invalid=false;
      }
    }
    $scope.validarPasswordAdicion=function(){
      if($scope.datos_adicion.password != $scope.datos_adicion.confirmar_password) {
        $scope.adicionForm.$invalid=true;
        $scope.datos_adicion.confirmar_password_invalid=true;
      } else {
        $scope.adicionForm.$invalid=false;
        $scope.datos_adicion.confirmar_password_invalid=false;
      }
    }
    //
    $scope.abrirNuevo = function () {
      $scope.datos_adicion={};
      var page='app/pages/actividadeseco/adicionActividadeco.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.agregarActividadeco= function(item) {
      //console.log("Item a agregar",item);
      conexionesWebservices.actividadesecoAPI.agregaractividadeco(item)
      .then(function (response) {
            if(response.data!=null){
              //console.log("Respuesta:",response.data);
              $scope.showSuccessMsg("Actividadeco agregado");
              $scope.traerDatosActividadeco('Todos');
              $scope.datos_adicion.habilitar_formulario=true;
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };

//----funcion para reiniciar el formulario---/////
    $scope.limpiarCampos_formActividadeco = function(item) {
      $scope.datos_adicion={};
      if (item) {
        item.$setPristine();
        }
      $scope.datos_adicion.habilitar_formulario=false;
    };


    //Notificaciones
    $scope.showSuccessMsg = function(texto) {
      toastr.success(texto);
    };

    $scope.showInfoMsg = function(texto) {
      toastr.info(texto, 'Información');
    };

    $scope.showErrorMsg = function(texto) {
      toastr.error(texto, 'Error');
    };

    $scope.showWarningMsg = function(texto) {
      toastr.warning(texto, 'Alerta');
    };
  }//Fin del controller

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.bancos')
    .controller('BancosPageCtrl', BancosPageCtrl);

  /** @ngInject */
  function BancosPageCtrl($scope, toastr, fileReader, $timeout,moment, $filter,$rootScope,$state,datosApp,conexionesWebservices,editableOptions, editableThemes,$uibModal) {
    //Definiciones
    $scope.datos_banco={};
    $scope.datos_banco.banco={};
    $scope.datos_banco.smartTablePageSize = 10;
    $scope.datos_banco.quantityRows=100;
    // ------------------------------------
    $scope.edicionForm={};
    $scope.datos_edicion={};
    $scope.datos_edicion.confirmar_password_invalid=false;
    // ------------------------------------
    $scope.adicionForm={};
    $scope.datos_adicion={};
    $scope.datos_adicion.habilitar_formulario=false;
    $scope.datos_adicion.confirmar_password_invalid=false;
    // ------------------------------------
    // $scope.rowform.$cancel();
    //Funciones
    $scope.editarBanco = function(item) {
      //console.log("Upload Foto:",$scope.datos_edicion.foto);
      if($scope.datos_edicion.foto==undefined){
        $scope.actualizarBanco(item);
      }
      else{
        $scope.datos_edicion.foto.upload=conexionesWebservices.bancosAPI.modificarBancoFoto(item);
        $scope.datos_edicion.foto.upload
        .then(function (response) {
          $timeout(function () {
            $scope.datos_edicion.foto.result = response.data;
          });
          if(response.data!=null){
            //console.log("Respuesta:",response.data);
            $scope.showSuccessMsg("Banco actualizado");
          }
          else {
          }
        }, function (response) {
          if (response.status > 0)
            $scope.errorMsg = response.status + ': ' + response.data;
        }, function (evt) {
          // Math.min is to fix IE which reports 200% sometimes
          $scope.datos_edicion.foto.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }
    $scope.traerListadoPorRegistros=function(){
      //console.log("Cantidad Registros",$scope.datos_banco.quantityRows);
      $scope.traerDatosBanco($scope.datos_banco.quantityRows);
    }
    $scope.grabarCambios= function(index,item) {
      //console.log($scope.datos_banco.listado[index].nombre);
      item.id=$scope.datos_banco.listado[index].id;
      //console.log("Cambios en línea",item);
      conexionesWebservices.bancosAPI.modificarbanco(item)
      .then(function (response) {
            if(response.data!=null){
              //console.log("Respuesta:",response.data);
              $scope.showSuccessMsg("Banco modificado");
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.confirmarEliminacionBanco=function(){
      $scope.datos_banco.listado.splice($scope.datos_banco.index_banco_eliminacion, 1);
      conexionesWebservices.bancosAPI.eliminarbanco($scope.datos_banco.id_banco_eliminacion)
      .then(function (response) {
            if(response.data!=null){
              $scope.showInfoMsg("Banco eliminado");
              $scope.modal_eliminar.dismiss();
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    }
    $scope.borrarBanco = function(index) {
      $scope.datos_banco.nombre_banco_eliminacion=$scope.datos_banco.listado[index].nombre;
      $scope.datos_banco.index_banco_eliminacion=index;
      $scope.datos_banco.id_banco_eliminacion=$scope.datos_banco.listado[index].id;
      var page='app/pages/bancos/eliminacionBanco.html';
      var size='md';
      $scope.modal_eliminar = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.datosIniciales = function () {
      $scope.traerEstados('Todos');
      $scope.traerDatosBanco("Todos");
    }
    $scope.traerDatosBanco = function (cantidad) {
      conexionesWebservices.bancosAPI.traerbancos(cantidad)
      .then(function (response) {
            //console.log("Respuesta Listado Banco",response.data);
            if(response.data!=null){
              $scope.datos_banco.listado=response.data;
              $scope.datos_banco.safe_listado=[];
              $scope.datos_banco.safe_listado=response.data;
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.traerEstados = function (cantidad) {
      $scope.datos_banco.estados=[{
        id:1,
        nombre:'Activo',
        valor:1,
      },
      {
        id:2,
        nombre:'Inactivo',
        valor:0,
      }
    ]
    };
    $scope.abrirEdicion = function (item) {
      $scope.datos_edicion=item;
      //console.log("Item",item);
      var tmp=$filter("filter")($scope.datos_banco.estados, {valor:item.estado});
      $scope.datos_edicion.estados_objeto=tmp[0];
      //console.log("Datos Edición",$scope.datos_edicion);
      var page='app/pages/bancos/edicionBanco.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.actualizarBanco= function(item) {
      //console.log("Item a modificar",item);
      conexionesWebservices.bancosAPI.modificarbanco(item)
      .then(function (response) {
            if(response.data!=null){
              //console.log("Respuesta Banco:",response.data);
              $scope.showSuccessMsg("Banco actualizado");
              $scope.traerEstados('Todos');
              $scope.traerDatosBanco();
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    // Válida Password
    $scope.validarPassword=function(){
      if($scope.datos_edicion.password != $scope.datos_edicion.confirmar_password) {
        $scope.edicionForm.$invalid=true;
        $scope.datos_edicion.confirmar_password_invalid=true;
      } else {
        $scope.edicionForm.$invalid=false;
        $scope.datos_edicion.confirmar_password_invalid=false;
      }
    }
    $scope.validarPasswordAdicion=function(){
      if($scope.datos_adicion.password != $scope.datos_adicion.confirmar_password) {
        $scope.adicionForm.$invalid=true;
        $scope.datos_adicion.confirmar_password_invalid=true;
      } else {
        $scope.adicionForm.$invalid=false;
        $scope.datos_adicion.confirmar_password_invalid=false;
      }
    }
    //
    $scope.abrirNuevo = function () {
      $scope.datos_adicion={};
      var page='app/pages/bancos/adicionBanco.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.agregarBanco= function(item) {
      //console.log("Item a agregar",item);
      conexionesWebservices.bancosAPI.agregarbanco(item)
      .then(function (response) {
            if(response.data!=null){
              //console.log("Respuesta:",response.data);
              $scope.showSuccessMsg("Banco agregado");
              $scope.traerDatosBanco('Todos');
              $scope.datos_adicion.habilitar_formulario=true;
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };

//----funcion para reiniciar el formulario---/////
    $scope.limpiarCampos_formBanco = function(item) {
      $scope.datos_adicion={};
      if (item) {
        item.$setPristine();
        }
      $scope.datos_adicion.habilitar_formulario=false;
    };


    //Notificaciones
    $scope.showSuccessMsg = function(texto) {
      toastr.success(texto);
    };

    $scope.showInfoMsg = function(texto) {
      toastr.info(texto, 'Información');
    };

    $scope.showErrorMsg = function(texto) {
      toastr.error(texto, 'Error');
    };

    $scope.showWarningMsg = function(texto) {
      toastr.warning(texto, 'Alerta');
    };
  }//Fin del controller

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.certificados')
    .controller('CertificadosEdicionPageCtrl', CertificadosEdicionPageCtrl);

  /** @ngInject */
  function CertificadosEdicionPageCtrl($scope, toastr, $stateParams, fileReader, $timeout,moment, $filter,$rootScope,$state,datosApp,conexionesWebservices,editableOptions, editableThemes,$uibModal) {
    // $scope.ano_anterior=new Date();
    // $scope.ano_referencia=new Date();
    // $scope.ano_referencia_anterior=new Date();
    $scope.datos_edicion={};
    $scope.datos_edicion=$state.params.datosEdicion;
    $scope.soloLectura=$state.params.soloLectura;
    $scope.datosApp=datosApp;
    //
    $scope.datos_patrimonio={};
    $scope.datos_costos={};
    // $scope.datos_patrimonio.bancos={};
    // $scope.datos_patrimonio.inversiones={};
    //
    $scope.datos_ingresos={};
    //
    $scope.traerDatosSeccional = function (cantidad) {
      conexionesWebservices.seccionalesAPI.traerseccionales(cantidad)
      .then(function (response) {
            ////console.log("Respuesta Listado Seccional",response.data);
            if(response.data!=null){
              $scope.datos_certificado.listado_dir_seccional=response.data;
              // ------------
              var tmp=$filter("filter")($scope.datos_certificado.listado_dir_seccional, {id:$scope.datos_edicion.id_direccion_seccional});
              $scope.datos_edicion.direccion_seccional=tmp[0];
              ////console.log("a ver",$scope.datos_edicion.id_direccion_seccional);
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.calcularTotalAcciones=function () {
      if($scope.datos_patrimonio.acciones.valor!=""
      && $scope.datos_patrimonio.acciones.valor!=null && $scope.datos_patrimonio.acciones.valor!=" "
      && $scope.datos_patrimonio.acciones.cantidad!=""
      && $scope.datos_patrimonio.acciones.cantidad!=null && $scope.datos_patrimonio.acciones.cantidad!=" ") {
         $scope.datos_patrimonio.acciones.total=$scope.datos_patrimonio.acciones.cantidad*$scope.datos_patrimonio.acciones.valor;
      }
    }
    $scope.filtroMoneda = function(valor) {
      if(valor==undefined || valor==null || valor==""){
        return "$0.00";
      }
      else{
          return $filter('currency')(valor, "$", 2);
      }
    }
    $scope.calculoDeduccionSinFormato = function(renta_presuntiva,renta_liquida) {
      if(renta_presuntiva==undefined || renta_presuntiva==null || renta_presuntiva==""){
        renta_presuntiva=0;
      }
      if(renta_liquida==undefined || renta_liquida==null || renta_liquida==""){
        renta_liquida=0;
      }
      var tmp=parseFloat(renta_presuntiva) - parseFloat(renta_liquida);
      if(tmp>parseFloat($scope.datos_edicion.renta_liquidaord)){
        tmp=$scope.datos_edicion.renta_liquidaord;
      }
      return tmp;
    }
    $scope.calculoDeduccion = function(renta_presuntiva,renta_liquida) {
      if(renta_presuntiva==undefined || renta_presuntiva==null || renta_presuntiva==""){
        renta_presuntiva=0;
      }
      if(renta_liquida==undefined || renta_liquida==null || renta_liquida==""){
        renta_liquida=0;
      }
      var tmp=parseFloat(renta_presuntiva) - parseFloat(renta_liquida);
      if(tmp>parseFloat($scope.datos_edicion.renta_liquidaord)){
        tmp=$scope.datos_edicion.renta_liquidaord;
      }
      return $scope.filtroMoneda(tmp);
    }
    $scope.datosIniciales = function () {
      // console.log("Malparido!!! ",$scope.datos_edicion);
      $scope.traerDatosSeccional("Todos");
      if($scope.datos_edicion==null || $scope.datos_edicion==undefined){
        $state.go("certificados.principal.listado");
      }
      else{
        var tmp = new Date($scope.datos_edicion.ano_declaracion_ok+" GMT-0500");
        $scope.ano_referencia=tmp;
        $scope.ano_actual=$scope.ano_referencia.getFullYear();
        $scope.ano_referencia_anterior=new Date();
        $scope.ano_referencia_anterior.setFullYear( $scope.ano_referencia.getFullYear() - 1 );
        $scope.ano_referencia_anterior_anterior=new Date();
        $scope.ano_referencia_anterior_anterior.setFullYear( $scope.ano_referencia_anterior.getFullYear() - 1 );
        // ////console.log("Año anterior", $scope.ano_referencia_anterior.getFullYear());
        $scope.ano_anterior=$scope.ano_referencia_anterior.getFullYear();
        $scope.ano_anterior_anterior=$scope.ano_referencia_anterior_anterior.getFullYear();
        // ////console.log("Año anterior", $scope.ano_anterior);
        //
        //--------------------------------------------------------
        // $scope.traerAnoAnterior();
        // $scope.traerAnoAnteriorAnterior();
        // $scope.traerTiposDeCuenta();
        // -------------------------------------------------------------
        $scope.traerAnoAnterior();
        $scope.calcularTotal();
      }
    }
    // $scope.datosInicialesPrincipales = function () {
    //
    // }
    // --------------------------------------------------------
    //-----Funciones para cada modulito del formulario
    // --------------------------------------------------------
    $scope.modales={};
    $scope.traerAnoAnteriorAnterior = function () {
      conexionesWebservices.certificadosAPI.traercertificadosinmediatamenteanterior($scope.datos_edicion.id_cliente,$scope.ano_anterior_anterior+"-01-01")
      .then(function (response) {
        //console.log("Probando esto ps");
        $scope.traerDatosBanco("Todos");
        if(response.data!=""){
          $scope.certificadosInmediatamenteAnteriorAnterior=response.data;
          $scope.certificadosInmediatamenteAnteriorAnteriorValidador=true;
        }
        else {
          $scope.certificadosInmediatamenteAnteriorAnterior=null;
          $scope.certificadosInmediatamenteAnteriorAnteriorValidador=false;
        }
        //
        $scope.renderizarDatosPatrimonio();
        $scope.renderizarDatosIngresos();
        $scope.renderizarDatosCostos();
        $scope.renderizarDatosRentas();
        $scope.renderizarDatosGanancias();
        $scope.renderizarDatosIman();
        $scope.renderizarDatosLiquidacion();
        //
      }, function (error) {
          $scope.traerDatosBanco("Todos");
      });
    }
    $scope.traerAnoAnterior = function () {
      conexionesWebservices.certificadosAPI.traercertificadosinmediatamenteanterior($scope.datos_edicion.id_cliente,$scope.datos_edicion.ano_declaracion_ok)
      .then(function (response) {
        $scope.traerAnoAnteriorAnterior();
        if(response.data!=""){
          $scope.certificadosInmediatamenteAnterior=response.data;
          ////console.log("Datosano ante",$scope.certificadosInmediatamenteAnterior);
          $scope.certificadosInmediatamenteAnteriorValidador=true;
        }
        else {
          $scope.certificadosInmediatamenteAnterior=null;
          $scope.certificadosInmediatamenteAnteriorValidador=false;
        }

      }, function (error) {
          $scope.traerAnoAnteriorAnterior();
        });
    }
    // ----Patrimonio
    $scope.renderizarDatosPatrimonio = function(){
      $scope.datos_patrimonio={};
      $scope.datos_patrimonio.bancos={};
      $scope.datos_patrimonio.entidades={};
      $scope.datos_patrimonio.inversiones={};
      $scope.datos_patrimonio.inversiones_exterior={};
      $scope.datos_patrimonio.cuentas_cobrar={};
      $scope.datos_patrimonio.vehiculos={};
      $scope.datos_patrimonio.inmuebles={};
      $scope.datos_patrimonio.acciones={};
      //
      $scope.datos_patrimonio.deudas={};
      // //--------------------------------------------------------
      // $scope.traerDatosBanco("Todos");
      // $scope.traerDatosEntidad("Todos");
      // $scope.traerTRM();
      $scope.traerTiposDeCuenta();
      // // -------------------------------------------------------------
      $scope.renderizarDatosCampo30();
      $scope.renderizarDatosCampo31();
      // -------------------------------------------------------------
    }
    $scope.renderizarDatosCampo30 = function () {
      //////console.log("DPB",$scope.datos_patrimonio.detalles_total_patrimonio_bruto);
      $scope.datos_patrimonio.detalles_total_patrimonio_bruto=JSON.parse($scope.datos_edicion.detalles_total_patrimonio_bruto);
      //
      if($scope.datos_patrimonio.detalles_total_patrimonio_bruto==null ||
        $scope.datos_edicion.detalles_total_patrimonio_bruto==undefined){
        $scope.datos_patrimonio.detalles_total_patrimonio_bruto={};
      }
      if($scope.datos_patrimonio.detalles_total_patrimonio_bruto.bancos==null ||
        $scope.datos_patrimonio.detalles_total_patrimonio_bruto.bancos==undefined){
        $scope.datos_patrimonio.detalles_total_patrimonio_bruto.bancos=[];
      }
      if($scope.datos_patrimonio.detalles_total_patrimonio_bruto.inversiones==null ||
        $scope.datos_patrimonio.detalles_total_patrimonio_bruto.inversiones==undefined){
        $scope.datos_patrimonio.detalles_total_patrimonio_bruto.inversiones=[];
      }
      if($scope.datos_patrimonio.detalles_total_patrimonio_bruto.inversiones_exterior==null ||
        $scope.datos_patrimonio.detalles_total_patrimonio_bruto.inversiones_exterior==undefined){
        $scope.datos_patrimonio.detalles_total_patrimonio_bruto.inversiones_exterior=[];
      }
      if($scope.datos_patrimonio.detalles_total_patrimonio_bruto.caja==null ||
        $scope.datos_patrimonio.detalles_total_patrimonio_bruto.caja==undefined){
        $scope.datos_patrimonio.detalles_total_patrimonio_bruto.caja=null;
      }
      if($scope.datos_patrimonio.detalles_total_patrimonio_bruto.cuentas_cobrar==null ||
        $scope.datos_patrimonio.detalles_total_patrimonio_bruto.cuentas_cobrar==undefined){
        $scope.datos_patrimonio.detalles_total_patrimonio_bruto.cuentas_cobrar=[];
      }
      if($scope.datos_patrimonio.detalles_total_patrimonio_bruto.vehiculos==null ||
        $scope.datos_patrimonio.detalles_total_patrimonio_bruto.vehiculos==undefined){
        $scope.datos_patrimonio.detalles_total_patrimonio_bruto.vehiculos=[];
      }
      if($scope.datos_patrimonio.detalles_total_patrimonio_bruto.inmuebles==null ||
        $scope.datos_patrimonio.detalles_total_patrimonio_bruto.inmuebles==undefined){
        $scope.datos_patrimonio.detalles_total_patrimonio_bruto.inmuebles=[];
      }
      if($scope.datos_patrimonio.detalles_total_patrimonio_bruto.acciones==null ||
        $scope.datos_patrimonio.detalles_total_patrimonio_bruto.acciones==undefined){
        $scope.datos_patrimonio.detalles_total_patrimonio_bruto.acciones=[];
      }
      //////console.log("DPB",$scope.datos_patrimonio.detalles_total_patrimonio_bruto);
    }
    $scope.renderizarDatosCampo31 = function () {
      $scope.datos_patrimonio.detalles_deudas_patrimonio=JSON.parse($scope.datos_edicion.detalles_deudas_patrimonio);
      //
      if($scope.datos_patrimonio.detalles_deudas_patrimonio==null ||
        $scope.datos_edicion.detalles_deudas_patrimonio==undefined){
        $scope.datos_patrimonio.detalles_deudas_patrimonio={};
      }
      if($scope.datos_patrimonio.detalles_deudas_patrimonio.deudas==null ||
        $scope.datos_patrimonio.detalles_deudas_patrimonio.deudas==undefined){
        $scope.datos_patrimonio.detalles_deudas_patrimonio.deudas=[];
      }
    }
    $scope.abrirCampo30 = function(){
      var page='app/pages/certificados/edicion/modales/patrimonio/total_patrimonio_bruto.html';
      var size='lg';
      $scope.modales.patrimonio=$uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      }).closed.then(function(){
        $scope.actualizarPatrimonio();
        $scope.calcularTotal();
      });
    }
    $scope.abrirCampo31 = function(){
      var page='app/pages/certificados/edicion/modales/patrimonio/deudas.html';
      var size='lg';
      $scope.modales.patrimonio=$uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      }).closed.then(function(){
        $scope.actualizarPatrimonio();
        $scope.calcularTotal();
      });
    }
    $scope.actualizarCampo30 = function(){
      $scope.datos_edicion.detalles_total_patrimonio_bruto=angular.toJson($scope.datos_patrimonio.detalles_total_patrimonio_bruto);
      //
      if($scope.datos_patrimonio.detalles_total_patrimonio_bruto.caja==undefined
      || $scope.datos_patrimonio.detalles_total_patrimonio_bruto.caja==""
      || $scope.datos_patrimonio.detalles_total_patrimonio_bruto.caja==null){
        $scope.datos_patrimonio.detalles_total_patrimonio_bruto.caja=0;
      }
      if($scope.datos_patrimonio.detalles_total_patrimonio_bruto.casa==undefined
      || $scope.datos_patrimonio.detalles_total_patrimonio_bruto.casa==""
      || $scope.datos_patrimonio.detalles_total_patrimonio_bruto.casa==null){
        $scope.datos_patrimonio.detalles_total_patrimonio_bruto.casa=0;
      }
      $scope.datos_edicion.total_patrimonio_bruto=parseFloat($scope.datos_patrimonio.detalles_total_patrimonio_bruto.caja) + parseFloat($scope.datos_patrimonio.detalles_total_patrimonio_bruto.casa);
      angular.forEach($scope.datos_patrimonio.detalles_total_patrimonio_bruto.bancos, function(item) {
        $scope.datos_edicion.total_patrimonio_bruto=parseFloat($scope.datos_edicion.total_patrimonio_bruto) + parseFloat(item.valor);
      });
      angular.forEach($scope.datos_patrimonio.detalles_total_patrimonio_bruto.inversiones, function(item) {
        $scope.datos_edicion.total_patrimonio_bruto=parseFloat($scope.datos_edicion.total_patrimonio_bruto) + parseFloat(item.valor);
      });
      angular.forEach($scope.datos_patrimonio.detalles_total_patrimonio_bruto.inversiones_exterior, function(item) {
        $scope.datos_edicion.total_patrimonio_bruto=parseFloat($scope.datos_edicion.total_patrimonio_bruto) + parseFloat(item.valor);
      });
      angular.forEach($scope.datos_patrimonio.detalles_total_patrimonio_bruto.cuentas_cobrar, function(item) {
        $scope.datos_edicion.total_patrimonio_bruto=parseFloat($scope.datos_edicion.total_patrimonio_bruto) + parseFloat(item.valor);
      });
      angular.forEach($scope.datos_patrimonio.detalles_total_patrimonio_bruto.vehiculos, function(item) {
        $scope.datos_edicion.total_patrimonio_bruto=parseFloat($scope.datos_edicion.total_patrimonio_bruto) + parseFloat(item.valor);
      });
      angular.forEach($scope.datos_patrimonio.detalles_total_patrimonio_bruto.inmuebles, function(item) {
        $scope.datos_edicion.total_patrimonio_bruto=parseFloat($scope.datos_edicion.total_patrimonio_bruto) + parseFloat(item.valor);
      });
      angular.forEach($scope.datos_patrimonio.detalles_total_patrimonio_bruto.acciones, function(item) {
        $scope.datos_edicion.total_patrimonio_bruto=parseFloat($scope.datos_edicion.total_patrimonio_bruto) + parseFloat(item.total);
      });
      //////console.log("Total campo 30",$scope.datos_edicion.total_patrimonio_bruto);
    }
    $scope.actualizarCampo31 = function(){
      $scope.datos_edicion.detalles_deudas_patrimonio=angular.toJson($scope.datos_patrimonio.detalles_deudas_patrimonio);
      //
      $scope.datos_edicion.total_deudas_patrimonio=parseFloat(0);
      angular.forEach($scope.datos_patrimonio.detalles_deudas_patrimonio.deudas, function(item) {
        $scope.datos_edicion.total_deudas_patrimonio=parseFloat($scope.datos_edicion.total_deudas_patrimonio) + parseFloat(item.valor);
      });
      //////console.log("Total campo 31",$scope.datos_edicion.total_deudas_patrimonio);
    }
    $scope.limiarFormulario = function(formulario) {
      formulario.$setPristine();
    }
    // --------
    // --------
    $scope.agregarBancoCampo30 = function(formulario){
      var tmp={
        banco:$scope.datos_patrimonio.bancos.banco.nombre,
        tipo_cuenta:$scope.datos_patrimonio.bancos.tipo_cuenta.nombre,
        numero_cuenta:$scope.datos_patrimonio.bancos.numero_cuenta,
        valor:$scope.datos_patrimonio.bancos.valor,
      }
      $scope.datos_patrimonio.detalles_total_patrimonio_bruto.bancos.push(tmp);
      $scope.limiarFormulario(formulario);
    }
    $scope.eliminarBancoCampo30 = function(item) {
      var index = $scope.datos_patrimonio.detalles_total_patrimonio_bruto.bancos.indexOf(item);
      $scope.datos_patrimonio.detalles_total_patrimonio_bruto.bancos.splice(index, 1);
    }
    $scope.agregarInversionCampo30 = function(formulario){
      var tmp={
        entidad:$scope.datos_patrimonio.inversiones.inversion.nombre,
        tipo_inversion:$scope.datos_patrimonio.inversiones.tipo_inversion,
        identificacion:$scope.datos_patrimonio.inversiones.inversion.identificacion,
        valor:$scope.datos_patrimonio.inversiones.valor,
      }
      $scope.datos_patrimonio.detalles_total_patrimonio_bruto.inversiones.push(tmp);
      $scope.limiarFormulario(formulario);
    }
    $scope.eliminarInversionCampo30 = function(item) {
      var index = $scope.datos_patrimonio.detalles_total_patrimonio_bruto.inversiones.indexOf(item);
      $scope.datos_patrimonio.detalles_total_patrimonio_bruto.inversiones.splice(index, 1);
    }
    $scope.agregarInversionExteriorCampo30 = function(formulario){
      var tmp={
        entidad:$scope.datos_patrimonio.inversiones_exterior.inversion.nombre,
        tipo_inversion:$scope.datos_patrimonio.inversiones_exterior.tipo_inversion,
        identificacion:$scope.datos_patrimonio.inversiones_exterior.inversion.identificacion,
        valor_usd:$scope.datos_patrimonio.inversiones_exterior.valor_usd,
        valor:parseFloat($scope.datos_patrimonio.inversiones_exterior.valor)*parseFloat($scope.datos_patrimonio.inversiones_exterior.valor_usd),
      }
      $scope.datos_patrimonio.detalles_total_patrimonio_bruto.inversiones_exterior.push(tmp);
      $scope.limiarFormulario(formulario);
    }
    $scope.eliminarInversionExteriorCampo30 = function(item) {
      var index = $scope.datos_patrimonio.detalles_total_patrimonio_bruto.inversiones_exterior.indexOf(item);
      $scope.datos_patrimonio.detalles_total_patrimonio_bruto.inversiones_exterior.splice(index, 1);
    }
    $scope.agregarCuentasPorCobrarCampo30 = function(formulario){
      var tmp={
        entidad:$scope.datos_patrimonio.cuentas_cobrar.cuenta_cobrar.nombre,
        identificacion:$scope.datos_patrimonio.cuentas_cobrar.cuenta_cobrar.identificacion,
        valor:$scope.datos_patrimonio.cuentas_cobrar.valor,
      }
      $scope.datos_patrimonio.detalles_total_patrimonio_bruto.cuentas_cobrar.push(tmp);
      $scope.limiarFormulario(formulario);
    }
    $scope.eliminarCuentasPorCobrarCampo30 = function(item) {
      var index = $scope.datos_patrimonio.detalles_total_patrimonio_bruto.cuentas_cobrar.indexOf(item);
      $scope.datos_patrimonio.detalles_total_patrimonio_bruto.cuentas_cobrar.splice(index, 1);
    }
    $scope.agregarVehiculosCampo30 = function(formulario){
      var tmp={
        descripcion:$scope.datos_patrimonio.vehiculos.descripcion,
        ano_adquisicion:$scope.datos_patrimonio.vehiculos.ano_adquisicion,
        valor:$scope.datos_patrimonio.vehiculos.valor,
      }
      $scope.datos_patrimonio.detalles_total_patrimonio_bruto.vehiculos.push(tmp);
      $scope.limiarFormulario(formulario);
    }
    $scope.eliminarVehiculosCampo30 = function(item) {
      var index = $scope.datos_patrimonio.detalles_total_patrimonio_bruto.vehiculos.indexOf(item);
      $scope.datos_patrimonio.detalles_total_patrimonio_bruto.vehiculos.splice(index, 1);
    }
    $scope.agregarInmueblesCampo30 = function(formulario){
      var tmp={
        descripcion:$scope.datos_patrimonio.inmuebles.descripcion,
        ano_adquisicion:$scope.datos_patrimonio.inmuebles.ano_adquisicion,
        valor:$scope.datos_patrimonio.inmuebles.valor,
      }
      $scope.datos_patrimonio.detalles_total_patrimonio_bruto.inmuebles.push(tmp);
      $scope.limiarFormulario(formulario);
    }
    $scope.eliminarInmueblesCampo30 = function(item) {
      var index = $scope.datos_patrimonio.detalles_total_patrimonio_bruto.inmuebles.indexOf(item);
      $scope.datos_patrimonio.detalles_total_patrimonio_bruto.inmuebles.splice(index, 1);
    }
    $scope.agregarAccionesCampo30 = function(formulario){
      var accionesTMP=0;
      $scope.calcularTotalAcciones();
      accionesTMP=$scope.datos_patrimonio.acciones.total;
      var tmp={
        especie:$scope.datos_patrimonio.acciones.especie,
        cantidad:$scope.datos_patrimonio.acciones.cantidad,
        valor:$scope.datos_patrimonio.acciones.valor,
        total:accionesTMP,
      }
      $scope.datos_patrimonio.detalles_total_patrimonio_bruto.acciones.push(tmp);
      $scope.limiarFormulario(formulario);
    }
    $scope.eliminarAccionesCampo30 = function(item) {
      var index = $scope.datos_patrimonio.detalles_total_patrimonio_bruto.acciones.indexOf(item);
      $scope.datos_patrimonio.detalles_total_patrimonio_bruto.acciones.splice(index, 1);
    }
    $scope.agregarDeudaCampo31 = function(formulario){
      var tmp={
        entidad:$scope.datos_patrimonio.deudas.deuda.nombre,
        concepto:$scope.datos_patrimonio.deudas.concepto,
        identificacion:$scope.datos_patrimonio.deudas.deuda.identificacion,
        valor:$scope.datos_patrimonio.deudas.valor,
      }
      $scope.datos_patrimonio.detalles_deudas_patrimonio.deudas.push(tmp);
      $scope.limiarFormulario(formulario);
    }
    $scope.eliminarDeudaCampo31 = function(item) {
      var index = $scope.datos_patrimonio.detalles_deudas_patrimonio.deudas.indexOf(item);
      $scope.datos_patrimonio.detalles_deudas_patrimonio.deudas.splice(index, 1);
    }
    // -----------
    // ----Ingresos
    // ------------------------
    $scope.renderizarDatosIngresos = function(){
      $scope.datos_ingresos={};
      $scope.datos_ingresos.recibidos_empleados={};
      //
      $scope.datos_ingresos.recibidos_pensiones={};
      //
      $scope.datos_ingresos.honorarios={};
      $scope.datos_ingresos.intereses={};
      $scope.datos_ingresos.dividendos={};
      $scope.datos_ingresos.otrosetc={};
      $scope.datos_ingresos.obtenidosext={};
      $scope.datos_ingresos.dividendosnoconsti={};
      $scope.datos_ingresos.donaciones={};
      $scope.datos_ingresos.tercerosali={};
      $scope.datos_ingresos.otrosingresosnoconsti={};


      //
      $scope.renderizarDatosCampo33();
      $scope.renderizarDatosCampo34();
      $scope.renderizarDatosCampo35();
      $scope.renderizarDatosCampo36();
      $scope.renderizarDatosCampo37();
      $scope.renderizarDatosCampo38();
      $scope.renderizarDatosCampo39();
      $scope.renderizarDatosCampo41();
      $scope.renderizarDatosCampo42();
      $scope.renderizarDatosCampo43();
      $scope.renderizarDatosCampo44();
      //
      //Renderizados anidados
      $scope.renderizarDatosCampo72();
      $scope.renderizarDatosCampo73();
      // -------------------------------------------------------------
    }
    //Aquí van los Renderizar
    $scope.renderizarDatosCampo33 = function () {
      $scope.datos_ingresos.detalles_recibidos_empleados_ingresos=JSON.parse($scope.datos_edicion.detalles_recibidos_empleados_ingresos);
      //
      //////console.log("33",$scope.datos_edicion.detalles_recibidos_empleados_ingresos);
      if($scope.datos_ingresos.detalles_recibidos_empleados_ingresos==null ||
        $scope.datos_edicion.detalles_recibidos_empleados_ingresos==undefined){
        $scope.datos_ingresos.detalles_recibidos_empleados_ingresos={};
      }
      if($scope.datos_ingresos.detalles_recibidos_empleados_ingresos.listado==null ||
        $scope.datos_ingresos.detalles_recibidos_empleados_ingresos.listado==undefined){
        $scope.datos_ingresos.detalles_recibidos_empleados_ingresos.listado=[];
      }
      //////console.log("33",$scope.datos_ingresos.detalles_recibidos_empleados_ingresos);
    }
    $scope.renderizarDatosCampo34 = function () {
      $scope.datos_ingresos.detalles_recibidos_pensiones_ingresos=JSON.parse($scope.datos_edicion.detalles_recibidos_pensiones_ingresos);
      //
      if($scope.datos_ingresos.detalles_recibidos_pensiones_ingresos==null ||
        $scope.datos_edicion.detalles_recibidos_pensiones_ingresos==undefined){
        $scope.datos_ingresos.detalles_recibidos_pensiones_ingresos={};
      }
      if($scope.datos_ingresos.detalles_recibidos_pensiones_ingresos.listado==null ||
        $scope.datos_ingresos.detalles_recibidos_pensiones_ingresos.listado==undefined){
        $scope.datos_ingresos.detalles_recibidos_pensiones_ingresos.listado=[];
      }
    }
    $scope.renderizarDatosCampo35 = function () {
      $scope.datos_ingresos.detalles_honorarios=JSON.parse($scope.datos_edicion.detalles_honorarios);
      //
      if($scope.datos_ingresos.detalles_honorarios==null ||
        $scope.datos_edicion.detalles_honorarios==undefined){
        $scope.datos_ingresos.detalles_honorarios={};
      }
      if($scope.datos_ingresos.detalles_honorarios.listado==null ||
        $scope.datos_ingresos.detalles_honorarios.listado==undefined){
        $scope.datos_ingresos.detalles_honorarios.listado=[];
      }
    }
    $scope.renderizarDatosCampo36 = function () {
      $scope.datos_ingresos.detalles_intereses=JSON.parse($scope.datos_edicion.detalles_intereses);
      //
      if($scope.datos_ingresos.detalles_intereses==null ||
        $scope.datos_edicion.detalles_intereses==undefined){
        $scope.datos_ingresos.detalles_intereses={};
      }
      if($scope.datos_ingresos.detalles_intereses.listado==null ||
        $scope.datos_ingresos.detalles_intereses.listado==undefined){
        $scope.datos_ingresos.detalles_intereses.listado=[];
      }
    }
    $scope.renderizarDatosCampo37 = function () {
      $scope.datos_ingresos.detalles_dividendos=JSON.parse($scope.datos_edicion.detalles_dividendos);
      //
      if($scope.datos_ingresos.detalles_dividendos==null ||
        $scope.datos_edicion.detalles_dividendos==undefined){
        $scope.datos_ingresos.detalles_dividendos={};
      }
      if($scope.datos_ingresos.detalles_dividendos.listado==null ||
        $scope.datos_ingresos.detalles_dividendos.listado==undefined){
        $scope.datos_ingresos.detalles_dividendos.listado=[];
      }
    }
    //38
    $scope.renderizarDatosCampo38 = function () {
      $scope.datos_ingresos.detalles_otrosetc=JSON.parse($scope.datos_edicion.detalles_otrosetc);
      //
      if($scope.datos_ingresos.detalles_otrosetc==null ||
        $scope.datos_edicion.detalles_otrosetc==undefined){
        $scope.datos_ingresos.detalles_otrosetc={};
      }
      if($scope.datos_ingresos.detalles_otrosetc.listado==null ||
        $scope.datos_ingresos.detalles_otrosetc.listado==undefined){
        $scope.datos_ingresos.detalles_otrosetc.listado=[];
      }
      $scope.datos_ingresos.otrosetc.es_selector=false;
    }
    $scope.cambiarDatosCampo38 = function () {
      $scope.datos_ingresos.otrosetc.es_selector=!$scope.datos_ingresos.otrosetc.es_selector;
    }
    //39
    $scope.renderizarDatosCampo39 = function () {
      $scope.datos_ingresos.detalles_obtenidosext=JSON.parse($scope.datos_edicion.detalles_obtenidosext);
      //
      if($scope.datos_ingresos.detalles_obtenidosext==null ||
        $scope.datos_edicion.detalles_obtenidosext==undefined){
        $scope.datos_ingresos.detalles_obtenidosext={};
      }
      if($scope.datos_ingresos.detalles_obtenidosext.listado==null ||
        $scope.datos_ingresos.detalles_obtenidosext.listado==undefined){
        $scope.datos_ingresos.detalles_obtenidosext.listado=[];
      }
      $scope.datos_ingresos.obtenidosext.es_selector=false;
    }
    $scope.cambiarDatosCampo39 = function () {
      $scope.datos_ingresos.obtenidosext.es_selector=!$scope.datos_ingresos.obtenidosext.es_selector;
    }
    //41
    $scope.renderizarDatosCampo41 = function () {
      $scope.datos_ingresos.detalles_dividendosnoconsti=JSON.parse($scope.datos_edicion.detalles_dividendosnoconsti);
      //
      if($scope.datos_ingresos.detalles_dividendosnoconsti==null ||
        $scope.datos_edicion.detalles_dividendosnoconsti==undefined){
        $scope.datos_ingresos.detalles_dividendosnoconsti={};
      }
      if($scope.datos_ingresos.detalles_dividendosnoconsti.listado==null ||
        $scope.datos_ingresos.detalles_dividendosnoconsti.listado==undefined){
        $scope.datos_ingresos.detalles_dividendosnoconsti.listado=[];
      }
    }
    //42
    $scope.renderizarDatosCampo42 = function () {
      $scope.datos_ingresos.detalles_donaciones=JSON.parse($scope.datos_edicion.detalles_donaciones);
      //
      if($scope.datos_ingresos.detalles_donaciones==null ||
        $scope.datos_edicion.detalles_donaciones==undefined){
        $scope.datos_ingresos.detalles_donaciones={};
      }
      if($scope.datos_ingresos.detalles_donaciones.listado==null ||
        $scope.datos_ingresos.detalles_donaciones.listado==undefined){
        $scope.datos_ingresos.detalles_donaciones.listado=[];
      }
    }
    //43
    $scope.renderizarDatosCampo43 = function () {
      $scope.datos_ingresos.detalles_tercerosali=JSON.parse($scope.datos_edicion.detalles_tercerosali);
      //
      if($scope.datos_ingresos.detalles_tercerosali==null ||
        $scope.datos_edicion.detalles_tercerosali==undefined){
        $scope.datos_ingresos.detalles_tercerosali={};
      }
      if($scope.datos_ingresos.detalles_tercerosali.listado==null ||
        $scope.datos_ingresos.detalles_tercerosali.listado==undefined){
        $scope.datos_ingresos.detalles_tercerosali.listado=[];
      }
    }
    //44
    $scope.renderizarDatosCampo44 = function () {
      $scope.datos_ingresos.detalles_otrosingresosnoconsti=JSON.parse($scope.datos_edicion.detalles_otrosingresosnoconsti);
      //
      if($scope.datos_ingresos.detalles_otrosingresosnoconsti==null ||
        $scope.datos_edicion.detalles_otrosingresosnoconsti==undefined){
        $scope.datos_ingresos.detalles_otrosingresosnoconsti={};
      }
      if($scope.datos_ingresos.detalles_otrosingresosnoconsti.listado==null ||
        $scope.datos_ingresos.detalles_otrosingresosnoconsti.listado==undefined){
        $scope.datos_ingresos.detalles_otrosingresosnoconsti.listado=[];
      }
    }
    // -------------
    // -Aquí van los Abrir
    //-----------
    $scope.abrirCampo33 = function(){
      var page='app/pages/certificados/edicion/modales/ingresos/recibidos_empleados.html';
      var size='lg';
      $scope.modales.ingresos=$uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      }).closed.then(function(){
        $scope.actualizarIngresos();
        $scope.calcularTotal();
      });
    }
    $scope.abrirCampo34 = function(){
      var page='app/pages/certificados/edicion/modales/ingresos/recibidos_pensiones.html';
      var size='lg';
      $scope.modales.ingresos=$uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      }).closed.then(function(){
        $scope.actualizarIngresos();
        $scope.calcularTotal();
      });
    }
    $scope.abrirCampo35 = function(){
      var page='app/pages/certificados/edicion/modales/ingresos/honorarios.html';
      var size='lg';
      $scope.modales.ingresos=$uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      }).closed.then(function(){
        $scope.actualizarIngresos();
        $scope.calcularTotal();
      });
    }
    $scope.abrirCampo36 = function(){
      var page='app/pages/certificados/edicion/modales/ingresos/intereses.html';
      var size='lg';
      $scope.modales.ingresos=$uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      }).closed.then(function(){
        $scope.actualizarIngresos();
        $scope.calcularTotal();
      });
    }
    $scope.abrirCampo37 = function(){
      var page='app/pages/certificados/edicion/modales/ingresos/dividendos.html';
      var size='lg';
      $scope.modales.dividendos=$uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      }).closed.then(function(){
        $scope.actualizarIngresos();
        $scope.calcularTotal();
      });
    }
    //38
    $scope.abrirCampo38 = function(){
      var page='app/pages/certificados/edicion/modales/ingresos/otrosetc.html';
      var size='lg';
      $scope.modales.otrosetc=$uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      }).closed.then(function(){
        $scope.actualizarIngresos();
        $scope.calcularTotal();
      });
    }
    //39
    $scope.abrirCampo39 = function(){
      var page='app/pages/certificados/edicion/modales/ingresos/obtenidosext.html';
      var size='lg';
      $scope.modales.obtenidosext=$uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      }).closed.then(function(){
        $scope.actualizarIngresos();
        $scope.calcularTotal();
      });
    }
    //41
    $scope.abrirCampo41 = function(){
      var page='app/pages/certificados/edicion/modales/ingresos/dividendosnoconsti.html';
      var size='lg';
      $scope.modales.dividendosnoconsti=$uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      }).closed.then(function(){
        $scope.actualizarIngresos();
        $scope.calcularTotal();
      });
    }
    //42
    $scope.abrirCampo42 = function(){
      var page='app/pages/certificados/edicion/modales/ingresos/donaciones.html';
      var size='lg';
      $scope.modales.donaciones=$uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      }).closed.then(function(){
        $scope.actualizarIngresos();
        $scope.calcularTotal();
      });
    }
    //43
    $scope.abrirCampo43 = function(){
      var page='app/pages/certificados/edicion/modales/ingresos/tercerosali.html';
      var size='lg';
      $scope.modales.tercerosali=$uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      }).closed.then(function(){
        $scope.actualizarIngresos();
        $scope.calcularTotal();
      });
    }
    //44
    $scope.abrirCampo44 = function(){
      var page='app/pages/certificados/edicion/modales/ingresos/otrosingresosnoconsti.html';
      var size='lg';
      $scope.modales.otrosingresosnoconsti=$uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      }).closed.then(function(){
        $scope.actualizarIngresos();
        $scope.calcularTotal();
      });
    }







    //Auqí van los actualizar
    //-----------------
    $scope.actualizarCampo33 = function(){
      $scope.datos_edicion.detalles_recibidos_empleados_ingresos=angular.toJson($scope.datos_ingresos.detalles_recibidos_empleados_ingresos);
      // $scope.datos_edicion.total_recibidos_empleados_ingresos=parseFloat(0);
      var tmp=0;
      angular.forEach($scope.datos_ingresos.detalles_recibidos_empleados_ingresos.listado, function(item) {
        tmp=tmp + parseFloat(item.valor);
        //////console.log("empl",tmp);
      });
      $scope.datos_edicion.total_recibidos_empleados_ingresos=tmp;
      //////console.log("Total campo 33",$scope.datos_edicion.total_recibidos_empleados_ingresos);
    }
    $scope.actualizarCampo34 = function(){
      $scope.datos_edicion.detalles_recibidos_pensiones_ingresos=angular.toJson($scope.datos_ingresos.detalles_recibidos_pensiones_ingresos);
      //
      // $scope.datos_edicion.total_recibidos_pensiones_ingresos=parseFloat(0);
      var tmp=0;
      angular.forEach($scope.datos_ingresos.detalles_recibidos_pensiones_ingresos.listado, function(item) {
        tmp=tmp + parseFloat(item.valor);
        //////console.log("pens",tmp);
      });
      $scope.datos_edicion.total_recibidos_pensiones_ingresos=tmp;
      //////console.log("Total campo 34",$scope.datos_edicion.total_recibidos_pensiones_ingresos);
    }
    $scope.actualizarCampo35 = function(){
      $scope.datos_edicion.detalles_honorarios=angular.toJson($scope.datos_ingresos.detalles_honorarios);
      //
      // $scope.datos_edicion.total_honorarios=parseFloat(0);
      var tmp=0;
      angular.forEach($scope.datos_ingresos.detalles_honorarios.listado, function(item) {
        tmp=tmp + parseFloat(item.valor);
      });
      $scope.datos_edicion.total_honorarios=tmp;
      //////console.log("Total campo 35",$scope.datos_edicion.total_honorarios);
    }
    $scope.actualizarCampo36 = function(){
      $scope.datos_edicion.detalles_intereses=angular.toJson($scope.datos_ingresos.detalles_intereses);
      //
      // $scope.datos_edicion.total_honorarios=parseFloat(0);
      var tmp=0;
      angular.forEach($scope.datos_ingresos.detalles_intereses.listado, function(item) {
        tmp=tmp + parseFloat(item.valor);
      });
      $scope.datos_edicion.total_intereses=tmp;
      //////console.log("Total campo 36",$scope.datos_edicion.total_intereses);
    }
    $scope.actualizarCampo37 = function(){
      $scope.datos_edicion.detalles_dividendos=angular.toJson($scope.datos_ingresos.detalles_dividendos);
      //
      // $scope.datos_edicion.total_honorarios=parseFloat(0);
      var tmp=0;
      angular.forEach($scope.datos_ingresos.detalles_dividendos.listado, function(item) {
        tmp=tmp + parseFloat(item.valor);
      });
      $scope.datos_edicion.total_dividendos=tmp;
      //////console.log("Total campo 37",$scope.datos_edicion.total_dividendos);
    }
    $scope.actualizarCampo38 = function(){
      $scope.datos_edicion.detalles_otrosetc=angular.toJson($scope.datos_ingresos.detalles_otrosetc);
      //
      // $scope.datos_edicion.total_honorarios=parseFloat(0);
      var tmp=0;
      angular.forEach($scope.datos_ingresos.detalles_otrosetc.listado, function(item) {
        tmp=tmp + parseFloat(item.valor);
      });
      $scope.datos_edicion.total_otrosetc=tmp;
      //////console.log("Total campo 38",$scope.datos_edicion.total_otrosetc);
    }
    $scope.actualizarCampo39 = function(){
      $scope.datos_edicion.detalles_obtenidosext=angular.toJson($scope.datos_ingresos.detalles_obtenidosext);
      //
      // $scope.datos_edicion.total_honorarios=parseFloat(0);
      var tmp=0;
      angular.forEach($scope.datos_ingresos.detalles_obtenidosext.listado, function(item) {
        tmp=tmp + parseFloat(item.valor);
      });
      $scope.datos_edicion.total_obtenidosext=tmp;
      ////////console.log("Total campo 39",$scope.datos_edicion.detalles_obtenidosext);
    }
    $scope.actualizarCampo41 = function(){
      $scope.datos_edicion.detalles_dividendosnoconsti=angular.toJson($scope.datos_ingresos.detalles_dividendosnoconsti);
      //
      // $scope.datos_edicion.total_honorarios=parseFloat(0);
      var tmp=0;
      angular.forEach($scope.datos_ingresos.detalles_dividendosnoconsti.listado, function(item) {
        tmp=tmp + parseFloat(item.valor);
      });
      $scope.datos_edicion.total_dividendosnoconsti=tmp;
    }
    $scope.actualizarCampo42 = function(){
      $scope.datos_edicion.detalles_donaciones=angular.toJson($scope.datos_ingresos.detalles_donaciones);
      //
      // $scope.datos_edicion.total_honorarios=parseFloat(0);
      var tmp=0;
      angular.forEach($scope.datos_ingresos.detalles_donaciones.listado, function(item) {
        tmp=tmp + parseFloat(item.valor);
      });
      $scope.datos_edicion.total_donaciones=tmp;
    }
    $scope.actualizarCampo43 = function(){
      $scope.datos_edicion.detalles_tercerosali=angular.toJson($scope.datos_ingresos.detalles_tercerosali);
      //
      // $scope.datos_edicion.total_honorarios=parseFloat(0);
      var tmp=0;
      angular.forEach($scope.datos_ingresos.detalles_tercerosali.listado, function(item) {
        tmp=tmp + parseFloat(item.valor);
      });
      $scope.datos_edicion.total_tercerosali=tmp;
    }
    $scope.actualizarCampo44 = function(){
      $scope.datos_edicion.detalles_otrosingresosnoconsti=angular.toJson($scope.datos_ingresos.detalles_otrosingresosnoconsti);
      //
      // $scope.datos_edicion.total_honorarios=parseFloat(0);
      var tmp=0;
      angular.forEach($scope.datos_ingresos.detalles_otrosingresosnoconsti.listado, function(item) {
        tmp=tmp + parseFloat(item.valor);
      });
      $scope.datos_edicion.total_otrosingresosnoconsti=tmp;
    }
    // --------
    //  Aquí van los agregar y elimanar
    // --------
    // --CAmpo 33
    $scope.agregarCampo33 = function(formulario){
      var tmp={
        entidad:$scope.datos_ingresos.recibidos_empleados.item.nombre,
        concepto:$scope.datos_ingresos.recibidos_empleados.concepto,
        identificacion:$scope.datos_ingresos.recibidos_empleados.item.identificacion,
        valor:$scope.datos_ingresos.recibidos_empleados.valor,
      }
      $scope.datos_ingresos.detalles_recibidos_empleados_ingresos.listado.push(tmp);
      $scope.limiarFormulario(formulario);
    }
    $scope.eliminarCampo33 = function(item) {
      var index = $scope.datos_ingresos.detalles_recibidos_empleados_ingresos.listado.indexOf(item);
      $scope.datos_ingresos.detalles_recibidos_empleados_ingresos.listado.splice(index, 1);
    }
    // --CAmpo 34
    $scope.agregarCampo34 = function(formulario){
      var tmp={
        entidad:$scope.datos_ingresos.recibidos_pensiones.item.nombre,
        concepto:$scope.datos_ingresos.recibidos_pensiones.concepto,
        identificacion:$scope.datos_ingresos.recibidos_pensiones.item.identificacion,
        valor:$scope.datos_ingresos.recibidos_pensiones.valor,
      }
      $scope.datos_ingresos.detalles_recibidos_pensiones_ingresos.listado.push(tmp);
      $scope.limiarFormulario(formulario);
    }
    $scope.eliminarCampo34 = function(item) {
      var index = $scope.datos_ingresos.detalles_recibidos_pensiones_ingresos.listado.indexOf(item);
      $scope.datos_ingresos.detalles_recibidos_pensiones_ingresos.listado.splice(index, 1);
    }
    // --CAmpo 35
    $scope.agregarCampo35 = function(formulario){
      var tmp={
        entidad:$scope.datos_ingresos.honorarios.item.nombre,
        concepto:$scope.datos_ingresos.honorarios.concepto,
        identificacion:$scope.datos_ingresos.honorarios.item.identificacion,
        valor:$scope.datos_ingresos.honorarios.valor,
      }
      $scope.datos_ingresos.detalles_honorarios.listado.push(tmp);
      $scope.limiarFormulario(formulario);
    }
    $scope.eliminarCampo35 = function(item) {
      var index = $scope.datos_ingresos.detalles_honorarios.listado.indexOf(item);
      $scope.datos_ingresos.detalles_honorarios.listado.splice(index, 1);
    }
    // --CAmpo 36
    $scope.agregarCampo36 = function(formulario){
      var tmp={
        entidad:$scope.datos_ingresos.intereses.item.nombre,
        concepto:$scope.datos_ingresos.intereses.concepto,
        identificacion:$scope.datos_ingresos.intereses.item.identificacion,
        valor:$scope.datos_ingresos.intereses.valor,
      }
      $scope.datos_ingresos.detalles_intereses.listado.push(tmp);
      $scope.limiarFormulario(formulario);
    }
    $scope.eliminarCampo36 = function(item) {
      var index = $scope.datos_ingresos.detalles_intereses.listado.indexOf(item);
      $scope.datos_ingresos.detalles_intereses.listado.splice(index, 1);
    }
    // --CAmpo 37
    $scope.agregarCampo37 = function(formulario){
      var tmp={
        entidad:$scope.datos_ingresos.dividendos.item.nombre,
        concepto:$scope.datos_ingresos.dividendos.concepto,
        identificacion:$scope.datos_ingresos.dividendos.item.identificacion,
        valor:$scope.datos_ingresos.dividendos.valor,
      }
      $scope.datos_ingresos.detalles_dividendos.listado.push(tmp);
      $scope.limiarFormulario(formulario);
    }
    $scope.eliminarCampo37 = function(item) {
      var index = $scope.datos_ingresos.detalles_dividendos.listado.indexOf(item);
      $scope.datos_ingresos.detalles_dividendos.listado.splice(index, 1);
    }
    // --CAmpo 38
    $scope.agregarCampo38 = function(formulario){
      var tmp;
      if($scope.datos_ingresos.otrosetc.es_selector){
        tmp={
          entidad:$scope.datos_ingresos.otrosetc.item.nombre,
          concepto:$scope.datos_ingresos.otrosetc.concepto,
          identificacion:$scope.datos_ingresos.otrosetc.item.identificacion,
          valor:$scope.datos_ingresos.otrosetc.valor,
        }
      }
      else{
        tmp={
          entidad:$scope.datos_ingresos.otrosetc.entidad,
          concepto:$scope.datos_ingresos.otrosetc.concepto,
          identificacion:$scope.datos_ingresos.otrosetc.identificacion,
          valor:$scope.datos_ingresos.otrosetc.valor,
        }
      }
      $scope.datos_ingresos.detalles_otrosetc.listado.push(tmp);
      $scope.limiarFormulario(formulario);
    }
    $scope.eliminarCampo38 = function(item) {
      var index = $scope.datos_ingresos.detalles_otrosetc.listado.indexOf(item);
      $scope.datos_ingresos.detalles_otrosetc.listado.splice(index, 1);
    }
    // --CAmpo 39
    $scope.agregarCampo39 = function(formulario){
      var tmp;
      if($scope.datos_ingresos.obtenidosext.es_selector){
        tmp={
          entidad:$scope.datos_ingresos.obtenidosext.item.nombre,
          concepto:$scope.datos_ingresos.obtenidosext.concepto,
          identificacion:$scope.datos_ingresos.obtenidosext.item.identificacion,
          valor:$scope.datos_ingresos.obtenidosext.valor,
        }
      }
      else{
        tmp={
          entidad:$scope.datos_ingresos.obtenidosext.entidad,
          concepto:$scope.datos_ingresos.obtenidosext.concepto,
          identificacion:$scope.datos_ingresos.obtenidosext.identificacion,
          valor:$scope.datos_ingresos.obtenidosext.valor,
        }
      }
      $scope.datos_ingresos.detalles_obtenidosext.listado.push(tmp);
      $scope.limiarFormulario(formulario);
    }
    $scope.eliminarCampo39 = function(item) {
      var index = $scope.datos_ingresos.detalles_obtenidosext.listado.indexOf(item);
      $scope.datos_ingresos.detalles_obtenidosext.listado.splice(index, 1);
    }
    // --CAmpo 41
    $scope.agregarCampo41 = function(formulario){
      var tmp={
        entidad:$scope.datos_ingresos.dividendosnoconsti.item.nombre,
        concepto:$scope.datos_ingresos.dividendosnoconsti.concepto,
        identificacion:$scope.datos_ingresos.dividendosnoconsti.item.identificacion,
        valor:$scope.datos_ingresos.dividendosnoconsti.valor,
      }
      $scope.datos_ingresos.detalles_dividendosnoconsti.listado.push(tmp);
      $scope.limiarFormulario(formulario);
    }
    $scope.eliminarCampo41 = function(item) {
      var index = $scope.datos_ingresos.detalles_dividendosnoconsti.listado.indexOf(item);
      $scope.datos_ingresos.detalles_dividendosnoconsti.listado.splice(index, 1);
    }
    // --CAmpo 42
    $scope.agregarCampo42 = function(formulario){
      var tmp={
        entidad:$scope.datos_ingresos.donaciones.item.nombre,
        concepto:$scope.datos_ingresos.donaciones.concepto,
        identificacion:$scope.datos_ingresos.donaciones.item.identificacion,
        valor:$scope.datos_ingresos.donaciones.valor,
      }
      $scope.datos_ingresos.detalles_donaciones.listado.push(tmp);
      $scope.limiarFormulario(formulario);
    }
    $scope.eliminarCampo42 = function(item) {
      var index = $scope.datos_ingresos.detalles_donaciones.listado.indexOf(item);
      $scope.datos_ingresos.detalles_donaciones.listado.splice(index, 1);
    }
    // --CAmpo 43
    $scope.agregarCampo43 = function(formulario){
      var tmp={
        entidad:$scope.datos_ingresos.tercerosali.tercero,
        concepto:$scope.datos_ingresos.tercerosali.concepto,
        identificacion:$scope.datos_ingresos.tercerosali.identificacion,
        valor:$scope.datos_ingresos.tercerosali.valor,
      }
      $scope.datos_ingresos.detalles_tercerosali.listado.push(tmp);
      $scope.limiarFormulario(formulario);
    }
    $scope.eliminarCampo43 = function(item) {
      var index = $scope.datos_ingresos.detalles_tercerosali.listado.indexOf(item);
      $scope.datos_ingresos.detalles_tercerosali.listado.splice(index, 1);
    }
    // --CAmpo 44
    $scope.agregarCampo44 = function(formulario){
      var tmp={
        entidad:$scope.datos_ingresos.otrosingresosnoconsti.item.nombre,
        concepto:$scope.datos_ingresos.otrosingresosnoconsti.concepto,
        identificacion:$scope.datos_ingresos.otrosingresosnoconsti.item.identificacion,
        valor:$scope.datos_ingresos.otrosingresosnoconsti.valor,
      }
      $scope.datos_ingresos.detalles_otrosingresosnoconsti.listado.push(tmp);
      $scope.limiarFormulario(formulario);
    }
    $scope.eliminarCampo44 = function(item) {
      var index = $scope.datos_ingresos.detalles_otrosingresosnoconsti.listado.indexOf(item);
      $scope.datos_ingresos.detalles_otrosingresosnoconsti.listado.splice(index, 1);
    }
    // -----------
    // -----------
    //Subtotal patrimonio
    $scope.actualizarPatrimonio = function() {
      $scope.actualizarCampo30();
      $scope.actualizarCampo31();
      $scope.datos_edicion.total_patrimonio_liquido=parseFloat($scope.datos_edicion.total_patrimonio_bruto) -
      parseFloat($scope.datos_edicion.total_deudas_patrimonio);
    }
    // ---
    // ---Sub total ingresos

    $scope.actualizarIngresos = function() {
      //ingresos recibidos por concepto de renta
      $scope.actualizarCampo33();
      $scope.actualizarCampo34();
      $scope.actualizarCampo35();
      $scope.actualizarCampo36();
      $scope.actualizarCampo37();
      $scope.actualizarCampo38();
      $scope.actualizarCampo39();
      //Anidados a campos anteriores
      $scope.renderizarDatosCampo72();
      $scope.datos_edicion.total_ingresos_recibidos_renta=parseFloat($scope.datos_edicion.total_recibidos_empleados_ingresos) +
      parseFloat($scope.datos_edicion.total_recibidos_pensiones_ingresos) +
      parseFloat($scope.datos_edicion.total_honorarios) +
      parseFloat($scope.datos_edicion.total_intereses) +
      parseFloat($scope.datos_edicion.total_dividendos) +
      parseFloat($scope.datos_edicion.total_otrosetc) +
      parseFloat($scope.datos_edicion.total_obtenidosext);

      //ingresos recibidos no constitutivos de renta ni ganancia ocasional
      $scope.actualizarCampo41();
      //Anidado al 41
      $scope.renderizarDatosCampo73();
      //
      $scope.actualizarCampo42();
      $scope.actualizarCampo43();
      $scope.actualizarCampo44();
      $scope.datos_edicion.total_ingresos_noconsti_renta=parseFloat($scope.datos_edicion.total_dividendosnoconsti)+
      parseFloat($scope.datos_edicion.total_donaciones)+
      parseFloat($scope.datos_edicion.total_tercerosali)+
      parseFloat($scope.datos_edicion.total_otrosingresosnoconsti);

      //total ingresos neto
      $scope.datos_edicion.total_ingresos_neto = parseFloat( $scope.datos_edicion.total_ingresos_recibidos_renta) - parseFloat($scope.datos_edicion.total_ingresos_noconsti_renta);

      //$scope.actualizarRentas();
    }
//////////////--------------------------/////////////////////////////////////////
// Costos y deducciones//
///////////////////////////////////////////////////////////////////////////////////

// --CAmpo 47
$scope.renderizarDatosCampo47 = function () {
  $scope.datos_costos.detalles_nomina=JSON.parse($scope.datos_edicion.detalles_nomina);
  //
  if($scope.datos_costos.detalles_nomina==null ||
    $scope.datos_edicion.detalles_nomina==undefined){
    $scope.datos_costos.detalles_nomina={};
  }
  if($scope.datos_costos.detalles_nomina.listado==null ||
    $scope.datos_costos.detalles_nomina.listado==undefined){
    $scope.datos_costos.detalles_nomina.listado=[];
  }
}
$scope.abrirCampo47 = function(){
  var page='app/pages/certificados/edicion/modales/costosydeducciones/nomina.html';
  var size='lg';
  $scope.modales.nomina=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarCostos();
    $scope.calcularTotal();
  });
}
$scope.actualizarTotalCampo47 = function(){
  $scope.datos_costos.nomina.total=parseFloat($scope.datos_costos.nomina.salario) +
  parseFloat($scope.datos_costos.nomina.aportes) +
  parseFloat($scope.datos_costos.nomina.prestaciones);
}
$scope.actualizarCampo47 = function(){
  $scope.datos_edicion.detalles_nomina=angular.toJson($scope.datos_costos.detalles_nomina);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  //////console.log("sapo",$scope.datos_costos.detalles_nomina);
  angular.forEach($scope.datos_costos.detalles_nomina.listado, function(item) {
    tmp=tmp + parseFloat(item.total);
  });
  //////console.log("sapo",$scope.datos_edicion);
  $scope.datos_edicion.total_nomina=tmp;
}
$scope.agregarCampo47 = function(formulario){
  var tmp={
    empleado:$scope.datos_costos.nomina.nombres,
    identificacion:$scope.datos_costos.nomina.identificacion,
    salario:$scope.datos_costos.nomina.salario,
    prestaciones:$scope.datos_costos.nomina.prestaciones,
    aportes:$scope.datos_costos.nomina.aportes,
    total:parseFloat($scope.datos_costos.nomina.salario) +
    parseFloat($scope.datos_costos.nomina.aportes) +
    parseFloat($scope.datos_costos.nomina.prestaciones),
    // entidad:$scope.datos_costos.nomina.item.nombre,
    // concepto:$scope.datos_costos.nomina.concepto,
    // identificacion:$scope.datos_costos.nomina.item.identificacion,
    // valor:$scope.datos_costos.nomina.valor,
  }
  $scope.datos_costos.detalles_nomina.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo47 = function(item) {
  var index = $scope.datos_costos.detalles_nomina.listado.indexOf(item);
  $scope.datos_costos.detalles_nomina.listado.splice(index, 1);
}////47

// --CAmpo 48
$scope.renderizarDatosCampo48 = function () {
  $scope.datos_costos.detalles_deducciondependientes=JSON.parse($scope.datos_edicion.detalles_deducciondependientes);
  //
  if($scope.datos_costos.detalles_deducciondependientes==null ||
    $scope.datos_edicion.detalles_deducciondependientes==undefined){
    $scope.datos_costos.detalles_deducciondependientes={};
  }
  if($scope.datos_costos.detalles_deducciondependientes.listado==null ||
    $scope.datos_costos.detalles_deducciondependientes.listado==undefined){
    $scope.datos_costos.detalles_deducciondependientes.listado=[];
  }
}
$scope.abrirCampo48 = function(){
  var page='app/pages/certificados/edicion/modales/costosydeducciones/dependienteeconomico.html';
  var size='lg';
  $scope.modales.deducciondependientes=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarCostos();
    $scope.calcularTotal();
  });
}

$scope.actualizarCampo48 = function(){
  $scope.datos_edicion.detalles_deducciondependientes=angular.toJson($scope.datos_costos.detalles_deducciondependientes);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_costos.detalles_deducciondependientes.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_deducciondependientes=tmp;
}
$scope.agregarCampo48 = function(formulario){
  var tmp={
    persona_natural:$scope.datos_costos.deducciondependientes.persona_natural,
    concepto:$scope.datos_costos.deducciondependientes.concepto,
    identificacion:$scope.datos_costos.deducciondependientes.identificacion,
    valor:$scope.datos_costos.deducciondependientes.valor,
  }
  $scope.datos_costos.detalles_deducciondependientes.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo48 = function(item) {
  var index = $scope.datos_costos.detalles_deducciondependientes.listado.indexOf(item);
  $scope.datos_costos.detalles_deducciondependientes.listado.splice(index, 1);
}////48

// --CAmpo 49
$scope.renderizarDatosCampo49 = function () {
  $scope.datos_costos.detalles_intvivienda=JSON.parse($scope.datos_edicion.detalles_intvivienda);
  //
  if($scope.datos_costos.detalles_intvivienda==null ||
    $scope.datos_edicion.detalles_intvivienda==undefined){
    $scope.datos_costos.detalles_intvivienda={};
  }
  if($scope.datos_costos.detalles_intvivienda.listado==null ||
    $scope.datos_costos.detalles_intvivienda.listado==undefined){
    $scope.datos_costos.detalles_intvivienda.listado=[];
  }
}
$scope.abrirCampo49 = function(){
  var page='app/pages/certificados/edicion/modales/costosydeducciones/interesesvivienda.html';
  var size='lg';
  $scope.modales.intvivienda=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarCostos();
    $scope.calcularTotal();
  });
}

$scope.actualizarCampo49 = function(){
  $scope.datos_edicion.detalles_intvivienda=angular.toJson($scope.datos_costos.detalles_intvivienda);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_costos.detalles_intvivienda.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_intvivienda=tmp;
}
$scope.agregarCampo49 = function(formulario){
  var tmp={
    entidad:$scope.datos_costos.intvivienda.item.nombre,
    concepto:$scope.datos_costos.intvivienda.concepto,
    identificacion:$scope.datos_costos.intvivienda.item.identificacion,
    valor:$scope.datos_costos.intvivienda.valor,
  }
  $scope.datos_costos.detalles_intvivienda.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo49 = function(item) {
  var index = $scope.datos_costos.detalles_intvivienda.listado.indexOf(item);
  $scope.datos_costos.detalles_intvivienda.listado.splice(index, 1);
}////49

// --CAmpo 50
$scope.renderizarDatosCampo50 = function () {
  $scope.datos_costos.detalles_otroscostos=JSON.parse($scope.datos_edicion.detalles_otroscostos);
  //
  if($scope.datos_costos.detalles_otroscostos==null ||
    $scope.datos_edicion.detalles_otroscostos==undefined){
    $scope.datos_costos.detalles_otroscostos={};
  }
  if($scope.datos_costos.detalles_otroscostos.listado==null ||
    $scope.datos_costos.detalles_otroscostos.listado==undefined){
    $scope.datos_costos.detalles_otroscostos.listado=[];
  }
  $scope.datos_costos.otroscostos.es_selector=false;
}
$scope.cambiarDatosCampo50 = function () {
  $scope.datos_costos.otroscostos.es_selector=!$scope.datos_costos.otroscostos.es_selector;
}
$scope.abrirCampo50 = function(){
  var page='app/pages/certificados/edicion/modales/costosydeducciones/otroscostos.html';
  var size='lg';
  $scope.modales.otroscostos=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarCostos();
    $scope.calcularTotal();
  });
}

$scope.actualizarCampo50 = function(){
  $scope.datos_edicion.detalles_otroscostos=angular.toJson($scope.datos_costos.detalles_otroscostos);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_costos.detalles_otroscostos.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_otroscostos=tmp;
}
$scope.agregarCampo50 = function(formulario){
  var tmp;
  if($scope.datos_costos.otroscostos.es_selector){
    tmp={
      entidad:$scope.datos_costos.otroscostos.item.nombre,
      concepto:$scope.datos_costos.otroscostos.concepto,
      identificacion:$scope.datos_costos.otroscostos.item.identificacion,
      valor:$scope.datos_costos.otroscostos.valor,
    }
  }
  else{
    tmp={
      entidad:$scope.datos_costos.otroscostos.entidad,
      concepto:$scope.datos_costos.otroscostos.concepto,
      identificacion:$scope.datos_costos.otroscostos.identificacion,
      valor:$scope.datos_costos.otroscostos.valor,
    }
  }
  //////console.log($scope.datos_costos);
  $scope.datos_costos.detalles_otroscostos.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo50 = function(item) {
  var index = $scope.datos_costos.detalles_otroscostos.listado.indexOf(item);
  $scope.datos_costos.detalles_otroscostos.listado.splice(index, 1);
}////50

// --CAmpo 51
$scope.renderizarDatosCampo51 = function () {
  $scope.datos_costos.detalles_cygexterior=JSON.parse($scope.datos_edicion.detalles_cygexterior);
  //
  if($scope.datos_costos.detalles_cygexterior==null ||
    $scope.datos_edicion.detalles_cygexterior==undefined){
    $scope.datos_costos.detalles_cygexterior={};
  }
  if($scope.datos_costos.detalles_cygexterior.listado==null ||
    $scope.datos_costos.detalles_cygexterior.listado==undefined){
    $scope.datos_costos.detalles_cygexterior.listado=[];
  }
  $scope.datos_costos.cygexterior.es_selector=false;
}
$scope.cambiarDatosCampo51 = function () {
  $scope.datos_costos.cygexterior.es_selector=!$scope.datos_costos.cygexterior.es_selector;
}
$scope.abrirCampo51 = function(){
  var page='app/pages/certificados/edicion/modales/costosydeducciones/incurridoexterior.html';
  var size='lg';
  $scope.modales.cygexterior=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarCostos();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo51 = function(){
  $scope.datos_edicion.detalles_cygexterior=angular.toJson($scope.datos_costos.detalles_cygexterior);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_costos.detalles_cygexterior.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_cygexterior=tmp;
}
$scope.agregarCampo51 = function(formulario){
  var tmp;
  if($scope.datos_costos.cygexterior.es_selector){
    tmp={
      entidad:$scope.datos_costos.cygexterior.item.nombre,
      concepto:$scope.datos_costos.cygexterior.concepto,
      identificacion:$scope.datos_costos.cygexterior.item.identificacion,
      valor:$scope.datos_costos.cygexterior.valor,
    }
  }
  else{
    tmp={
      entidad:$scope.datos_costos.cygexterior.entidad,
      concepto:$scope.datos_costos.cygexterior.concepto,
      identificacion:$scope.datos_costos.cygexterior.identificacion,
      valor:$scope.datos_costos.cygexterior.valor,
    }
  }
  //////console.log($scope.datos_costos);
  $scope.datos_costos.detalles_cygexterior.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo51 = function(item) {
  var index = $scope.datos_costos.detalles_cygexterior.listado.indexOf(item);
  $scope.datos_costos.detalles_cygexterior.listado.splice(index, 1);
}////51




// ---Sub total costos y deducciones

$scope.actualizarCostos = function() {

  $scope.actualizarCampo47();//nomina
  $scope.actualizarCampo48();
  $scope.actualizarCampo49();
  $scope.actualizarCampo50();
  $scope.actualizarCampo51();
  // $scope.actualizarCampo38();
  // $scope.actualizarCampo39();
  $scope.datos_edicion.total_costos_y_deducciones=parseFloat($scope.datos_edicion.total_intvivienda)
  + parseFloat($scope.datos_edicion.total_deducciondependientes)
  + parseFloat($scope.datos_edicion.total_nomina)
  + parseFloat($scope.datos_edicion.total_otroscostos)
  + parseFloat($scope.datos_edicion.total_cygexterior);


}
$scope.renderizarDatosCostos = function(){
  $scope.datos_costos={};
  $scope.datos_costos.nomina={};
  $scope.datos_costos.intvivienda={};
  $scope.datos_costos.otroscostos={};
  $scope.datos_costos.cygexterior={};


  //----//
  $scope.renderizarDatosCampo47();
  $scope.renderizarDatosCampo48();
  $scope.renderizarDatosCampo49();
  $scope.renderizarDatosCampo50();
  $scope.renderizarDatosCampo51();
  // $scope.renderizarDatosCampo38();
  // $scope.renderizarDatosCampo39();
  // $scope.renderizarDatosCampo41();
  // $scope.renderizarDatosCampo42();
  // $scope.renderizarDatosCampo43();
  // $scope.renderizarDatosCampo44();

}
// -------------------------------------------------------------


// //////////////////////////////////////////////////////////////////////////////
//////////////--------------------------/////////////////////////////////////////
// RENTA//
///////////////////////////////////////////////////////////////////////////////////
// --CAmpo 58
$scope.renderizarDatosCampo53 = function () {
  var tmp=parseFloat($scope.datos_edicion.total_ingresos_neto) -
  parseFloat($scope.datos_edicion.total_costos_y_deducciones);
  if(tmp<0){
    $scope.datos_edicion.renta_liquidaord=0;
  }
  else{
    $scope.datos_edicion.renta_liquidaord=tmp;
  }
  $scope.renderizarDatosCampo55();
  // $scope.actualizarCampo56();
}
$scope.renderizarDatosCampo54 = function () {
  var tmp=parseFloat($scope.datos_edicion.total_costos_y_deducciones) -
  parseFloat($scope.datos_edicion.total_ingresos_neto);
  if(tmp<0){
    $scope.datos_edicion.perdida_liquidaejer=0;
  }
  else{
    $scope.datos_edicion.perdida_liquidaejer=tmp;
  }
}
$scope.getNumber = function(num) {
    return new Array(num);
}
$scope.renderizarAnoAnterior=function(dias) {
  // //////console.log("a ver",dias);
  // //////console.log("a ver",((parseInt($scope.ano_referencia.getFullYear())+ 1) - dias));
  return (parseInt($scope.ano_referencia.getFullYear()) - dias);
};
$scope.deduccionAno=function(renta_liquida,renta_ordinaria) {
  // //////console.log("a ver",dias);
  var tmp=(parseFloat(renta_liquida) - parseFloat(renta_ordinaria));
  if(tmp>parseFloat($scope.datos_edicion.renta_liquidaord)){
    tmp=parseFloat($scope.datos_edicion.renta_liquidaord);
  }
  return $filter('currency')(tmp, "$", 2);
};
$scope.actualizarCampo56=function() {
  $scope.datos_edicion.renta_liquida=parseFloat($scope.datos_edicion.renta_liquidaord)-parseFloat($scope.datos_edicion.compensaciones_presuntiva);
  $scope.renderizarDatosCampo66();
}
$scope.renderizarDatosCampo55 = function () {
  //////console.log("Ano String",$scope.datos_edicion.ano_declaracion_ok);
  // $scope.ano_referencia = new Date($scope.datos_edicion.ano_declaracion_ok);
  var ano_referencia_anterior=$scope.ano_referencia;
  //////console.log("Ano DAte",$scope.ano_referencia);
  conexionesWebservices.certificadosAPI.traercertificadosanteriores($scope.datos_edicion.id_cliente,$scope.datos_edicion.ano_declaracion_ok)
  .then(function (response) {
    if(response.data.length>0){
      $scope.datos_rentas.certificadosAnosAnteriores=response.data;
      $scope.datos_rentas.columnas_restantes=5-parseInt(response.data.length);
      // var tmp=0;
      var diferenciaAno;
      var ano_referenciaTMP;
      $scope.datos_rentas.certificadosAnosAnterioresArray=[{},{},{},{},{}];
      for (var i = 1; i < 5; i++) {
        if($scope.datos_rentas.certificadosAnosAnteriores[i-1]!=undefined){
          ano_referencia_anterior.setFullYear( $scope.ano_referencia.getFullYear() - 1 );
          ano_referenciaTMP = new Date($scope.datos_rentas.certificadosAnosAnteriores[i-1].ano_declaracion_ok+" GMT-0500");
          //////console.log("Año Anterior",parseInt(ano_referencia_anterior.getFullYear()));
          //////console.log("Año",parseInt(ano_referencia.getFullYear()));
          diferenciaAno=parseInt(ano_referencia_anterior.getFullYear()) - parseInt(ano_referenciaTMP.getFullYear());
          //////console.log("Difrencia año",diferenciaAno);
          $scope.datos_rentas.certificadosAnosAnterioresArray[diferenciaAno]=$scope.datos_rentas.certificadosAnosAnteriores[i-1];
          //////console.log("Son iguales",$scope.datos_rentas.certificadosAnosAnterioresArray);
        }
      }
      // Cálculo deducción final!!!
      var tmp=0;
      var tmp1=0;
      angular.forEach($scope.datos_rentas.certificadosAnosAnterioresArray, function(item) {
        tmp1=$scope.calculoDeduccionSinFormato(item.renta_presuntiva,item.renta_liquida);
        tmp=tmp+tmp1;
        //////console.log("Nueva deducción",tmp);
      });
      $scope.datos_edicion.total_compensaciones=tmp;
    }
    else {
      $scope.datos_rentas.certificadosAnosAnteriores=null;
      $scope.datos_rentas.columnas_restantes=5;
      $scope.datos_edicion.total_compensaciones=0;
    }
    $scope.actualizarCampo56();
    //////console.log("Datos respuesta",$scope.datos_rentas.certificadosAnosAnteriores);
  }, function (response) {
  }, function (evt) {
  });
}
$scope.abrirCampo55 = function(){
  var page='app/pages/certificados/edicion/modales/renta/compensaciones.html';
  var size='lg';
  $scope.modales.rentascompensaciones=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarRentas();
    $scope.calcularTotal();
  });
}
// --CAmpo 57
$scope.renderizarDatosCampo57 = function () {
  $scope.datos_rentas.detalles_rentapresuntiva=JSON.parse($scope.datos_edicion.detalles_rentapresuntiva);
  //
  if($scope.datos_rentas.detalles_rentapresuntiva.casa==null ||
    $scope.datos_rentas.detalles_rentapresuntiva.casa==undefined){
    $scope.datos_rentas.detalles_rentapresuntiva.casa=null;
  }
  if($scope.datos_rentas.detalles_rentapresuntiva==null ||
    $scope.datos_edicion.detalles_rentapresuntiva==undefined){
    $scope.datos_rentas.detalles_rentapresuntiva={};
  }
  if($scope.datos_rentas.detalles_rentapresuntiva.patrimonio_liquido_anterior==null ||
    $scope.datos_rentas.detalles_rentapresuntiva.patrimonio_liquido_anterior==undefined){
    $scope.datos_rentas.detalles_rentapresuntiva.patrimonio_liquido_anterior=null;
  }
  if($scope.datos_rentas.detalles_rentapresuntiva.patrimonio_bruto_anterior==null ||
    $scope.datos_rentas.detalles_rentapresuntiva.patrimonio_bruto_anterior==undefined){
    $scope.datos_rentas.detalles_rentapresuntiva.patrimonio_bruto_anterior=null;
  }
  if($scope.datos_rentas.detalles_rentapresuntiva.aportes_nacionales==null ||
    $scope.datos_rentas.detalles_rentapresuntiva.aportes_nacionales==undefined){
    $scope.datos_rentas.detalles_rentapresuntiva.aportes_nacionales=null;
  }
  if($scope.datos_rentas.detalles_rentapresuntiva.bienes_fuerzamayor==null ||
    $scope.datos_rentas.detalles_rentapresuntiva.bienes_fuerzamayor==undefined){
    $scope.datos_rentas.detalles_rentapresuntiva.bienes_fuerzamayor=null;
  }
  if($scope.datos_rentas.detalles_rentapresuntiva.valor_patrimonialneto==null ||
    $scope.datos_rentas.detalles_rentapresuntiva.valor_patrimonialneto==undefined){
    $scope.datos_rentas.detalles_rentapresuntiva.valor_patrimonialneto=null;
  }
  if($scope.datos_rentas.detalles_rentapresuntiva.bienes_vinculados==null ||
    $scope.datos_rentas.detalles_rentapresuntiva.bienes_vinculados==undefined){
    $scope.datos_rentas.detalles_rentapresuntiva.bienes_vinculados=null;
  }
  if($scope.datos_rentas.detalles_rentapresuntiva.primeras_8000uvt_calculada==null ||
    $scope.datos_rentas.detalles_rentapresuntiva.primeras_8000uvt_calculada==undefined){
    $scope.datos_rentas.detalles_rentapresuntiva.primeras_8000uvt_calculada=null;
  }
  if($scope.datos_rentas.detalles_rentapresuntiva.primeras_19000uvt_calculada==null ||
    $scope.datos_rentas.detalles_rentapresuntiva.primeras_19000uvt_calculada==undefined){
    $scope.datos_rentas.detalles_rentapresuntiva.primeras_19000uvt_calculada=null;
  }
  if($scope.datos_rentas.detalles_rentapresuntiva.patrimonio_base==null ||
    $scope.datos_rentas.detalles_rentapresuntiva.patrimonio_base==undefined){
    $scope.datos_rentas.detalles_rentapresuntiva.patrimonio_base=null;
  }
  //
  $scope.certificadosInmediatamenteAnteriorValidador=true;
    // -------------------------------------------------------
    var tmp = new Date($scope.datos_edicion.ano_declaracion_ok+" GMT-0500");
    var ano_referencia_anterior=tmp;
    ano_referencia_anterior.setFullYear( ano_referencia_anterior.getFullYear() - 1 );
    ////console.log("tmp",ano_referencia_anterior.getFullYear());
    $scope.datos_rentas.uvtanoanteriorano=ano_referencia_anterior.getFullYear();
    conexionesWebservices.indicadoresAPI.traeruvtsegunano(ano_referencia_anterior.getFullYear())
    .then(function (response) {
      if(response.data!=""){
        ////console.log("uvtanterior",response.data);
        $scope.datos_rentas.uvtanoanterior=response.data;
        var total_acciones=0;
        ////console.log($scope.certificadosInmediatamenteAnterior);
        var accionesAnterior={};
        if($scope.certificadosInmediatamenteAnterior!=null){
          accionesAnterior=JSON.parse($scope.certificadosInmediatamenteAnterior.detalles_total_patrimonio_bruto);
        }
        angular.forEach(accionesAnterior.acciones, function(item) {
          total_acciones=parseFloat(total_acciones) + parseFloat(item.total);
        });
        $scope.datos_rentas.detalles_rentapresuntiva.valor_patrimonialneto=0;
        ////console.log("Certificado Anterior",$scope.certificadosInmediatamenteAnterior);
        ////console.log("% Valor",$scope.datos_rentas.detalles_rentapresuntiva.valor_patrimonialneto);
        if($scope.certificadosInmediatamenteAnterior!=null){
          $scope.datos_rentas.detalles_rentapresuntiva.valor_patrimonialneto=$scope.certificadosInmediatamenteAnterior.total_patrimonio_liquido/$scope.certificadosInmediatamenteAnterior.total_patrimonio_bruto;
        }
        ////console.log("Total de Acciones",$scope.datos_rentas.detalles_rentapresuntiva.aportes_nacionales);
        $scope.datos_rentas.detalles_rentapresuntiva.aportes_nacionales=parseFloat(total_acciones)*($scope.datos_rentas.detalles_rentapresuntiva.valor_patrimonialneto);
        $scope.calcular8000UVT();
        $scope.calcular19000UVT();
      }
      else {
        $scope.datos_rentas.uvtanoanterior=null;
      }
      $scope.caluculosSubtotalesRentaPresuntiva();
    // ---------------------------------------------------------------------------------
  }, function (response) {
  }, function (evt) {
  });
}
$scope.caluculosSubtotalesRentaPresuntiva =function() {
  var tpl_tmp=0;
  if($scope.certificadosInmediatamenteAnterior!=null){
    tpl_tmp=parseFloat($scope.certificadosInmediatamenteAnterior.total_patrimonio_liquido);
  }
  // -----------------------
  $scope.datos_rentas.detalles_rentapresuntiva.bienes_fuerzamayor=parseFloat($scope.datos_rentas.detalles_rentapresuntiva.bienes_fuerzamayor_tmp)
  *parseFloat($scope.datos_rentas.detalles_rentapresuntiva.valor_patrimonialneto);
  // ----------------------
  $scope.datos_rentas.detalles_rentapresuntiva.valor_patrimonialneto_bienes=parseFloat($scope.datos_rentas.detalles_rentapresuntiva.valor_patrimonialneto_bienes_tmp)
  *parseFloat($scope.datos_rentas.detalles_rentapresuntiva.valor_patrimonialneto);
  // ----------------------
  $scope.datos_rentas.detalles_rentapresuntiva.bienes_vinculados=parseFloat($scope.datos_rentas.detalles_rentapresuntiva.bienes_vinculados_tmp)
  *parseFloat($scope.datos_rentas.detalles_rentapresuntiva.valor_patrimonialneto);
  // ----------------------
  $scope.datos_rentas.detalles_rentapresuntiva.patrimonio_base=tpl_tmp -
  (parseFloat($scope.datos_rentas.detalles_rentapresuntiva.aportes_nacionales)+
  parseFloat($scope.datos_rentas.detalles_rentapresuntiva.bienes_fuerzamayor) +
  parseFloat($scope.datos_rentas.detalles_rentapresuntiva.valor_patrimonialneto)+
  parseFloat($scope.datos_rentas.detalles_rentapresuntiva.bienes_vinculados)+
  parseFloat($scope.datos_rentas.detalles_rentapresuntiva.primeras_8000uvt_calculada)+
  parseFloat($scope.datos_rentas.detalles_rentapresuntiva.primeras_19000uvt_calculada)+
  parseFloat($scope.datos_rentas.detalles_rentapresuntiva.casa));
  //
  if($scope.datos_rentas.detalles_rentapresuntiva.patrimonio_base==undefined
  || $scope.datos_rentas.detalles_rentapresuntiva.patrimonio_base==""
  || $scope.datos_rentas.detalles_rentapresuntiva.patrimonio_base==null){
    $scope.datos_rentas.detalles_rentapresuntiva.patrimonio_base=0;
  }
  $scope.datos_rentas.detalles_rentapresuntiva.subtotal_renta_presuntiva=parseFloat($scope.datos_rentas.detalles_rentapresuntiva.valor_prp)*
  parseFloat(  $scope.datos_rentas.detalles_rentapresuntiva.patrimonio_base)/100;
  //
  $scope.datos_rentas.total_rentapresuntiva=parseFloat($scope.datos_rentas.detalles_rentapresuntiva.subtotal_renta_presuntiva)+
  parseFloat($scope.datos_rentas.detalles_rentapresuntiva.mas_renta_producida_bienes_excluidos);
  //
}
$scope.calcular8000UVT = function() {
  var casaHabitacion=0;
  // ////console.log("anterior",$scope.certificadosInmediatamenteAnterior.detalles_total_patrimonio_bruto);
  var Anterior={};
  if($scope.certificadosInmediatamenteAnterior!=null){
    Anterior=JSON.parse($scope.certificadosInmediatamenteAnterior.detalles_total_patrimonio_bruto);
    casaHabitacion=parseFloat(Anterior.casa)
    *parseFloat($scope.datos_rentas.detalles_rentapresuntiva.valor_patrimonialneto);
  }
  var primeras8000=parseFloat($scope.datos_rentas.uvtanoanterior.valor)*8000;
  $scope.datos_rentas.detalles_rentapresuntiva.primeras_8000uvt_calculada=casaHabitacion;
  if(primeras8000<casaHabitacion){
    $scope.datos_rentas.detalles_rentapresuntiva.primeras_8000uvt_calculada=primeras8000;
  }
}
$scope.calcular19000UVT = function() {
  var primeras19000=parseFloat($scope.datos_rentas.uvtanoanterior.valor)*19000;
  $scope.datos_rentas.detalles_rentapresuntiva.primeras_19000uvt_calculada=$scope.datos_rentas.detalles_rentapresuntiva.primeras_19000uvt_calculada_tmp;
  if(primeras19000<parseFloat($scope.datos_rentas.detalles_rentapresuntiva.primeras_19000uvt_calculada_tmp)){
    $scope.datos_rentas.detalles_rentapresuntiva.primeras_19000uvt_calculada=primeras19000;
  }
  // ////console.log("primeras19000",primeras19000);
  // ////console.log("sub",$scope.datos_rentas.detalles_rentapresuntiva.primeras_19000uvt_calculada_tmp);
  // ////console.log("total",$scope.datos_rentas.detalles_rentapresuntiva.primeras_19000uvt_calculada);
  // $scope.datos_rentas.detalles_rentapresuntiva.primeras_19000uvt_calculada=primeras19000;
  $scope.caluculosSubtotalesRentaPresuntiva();
}
$scope.abrirCampo57 = function(){
  var page='app/pages/certificados/edicion/modales/renta/rentapresuntiva.html';
  var size='lg';
  $scope.modales.rentapresuntiva=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarRentas();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo57 = function(){
  // $scope.datos_edicion.detalles_rentapresuntiva=angular.toJson($scope.datos_rentas.detalles_rentapresuntiva);
  var tmp=0;
  // angular.forEach($scope.datos_rentas.detalles_rentapresuntiva, function(item) {
  //   tmp=tmp + parseFloat(item.valor);
  // });
  tmp=parseFloat($scope.datos_rentas.total_rentapresuntiva);
  ////console.log('ssssss',tmp);
  if(tmp=="" || tmp==undefined || isNaN(tmp)){
    $scope.datos_edicion.renta_presuntiva=0;
  }
  else{
    $scope.datos_edicion.renta_presuntiva=$scope.datos_rentas.total_rentapresuntiva;
  }
}
////57//////////////////////////////////////////////////////////////////
// --
$scope.renderizarDatosCampo58 = function () {
  $scope.datos_rentas.detalles_rentastrabajo=JSON.parse($scope.datos_edicion.detalles_rentastrabajo);
  //
  if($scope.datos_rentas.detalles_rentastrabajo==null ||
    $scope.datos_edicion.detalles_rentastrabajo==undefined){
    $scope.datos_rentas.detalles_rentastrabajo={};
  }
  if($scope.datos_rentas.detalles_rentastrabajo.listado==null ||
    $scope.datos_rentas.detalles_rentastrabajo.listado==undefined){
    $scope.datos_rentas.detalles_rentastrabajo.listado=[];
  }
}
$scope.abrirCampo58 = function(){
  var page='app/pages/certificados/edicion/modales/renta/representacionyotrasrentas.html';
  var size='lg';
  $scope.modales.rentastrabajo=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarRentas();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo58 = function(){
  $scope.datos_edicion.detalles_rentastrabajo=angular.toJson($scope.datos_rentas.detalles_rentastrabajo);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_rentas.detalles_rentastrabajo.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_rentastrabajo=tmp;
}
$scope.agregarCampo58 = function(formulario){
  var tmp={
    entidad:$scope.datos_rentas.rentastrabajo.item.nombre,
    concepto:$scope.datos_rentas.rentastrabajo.concepto,
    identificacion:$scope.datos_rentas.rentastrabajo.item.identificacion,
    valor:$scope.datos_rentas.rentastrabajo.valor,
  }
  $scope.datos_rentas.detalles_rentastrabajo.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo58 = function(item) {
  var index = $scope.datos_rentas.detalles_rentastrabajo.listado.indexOf(item);
  $scope.datos_rentas.detalles_rentastrabajo.listado.splice(index, 1);
}////58//////////////////////////////////////////////////////////////////

// --CAmpo 59//////////////////////////////////////////////////////////////////
$scope.renderizarDatosCampo59 = function () {
  $scope.datos_rentas.detalles_pensionobli=JSON.parse($scope.datos_edicion.detalles_pensionobli);
  //
  if($scope.datos_rentas.detalles_pensionobli==null ||
    $scope.datos_edicion.detalles_pensionobli==undefined){
    $scope.datos_rentas.detalles_pensionobli={};
  }
  if($scope.datos_rentas.detalles_pensionobli.listado==null ||
    $scope.datos_rentas.detalles_pensionobli.listado==undefined){
    $scope.datos_rentas.detalles_pensionobli.listado=[];
  }
}
$scope.abrirCampo59 = function(){
  var page='app/pages/certificados/edicion/modales/renta/obligatoriopension.html';
  var size='lg';
  $scope.modales.pensionobli=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarRentas();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo59 = function(){
  $scope.datos_edicion.detalles_pensionobli=angular.toJson($scope.datos_rentas.detalles_pensionobli);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_rentas.detalles_pensionobli.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_pensionobli=tmp;
}
$scope.agregarCampo59 = function(formulario){
  var tmp={
    entidad:$scope.datos_rentas.pensionobli.item.nombre,
    concepto:$scope.datos_rentas.pensionobli.concepto,
    identificacion:$scope.datos_rentas.pensionobli.item.identificacion,
    valor:$scope.datos_rentas.pensionobli.valor,
  }
  $scope.datos_rentas.detalles_pensionobli.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo59 = function(item) {
  var index = $scope.datos_rentas.detalles_pensionobli.listado.indexOf(item);
  $scope.datos_rentas.detalles_pensionobli.listado.splice(index, 1);
}////59//////////////////////////////////////////////////////////////////

// --CAmpo 60//////////////////////////////////////////////////////////////////
$scope.renderizarDatosCampo60 = function () {
  $scope.datos_rentas.detalles_pensionvol=JSON.parse($scope.datos_edicion.detalles_pensionvol);
  //
  if($scope.datos_rentas.detalles_pensionvol==null ||
    $scope.datos_edicion.detalles_pensionvol==undefined){
    $scope.datos_rentas.detalles_pensionvol={};
  }
  if($scope.datos_rentas.detalles_pensionvol.listado==null ||
    $scope.datos_rentas.detalles_pensionvol.listado==undefined){
    $scope.datos_rentas.detalles_pensionvol.listado=[];
  }
}
$scope.abrirCampo60 = function(){
  var page='app/pages/certificados/edicion/modales/renta/voluntariopension.html';
  var size='lg';
  $scope.modales.pensionvol=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarRentas();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo60 = function(){
  $scope.datos_edicion.detalles_pensionvol=angular.toJson($scope.datos_rentas.detalles_pensionvol);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_rentas.detalles_pensionvol.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_pensionvol=tmp;
}
$scope.agregarCampo60 = function(formulario){
  var tmp={
    entidad:$scope.datos_rentas.pensionvol.item.nombre,
    concepto:$scope.datos_rentas.pensionvol.concepto,
    identificacion:$scope.datos_rentas.pensionvol.item.identificacion,
    valor:$scope.datos_rentas.pensionvol.valor,
  }
  $scope.datos_rentas.detalles_pensionvol.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo60 = function(item) {
  var index = $scope.datos_rentas.detalles_pensionvol.listado.indexOf(item);
  $scope.datos_rentas.detalles_pensionvol.listado.splice(index, 1);
}////60//////////////////////////////////////////////////////////////////

// --CAmpo 61//////////////////////////////////////////////////////////////////
$scope.renderizarDatosCampo61 = function () {
  $scope.datos_rentas.detalles_cuentasafc=JSON.parse($scope.datos_edicion.detalles_cuentasafc);
  //
  if($scope.datos_rentas.detalles_cuentasafc==null ||
    $scope.datos_edicion.detalles_cuentasafc==undefined){
    $scope.datos_rentas.detalles_cuentasafc={};
  }
  if($scope.datos_rentas.detalles_cuentasafc.listado==null ||
    $scope.datos_rentas.detalles_cuentasafc.listado==undefined){
    $scope.datos_rentas.detalles_cuentasafc.listado=[];
  }
}
$scope.abrirCampo61 = function(){
  var page='app/pages/certificados/edicion/modales/renta/aportesafc.html';
  var size='lg';
  $scope.modales.cuentasafc=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarRentas();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo61 = function(){
  $scope.datos_edicion.detalles_cuentasafc=angular.toJson($scope.datos_rentas.detalles_cuentasafc);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_rentas.detalles_cuentasafc.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_cuentasafc=tmp;
}
$scope.agregarCampo61 = function(formulario){
  var tmp={
    entidad:$scope.datos_rentas.cuentasafc.item.nombre,
    concepto:$scope.datos_rentas.cuentasafc.concepto,
    identificacion:$scope.datos_rentas.cuentasafc.item.identificacion,
    valor:$scope.datos_rentas.cuentasafc.valor,
  }
  $scope.datos_rentas.detalles_cuentasafc.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo61 = function(item) {
  var index = $scope.datos_rentas.detalles_cuentasafc.listado.indexOf(item);
  $scope.datos_rentas.detalles_cuentasafc.listado.splice(index, 1);
}////61//////////////////////////////////////////////////////////////////

// --CAmpo 62//////////////////////////////////////////////////////////////////
$scope.renderizarDatosCampo62 = function () {
  $scope.datos_rentas.detalles_rtexentas=JSON.parse($scope.datos_edicion.detalles_rtexentas);
  //
  if($scope.datos_rentas.detalles_rtexentas==null ||
    $scope.datos_edicion.detalles_rtexentas==undefined){
    $scope.datos_rentas.detalles_rtexentas={};
  }
  if($scope.datos_rentas.detalles_rtexentas.listado==null ||
    $scope.datos_rentas.detalles_rtexentas.listado==undefined){
    $scope.datos_rentas.detalles_rtexentas.listado=[];
  }
}
$scope.abrirCampo62 = function(){
  var page='app/pages/certificados/edicion/modales/renta/exentas.html';
  var size='lg';
  $scope.modales.rtexentas=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarRentas();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo62 = function(){
  $scope.datos_edicion.detalles_rtexentas=angular.toJson($scope.datos_rentas.detalles_rtexentas);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_rentas.detalles_rtexentas.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_rtexentas=tmp;
}
$scope.agregarCampo62 = function(formulario){
  var tmp={
    entidad:$scope.datos_rentas.rtexentas.item.nombre,
    concepto:$scope.datos_rentas.rtexentas.concepto,
    identificacion:$scope.datos_rentas.rtexentas.item.identificacion,
    valor:$scope.datos_rentas.rtexentas.valor,
  }
  $scope.datos_rentas.detalles_rtexentas.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo62 = function(item) {
  var index = $scope.datos_rentas.detalles_rtexentas.listado.indexOf(item);
  $scope.datos_rentas.detalles_rtexentas.listado.splice(index, 1);
}////62//////////////////////////////////////////////////////////////////

// --CAmpo 63//////////////////////////////////////////////////////////////////
$scope.renderizarDatosCampo63 = function () {
  $scope.datos_rentas.detalles_laborypension=JSON.parse($scope.datos_edicion.detalles_laborypension);
  //
  if($scope.datos_rentas.detalles_laborypension==null ||
    $scope.datos_edicion.detalles_laborypension==undefined){
    $scope.datos_rentas.detalles_laborypension={};
  }
  if($scope.datos_rentas.detalles_laborypension.listado==null ||
    $scope.datos_rentas.detalles_laborypension.listado==undefined){
    $scope.datos_rentas.detalles_laborypension.listado=[];
  }
}
$scope.abrirCampo63 = function(){
  var page='app/pages/certificados/edicion/modales/renta/laboralesypensiones.html';
  var size='lg';
  $scope.modales.laborypension=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarRentas();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo63 = function(){
  $scope.datos_edicion.detalles_laborypension=angular.toJson($scope.datos_rentas.detalles_laborypension);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_rentas.detalles_laborypension.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_laborypension=tmp;
}
$scope.agregarCampo63 = function(formulario){
  var tmp={
    entidad:$scope.datos_rentas.laborypension.item.nombre,
    concepto:$scope.datos_rentas.laborypension.concepto,
    identificacion:$scope.datos_rentas.laborypension.item.identificacion,
    valor:$scope.datos_rentas.laborypension.valor,
  }
  $scope.datos_rentas.detalles_laborypension.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo63 = function(item) {
  var index = $scope.datos_rentas.detalles_laborypension.listado.indexOf(item);
  $scope.datos_rentas.detalles_laborypension.listado.splice(index, 1);
}////63//////////////////////////////////////////////////////////////////
// --CAmpo 65//////////////////////////////////////////////////////////////////
$scope.renderizarDatosCampo65 = function () {
  $scope.datos_rentas.detalles_rentasgravables=JSON.parse($scope.datos_edicion.detalles_rentasgravables);
  //
  if($scope.datos_rentas.detalles_rentasgravables==null ||
    $scope.datos_edicion.detalles_rentasgravables==undefined){
    $scope.datos_rentas.detalles_rentasgravables={};
  }
  if($scope.datos_rentas.detalles_rentasgravables.listado==null ||
    $scope.datos_rentas.detalles_rentasgravables.listado==undefined){
    $scope.datos_rentas.detalles_rentasgravables.listado=[];
  }
}
$scope.abrirCampo65 = function(){
  var page='app/pages/certificados/edicion/modales/renta/rentasgravables.html';
  var size='lg';
  $scope.modales.laborypension=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarRentas();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo65 = function(){
  $scope.datos_edicion.detalles_rentasgravables=angular.toJson($scope.datos_rentas.detalles_rentasgravables);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_rentas.detalles_rentasgravables.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_rentasgravables=tmp;
}
$scope.agregarCampo65 = function(formulario){
  var tmp={
    entidad:$scope.datos_rentas.rentasgravables.item.nombre,
    concepto:$scope.datos_rentas.rentasgravables.concepto,
    identificacion:$scope.datos_rentas.rentasgravables.item.identificacion,
    valor:$scope.datos_rentas.rentasgravables.valor,
  }
  $scope.datos_rentas.detalles_rentasgravables.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo65 = function(item) {
  var index = $scope.datos_rentas.detalles_rentasgravables.listado.indexOf(item);
  $scope.datos_rentas.detalles_rentasgravables.listado.splice(index, 1);
}////65//////////////////////////////////////////////////////////////////
//66
$scope.renderizarDatosCampo66=function () {
  var tmp;
  tmp=parseFloat($scope.datos_edicion.renta_presuntiva);
  if(parseFloat($scope.datos_edicion.renta_liquida)>parseFloat($scope.datos_edicion.renta_presuntiva)) {
    tmp=parseFloat($scope.datos_edicion.renta_liquida);
  }
  tmp=tmp-parseFloat($scope.datos_edicion.total_rentaexenta)
  + parseFloat($scope.datos_edicion.total_rentasgravables);
  $scope.datos_edicion.total_renta_liquida_gravable=tmp;
  ////console.log("Por acá",tmp);
  if(tmp<0){
    $scope.datos_edicion.total_renta_liquida_gravable=0;
  }
  $scope.renderizarDatosCampo84();
}
// --------------------------------------------------------------------
/////renderizar renta///////
$scope.renderizarDatosRentas = function(){
  $scope.datos_rentas={};
  // $scope.datos_rentas.rentastrabajo={};
  // $scope.datos_rentas.pensionobli={};
  // $scope.datos_rentas.pensionvol={};
  // $scope.datos_rentas.cuentasafc={};
  // $scope.datos_rentas.rtexentas={};
  // $scope.datos_rentas.laborypension={};
  $scope.renderizarDatosCampo53();
  $scope.renderizarDatosCampo54();
  $scope.renderizarDatosCampo55();
  $scope.renderizarDatosCampo57();
  //----//
  $scope.renderizarDatosCampo58();
  $scope.renderizarDatosCampo59();
  $scope.renderizarDatosCampo60();
  $scope.renderizarDatosCampo61();
  $scope.renderizarDatosCampo62();
  $scope.renderizarDatosCampo63();
  $scope.renderizarDatosCampo65();

}
// -------------------------------------------------------------

$scope.actualizarRentas = function(){
  $scope.renderizarDatosCampo53();
  $scope.renderizarDatosCampo54();
  $scope.renderizarDatosCampo55();
  // $scope.actualizarCampo53();
  $scope.actualizarCampo57();
  $scope.actualizarCampo58();
  $scope.actualizarCampo59();
  $scope.actualizarCampo60();
  $scope.actualizarCampo61();
  $scope.actualizarCampo62();
  $scope.actualizarCampo63();
  $scope.actualizarCampo65();
  //
  $scope.datos_edicion.total_rentaexenta = parseFloat($scope.datos_edicion.total_rentastrabajo)+
  parseFloat($scope.datos_edicion.total_pensionobli)+
  parseFloat($scope.datos_edicion.total_pensionvol)+
  parseFloat($scope.datos_edicion.total_cuentasafc)+
  parseFloat($scope.datos_edicion.total_rtexentas)+
  parseFloat($scope.datos_edicion.total_laborypension);
  //
  $scope.renderizarDatosCampo66();
}


// //////////////////////////////////////////////////////////////////////////////
//////////////--------------------------/////////////////////////////////////////
// Ganancia ocasional//
///////////////////////////////////////////////////////////////////////////////////
// --CAmpo 67
$scope.renderizarDatosCampo67 = function () {
  $scope.datos_ganancias.detalles_gananciapais=JSON.parse($scope.datos_edicion.detalles_gananciapais);
  //
  if($scope.datos_ganancias.detalles_gananciapais==null ||
    $scope.datos_edicion.detalles_gananciapais==undefined){
    $scope.datos_ganancias.detalles_gananciapais={};
  }
  if($scope.datos_ganancias.detalles_gananciapais.listado==null ||
    $scope.datos_ganancias.detalles_gananciapais.listado==undefined){
    $scope.datos_ganancias.detalles_gananciapais.listado=[];
  }
  $scope.datos_ganancias.gananciapais.es_selector=false;
}
$scope.abrirCampo67 = function(){
  var page='app/pages/certificados/edicion/modales/gananciaocasional/gananciapais.html';
  var size='lg';
  $scope.modales.gananciapais=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarGanancias();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo67 = function(){
  $scope.datos_edicion.detalles_gananciapais=angular.toJson($scope.datos_ganancias.detalles_gananciapais);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_ganancias.detalles_gananciapais.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_gananciapais=tmp;
}
$scope.agregarCampo67 = function(formulario){
  var tmp;
  if($scope.datos_ganancias.gananciapais.es_selector){
    tmp={
      entidad:$scope.datos_ganancias.gananciapais.item.nombre,
      concepto:$scope.datos_ganancias.gananciapais.concepto,
      identificacion:$scope.datos_ganancias.gananciapais.item.identificacion,
      valor:$scope.datos_ganancias.gananciapais.valor,
    }
  }
  else{
    tmp={
      entidad:$scope.datos_ganancias.gananciapais.entidad,
      concepto:$scope.datos_ganancias.gananciapais.concepto,
      identificacion:$scope.datos_ganancias.gananciapais.identificacion,
      valor:$scope.datos_ganancias.gananciapais.valor,
    }
  }
  $scope.datos_ganancias.detalles_gananciapais.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo67 = function(item) {
  var index = $scope.datos_ganancias.detalles_gananciapais.listado.indexOf(item);
  $scope.datos_ganancias.detalles_gananciapais.listado.splice(index, 1);
}
$scope.cambiarDatosCampo67 = function () {
  $scope.datos_ganancias.gananciapais.es_selector=!$scope.datos_ganancias.gananciapais.es_selector;
}
////67//////////////////////////////////////////////////////////////////

// --CAmpo 68
$scope.renderizarDatosCampo68 = function () {
  $scope.datos_ganancias.detalles_gananciaexterior=JSON.parse($scope.datos_edicion.detalles_gananciaexterior);
  //
  if($scope.datos_ganancias.detalles_gananciaexterior==null ||
    $scope.datos_edicion.detalles_gananciaexterior==undefined){
    $scope.datos_ganancias.detalles_gananciaexterior={};
  }
  if($scope.datos_ganancias.detalles_gananciaexterior.listado==null ||
    $scope.datos_ganancias.detalles_gananciaexterior.listado==undefined){
    $scope.datos_ganancias.detalles_gananciaexterior.listado=[];
  }
  $scope.datos_ganancias.gananciaexterior.es_selector=false;
}
$scope.abrirCampo68 = function(){
  var page='app/pages/certificados/edicion/modales/gananciaocasional/gananciaexterior.html';
  var size='lg';
  $scope.modales.gananciaexterior=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarGanancias();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo68 = function(){
  $scope.datos_edicion.detalles_gananciaexterior=angular.toJson($scope.datos_ganancias.detalles_gananciaexterior);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_ganancias.detalles_gananciaexterior.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_gananciaexterior=tmp;
}
$scope.agregarCampo68 = function(formulario){
  var tmp;
  if($scope.datos_ganancias.gananciaexterior.es_selector){
    tmp={
      entidad:$scope.datos_ganancias.gananciaexterior.item.nombre,
      concepto:$scope.datos_ganancias.gananciaexterior.concepto,
      identificacion:$scope.datos_ganancias.gananciaexterior.item.identificacion,
      valor:$scope.datos_ganancias.gananciaexterior.valor,
    }
  }
  else{
    tmp={
      entidad:$scope.datos_ganancias.gananciaexterior.entidad,
      concepto:$scope.datos_ganancias.gananciaexterior.concepto,
      identificacion:$scope.datos_ganancias.gananciaexterior.identificacion,
      valor:$scope.datos_ganancias.gananciaexterior.valor,
    }
  }
  $scope.datos_ganancias.detalles_gananciaexterior.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo68 = function(item) {
  var index = $scope.datos_ganancias.detalles_gananciaexterior.listado.indexOf(item);
  $scope.datos_ganancias.detalles_gananciaexterior.listado.splice(index, 1);
}
$scope.cambiarDatosCampo68 = function () {
  $scope.datos_ganancias.gananciaexterior.es_selector=!$scope.datos_ganancias.gananciaexterior.es_selector;
}////68//////////////////////////////////////////////////////////////////

// --CAmpo 69
$scope.renderizarDatosCampo69 = function () {
  $scope.datos_ganancias.detalles_gananciasocasionales=JSON.parse($scope.datos_edicion.detalles_gananciasocasionales);
  //
  if($scope.datos_ganancias.detalles_gananciasocasionales==null ||
    $scope.datos_edicion.detalles_gananciasocasionales==undefined){
    $scope.datos_ganancias.detalles_gananciasocasionales={};
  }
  if($scope.datos_ganancias.detalles_gananciasocasionales.listado==null ||
    $scope.datos_ganancias.detalles_gananciasocasionales.listado==undefined){
    $scope.datos_ganancias.detalles_gananciasocasionales.listado=[];
  }
  $scope.datos_ganancias.gananciasocasionales.es_selector=false;
}
$scope.abrirCampo69 = function(){
  var page='app/pages/certificados/edicion/modales/gananciaocasional/gananciasocasionales.html';
  var size='lg';
  $scope.modales.gananciasocasionales=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarGanancias();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo69 = function(){
  $scope.datos_edicion.detalles_gananciasocasionales=angular.toJson($scope.datos_ganancias.detalles_gananciasocasionales);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_ganancias.detalles_gananciasocasionales.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_gananciasocasionales=tmp;
}
$scope.agregarCampo69 = function(formulario){
  var tmp;
  if($scope.datos_ganancias.gananciasocasionales.es_selector){
    tmp={
      entidad:$scope.datos_ganancias.gananciasocasionales.item.nombre,
      concepto:$scope.datos_ganancias.gananciasocasionales.concepto,
      identificacion:$scope.datos_ganancias.gananciasocasionales.item.identificacion,
      valor:$scope.datos_ganancias.gananciasocasionales.valor,
    }
  }
  else{
    tmp={
      entidad:$scope.datos_ganancias.gananciasocasionales.entidad,
      concepto:$scope.datos_ganancias.gananciasocasionales.concepto,
      identificacion:$scope.datos_ganancias.gananciasocasionales.identificacion,
      valor:$scope.datos_ganancias.gananciasocasionales.valor,
    }
  }
  $scope.datos_ganancias.detalles_gananciasocasionales.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo69 = function(item) {
  var index = $scope.datos_ganancias.detalles_gananciasocasionales.listado.indexOf(item);
  $scope.datos_ganancias.detalles_gananciasocasionales.listado.splice(index, 1);
}
$scope.cambiarDatosCampo69 = function () {
  $scope.datos_ganancias.gananciasocasionales.es_selector=!$scope.datos_ganancias.gananciasocasionales.es_selector;
}////69//////////////////////////////////////////////////////////////////

// --CAmpo 70
$scope.renderizarDatosCampo70 = function () {
  $scope.datos_ganancias.detalles_gananciasocasionalesexentas=JSON.parse($scope.datos_edicion.detalles_gananciasocasionalesexentas);
  //
  if($scope.datos_ganancias.detalles_gananciasocasionalesexentas==null ||
    $scope.datos_edicion.detalles_gananciasocasionalesexentas==undefined){
    $scope.datos_ganancias.detalles_gananciasocasionalesexentas={};
  }
  if($scope.datos_ganancias.detalles_gananciasocasionalesexentas.listado==null ||
    $scope.datos_ganancias.detalles_gananciasocasionalesexentas.listado==undefined){
    $scope.datos_ganancias.detalles_gananciasocasionalesexentas.listado=[];
  }
  $scope.datos_ganancias.gananciasocasionalesexentas.es_selector=false;
}
$scope.abrirCampo70 = function(){
  var page='app/pages/certificados/edicion/modales/gananciaocasional/nogravadasyexentas.html';
  var size='lg';
  $scope.modales.gananciasocasionalesexentas=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarGanancias();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo70 = function(){
  $scope.datos_edicion.detalles_gananciasocasionalesexentas=angular.toJson($scope.datos_ganancias.detalles_gananciasocasionalesexentas);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_ganancias.detalles_gananciasocasionalesexentas.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_gananciasocasionalesexentas=tmp;
}
$scope.agregarCampo70 = function(formulario){
  var tmp;
  if($scope.datos_ganancias.gananciasocasionalesexentas.es_selector){
    tmp={
      entidad:$scope.datos_ganancias.gananciasocasionalesexentas.item.nombre,
      concepto:$scope.datos_ganancias.gananciasocasionalesexentas.concepto,
      identificacion:$scope.datos_ganancias.gananciasocasionalesexentas.item.identificacion,
      valor:$scope.datos_ganancias.gananciasocasionalesexentas.valor,
    }
  }
  else{
    tmp={
      entidad:$scope.datos_ganancias.gananciasocasionalesexentas.entidad,
      concepto:$scope.datos_ganancias.gananciasocasionalesexentas.concepto,
      identificacion:$scope.datos_ganancias.gananciasocasionalesexentas.identificacion,
      valor:$scope.datos_ganancias.gananciasocasionalesexentas.valor,
    }
  }
  $scope.datos_ganancias.detalles_gananciasocasionalesexentas.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo70 = function(item) {
  var index = $scope.datos_ganancias.detalles_gananciasocasionalesexentas.listado.indexOf(item);
  $scope.datos_ganancias.detalles_gananciasocasionalesexentas.listado.splice(index, 1);
}
$scope.cambiarDatosCampo70 = function () {
  $scope.datos_ganancias.gananciasocasionalesexentas.es_selector=!$scope.datos_ganancias.gananciasocasionalesexentas.es_selector;
}////70//////////////////////////////////////////////////////////////////


// --------------------------------------------------------------------
/////renderizar ganancias///////
$scope.renderizarDatosGanancias = function(){
  $scope.datos_ganancias={};
  $scope.datos_ganancias.gananciapais={};
  $scope.datos_ganancias.gananciaexterior={};
  $scope.datos_ganancias.gananciasocasionales={};
  $scope.datos_ganancias.gananciasocasionalesexentas={};

  //----//
  $scope.renderizarDatosCampo67();
  $scope.renderizarDatosCampo68();
  $scope.renderizarDatosCampo69();
  $scope.renderizarDatosCampo70();

}
// -------------------------------------------------------------

$scope.actualizarGanancias = function(){

  $scope.actualizarCampo67();
  $scope.actualizarCampo68();
  $scope.actualizarCampo69();
  $scope.actualizarCampo70();

//
//totales ganancia ocasional  gravable (67-68-69-70)
  $scope.datos_edicion.total_gananciasocasionalesgravables = parseFloat($scope.datos_edicion.total_gananciapais) +
  parseFloat($scope.datos_edicion.total_gananciaexterior) -
  parseFloat($scope.datos_edicion.total_gananciasocasionales)-
  parseFloat($scope.datos_edicion.total_gananciasocasionalesexentas);
  $scope.renderizarDatosCampo92();
  $scope.renderizarDatosCampo94();
//

}

// //////////////////////////////////////////////////////////////////////////////
//////////////--------------------------/////////////////////////////////////////
// DETERMINACION DE LA RENTA GRAVABLE ALTERNATIVA//
///////////////////////////////////////////////////////////////////////////////////
//--- Campo 72
$scope.renderizarDatosCampo72 = function () {
  $scope.datos_edicion.total_ingresosobtenidosgravables=parseFloat($scope.datos_edicion.total_recibidos_empleados_ingresos) +
  parseFloat($scope.datos_edicion.total_honorarios) +
  parseFloat($scope.datos_edicion.total_intereses) +
  parseFloat($scope.datos_edicion.total_dividendos) +
  parseFloat($scope.datos_edicion.total_otrosetc) +
  parseFloat($scope.datos_edicion.total_obtenidosext);
}
$scope.renderizarDatosCampo73 = function () {
  $scope.datos_edicion.total_dividendosparticipaciones=parseFloat($scope.datos_edicion.total_dividendosnoconsti);
}
// --CAmpo 74
$scope.renderizarDatosCampo74 = function () {
  $scope.datos_iman.detalles_indemseguro=JSON.parse($scope.datos_edicion.detalles_indemseguro);
  //
  if($scope.datos_iman.detalles_indemseguro==null ||
    $scope.datos_edicion.detalles_indemseguro==undefined){
    $scope.datos_iman.detalles_indemseguro={};
  }
  if($scope.datos_iman.detalles_indemseguro.listado==null ||
    $scope.datos_iman.detalles_indemseguro.listado==undefined){
    $scope.datos_iman.detalles_indemseguro.listado=[];
  }
  $scope.datos_iman.indemseguro.es_selector=false;
}
$scope.abrirCampo74 = function(){
  var page='app/pages/certificados/edicion/modales/iman/indemseguro.html';
  var size='lg';
  $scope.modales.indemseguro=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarIman();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo74 = function(){
  $scope.datos_edicion.detalles_indemseguro=angular.toJson($scope.datos_iman.detalles_indemseguro);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_iman.detalles_indemseguro.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_indemseguro=tmp;
}
$scope.agregarCampo74 = function(formulario){
  var tmp;
  if($scope.datos_iman.indemseguro.es_selector){
    tmp={
      entidad:$scope.datos_iman.indemseguro.item.nombre,
      concepto:$scope.datos_iman.indemseguro.concepto,
      identificacion:$scope.datos_iman.indemseguro.item.identificacion,
      valor:$scope.datos_iman.indemseguro.valor,
    }
  }
  else{
    tmp={
      entidad:$scope.datos_iman.indemseguro.entidad,
      concepto:$scope.datos_iman.indemseguro.concepto,
      identificacion:$scope.datos_iman.indemseguro.identificacion,
      valor:$scope.datos_iman.indemseguro.valor,
    }
  }
  $scope.datos_iman.detalles_indemseguro.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo74 = function(item) {
  var index = $scope.datos_iman.detalles_indemseguro.listado.indexOf(item);
  $scope.datos_iman.detalles_indemseguro.listado.splice(index, 1);
}
$scope.cambiarDatosCampo74 = function () {
  $scope.datos_iman.indemseguro.es_selector=!$scope.datos_iman.indemseguro.es_selector;
}////74//////////////////////////////////////////////////////////////////

// --CAmpo 75
$scope.renderizarDatosCampo75 = function () {
  $scope.datos_iman.detalles_aportesss=JSON.parse($scope.datos_edicion.detalles_aportesss);
  //
  if($scope.datos_iman.detalles_aportesss==null ||
    $scope.datos_edicion.detalles_aportesss==undefined){
    $scope.datos_iman.detalles_aportesss={};
  }
  if($scope.datos_iman.detalles_aportesss.listado==null ||
    $scope.datos_iman.detalles_aportesss.listado==undefined){
    $scope.datos_iman.detalles_aportesss.listado=[];
  }
  $scope.datos_iman.aportesss.es_selector=false;
}
$scope.abrirCampo75 = function(){
  var page='app/pages/certificados/edicion/modales/iman/aportesss.html';
  var size='lg';
  $scope.modales.aportesss=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarIman();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo75 = function(){
  $scope.datos_edicion.detalles_aportesss=angular.toJson($scope.datos_iman.detalles_aportesss);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_iman.detalles_aportesss.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_aportesss=tmp;
}
$scope.agregarCampo75 = function(formulario){
  var tmp;
  if($scope.datos_iman.aportesss.es_selector){
    tmp={
      entidad:$scope.datos_iman.aportesss.item.nombre,
      concepto:$scope.datos_iman.aportesss.concepto,
      identificacion:$scope.datos_iman.aportesss.item.identificacion,
      valor:$scope.datos_iman.aportesss.valor,
    }
  }
  else{
    tmp={
      entidad:$scope.datos_iman.aportesss.entidad,
      concepto:$scope.datos_iman.aportesss.concepto,
      identificacion:$scope.datos_iman.aportesss.identificacion,
      valor:$scope.datos_iman.aportesss.valor,
    }
  }
  $scope.datos_iman.detalles_aportesss.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo75 = function(item) {
  var index = $scope.datos_iman.detalles_aportesss.listado.indexOf(item);
  $scope.datos_iman.detalles_aportesss.listado.splice(index, 1);
}
$scope.cambiarDatosCampo75 = function () {
  $scope.datos_iman.aportesss.es_selector=!$scope.datos_iman.aportesss.es_selector;
}////75//////////////////////////////////////////////////////////////////


// --CAmpo 76
$scope.renderizarDatosCampo76 = function () {
  $scope.datos_iman.detalles_gtrepreexento=JSON.parse($scope.datos_edicion.detalles_gtrepreexento);
  //
  if($scope.datos_iman.detalles_gtrepreexento==null ||
    $scope.datos_edicion.detalles_gtrepreexento==undefined){
    $scope.datos_iman.detalles_gtrepreexento={};
  }
  if($scope.datos_iman.detalles_gtrepreexento.listado==null ||
    $scope.datos_iman.detalles_gtrepreexento.listado==undefined){
    $scope.datos_iman.detalles_gtrepreexento.listado=[];
  }
  $scope.datos_iman.gtrepreexento.es_selector=false;
}
$scope.abrirCampo76 = function(){
  var page='app/pages/certificados/edicion/modales/iman/gtrepreexento.html';
  var size='lg';
  $scope.modales.gtrepreexento=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarIman();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo76 = function(){
  $scope.datos_edicion.detalles_gtrepreexento=angular.toJson($scope.datos_iman.detalles_gtrepreexento);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_iman.detalles_gtrepreexento.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_gtrepreexento=tmp;
}
$scope.agregarCampo76 = function(formulario){
  var tmp;
  if($scope.datos_iman.gtrepreexento.es_selector){
    tmp={
      entidad:$scope.datos_iman.gtrepreexento.item.nombre,
      concepto:$scope.datos_iman.gtrepreexento.concepto,
      identificacion:$scope.datos_iman.gtrepreexento.item.identificacion,
      valor:$scope.datos_iman.gtrepreexento.valor,
    }
  }
  else{
    tmp={
      entidad:$scope.datos_iman.gtrepreexento.entidad,
      concepto:$scope.datos_iman.gtrepreexento.concepto,
      identificacion:$scope.datos_iman.gtrepreexento.identificacion,
      valor:$scope.datos_iman.gtrepreexento.valor,
    }
  }
  $scope.datos_iman.detalles_gtrepreexento.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo76 = function(item) {
  var index = $scope.datos_iman.detalles_gtrepreexento.listado.indexOf(item);
  $scope.datos_iman.detalles_gtrepreexento.listado.splice(index, 1);
}
$scope.cambiarDatosCampo76 = function () {
  $scope.datos_iman.gtrepreexento.es_selector=!$scope.datos_iman.gtrepreexento.es_selector;
}////76//////////////////////////////////////////////////////////////////

// --CAmpo 77
$scope.renderizarDatosCampo77 = function () {
  $scope.datos_iman.detalles_saludnopos=JSON.parse($scope.datos_edicion.detalles_saludnopos);
  //
  if($scope.datos_iman.detalles_saludnopos==null ||
    $scope.datos_edicion.detalles_saludnopos==undefined){
    $scope.datos_iman.detalles_saludnopos={};
  }
  if($scope.datos_iman.detalles_saludnopos.listado==null ||
    $scope.datos_iman.detalles_saludnopos.listado==undefined){
    $scope.datos_iman.detalles_saludnopos.listado=[];
  }
  $scope.datos_iman.saludnopos.es_selector=false;
}
$scope.abrirCampo77 = function(){
  var page='app/pages/certificados/edicion/modales/iman/saludnopos.html';
  var size='lg';
  $scope.modales.saludnopos=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarIman();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo77 = function(){
  $scope.datos_edicion.detalles_saludnopos=angular.toJson($scope.datos_iman.detalles_saludnopos);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_iman.detalles_saludnopos.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_saludnopos=tmp;
}
$scope.agregarCampo77 = function(formulario){
  var tmp;
  if($scope.datos_iman.saludnopos.es_selector){
    tmp={
      entidad:$scope.datos_iman.saludnopos.item.nombre,
      concepto:$scope.datos_iman.saludnopos.concepto,
      identificacion:$scope.datos_iman.saludnopos.item.identificacion,
      valor:$scope.datos_iman.saludnopos.valor,
    }
  }
  else{
    tmp={
      entidad:$scope.datos_iman.saludnopos.entidad,
      concepto:$scope.datos_iman.saludnopos.concepto,
      identificacion:$scope.datos_iman.saludnopos.identificacion,
      valor:$scope.datos_iman.saludnopos.valor,
    }
  }
  $scope.datos_iman.detalles_saludnopos.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo77 = function(item) {
  var index = $scope.datos_iman.detalles_saludnopos.listado.indexOf(item);
  $scope.datos_iman.detalles_saludnopos.listado.splice(index, 1);
}
$scope.cambiarDatosCampo77 = function () {
  $scope.datos_iman.saludnopos.es_selector=!$scope.datos_iman.saludnopos.es_selector;
}////77//////////////////////////////////////////////////////////////////

// --CAmpo 78
$scope.renderizarDatosCampo78 = function () {
  $scope.datos_iman.detalles_desastreycal=JSON.parse($scope.datos_edicion.detalles_desastreycal);
  //
  if($scope.datos_iman.detalles_desastreycal==null ||
    $scope.datos_edicion.detalles_desastreycal==undefined){
    $scope.datos_iman.detalles_desastreycal={};
  }
  if($scope.datos_iman.detalles_desastreycal.listado==null ||
    $scope.datos_iman.detalles_desastreycal.listado==undefined){
    $scope.datos_iman.detalles_desastreycal.listado=[];
  }
  $scope.datos_iman.desastreycal.es_selector=false;
}
$scope.abrirCampo78 = function(){
  var page='app/pages/certificados/edicion/modales/iman/desastreycalamidad.html';
  var size='lg';
  $scope.modales.desastreycal=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarIman();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo78 = function(){
  $scope.datos_edicion.detalles_desastreycal=angular.toJson($scope.datos_iman.detalles_desastreycal);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_iman.detalles_desastreycal.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_desastreycal=tmp;
}
$scope.agregarCampo78 = function(formulario){
  var tmp;
  if($scope.datos_iman.desastreycal.es_selector){
    tmp={
      entidad:$scope.datos_iman.desastreycal.item.nombre,
      concepto:$scope.datos_iman.desastreycal.concepto,
      identificacion:$scope.datos_iman.desastreycal.item.identificacion,
      valor:$scope.datos_iman.desastreycal.valor,
    }
  }
  else{
    tmp={
      entidad:$scope.datos_iman.desastreycal.entidad,
      concepto:$scope.datos_iman.desastreycal.concepto,
      identificacion:$scope.datos_iman.desastreycal.identificacion,
      valor:$scope.datos_iman.desastreycal.valor,
    }
  }
  $scope.datos_iman.detalles_desastreycal.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo78 = function(item) {
  var index = $scope.datos_iman.detalles_desastreycal.listado.indexOf(item);
  $scope.datos_iman.detalles_desastreycal.listado.splice(index, 1);
}
$scope.cambiarDatosCampo78 = function () {
  $scope.datos_iman.desastreycal.es_selector=!$scope.datos_iman.desastreycal.es_selector;
}////78//////////////////////////////////////////////////////////////////

// --CAmpo 79
$scope.renderizarDatosCampo79 = function () {
  $scope.datos_iman.detalles_empleadodomestico=JSON.parse($scope.datos_edicion.detalles_empleadodomestico);
  //
  if($scope.datos_iman.detalles_empleadodomestico==null ||
    $scope.datos_edicion.detalles_empleadodomestico==undefined){
    $scope.datos_iman.detalles_empleadodomestico={};
  }
  if($scope.datos_iman.detalles_empleadodomestico.listado==null ||
    $scope.datos_iman.detalles_empleadodomestico.listado==undefined){
    $scope.datos_iman.detalles_empleadodomestico.listado=[];
  }
  $scope.datos_iman.empleadodomestico.es_selector=false;
}
$scope.abrirCampo79 = function(){
  var page='app/pages/certificados/edicion/modales/iman/empleadodomestico.html';
  var size='lg';
  $scope.modales.empleadodomestico=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarIman();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo79 = function(){
  $scope.datos_edicion.detalles_empleadodomestico=angular.toJson($scope.datos_iman.detalles_empleadodomestico);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_iman.detalles_empleadodomestico.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_empleadodomestico=tmp;
}
$scope.agregarCampo79 = function(formulario){
  var tmp;
  if($scope.datos_iman.empleadodomestico.es_selector){
    tmp={
      entidad:$scope.datos_iman.empleadodomestico.item.nombre,
      concepto:$scope.datos_iman.empleadodomestico.concepto,
      identificacion:$scope.datos_iman.empleadodomestico.item.identificacion,
      valor:$scope.datos_iman.empleadodomestico.valor,
    }
  }
  else{
    tmp={
      entidad:$scope.datos_iman.empleadodomestico.entidad,
      concepto:$scope.datos_iman.empleadodomestico.concepto,
      identificacion:$scope.datos_iman.empleadodomestico.identificacion,
      valor:$scope.datos_iman.empleadodomestico.valor,
    }
  }
  $scope.datos_iman.detalles_empleadodomestico.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo79 = function(item) {
  var index = $scope.datos_iman.detalles_empleadodomestico.listado.indexOf(item);
  $scope.datos_iman.detalles_empleadodomestico.listado.splice(index, 1);
}
$scope.cambiarDatosCampo79 = function () {
  $scope.datos_iman.empleadodomestico.es_selector=!$scope.datos_iman.empleadodomestico.es_selector;
}////79//////////////////////////////////////////////////////////////////

// --CAmpo 80
$scope.renderizarDatosCampo80 = function () {
  $scope.datos_iman.detalles_bienesenaje=JSON.parse($scope.datos_edicion.detalles_bienesenaje);
  //
  if($scope.datos_iman.detalles_bienesenaje==null ||
    $scope.datos_edicion.detalles_bienesenaje==undefined){
    $scope.datos_iman.detalles_bienesenaje={};
  }
  if($scope.datos_iman.detalles_bienesenaje.listado==null ||
    $scope.datos_iman.detalles_bienesenaje.listado==undefined){
    $scope.datos_iman.detalles_bienesenaje.listado=[];
  }
  $scope.datos_iman.bienesenaje.es_selector=false;
}
$scope.abrirCampo80 = function(){
  var page='app/pages/certificados/edicion/modales/iman/bienesenaje.html';
  var size='lg';
  $scope.modales.bienesenaje=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarIman();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo80 = function(){
  $scope.datos_edicion.detalles_bienesenaje=angular.toJson($scope.datos_iman.detalles_bienesenaje);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_iman.detalles_bienesenaje.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_bienesenaje=tmp;
}
$scope.agregarCampo80 = function(formulario){
  var tmp;
  if($scope.datos_iman.bienesenaje.es_selector){
    tmp={
      entidad:$scope.datos_iman.bienesenaje.item.nombre,
      concepto:$scope.datos_iman.bienesenaje.concepto,
      identificacion:$scope.datos_iman.bienesenaje.item.identificacion,
      valor:$scope.datos_iman.bienesenaje.valor,
    }
  }
  else{
    tmp={
      entidad:$scope.datos_iman.bienesenaje.entidad,
      concepto:$scope.datos_iman.bienesenaje.concepto,
      identificacion:$scope.datos_iman.bienesenaje.identificacion,
      valor:$scope.datos_iman.bienesenaje.valor,
    }
  }
  $scope.datos_iman.detalles_bienesenaje.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo80 = function(item) {
  var index = $scope.datos_iman.detalles_bienesenaje.listado.indexOf(item);
  $scope.datos_iman.detalles_bienesenaje.listado.splice(index, 1);
}
$scope.cambiarDatosCampo80 = function () {
  $scope.datos_iman.bienesenaje.es_selector=!$scope.datos_iman.bienesenaje.es_selector;
}////80//////////////////////////////////////////////////////////////////

// --CAmpo 81
$scope.renderizarDatosCampo81 = function () {
  $scope.datos_iman.detalles_indemnizaciones=JSON.parse($scope.datos_edicion.detalles_indemnizaciones);
  //
  if($scope.datos_iman.detalles_indemnizaciones==null ||
    $scope.datos_edicion.detalles_indemnizaciones==undefined){
    $scope.datos_iman.detalles_indemnizaciones={};
  }
  if($scope.datos_iman.detalles_indemnizaciones.listado==null ||
    $scope.datos_iman.detalles_indemnizaciones.listado==undefined){
    $scope.datos_iman.detalles_indemnizaciones.listado=[];
  }
  $scope.datos_iman.indemnizaciones.es_selector=false;
}
$scope.abrirCampo81 = function(){
  var page='app/pages/certificados/edicion/modales/iman/indemnizaciones.html';
  var size='lg';
  $scope.modales.indemnizaciones=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarIman();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo81 = function(){
  $scope.datos_edicion.detalles_indemnizaciones=angular.toJson($scope.datos_iman.detalles_indemnizaciones);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_iman.detalles_indemnizaciones.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_indemnizaciones=tmp;
}
$scope.agregarCampo81 = function(formulario){
  var tmp;
  if($scope.datos_iman.indemnizaciones.es_selector){
    tmp={
      entidad:$scope.datos_iman.indemnizaciones.item.nombre,
      concepto:$scope.datos_iman.indemnizaciones.concepto,
      identificacion:$scope.datos_iman.indemnizaciones.item.identificacion,
      valor:$scope.datos_iman.indemnizaciones.valor,
    }
  }
  else{
    tmp={
      entidad:$scope.datos_iman.indemnizaciones.entidad,
      concepto:$scope.datos_iman.indemnizaciones.concepto,
      identificacion:$scope.datos_iman.indemnizaciones.identificacion,
      valor:$scope.datos_iman.indemnizaciones.valor,
    }
  }
  $scope.datos_iman.detalles_indemnizaciones.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo81 = function(item) {
  var index = $scope.datos_iman.detalles_indemnizaciones.listado.indexOf(item);
  $scope.datos_iman.detalles_indemnizaciones.listado.splice(index, 1);
}
$scope.cambiarDatosCampo81 = function () {
  $scope.datos_iman.indemnizaciones.es_selector=!$scope.datos_iman.indemnizaciones.es_selector;
}////81//////////////////////////////////////////////////////////////////

// --CAmpo 82
$scope.renderizarDatosCampo82 = function () {
  $scope.datos_iman.detalles_retirosfondos=JSON.parse($scope.datos_edicion.detalles_retirosfondos);
  //
  if($scope.datos_iman.detalles_retirosfondos==null ||
    $scope.datos_edicion.detalles_retirosfondos==undefined){
    $scope.datos_iman.detalles_retirosfondos={};
  }
  if($scope.datos_iman.detalles_retirosfondos.listado==null ||
    $scope.datos_iman.detalles_retirosfondos.listado==undefined){
    $scope.datos_iman.detalles_retirosfondos.listado=[];
  }
}
$scope.abrirCampo82 = function(){
  var page='app/pages/certificados/edicion/modales/iman/retirosfondos.html';
  var size='lg';
  $scope.modales.retirosfondos=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarIman();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo82 = function(){
  $scope.datos_edicion.detalles_retirosfondos=angular.toJson($scope.datos_iman.detalles_retirosfondos);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_iman.detalles_retirosfondos.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_retirosfondos=tmp;
}
$scope.agregarCampo82 = function(formulario){
  var tmp={
    entidad:$scope.datos_iman.retirosfondos.item.nombre,
    concepto:$scope.datos_iman.retirosfondos.concepto,
    identificacion:$scope.datos_iman.retirosfondos.item.identificacion,
    valor:$scope.datos_iman.retirosfondos.valor,
  }
  $scope.datos_iman.detalles_retirosfondos.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo82 = function(item) {
  var index = $scope.datos_iman.detalles_retirosfondos.listado.indexOf(item);
  $scope.datos_iman.detalles_retirosfondos.listado.splice(index, 1);
}////82//////////////////////////////////////////////////////////////////

// --------------------------------------------------------------------
/////renderizar Det renta gravable alternativa///////
$scope.renderizarDatosIman = function(){

  $scope.datos_iman={};
  $scope.datos_iman.indemseguro={};
  $scope.datos_iman.aportesss={};
  $scope.datos_iman.gtrepreexento={};
  $scope.datos_iman.saludnopos={};
  $scope.datos_iman.desastreycal={};
  $scope.datos_iman.empleadodomestico={};
  $scope.datos_iman.bienesenaje={};
  $scope.datos_iman.indemnizaciones={};
  $scope.datos_iman.retirosfondos={};

  // //----//
  $scope.renderizarDatosCampo72();
  $scope.renderizarDatosCampo73();
  $scope.renderizarDatosCampo74();
  $scope.renderizarDatosCampo75();
  $scope.renderizarDatosCampo76();
  $scope.renderizarDatosCampo77();
  $scope.renderizarDatosCampo78();
  $scope.renderizarDatosCampo79();
  $scope.renderizarDatosCampo80();
  $scope.renderizarDatosCampo81();
  $scope.renderizarDatosCampo82();
}
// -------------------------------------------------------------

$scope.actualizarIman = function(){
  $scope.renderizarDatosCampo72();
  $scope.renderizarDatosCampo73();
  $scope.actualizarCampo74();
  $scope.actualizarCampo75();
  $scope.actualizarCampo76();
  $scope.actualizarCampo77();
  $scope.actualizarCampo78();
  $scope.actualizarCampo79();
  $scope.actualizarCampo80();
  $scope.actualizarCampo81();
  $scope.actualizarCampo82();


  //
  //totales ingresos obtenidos periodo gravable 72  (Si renglones 33 + 35 son iguals o superiores al 80% de renglon 40: sume 33+35+36,37,38,39)
  // if ((parseFloat($scope.datos_edicion.total_recibidos_empleados_ingresos)+
  //   parseFloat($scope.datos_edicion.total_honorarios)) >= (parseFloat($scope.datos_edicion.total_ingresos_recibidos_renta)*0.8)) {
  //
  //     $scope.datos_edicion.total_iman_ingresos_periodo_gravable = parseFloat($scope.datos_edicion.total_recibidos_empleados_ingresos) +
  //     parseFloat($scope.datos_edicion.total_honorarios) +
  //     parseFloat($scope.datos_edicion.total_intereses) +
  //     parseFloat($scope.datos_edicion.total_dividendos) +
  //     parseFloat($scope.datos_edicion.total_otrosetc) +
  //     parseFloat($scope.datos_edicion.total_obtenidosext);
  // }
  // else {
  //   $scope.datos_edicion.total_iman_ingresos_periodo_gravable = 0;
  // }
  // calculo de casilla 83, hace falta la casilla 73
  var tmp = parseFloat($scope.datos_edicion.total_ingresosobtenidosgravables)-
  (
    parseFloat($scope.datos_edicion.total_dividendosparticipaciones)+
    parseFloat($scope.datos_edicion.total_indemseguro)+
    parseFloat($scope.datos_edicion.total_aportesss)+
    parseFloat($scope.datos_edicion.total_gtrepreexento)+
    parseFloat($scope.datos_edicion.total_saludnopos)+
    parseFloat($scope.datos_edicion.total_desastreycal)+
    parseFloat($scope.datos_edicion.total_empleadodomestico)+
    parseFloat($scope.datos_edicion.total_bienesenaje)+
    parseFloat($scope.datos_edicion.total_indemnizaciones)+
    parseFloat($scope.datos_edicion.total_retirosfondos)
  );
  $scope.datos_edicion.total_rentagravablealternativa=tmp;
  if(tmp<0){
    $scope.datos_edicion.total_rentagravablealternativa=0;
  }
  // parseFloat($scope.datos_edicion.total_iman_pago_salud_nopos)+
  // parseFloat($scope.datos_edicion.total_iman_perdida_desastre)+
  // parseFloat($scope.datos_edicion.total_iman_pago_salud_nopos)+
  // parseFloat($scope.datos_edicion.total_iman_empleado_domestico)+
  // parseFloat($scope.datos_edicion.total_iman_bienes_enajenados)+
  // parseFloat($scope.datos_edicion.total_iman_indemnizaciones)+
  // parseFloat($scope.datos_edicion.total_iman_retirosfondos);
}


// //////////////////////////////////////////////////////////////////////////////
//////////////--------------------------/////////////////////////////////////////
// LIQUIDACION PRIVADA//
///////////////////////////////////////////////////////////////////////////////////
// --CAmpo 84
$scope.renderizarDatosCampo84 = function () {
  var uvt_total_renta_liquida=0;
  $scope.datos_edicion.total_impuestorentaliquidagravable=uvt_total_renta_liquida;
  ////console.log("impuesto",  $scope.datos_edicion.total_impuestorentaliquidagravable);
  conexionesWebservices.indicadoresAPI.traeruvtsegunano($scope.ano_actual)
  .then(function (response) {
      if(response.data!=""){
        $scope.datos_rentas.uvtanoactual=response.data.valor;
        uvt_total_renta_liquida=parseFloat($scope.datos_edicion.total_renta_liquida_gravable)
        /parseFloat($scope.datos_rentas.uvtanoactual);
      }
      else {
        uvt_total_renta_liquida=0;
      }
      // ---------------------------------------------------------------------------------
      ////console.log("$scope.datos_rentas.uvtanoactual",$scope.datos_rentas.uvtanoactual);
      ////console.log("uvt_total_renta_liquida",uvt_total_renta_liquida);
      if(uvt_total_renta_liquida>0 && uvt_total_renta_liquida<=1090) {
        uvt_total_renta_liquida=0;
      }
      else if(uvt_total_renta_liquida>1090 && uvt_total_renta_liquida<=1700) {
        uvt_total_renta_liquida=uvt_total_renta_liquida-1090;
        uvt_total_renta_liquida=uvt_total_renta_liquida*0.19;
      }
      else if(uvt_total_renta_liquida>1700 && uvt_total_renta_liquida<=4100) {
        uvt_total_renta_liquida=uvt_total_renta_liquida-1700;
        uvt_total_renta_liquida=uvt_total_renta_liquida*0.28 + 116;
      }
      else if(uvt_total_renta_liquida>4100) {
        uvt_total_renta_liquida=uvt_total_renta_liquida-4100;
        uvt_total_renta_liquida=uvt_total_renta_liquida*0.33 + 788;
      }
      $scope.datos_edicion.total_impuestorentaliquidagravable=uvt_total_renta_liquida*$scope.datos_rentas.uvtanoactual;
      ////console.log("impuesto",  $scope.datos_edicion.total_impuestorentaliquidagravable);
      $scope.renderizarDatosCampo91();
  }, function (response) {
  }, function (evt) {
  });
}
// $scope.abrirCampo84 = function(){
//   var page='app/pages/certificados/edicion/modales/liquidacion/impuestorentaliquidagravable.html';
//   var size='lg';
//   $scope.modales.impuestorentaliquidagravable=$uibModal.open({
//     animation: true,
//     templateUrl: page,
//     size: size,
//     scope: $scope,
//     resolve: {
//       items: function () {
//         return $scope.items;
//       }
//     }
//   }).closed.then(function(){
//     $scope.actualizarLiquidacion();
//     $scope.calcularTotal();
//   });
// }
// $scope.actualizarCampo84 = function(){
//   $scope.datos_edicion.detalles_impuestorentaliquidagravable=angular.toJson($scope.datos_liquidacion.detalles_impuestorentaliquidagravable);
//   //
//   // $scope.datos_edicion.total_honorarios=parseFloat(0);
//   var tmp=0;
//   angular.forEach($scope.datos_liquidacion.detalles_impuestorentaliquidagravable.listado, function(item) {
//     tmp=tmp + parseFloat(item.valor);
//   });
//   $scope.datos_edicion.total_impuestorentaliquidagravable=tmp;
// }
// $scope.agregarCampo84 = function(formulario){
//   var tmp={
//     concepto:$scope.datos_liquidacion.impuestorentaliquidagravable.concepto,
//     valor:$scope.datos_liquidacion.impuestorentaliquidagravable.valor,
//   }
//   $scope.datos_liquidacion.detalles_impuestorentaliquidagravable.listado.push(tmp);
//   $scope.limiarFormulario(formulario);
// }
// $scope.eliminarCampo84 = function(item) {
//   var index = $scope.datos_liquidacion.detalles_impuestorentaliquidagravable.listado.indexOf(item);
//   $scope.datos_liquidacion.detalles_impuestorentaliquidagravable.listado.splice(index, 1);
// }////84///////////////////
// --CAmpo 85
$scope.renderizarDatosCampo85 = function () {
  $scope.datos_liquidacion.detalles_impuestoiman=JSON.parse($scope.datos_edicion.detalles_impuestoiman);
  //
  if($scope.datos_liquidacion.detalles_impuestoiman==null ||
    $scope.datos_edicion.detalles_impuestoiman==undefined){
    $scope.datos_liquidacion.detalles_impuestoiman={};
  }
  if($scope.datos_liquidacion.detalles_impuestoiman.listado==null ||
    $scope.datos_liquidacion.detalles_impuestoiman.listado==undefined){
    $scope.datos_liquidacion.detalles_impuestoiman.listado=[];
  }
}
$scope.abrirCampo85 = function(){
  var page='app/pages/certificados/edicion/modales/liquidacion/impuestoiman.html';
  var size='lg';
  $scope.modales.impuestoiman=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarLiquidacion();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo85 = function(){
  $scope.datos_edicion.detalles_impuestoiman=angular.toJson($scope.datos_liquidacion.detalles_impuestoiman);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_liquidacion.detalles_impuestoiman.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_impuestoiman=tmp;
}
$scope.agregarCampo85 = function(formulario){
  var tmp={
    concepto:$scope.datos_liquidacion.impuestoiman.concepto,
    valor:$scope.datos_liquidacion.impuestoiman.valor,
  }
  $scope.datos_liquidacion.detalles_impuestoiman.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo85 = function(item) {
  var index = $scope.datos_liquidacion.detalles_impuestoiman.listado.indexOf(item);
  $scope.datos_liquidacion.detalles_impuestoiman.listado.splice(index, 1);
}////85///////////////////
// --CAmpo 86
$scope.renderizarDatosCampo86 = function () {
  $scope.datos_liquidacion.detalles_impuexteriorabc=JSON.parse($scope.datos_edicion.detalles_impuexteriorabc);
  //
  if($scope.datos_liquidacion.detalles_impuexteriorabc==null ||
    $scope.datos_edicion.detalles_impuexteriorabc==undefined){
    $scope.datos_liquidacion.detalles_impuexteriorabc={};
  }
  if($scope.datos_liquidacion.detalles_impuexteriorabc.listado==null ||
    $scope.datos_liquidacion.detalles_impuexteriorabc.listado==undefined){
    $scope.datos_liquidacion.detalles_impuexteriorabc.listado=[];
  }
}
$scope.abrirCampo86 = function(){
  var page='app/pages/certificados/edicion/modales/liquidacion/impuexteriorabc.html';
  var size='lg';
  $scope.modales.impuexteriorabc=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarLiquidacion();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo86 = function(){
  $scope.datos_edicion.detalles_impuexteriorabc=angular.toJson($scope.datos_liquidacion.detalles_impuexteriorabc);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_liquidacion.detalles_impuexteriorabc.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_impuexteriorabc=tmp;
}
$scope.agregarCampo86 = function(formulario){
  var tmp={
    entidad:$scope.datos_liquidacion.impuexteriorabc.item.nombre,
    concepto:$scope.datos_liquidacion.impuexteriorabc.concepto,
    identificacion:$scope.datos_liquidacion.impuexteriorabc.item.identificacion,
    valor:$scope.datos_liquidacion.impuexteriorabc.valor,
  }
  $scope.datos_liquidacion.detalles_impuexteriorabc.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo86 = function(item) {
  var index = $scope.datos_liquidacion.detalles_impuexteriorabc.listado.indexOf(item);
  $scope.datos_liquidacion.detalles_impuexteriorabc.listado.splice(index, 1);
}////86//////////////////////////////////////////////////////////////////

// --CAmpo 87
$scope.renderizarDatosCampo87 = function () {
  $scope.datos_liquidacion.detalles_impuexteriord=JSON.parse($scope.datos_edicion.detalles_impuexteriord);
  //
  if($scope.datos_liquidacion.detalles_impuexteriord==null ||
    $scope.datos_edicion.detalles_impuexteriord==undefined){
    $scope.datos_liquidacion.detalles_impuexteriord={};
  }
  if($scope.datos_liquidacion.detalles_impuexteriord.listado==null ||
    $scope.datos_liquidacion.detalles_impuexteriord.listado==undefined){
    $scope.datos_liquidacion.detalles_impuexteriord.listado=[];
  }
}
$scope.abrirCampo87 = function(){
  var page='app/pages/certificados/edicion/modales/liquidacion/impuexteriord.html';
  var size='lg';
  $scope.modales.impuexteriord=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarLiquidacion();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo87 = function(){
  $scope.datos_edicion.detalles_impuexteriord=angular.toJson($scope.datos_liquidacion.detalles_impuexteriord);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_liquidacion.detalles_impuexteriord.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_impuexteriord=tmp;
}
$scope.agregarCampo87 = function(formulario){
  var tmp={
    entidad:$scope.datos_liquidacion.impuexteriord.item.nombre,
    concepto:$scope.datos_liquidacion.impuexteriord.concepto,
    identificacion:$scope.datos_liquidacion.impuexteriord.item.identificacion,
    valor:$scope.datos_liquidacion.impuexteriord.valor,
  }
  $scope.datos_liquidacion.detalles_impuexteriord.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo87 = function(item) {
  var index = $scope.datos_liquidacion.detalles_impuexteriord.listado.indexOf(item);
  $scope.datos_liquidacion.detalles_impuexteriord.listado.splice(index, 1);
}////87//////////////////////////////////////////////////////////////////

// --CAmpo 88
$scope.renderizarDatosCampo88 = function () {
  $scope.datos_liquidacion.detalles_impuexteriordistinto=JSON.parse($scope.datos_edicion.detalles_impuexteriordistinto);
  //
  if($scope.datos_liquidacion.detalles_impuexteriordistinto==null ||
    $scope.datos_edicion.detalles_impuexteriordistinto==undefined){
    $scope.datos_liquidacion.detalles_impuexteriordistinto={};
  }
  if($scope.datos_liquidacion.detalles_impuexteriordistinto.listado==null ||
    $scope.datos_liquidacion.detalles_impuexteriordistinto.listado==undefined){
    $scope.datos_liquidacion.detalles_impuexteriordistinto.listado=[];
  }
}
$scope.abrirCampo88 = function(){
  var page='app/pages/certificados/edicion/modales/liquidacion/impuexteriordistinto.html';
  var size='lg';
  $scope.modales.impuexteriordistinto=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarLiquidacion();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo88 = function(){
  $scope.datos_edicion.detalles_impuexteriordistinto=angular.toJson($scope.datos_liquidacion.detalles_impuexteriordistinto);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_liquidacion.detalles_impuexteriordistinto.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_impuexteriordistinto=tmp;
}
$scope.agregarCampo88 = function(formulario){
  var tmp={
    entidad:$scope.datos_liquidacion.impuexteriordistinto.item.nombre,
    concepto:$scope.datos_liquidacion.impuexteriordistinto.concepto,
    identificacion:$scope.datos_liquidacion.impuexteriordistinto.item.identificacion,
    valor:$scope.datos_liquidacion.impuexteriordistinto.valor,
  }
  $scope.datos_liquidacion.detalles_impuexteriordistinto.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo88 = function(item) {
  var index = $scope.datos_liquidacion.detalles_impuexteriordistinto.listado.indexOf(item);
  $scope.datos_liquidacion.detalles_impuexteriordistinto.listado.splice(index, 1);
}////88//////////////////////////////////////////////////////////////////

// --CAmpo 89
$scope.renderizarDatosCampo89 = function () {
  $scope.datos_liquidacion.detalles_otrosdesc=JSON.parse($scope.datos_edicion.detalles_otrosdesc);
  //
  if($scope.datos_liquidacion.detalles_otrosdesc==null ||
    $scope.datos_edicion.detalles_otrosdesc==undefined){
    $scope.datos_liquidacion.detalles_otrosdesc={};
  }
  if($scope.datos_liquidacion.detalles_otrosdesc.listado==null ||
    $scope.datos_liquidacion.detalles_otrosdesc.listado==undefined){
    $scope.datos_liquidacion.detalles_otrosdesc.listado=[];
  }
}
$scope.abrirCampo89 = function(){
  var page='app/pages/certificados/edicion/modales/liquidacion/otrosdesc.html';
  var size='lg';
  $scope.modales.otrosdesc=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarLiquidacion();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo89 = function(){
  $scope.datos_edicion.detalles_otrosdesc=angular.toJson($scope.datos_liquidacion.detalles_otrosdesc);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_liquidacion.detalles_otrosdesc.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_otrosdesc=tmp;
}
$scope.agregarCampo89 = function(formulario){
  var tmp={
    entidad:$scope.datos_liquidacion.otrosdesc.item.nombre,
    concepto:$scope.datos_liquidacion.otrosdesc.concepto,
    identificacion:$scope.datos_liquidacion.otrosdesc.item.identificacion,
    valor:$scope.datos_liquidacion.otrosdesc.valor,
  }
  $scope.datos_liquidacion.detalles_otrosdesc.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo89 = function(item) {
  var index = $scope.datos_liquidacion.detalles_otrosdesc.listado.indexOf(item);
  $scope.datos_liquidacion.detalles_otrosdesc.listado.splice(index, 1);
}////89//////////////////////////////////////////////////////////////////
//--CAmpo 90
$scope.renderizarDatosCampo90 = function () {
  $scope.datos_edicion.total_descuentostributarios=parseFloat($scope.datos_edicion.total_impuexteriorabc) +
  parseFloat($scope.datos_edicion.total_impuexteriord) +
  parseFloat($scope.datos_edicion.total_impuexteriordistinto) +
  parseFloat($scope.datos_edicion.total_otrosdesc);
}
//--CAmpo 91
$scope.renderizarDatosCampo91 = function () {
  var tmp=parseFloat($scope.datos_edicion.total_impuestorentaliquidagravable);
  console.log("tmp ants",tmp);
  if(parseFloat($scope.datos_edicion.total_impuestorentaliquidagravable)
    <parseFloat($scope.datos_edicion.total_impuestoiman)){
    tmp=parseFloat($scope.datos_edicion.total_impuestoiman);
    console.log("tmp des",tmp);
  }
  $scope.datos_edicion.total_impuestonetorenta=tmp
  -parseFloat($scope.datos_edicion.total_descuentostributarios);
  $scope.renderizarDatosCampo94();
}
$scope.renderizarDatosCampo92 = function () {
  var tmp;
  tmp=parseFloat($scope.datos_edicion.total_gananciasocasionalesgravables)*0.1;
  $scope.datos_edicion.total_impuestogananciaocasional=parseFloat(tmp);
  if(tmp<0){
    $scope.datos_edicion.total_impuestogananciaocasional=0;
  }
}
// --CAmpo 93
$scope.renderizarDatosCampo93 = function () {
  $scope.datos_liquidacion.detalles_impextocasional=JSON.parse($scope.datos_edicion.detalles_impextocasional);
  //
  if($scope.datos_liquidacion.detalles_impextocasional==null ||
    $scope.datos_edicion.detalles_impextocasional==undefined){
    $scope.datos_liquidacion.detalles_impextocasional={};
  }
  if($scope.datos_liquidacion.detalles_impextocasional.listado==null ||
    $scope.datos_liquidacion.detalles_impextocasional.listado==undefined){
    $scope.datos_liquidacion.detalles_impextocasional.listado=[];
  }
}
$scope.abrirCampo93 = function(){
  var page='app/pages/certificados/edicion/modales/liquidacion/impextocasional.html';
  var size='lg';
  $scope.modales.impextocasional=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarLiquidacion();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo93 = function(){
  $scope.datos_edicion.detalles_impextocasional=angular.toJson($scope.datos_liquidacion.detalles_impextocasional);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_liquidacion.detalles_impextocasional.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_impextocasional=tmp;
}
$scope.agregarCampo93 = function(formulario){
  var tmp={
    entidad:$scope.datos_liquidacion.impextocasional.item.nombre,
    concepto:$scope.datos_liquidacion.impextocasional.concepto,
    identificacion:$scope.datos_liquidacion.impextocasional.item.identificacion,
    valor:$scope.datos_liquidacion.impextocasional.valor,
  }
  $scope.datos_liquidacion.detalles_impextocasional.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo93 = function(item) {
  var index = $scope.datos_liquidacion.detalles_impextocasional.listado.indexOf(item);
  $scope.datos_liquidacion.detalles_impextocasional.listado.splice(index, 1);
}////93//////////////////////////////////////////////////////////////////
$scope.renderizarDatosCampo94 = function () {
  var tmp=parseFloat($scope.datos_edicion.total_impuestonetorenta) + parseFloat($scope.datos_edicion.total_impuestogananciaocasional) -
  parseFloat($scope.datos_edicion.total_impextocasional);
  $scope.datos_edicion.total_impuestoacargo=tmp;
  if(tmp<0){
    $scope.datos_edicion.total_impuestoacargo=0;
  }
  $scope.renderizarDatosCampo99();
  $scope.renderizarDatosCampo101();
  $scope.renderizarDatosCampo102();
}
$scope.renderizarDatosCampo95 = function () {
  if($scope.certificadosInmediatamenteAnterior!=null){
      $scope.datos_edicion.total_liquidacion_anticipo_renta_ano_anterior=parseFloat($scope.certificadosInmediatamenteAnterior.anticipo_rentagravable);
  }
  else{
    $scope.datos_edicion.total_liquidacion_anticipo_renta_ano_anterior=0;
  }
  $scope.renderizarDatosCampo101();
  $scope.renderizarDatosCampo102();
}
$scope.renderizarDatosCampo96 = function () {
  if($scope.certificadosInmediatamenteAnteriorAnterior!=null){
      $scope.datos_edicion.total_saldo_a_favor_anterior_anterior=parseFloat($scope.certificadosInmediatamenteAnteriorAnterior.total_saldo_favor);
  }
  else{
    $scope.datos_edicion.total_saldo_a_favor_anterior_anterior=0;
  }
  $scope.renderizarDatosCampo101();
  $scope.renderizarDatosCampo102();
}
// ---------------------------
// --CAmpo 97
// ---------------------------
$scope.renderizarDatosCampo97 = function () {
  $scope.datos_liquidacion.detalles_retencionesanoanterior=JSON.parse($scope.datos_edicion.detalles_retencionesanoanterior);
  //
  if($scope.datos_liquidacion.detalles_retencionesanoanterior==null ||
    $scope.datos_edicion.detalles_retencionesanoanterior==undefined){
    $scope.datos_liquidacion.detalles_retencionesanoanterior={};
  }
  if($scope.datos_liquidacion.detalles_retencionesanoanterior.listado==null ||
    $scope.datos_liquidacion.detalles_retencionesanoanterior.listado==undefined){
    $scope.datos_liquidacion.detalles_retencionesanoanterior.listado=[];
  }
  $scope.datos_liquidacion.retencionesanoanterior.es_selector=false;
  $scope.renderizarDatosCampo101();
  $scope.renderizarDatosCampo102();
}
$scope.cambiarDatosCampo97 = function () {
  $scope.datos_liquidacion.retencionesanoanterior.es_selector=!$scope.datos_liquidacion.retencionesanoanterior.es_selector;
}
$scope.abrirCampo97 = function(){
  var page='app/pages/certificados/edicion/modales/liquidacion/retencionesanoanterior.html';
  var size='lg';
  $scope.modales.retencionesanoanterior=$uibModal.open({
    animation: true,
    templateUrl: page,
    size: size,
    scope: $scope,
    resolve: {
      items: function () {
        return $scope.items;
      }
    }
  }).closed.then(function(){
    $scope.actualizarLiquidacion();
    $scope.calcularTotal();
  });
}
$scope.actualizarCampo97 = function(){
  $scope.datos_edicion.detalles_retencionesanoanterior=angular.toJson($scope.datos_liquidacion.detalles_retencionesanoanterior);
  //
  // $scope.datos_edicion.total_honorarios=parseFloat(0);
  var tmp=0;
  angular.forEach($scope.datos_liquidacion.detalles_retencionesanoanterior.listado, function(item) {
    tmp=tmp + parseFloat(item.valor);
  });
  $scope.datos_edicion.total_retencionesanoanterior=tmp;
  $scope.renderizarDatosCampo98();
  $scope.renderizarDatosCampo99();
  $scope.renderizarDatosCampo101();
  $scope.renderizarDatosCampo102();
}
$scope.agregarCampo97 = function(formulario){
  var tmp;
  if($scope.datos_liquidacion.retencionesanoanterior.es_selector){
    tmp={
      entidad:$scope.datos_liquidacion.retencionesanoanterior.item.nombre,
      concepto:$scope.datos_liquidacion.retencionesanoanterior.concepto,
      identificacion:$scope.datos_liquidacion.retencionesanoanterior.item.identificacion,
      valor:$scope.datos_liquidacion.retencionesanoanterior.valor,
    }
  }
  else{
    tmp={
      entidad:$scope.datos_liquidacion.retencionesanoanterior.entidad,
      concepto:$scope.datos_liquidacion.retencionesanoanterior.concepto,
      identificacion:$scope.datos_liquidacion.retencionesanoanterior.identificacion,
      valor:$scope.datos_liquidacion.retencionesanoanterior.valor,
    }
  }
  $scope.datos_liquidacion.detalles_retencionesanoanterior.listado.push(tmp);
  $scope.limiarFormulario(formulario);
}
$scope.eliminarCampo97 = function(item) {
  var index = $scope.datos_liquidacion.detalles_retencionesanoanterior.listado.indexOf(item);
  $scope.datos_liquidacion.detalles_retencionesanoanterior.listado.splice(index, 1);
}////97//////////////////////////////////////////////////////////////////
$scope.renderizarDatosCampo98 = function () {
  // Opción 1
  var tmp=$scope.datos_edicion.total_impuestonetorenta*0.75;
  tmp=tmp-$scope.datos_edicion.total_retencionesanoanterior;
  var opcion1=tmp;
  if(tmp<0){
    opcion1=0;
  }
  // Opción 2
  var opcion2;
  var tmp1=$scope.datos_edicion.total_impuestonetorenta;
  if($scope.certificadosInmediatamenteAnterior!=null){
      tmp1=tmp1+parseFloat($scope.certificadosInmediatamenteAnterior.total_impuestonetorenta);
      tmp1=tmp1/2;
      tmp1=tmp1*0.75;
      opcion2=tmp1-$scope.datos_edicion.total_retencionesanoanterior;
      if(opcion2<0){
        opcion2=0;
      }
  }
  else{
    opcion2=0;
  }
  $scope.datos_edicion.anticipo_rentagravable=opcion2;
  if(opcion1<=opcion2){
    $scope.datos_edicion.anticipo_rentagravable=opcion1;
  }
  $scope.renderizarDatosCampo101();
  $scope.renderizarDatosCampo102();
}
$scope.renderizarDatosCampo99 = function () {
  var tmp=parseFloat($scope.datos_edicion.total_impuestoacargo)+
  parseFloat($scope.datos_edicion.anticipo_rentagravable)-
  parseFloat($scope.datos_edicion.total_liquidacion_anticipo_renta_ano_anterior)-
  parseFloat($scope.datos_edicion.total_saldo_a_favor_anterior_anterior)-
  parseFloat($scope.datos_edicion.total_retencionesanoanterior);
  $scope.datos_edicion.total_saldopagarimpuesto=tmp;
  console.log("99",tmp);
  if(tmp<0){
    $scope.datos_edicion.total_saldopagarimpuesto=0;
  }
}
$scope.renderizarDatosCampo101 = function () {
  var tmp=parseFloat($scope.datos_edicion.total_impuestoacargo)+
  parseFloat($scope.datos_edicion.anticipo_rentagravable)+
  parseFloat($scope.datos_edicion.total_sanciones)-
  parseFloat($scope.datos_edicion.total_liquidacion_anticipo_renta_ano_anterior)-
  parseFloat($scope.datos_edicion.total_saldo_a_favor_anterior_anterior)-
  parseFloat($scope.datos_edicion.total_retencionesanoanterior);
  $scope.datos_edicion.total_saldo_pagar=tmp;
  if(tmp<0){
    $scope.datos_edicion.total_saldo_pagar=0;
  }
}
$scope.renderizarDatosCampo102 = function () {
  var tmp=parseFloat($scope.datos_edicion.total_liquidacion_anticipo_renta_ano_anterior)+
  parseFloat($scope.datos_edicion.total_saldo_a_favor_anterior_anterior)+
  parseFloat($scope.datos_edicion.total_retencionesanoanterior)-
  parseFloat($scope.datos_edicion.total_impuestoacargo)-
  parseFloat($scope.datos_edicion.anticipo_rentagravable)-
  parseFloat($scope.datos_edicion.total_sanciones);
  $scope.datos_edicion.total_saldo_favor=tmp;
  if(tmp<0){
    $scope.datos_edicion.total_saldo_favor=0;
  }
}
// --------------------------------------------------------------------
/////renderizar liquidacion///////
$scope.renderizarDatosLiquidacion = function(){

  $scope.datos_liquidacion={};
  $scope.datos_liquidacion.impuestorentaliquidagravable={};
  $scope.datos_liquidacion.impuexteriorabc={};
  $scope.datos_liquidacion.impuexteriord={};
  $scope.datos_liquidacion.impuexteriordistinto={};
  $scope.datos_liquidacion.otrosdesc={};
  $scope.datos_liquidacion.impextocasional={};
  $scope.datos_liquidacion.retencionesanoanterior={};
  $scope.datos_liquidacion.impuestoiman={};


  // //----//
  $scope.renderizarDatosCampo84();
  $scope.renderizarDatosCampo85();
  $scope.renderizarDatosCampo86();
  $scope.renderizarDatosCampo87();
  $scope.renderizarDatosCampo88();
  $scope.renderizarDatosCampo89();
  $scope.renderizarDatosCampo91();
  $scope.renderizarDatosCampo92();
  $scope.renderizarDatosCampo93();
  $scope.renderizarDatosCampo94();
  $scope.renderizarDatosCampo95();
  $scope.renderizarDatosCampo96();
  $scope.renderizarDatosCampo97();
  $scope.renderizarDatosCampo98();
  $scope.renderizarDatosCampo99();
  $scope.renderizarDatosCampo101();
  $scope.renderizarDatosCampo102();
}
// -------------------------------------------------------------

$scope.actualizarLiquidacion = function(){
  $scope.actualizarCampo85();
  $scope.renderizarDatosCampo84();
  $scope.actualizarCampo86();
  $scope.actualizarCampo87();
  $scope.actualizarCampo88();
  $scope.actualizarCampo89();
  $scope.renderizarDatosCampo90();
  $scope.renderizarDatosCampo91();
  $scope.renderizarDatosCampo92();
  $scope.actualizarCampo93();
  $scope.renderizarDatosCampo94();
  $scope.renderizarDatosCampo95();
  $scope.actualizarCampo97();
  $scope.renderizarDatosCampo98();
  $scope.renderizarDatosCampo99();
  $scope.renderizarDatosCampo101();
  $scope.renderizarDatosCampo102();
  // calculo de casilla 90,
  // $scope.datos_edicion.total_liquidacion_descuentos_tributarios = parseFloat($scope.datos_edicion.total_liquidacion_impuestos_exterior_abc)+
  // parseFloat($scope.datos_edicion.total_liquidacion_impuestos_exterior_d)+
  // parseFloat($scope.datos_edicion.total_liquidacion_impuestos_exterior_distinto)+
  // parseFloat($scope.datos_edicion.total_liquidacion_otros_desc);

}




/////////////////////////////////////////////////////////

// ultuimo total, total general, este es el ultimo valor del formulario de la dian 210
    //-----Calcular Total
    $scope.calcularTotal = function(){
      // $scope.datos_edicion.pago_total=parseFloat($scope.datos_edicion.total_patrimonio_liquido) +
      // parseFloat($scope.datos_edicion.total_ingresos_neto) +
      // parseFloat($scope.datos_edicion.total_costos_y_deducciones) +
      // parseFloat($scope.datos_edicion.total_renta_liquida_gravable) +
      // parseFloat($scope.datos_edicion.total_gananciasocasionalesgravables) +
      // parseFloat($scope.datos_edicion.total_gananciasocasionalesgravables);
    }
    // ---------------------------------------------------------------------------
    $scope.regresarAListado=function(){
      $state.go("certificados.principal.listado");
    }
    $scope.actualizarCertificado = function(item) {
      // console.log("Datos a enviar",item);
      conexionesWebservices.certificadosAPI.modificarcertificado(item)
      .then(function (response) {
        if(response.data!=null){
          if(response.data.consulta_exitosa){
            // console.log("Respuesta datos",response.data);
            $scope.showSuccessMsg("Certificado actualizado");
            var notificacion={
              id_asociacion:response.data.datos.id,
              tipo:1,//Certificado
              id_implicado:response.data.datos.id_cliente,
              fecha_notificacion: new Date()
            }
            $scope.$emit('agregarNotificacion',notificacion);
            // Llama función para gnerar notificación asociada
            // $scope.generarNotificaciones($scope.);
          }
          else{
            $scope.showErrorMsg("Error al actualizar certificado, intente de nuevo");
          }
        }
        else {
        }
      }, function (response) {
        if (response.status > 0)
          $scope.errorMsg = response.status + ': ' + response.data;
      }, function (evt) {
        // Math.min is to fix IE which reports 200% sometimes
        $scope.datos_edicion.foto.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
      });
    };
    //Notificaciones
    $scope.showSuccessMsg = function(texto) {
      toastr.success(texto);
    };

    $scope.showInfoMsg = function(texto) {
      toastr.info(texto, 'Información');
    };

    $scope.showErrorMsg = function(texto) {
      toastr.error(texto, 'Error');
    };

    $scope.showWarningMsg = function(texto) {
      toastr.warning(texto, 'Alerta');
    };
    // Funciones extras necesitadas!!
    $scope.traerDatosBanco = function (cantidad) {
      conexionesWebservices.bancosAPI.traerbancos(cantidad)
      .then(function (response) {
            if(response.data!=null){
              $scope.datos_patrimonio.bancos.listado= response.data;
            }
            else {
              $scope.datos_patrimonio.bancos.listado= null;
            }
            ////console.log("Por acá",response);
            $scope.traerDatosEntidad("Todos");
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
            $scope.traerDatosEntidad("Todos");
            $scope.datos_patrimonio.bancos.listado= null;
        });
    };
    $scope.traerDatosEntidad = function (cantidad) {
      conexionesWebservices.entidadesAPI.traerentidades(cantidad)
      .then(function (response) {
            if(response.data!=null){
              $scope.datos_patrimonio.entidades= response.data;
            }
            else {
              $scope.datos_patrimonio.entidades= null;
            }
            $scope.traerTRM();
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
            $scope.traerTRM();
            $scope.datos_patrimonio.entidades= null;
        });
    };
    $scope.traerTRM = function () {
      conexionesWebservices.indicadoresAPI.traerindicadorPorId(1)//1 es el Dolar
      .then(function (response) {
            if(response.data!=null){
              //////console.log("Dolar",response.data);
              $scope.datos_patrimonio.inversiones_exterior.valor_usd= parseFloat(response.data.valor);
            }
            else {
              $scope.datos_patrimonio.inversiones_exterior.valor_usd= 0;
            }
            //Porcentaje Renta Presuntiva
            $scope.traerPorcentajeRentaPresuntiva();
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
            $scope.traerPorcentajeRentaPresuntiva();
            $scope.datos_patrimonio.inversiones_exterior.valor_usd= 0;
        });
    };
    $scope.traerPorcentajeRentaPresuntiva = function () {
      // var tmp = new Date($scope.datos_edicion.ano_declaracion_ok+" GMT-0500");
      // var ano_actual=tmp.getFullYear();
      conexionesWebservices.indicadoresAPI.traerPorcentajeRentaPresuntivaSegunAno($scope.ano_actual)//
      .then(function (response) {
            if(response.data!=null){
              //////console.log("Dolar",response.data);
              $scope.datos_rentas.detalles_rentapresuntiva.valor_prp = parseFloat(response.data.valor);
            }
            else {
              $scope.datos_rentas.detalles_rentapresuntiva.valor_prp= 0;
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
            $scope.datos_rentas.detalles_rentapresuntiva.valor_prp= 0;
        });
    };
    //
    $scope.traerTiposDeCuenta = function () {
      $scope.datos_patrimonio.tipos_cuenta = [{
        id:1,
        nombre:'Ahorros',
        },
        {
          id:2,
          nombre:'Corriente',
        }
      ];
      //////console.log("Tipos cuenta",$scope.datos_patrimonio.tipos_cuenta);
    };
  }//Fin del controller

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.certificados')
    .controller('CertificadosMainCtrl', CertificadosMainCtrl);

  /** @ngInject */
  function CertificadosMainCtrl($scope, toastr, fileReader, $timeout,moment, $filter,$rootScope,$state,datosApp,conexionesWebservices,editableOptions, editableThemes,$uibModal) {
    //Definiciones
    $scope.datos_certificado={};

  }//Fin del controller

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.certificados')
    .controller('CertificadosPageCtrl', CertificadosPageCtrl);

  /** @ngInject */
  function CertificadosPageCtrl($scope, toastr, permisosUsuario,fileReader, $timeout,moment, $filter,$rootScope,$state,datosApp,conexionesWebservices,editableOptions, editableThemes,$uibModal) {
    //Definiciones
    // ////console.log("d",permisosUsuario);
    $scope.esAdmin=$rootScope.$datosLogin.datos.id_perfil_administrativo;
    $scope.idUsuario=$rootScope.$datosLogin.datos.id;
    $scope.datos_certificado={};
    $scope.datos_certificado.id_perfil_administrativo=parseFloat(permisosUsuario.id_perfil_administrativo);
    $scope.datos_certificado.certificado={};
    $scope.datos_certificado.smartTablePageSize = 10;
    $scope.datos_certificado.quantityRows=100;
    // ------------------------------------
    $scope.datosApp=datosApp;
    $scope.edicionForm={};
    $scope.datos_edicion={};
    $scope.datos_edicion.confirmar_password_invalid=false;
    // ------------------------------------
    $scope.adicionForm={};
    $scope.datos_adicion={};
    $scope.datos_adicion.confirmar_password_invalid=false;
    // ------------------------------------
    // $scope.rowform.$cancel();
    //Funciones
    //DEfiniciones CAlendario-------------------------------------
    $scope.fijarFechaHoy = function() {
      //console.log("acá fecha hoy");
    $scope.datos_adicion.ano_declaracion = new Date();
  };
  $scope.clear = function() {
    $scope.datos_adicion.ano_declaracion = null;
  };

  $scope.dateOptions = {
    dateDisabled: disabled,
    formatYear: 'yyyy',
    // maxDate: new Date(2020, 5, 22),
    // minDate: new Date(),
    maxMode:'year',
    minMode:'year',
    startingDay: 1
  };

  // Disable weekend selection
  function disabled(data) {
    var date = data.date,
      mode = data.mode;
    return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
  }
  $scope.popup2 = {
    opened: false
  };
  $scope.open2 = function() {
    $scope.popup2.opened = true;
  };
  $scope.formats = ['yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
  $scope.format = $scope.formats[0];
  $scope.altInputFormats = ['M!/d!/yyyy'];
    //-------------------------------------------------------------
    $scope.traerListadoPorRegistros=function(){
      $scope.traerDatosCertificado($scope.datos_certificado.quantityRows);
    }
    $scope.grabarCambios= function(index,item) {
      item.id=$scope.datos_certificado.listado[index].id;
      conexionesWebservices.certificadosAPI.modificarcertificado(item)
      .then(function (response) {
            if(response.data!=null){
              $scope.showSuccessMsg("Certificado actualizado");
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.confirmarEliminacionCertificado=function(){
      $scope.datos_certificado.listado.splice($scope.datos_certificado.index_certificado_eliminacion, 1);
      conexionesWebservices.certificadosAPI.eliminarcertificado($scope.datos_certificado.id_certificado_eliminacion)
      .then(function (response) {
            if(response.data!=null){
              $scope.showInfoMsg("Certificado eliminado");
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    }
    $scope.borrarCertificado = function(index) {
      $scope.datos_certificado.numero_formulario=$scope.datos_certificado.listado[index].numero_formulario;
      $scope.datos_certificado.index_certificado_eliminacion=index;
      $scope.datos_certificado.id_certificado_eliminacion=$scope.datos_certificado.listado[index].id;
      var page='app/pages/certificados/eliminacionCertificado.html';
      var size='md';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.traerDatosSeccional = function (cantidad) {
      //console.log("acá secciona");
      conexionesWebservices.seccionalesAPI.traerseccionales(cantidad)
      .then(function (response) {
            ////console.log("Respuesta Listado Seccional",response.data);
            if(response.data!=null){
              $scope.datos_certificado.listado_dir_seccional=response.data;
            }
            else {
            }
            $scope.traerListadoClientes("Todos");
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.datosIniciales = function () {
      $scope.$emit('cargarNotificaciones');
      $scope.datos_certificado={};
      $scope.datos_certificado.id_perfil_administrativo=parseFloat(permisosUsuario.id_perfil_administrativo);
      $scope.datos_certificado.smartTablePageSize = 10;
      $scope.datos_certificado.quantityRows=100;
      //console.log("probando",$scope.datos_certificado);
      $scope.fijarFechaHoy();
      $scope.traerDatosCertificado("Todos");


      // $scope.$apply();
    }
    $scope.traerListadoClientes = function (cantidad) {
      //console.log("acá clientes");
      conexionesWebservices.clientesAPI.traerclientes(cantidad)
      .then(function (response) {
            if(response.data!=null){
              $scope.datos_certificado.listado_clientes=response.data;
              console.log("clientes",$scope.datos_certificado.listado_clientes);
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.traerDatosCertificado = function (cantidad) {
      //console.log("acá certificados");
      $scope.datos_certificado={};
      $scope.datos_certificado.id_perfil_administrativo=parseFloat(permisosUsuario.id_perfil_administrativo);
      $scope.datos_certificado.smartTablePageSize = 10;
      $scope.datos_certificado.quantityRows=100;
      conexionesWebservices.certificadosAPI.traercertificados(cantidad)
      .then(function (response) {
            if(response.data!=null){
              $scope.datos_certificado.listado=response.data;
              $scope.datos_certificado.safe_listado=[];
              $scope.datos_certificado.safe_listado=response.data;
              console.log("certificados traídos",response.data);
              // $scope.$apply();
            }
            else {
            }
            $scope.traerDatosSeccional("Todos");
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.abrirEdicion = function (item,sololectura) {
      $scope.datos_edicion=item;
      $state.go("certificados.principal.edicion",{datosEdicion:item,soloLectura:sololectura});
      // var tmp=$filter("filter")($scope.datos_certificado.perfiles_administrativos, {id:item.id_perfil_administrativo});
      // $scope.datos_edicion.perfil_administrativo_objeto=tmp[0];
      // $scope.datos_edicion.foto={};
      // // $scope.datos_edicion.foto.upload
      // var page='app/pages/certificados/edicionCertificado.html';
      // var size='lg';
      // $uibModal.open({
      //   animation: true,
      //   templateUrl: page,
      //   size: size,
      //   scope: $scope,
      //   resolve: {
      //     items: function () {
      //       return $scope.items;
      //     }
      //   }
      // });
    };
    $scope.actualizarCertificado= function(item) {
      conexionesWebservices.certificadosAPI.modificarcertificado(item)
      .then(function (response) {
            if(response.data!=null){
              $scope.showSuccessMsg("Certificado actualizado");
              //console.log("Certificado traído antes de guardado");
              $scope.traerDatosCertificado("Todos");
              //console.log("Certificado traído desués de guardado");
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    // Válida Password
    $scope.validarPassword=function(){
      if($scope.datos_edicion.password != $scope.datos_edicion.confirmar_password) {
        $scope.edicionForm.$invalid=true;
        $scope.datos_edicion.confirmar_password_invalid=true;
      } else {
        $scope.edicionForm.$invalid=false;
        $scope.datos_edicion.confirmar_password_invalid=false;
      }
    }
    $scope.validarPasswordAdicion=function(){
      if($scope.datos_adicion.password != $scope.datos_adicion.confirmar_password) {
        $scope.adicionForm.$invalid=true;
        $scope.datos_adicion.confirmar_password_invalid=true;
      } else {
        $scope.adicionForm.$invalid=false;
        $scope.datos_adicion.confirmar_password_invalid=false;
      }
    }
    //
    $scope.abrirNuevo = function () {
      $scope.datos_adicion={};
      var page='app/pages/certificados/adicionCertificado.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.agregarCertificado= function(item) {
      conexionesWebservices.certificadosAPI.agregarcertificado(item)
      .then(function (response) {
            if(response.data!=null){
              $scope.showSuccessMsg("Certificado agregado");
              //console.log("Certificado traído antes de guardado");
              var notificacion={
                id_asociacion:response.data.datos.id,
                tipo:2,//Certificado agregado
                id_implicado:response.data.datos.listado_clientes.id,
                fecha_notificacion: new Date()
              }
              $scope.$emit('agregarNotificacion',notificacion);
              $scope.traerDatosCertificado("Todos");
              //console.log("Certificado traído después de guardado");
              // $scope.$apply();
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    //Notificaciones
    $scope.showSuccessMsg = function(texto) {
      toastr.success(texto);
    };

    $scope.showInfoMsg = function(texto) {
      toastr.info(texto, 'Información');
    };

    $scope.showErrorMsg = function(texto) {
      toastr.error(texto, 'Error');
    };

    $scope.showWarningMsg = function(texto) {
      toastr.warning(texto, 'Alerta');
    };
  }//Fin del controller

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.clientes')
    .controller('ClientesPageCtrl', ClientesPageCtrl);

  /** @ngInject */
  function ClientesPageCtrl($scope, toastr, fileReader, $timeout,moment, $filter,$rootScope,$state,datosApp,conexionesWebservices,editableOptions, editableThemes,$uibModal) {
    //Definiciones
    $scope.datos_cliente={};
    $scope.datos_cliente.cliente={};
    $scope.datos_cliente.smartTablePageSize = 10;
    $scope.datos_cliente.quantityRows=100;
    // ------------------------------------
    $scope.edicionForm={};
    $scope.datos_edicion={};
    $scope.datos_edicion.confirmar_password_invalid=false;
    // ------------------------------------
    $scope.adicionForm={};
    $scope.datos_adicion={};
    $scope.datos_adicion.habilitar_formulario=false;
    $scope.datos_adicion.confirmar_password_invalid=false;
    // ------------------------------------
    // $scope.rowform.$cancel();
    //Funciones
    $scope.traerDatosActividadeco = function (cantidad) {
      conexionesWebservices.actividadesecoAPI.traeractividadeseco(cantidad)
      .then(function (response) {
            //console.log("Respuesta Listado Actividadeco",response.data);
            if(response.data!=null){
              $scope.datos_cliente.actividades_economicas=response.data;
            }
            else {
            }
            $scope.traerDatosCliente('Todos');
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
            $scope.traerDatosCliente('Todos');
        });
    };
    $scope.editarCliente = function(item) {
      //console.log("Upload Foto:",$scope.datos_edicion.foto);
      if($scope.datos_edicion.foto==undefined){
        $scope.actualizarCliente(item);
      }
      else{
        $scope.datos_edicion.foto.upload=conexionesWebservices.clientesAPI.modificarClienteFoto(item);
        $scope.datos_edicion.foto.upload
        .then(function (response) {
          $timeout(function () {
            $scope.datos_edicion.foto.result = response.data;
          });
          if(response.data!=null){
            //console.log("Respuesta:",response.data);
            $scope.showSuccessMsg("Cliente actualizado");
            $scope.traerDatosCliente('Todos');
          }
          else {
          }
        }, function (response) {
          if (response.status > 0)
            $scope.errorMsg = response.status + ': ' + response.data;
        }, function (evt) {
          // Math.min is to fix IE which reports 200% sometimes
          $scope.datos_edicion.foto.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }
    $scope.traerListadoPorRegistros=function(){
      //console.log("Cantidad Registros",$scope.datos_cliente.quantityRows);
      $scope.traerDatosCliente($scope.datos_cliente.quantityRows);
    }
    $scope.grabarCambios= function(index,item) {
      //console.log($scope.datos_cliente.listado[index].nombres);
      item.id=$scope.datos_cliente.listado[index].id;
      //console.log("Cambios en línea",item);
      conexionesWebservices.clientesAPI.modificarcliente(item)
      .then(function (response) {
            if(response.data!=null){
              //console.log("Respuesta:",response.data);
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.confirmarEliminacionCliente=function(){
      $scope.datos_cliente.listado.splice($scope.datos_cliente.index_cliente_eliminacion, 1);
      conexionesWebservices.clientesAPI.eliminarCliente($scope.datos_cliente.id_cliente_eliminacion)
      .then(function (response) {
            if(response.data!=null){
              $scope.showInfoMsg("Cliente eliminado");
              $scope.modal_eliminar.dismiss();
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    }
    $scope.borrarCliente = function(index) {
      $scope.datos_cliente.nombre_cliente_eliminacion=$scope.datos_cliente.listado[index].nombres + " " + $scope.datos_cliente.listado[index].apellidos;
      $scope.datos_cliente.index_cliente_eliminacion=index;
      $scope.datos_cliente.id_cliente_eliminacion=$scope.datos_cliente.listado[index].id;
      var page='app/pages/clientes/eliminacionCliente.html';
      var size='md';
      $scope.modal_eliminar = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.datosIniciales = function () {
      //$scope.traerPerfilesAdministrativos('');
      $scope.traerDatosActividadeco('Todos');
    }
    $scope.traerDatosCliente = function (cantidad) {
      conexionesWebservices.clientesAPI.traerclientes(cantidad)
      .then(function (response) {
            //console.log("Respuesta Listado Cliente",response.data);
            if(response.data!=null){
              $scope.datos_cliente.listado=response.data;
              $scope.datos_cliente.safe_listado=[];
              $scope.datos_cliente.safe_listado=response.data;
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.traerPerfilesAdministrativos = function (cantidad) {
      conexionesWebservices.perfilesAdministrativosAPI.traerPerfilesAdministrativos(cantidad)
      .then(function (response) {
            if(response.data!=null){
              $scope.datos_cliente.perfiles_administrativos=response.data;
              //console.log("Perfiles",$scope.datos_cliente.perfiles_administrativos);
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.abrirEdicion = function (item) {
      $scope.datos_edicion=item;
      //console.log("Item",item);
      // var tmp=$filter("filter")($scope.datos_cliente.perfiles_administrativos, {id:item.id_perfil_administrativo});
      // $scope.datos_edicion.perfil_administrativo_objeto=tmp[0];
      //console.log("Datos Edición",$scope.datos_edicion);
      $scope.datos_edicion.foto={};
      // $scope.datos_edicion.foto.upload
      //console.log("Perfil Adm del cliente",$scope.datos_edicion.perfil_administrativo_objeto);
      var page='app/pages/clientes/edicionCliente.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.actualizarCliente= function(item) {
      //console.log("Item a modificar",item);
      conexionesWebservices.clientesAPI.modificarcliente(item)
      .then(function (response) {
            if(response.data!=null){
              //console.log("Respuesta Cliente:",response.data);
              $scope.showSuccessMsg("Cliente actualizado");
              $scope.traerDatosCliente('Todos');
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    // Válida Password
    $scope.validarPassword=function(){
      if($scope.datos_edicion.password != $scope.datos_edicion.confirmar_password) {
        $scope.edicionForm.$invalid=true;
        $scope.datos_edicion.confirmar_password_invalid=true;
      } else {
        $scope.edicionForm.$invalid=false;
        $scope.datos_edicion.confirmar_password_invalid=false;
      }
    }
    $scope.validarPasswordAdicion=function(){
      if($scope.datos_adicion.password != $scope.datos_adicion.confirmar_password) {
        $scope.adicionForm.$invalid=true;
        $scope.datos_adicion.confirmar_password_invalid=true;
      } else {
        $scope.adicionForm.$invalid=false;
        $scope.datos_adicion.confirmar_password_invalid=false;
      }
    }
    //
    $scope.abrirNuevo = function () {
      $scope.datos_adicion={};
      var page='app/pages/clientes/adicionCliente.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.agregarCliente= function(item) {
      //console.log("Item a agregar",item);
      conexionesWebservices.clientesAPI.agregarcliente(item)
      .then(function (response) {
            if(response.data!=null){
              //console.log("Respuesta:",response.data);
              $scope.showSuccessMsg("Cliente agregado");
              $scope.traerDatosCliente('Todos');
              $scope.datos_adicion.habilitar_formulario=true;
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };

    //----funcion para reiniciar el formulario---/////
        $scope.limpiarCampos_formCliente = function(item) {
          $scope.datos_adicion={};
          if (item) {
            item.$setPristine();
            }
          $scope.datos_adicion.habilitar_formulario=false;
        };


    //Notificaciones
    $scope.showSuccessMsg = function(texto) {
      toastr.success(texto);
    };

    $scope.showInfoMsg = function(texto) {
      toastr.info(texto, 'Información');
    };

    $scope.showErrorMsg = function(texto) {
      toastr.error(texto, 'Error');
    };

    $scope.showWarningMsg = function(texto) {
      toastr.warning(texto, 'Alerta');
    };
  }//Fin del controller

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.dashboard')
    .controller('DashboardPageCtrl', DashboardPageCtrl);

  /** @ngInject */
  function DashboardPageCtrl($scope, fileReader, $filter, $uibModal,$state,$rootScope,datosApp) {
    //console.log("datosApp",$state);
    $rootScope.title=$state.current.title;
    if($rootScope.$pageLogin==0){
      //console.log("Login Dash");
      $state.go('login');
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.entidades')
    .controller('EntidadesPageCtrl', EntidadesPageCtrl);

  /** @ngInject */
  function EntidadesPageCtrl($scope, toastr, fileReader, $timeout,moment, $filter,$rootScope,$state,datosApp,conexionesWebservices,editableOptions, editableThemes,$uibModal) {
    //Definiciones
    $scope.datos_entidad={};
    $scope.datos_entidad.entidad={};
    $scope.datos_entidad.smartTablePageSize = 10;
    $scope.datos_entidad.quantityRows=100;
    // ------------------------------------
    $scope.edicionForm={};
    $scope.datos_edicion={};
    $scope.datos_edicion.confirmar_password_invalid=false;
    // ------------------------------------
    $scope.adicionForm={};
    $scope.datos_adicion={};
    $scope.datos_adicion.habilitar_formulario=false;
    $scope.datos_adicion.confirmar_password_invalid=false;
    // ------------------------------------
    // $scope.rowform.$cancel();
    //Funciones
    $scope.editarEntidad = function(item) {
      //console.log("Upload Foto:",$scope.datos_edicion.foto);
      if($scope.datos_edicion.foto==undefined){
        $scope.actualizarEntidad(item);
      }
      else{
        $scope.datos_edicion.foto.upload=conexionesWebservices.entidadesAPI.modificarEntidadFoto(item);
        $scope.datos_edicion.foto.upload
        .then(function (response) {
          $timeout(function () {
            $scope.datos_edicion.foto.result = response.data;
          });
          if(response.data!=null){
            //console.log("Respuesta:",response.data);
            $scope.showSuccessMsg("Entidad actualizado");
          }
          else {
          }
        }, function (response) {
          if (response.status > 0)
            $scope.errorMsg = response.status + ': ' + response.data;
        }, function (evt) {
          // Math.min is to fix IE which reports 200% sometimes
          $scope.datos_edicion.foto.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }
    $scope.traerListadoPorRegistros=function(){
      //console.log("Cantidad Registros",$scope.datos_entidad.quantityRows);
      $scope.traerDatosEntidad($scope.datos_entidad.quantityRows);
    }
    $scope.grabarCambios= function(index,item) {
      //console.log($scope.datos_entidad.listado[index].nombre);
      item.id=$scope.datos_entidad.listado[index].id;
      //console.log("Cambios en línea",item);
      conexionesWebservices.entidadesAPI.modificarentidad(item)
      .then(function (response) {
            if(response.data!=null){
              //console.log("Respuesta:",response.data);
              $scope.showSuccessMsg("Entidad modificado");
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.confirmarEliminacionEntidad=function(){
      $scope.datos_entidad.listado.splice($scope.datos_entidad.index_entidad_eliminacion, 1);
      conexionesWebservices.entidadesAPI.eliminarentidad($scope.datos_entidad.id_entidad_eliminacion)
      .then(function (response) {
            if(response.data!=null){
              $scope.showInfoMsg("Entidad eliminado");
              $scope.modal_eliminar.dismiss();
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    }
    $scope.borrarEntidad = function(index) {
      $scope.datos_entidad.nombre_entidad_eliminacion=$scope.datos_entidad.listado[index].nombre;
      $scope.datos_entidad.index_entidad_eliminacion=index;
      $scope.datos_entidad.id_entidad_eliminacion=$scope.datos_entidad.listado[index].id;
      var page='app/pages/entidades/eliminacionEntidad.html';
      var size='md';
      $scope.modal_eliminar = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.datosIniciales = function () {
      $scope.traerEstados();
      $scope.traerDatosEntidad('Todos');
    }
    $scope.traerDatosEntidad = function (cantidad) {
      conexionesWebservices.entidadesAPI.traerentidades(cantidad)
      .then(function (response) {
            //console.log("Respuesta Listado Entidad",response.data);
            if(response.data!=null){
              $scope.datos_entidad.listado=response.data;
              $scope.datos_entidad.safe_listado=[];
              $scope.datos_entidad.safe_listado=response.data;
            }
            else {
            }
            $scope.traerTipoEntidades('Todos');
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
            $scope.traerTipoEntidades('Todos');
        });
    };
    $scope.traerTipoEntidades = function (cantidad) {
      conexionesWebservices.tipoEntidadesAPI.traertipoentidades(cantidad)
      .then(function (response) {
            if(response.data!=null){
              $scope.datos_entidad.tipo_entidades=response.data;
              //console.log("Perfiles",$scope.datos_entidad.tipo_entidades);
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.traerEstados = function () {
      $scope.datos_entidad.estados=[{
        id:1,
        nombre:'Activo',
        valor:1,
      },
      {
        id:2,
        nombre:'Inactivo',
        valor:0,
      }
    ]
    };
    $scope.abrirEdicion = function (item) {
      $scope.datos_edicion=item;
      //console.log("Item",item);
      // filtros para consultar en la bd y llenar el select//
      //filtro de tipo persona
      var tmp=$filter("filter")($scope.datos_entidad.tipo_entidades, {id:item.id_tipo_entidad});
      $scope.datos_edicion.tipo_entidades=tmp[0];
      //filtro tipo estado
      var tmp=$filter("filter")($scope.datos_entidad.estados, {valor:item.estado});
      $scope.datos_edicion.estados=tmp[0];
      //console.log("Datos Edición",$scope.datos_edicion);
      var page='app/pages/entidades/edicionEntidad.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.actualizarEntidad= function(item) {
      //console.log("Item a modificar",item);
      conexionesWebservices.entidadesAPI.modificarentidad(item)
      .then(function (response) {
            if(response.data!=null){
              //console.log("Respuesta Entidad:",response.data);
              $scope.showSuccessMsg("Entidad actualizada");
              $scope.traerEstados();
              $scope.traerDatosEntidad('Todos');
              $scope.traerTipoEntidades('Todos');

            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    // Válida Password
    $scope.validarPassword=function(){
      if($scope.datos_edicion.password != $scope.datos_edicion.confirmar_password) {
        $scope.edicionForm.$invalid=true;
        $scope.datos_edicion.confirmar_password_invalid=true;
      } else {
        $scope.edicionForm.$invalid=false;
        $scope.datos_edicion.confirmar_password_invalid=false;
      }
    }
    $scope.validarPasswordAdicion=function(){
      if($scope.datos_adicion.password != $scope.datos_adicion.confirmar_password) {
        $scope.adicionForm.$invalid=true;
        $scope.datos_adicion.confirmar_password_invalid=true;
      } else {
        $scope.adicionForm.$invalid=false;
        $scope.datos_adicion.confirmar_password_invalid=false;
      }
    }
    //
    $scope.abrirNuevo = function () {
      $scope.datos_adicion={};
      var page='app/pages/entidades/adicionEntidad.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.agregarEntidad = function(item) {
      //console.log("Item a agregar",item);
      conexionesWebservices.entidadesAPI.agregarentidad(item)
      .then(function (response) {
            if(response.data!=null){
              //console.log("Respuesta:",response.data);
              $scope.showSuccessMsg("Entidad agregado");
              $scope.traerDatosEntidad('Todos');
              $scope.datos_adicion.habilitar_formulario=true;
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };

//----funcion para reiniciar el formulario---/////
    $scope.limpiarCampos_formEntidad = function(item) {
      $scope.datos_adicion={};
      if (item) {
        item.$setPristine();
        }
      $scope.datos_adicion.habilitar_formulario=false;
    };


    //Notificaciones
    $scope.showSuccessMsg = function(texto) {
      toastr.success(texto);
    };

    $scope.showInfoMsg = function(texto) {
      toastr.info(texto, 'Información');
    };

    $scope.showErrorMsg = function(texto) {
      toastr.error(texto, 'Error');
    };

    $scope.showWarningMsg = function(texto) {
      toastr.warning(texto, 'Alerta');
    };
  }//Fin del controller

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.indicadores')
    .controller('IndicadoresPageCtrl', IndicadoresPageCtrl);

  /** @ngInject */
  function IndicadoresPageCtrl($scope, toastr, fileReader, $timeout,moment, $filter,$rootScope,$state,datosApp,conexionesWebservices,editableOptions, editableThemes,$uibModal) {
    //Definiciones
    $scope.datos_indicador={};
    $scope.datos_indicador.indicador={};
    $scope.datos_indicador.smartTablePageSize = 10;
    $scope.datos_indicador.quantityRows=100;
    // ------------------------------------
    $scope.edicionForm={};
    $scope.datos_edicion={};
    $scope.datos_edicion.confirmar_password_invalid=false;
    // ------------------------------------
    $scope.adicionForm={};
    $scope.datos_adicion={};
    $scope.datos_adicion.habilitar_formulario=false;
    $scope.datos_adicion.confirmar_password_invalid=false;
    // ------------------------------------
    // $scope.rowform.$cancel();
    //Funciones
    $scope.traerListadoPorRegistros=function(){
      //console.log("Cantidad Registros",$scope.datos_indicador.quantityRows);
      $scope.traerDatosIndicador($scope.datos_indicador.quantityRows);
    }
    $scope.grabarCambios= function(index,item) {
      //console.log($scope.datos_indicador.listado[index].nombres);
      item.id=$scope.datos_indicador.listado[index].id;
      //console.log("Cambios en línea",item);
      conexionesWebservices.indicadoresAPI.modificarindicador(item)
      .then(function (response) {
            if(response.data!=null){
              //console.log("Respuesta:",response.data);
                $scope.showSuccessMsg("Indicador actualizado");
                $scope.traerDatosIndicador('Todos');

            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.confirmarEliminacionIndicador=function(){
      $scope.datos_indicador.listado.splice($scope.datos_indicador.index_indicador_eliminacion, 1);
      conexionesWebservices.indicadoresAPI.eliminarIndicador($scope.datos_indicador.id_indicador_eliminacion)
      .then(function (response) {
            if(response.data!=null){
              $scope.showInfoMsg("Indicador eliminado");
              $scope.modal_eliminar.dismiss();
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    }
    $scope.borrarIndicador = function(index) {
      $scope.datos_indicador.nombre_indicador_eliminacion=$scope.datos_indicador.listado[index].nombre;
      $scope.datos_indicador.index_indicador_eliminacion=index;
      $scope.datos_indicador.id_indicador_eliminacion=$scope.datos_indicador.listado[index].id;
      var page='app/pages/indicadores/eliminacionIndicador.html';
      var size='md';
      $scope.modal_eliminar = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };

    $scope.datosIniciales = function () {
      $scope.traerDatosIndicador('Todos');
    }
    $scope.traerDatosIndicador = function (cantidad) {
      conexionesWebservices.indicadoresAPI.traerindicadores(cantidad)
      .then(function (response) {
            //console.log("Respuesta Listado Indicador",response.data);
            if(response.data!=null){
              $scope.datos_indicador.listado=response.data;
              $scope.datos_indicador.safe_listado=[];
              $scope.datos_indicador.safe_listado=response.data;
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.traerPerfilesAdministrativos = function (cantidad) {
      conexionesWebservices.perfilesAdministrativosAPI.traerPerfilesAdministrativos(cantidad)
      .then(function (response) {
            if(response.data!=null){
              $scope.datos_indicador.perfiles_administrativos=response.data;
              //console.log("Perfiles",$scope.datos_indicador.perfiles_administrativos);
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.abrirEdicion = function (item) {
      $scope.datos_edicion=item;
      //console.log("Item",item);
      //console.log("Datos Edición",$scope.datos_edicion);
      var page='app/pages/indicadores/edicionIndicador.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.actualizarIndicador= function(item) {
      //console.log("Item a modificar",item);
      conexionesWebservices.indicadoresAPI.modificarindicador(item)
      .then(function (response) {
            if(response.data!=null){
              //console.log("Respuesta Indicador:",response.data);
              $scope.showSuccessMsg("Indicador actualizado");
              $scope.traerDatosIndicador('Todos');
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    // Válida Password
    $scope.validarPassword=function(){
      if($scope.datos_edicion.password != $scope.datos_edicion.confirmar_password) {
        $scope.edicionForm.$invalid=true;
        $scope.datos_edicion.confirmar_password_invalid=true;
      } else {
        $scope.edicionForm.$invalid=false;
        $scope.datos_edicion.confirmar_password_invalid=false;
      }
    }
    $scope.validarPasswordAdicion=function(){
      if($scope.datos_adicion.password != $scope.datos_adicion.confirmar_password) {
        $scope.adicionForm.$invalid=true;
        $scope.datos_adicion.confirmar_password_invalid=true;
      } else {
        $scope.adicionForm.$invalid=false;
        $scope.datos_adicion.confirmar_password_invalid=false;
      }
    }
    //
    $scope.abrirNuevo = function () {
      $scope.datos_adicion={};
      var page='app/pages/indicadores/adicionIndicador.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.agregarIndicador= function(item) {
      //console.log("Item a agregar",item);
      conexionesWebservices.indicadoresAPI.agregarindicador(item)
      .then(function (response) {
            if(response.data!=null){
              //console.log("Respuesta:",response.data);
              $scope.showSuccessMsg("Indicador agregado");
              $scope.traerDatosIndicador('Todos');
              $scope.datos_adicion.habilitar_formulario=true;
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };

    $scope.limpiarCampos_formIndicador = function(item) {
      $scope.datos_adicion={};
      if (item) {
        item.$setPristine();
        }
      $scope.datos_adicion.habilitar_formulario=false;
    };
    //Notificaciones
    $scope.showSuccessMsg = function(texto) {
      toastr.success(texto);
    };

    $scope.showInfoMsg = function(texto) {
      toastr.info(texto, 'Información');
    };

    $scope.showErrorMsg = function(texto) {
      toastr.error(texto, 'Error');
    };

    $scope.showWarningMsg = function(texto) {
      toastr.warning(texto, 'Alerta');
    };
  }//Fin del controller

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.perfilusuario')
    .controller('PerfilusuarioPageCtrl', PerfilusuarioPageCtrl);

  /** @ngInject */
  function PerfilusuarioPageCtrl($scope, toastr, fileReader, $stateParams, $timeout,moment, $filter,$rootScope,$state,datosApp,conexionesWebservices,editableOptions, editableThemes,$uibModal) {
    //Definiciones
    $scope.datos_perfilusuario={};
    $scope.datos_perfilusuario.perfilusuario={};
    // ------------------------------------
    $scope.edicionForm={};
    $scope.datos_edicion={};
    $scope.datos_edicion.confirmar_password_invalid=false;
    // ------------------------------------
    // $scope.rowform.$cancel();
    //Funciones
    $scope.traerDatosActividadeco = function (cantidad) {
      conexionesWebservices.actividadesecoAPI.traeractividadeseco(cantidad)
      .then(function (response) {
            //console.log("Respuesta Listado Actividadeco",response.data);
            if(response.data!=null){
              $scope.datos_perfilusuario.actividades_economicas=response.data;
              $scope.traerPerfilesAdministrativos('Todos');
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.editarUsuario = function() {
      //console.log("Upload Foto:",$scope.datos_edicion.foto);
      if($scope.datos_edicion.foto==undefined){
        $scope.actualizarUsuario($scope.datos_edicion);
      }
      else{
        $scope.datos_edicion.foto.upload=conexionesWebservices.usuariosAPI.modificarUsuarioFoto($scope.datos_edicion);
        $scope.datos_edicion.foto.upload
        .then(function (response) {
          $timeout(function () {
            $scope.datos_edicion.foto.result = response.data;
          });
          if(response.data.consulta_exitosa){
            console.log("Respuesta ome 2:",response.data);
            $scope.showSuccessMsg("Usuario actualizado");
            window.localStorage.setItem("datos_de_usuario",angular.toJson(response.data));
          }
          else {
          }
        }, function (response) {
          if (response.status > 0)
            $scope.errorMsg = response.status + ': ' + response.data;
        }, function (evt) {
          // Math.min is to fix IE which reports 200% sometimes
          $scope.datos_edicion.foto.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }
    $scope.traerPerfilesAdministrativos = function (cantidad) {
      conexionesWebservices.perfilesAdministrativosAPI.traerPerfilesAdministrativos(cantidad)
      .then(function (response) {
            if(response.data!=null){
              $scope.datos_perfilusuario.perfiles_administrativos=response.data;
              //
              if($state.params.datosEdicion!=null){
                $scope.datos_edicion=$state.params.datosEdicion;
                console.log("Item 1",$scope.datos_edicion);              
              }
              else{
                $scope.datosUsuario=angular.fromJson(window.localStorage.getItem("datos_de_usuario"));
                $scope.datos_edicion=$scope.datosUsuario.datos;
                console.log("Item 2",$scope.datos_edicion);
              }
              var tmp=$filter("filter")($scope.datos_perfilusuario.perfiles_administrativos, {id:$scope.datos_edicion.id_perfil_administrativo});
              $scope.datos_edicion.perfil_administrativo=tmp[0];
              // --------------
              var tmp1=$filter("filter")($scope.datos_perfilusuario.actividades_economicas, {id:$scope.datos_edicion.id_actividad_economica});
              $scope.datos_edicion.actividad_economica=tmp1[0];
              // --------------
              $scope.datos_edicion.foto={};
              // $scope.datos_edicion.foto.upload
              //
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.abrirEdicion = function () {
      $scope.traerDatosActividadeco("Todos");
    };
    $scope.actualizarUsuario= function() {
      //console.log("Item a modificar",$scope.datos_edicion);
      conexionesWebservices.usuariosAPI.modificarperfilusuario($scope.datos_edicion)
      .then(function (response) {
            if(response.data!=null){
              console.log("Respuesta ome 1:",response.data);
              $scope.showSuccessMsg("Usuario actualizado");
              window.localStorage.setItem("datos_de_usuario",angular.toJson(response.data));
              // $scope.traerDatosUsuario('Todos');
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    // Válida Password
    $scope.validarPassword=function(){
      if($scope.datos_edicion.password != $scope.datos_edicion.confirmar_password) {
        $scope.edicionForm.$invalid=true;
        $scope.datos_edicion.confirmar_password_invalid=true;
      } else {
        $scope.edicionForm.$invalid=false;
        $scope.datos_edicion.confirmar_password_invalid=false;
      }
    }
    $scope.validarPasswordAdicion=function(){
      if($scope.datos_adicion.password != $scope.datos_adicion.confirmar_password) {
        $scope.adicionForm.$invalid=true;
        $scope.datos_adicion.confirmar_password_invalid=true;
      } else {
        $scope.adicionForm.$invalid=false;
        $scope.datos_adicion.confirmar_password_invalid=false;
      }
    }
    //Notificaciones
    $scope.showSuccessMsg = function(texto) {
      toastr.success(texto);
    };

    $scope.showInfoMsg = function(texto) {
      toastr.info(texto, 'Información');
    };

    $scope.showErrorMsg = function(texto) {
      toastr.error(texto, 'Error');
    };

    $scope.showWarningMsg = function(texto) {
      toastr.warning(texto, 'Alerta');
    };
  }//Fin del controller

})();

/**
 * @author a.demeshko
 * created on 21.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile')
    .controller('ProfileModalCtrl', ProfileModalCtrl);

  /** @ngInject */
  function ProfileModalCtrl($scope, $uibModalInstance) {
    $scope.link = '';
    $scope.ok = function () {
      $uibModalInstance.close($scope.link);
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile')
    .controller('ProfilePageCtrl', ProfilePageCtrl);

  /** @ngInject */
  function ProfilePageCtrl($scope, fileReader, $filter, $uibModal) {
    $scope.picture = $filter('profilePicture')('Nasta');

    $scope.removePicture = function () {
      $scope.picture = $filter('appImage')('theme/no-photo.png');
      $scope.noPicture = true;
    };

    $scope.uploadPicture = function () {
      var fileInput = document.getElementById('uploadFile');
      fileInput.click();

    };

    $scope.socialProfiles = [
      {
        name: 'Facebook',
        href: 'https://www.facebook.com/akveo/',
        icon: 'socicon-facebook'
      },
      {
        name: 'Twitter',
        href: 'https://twitter.com/akveo_inc',
        icon: 'socicon-twitter'
      },
      {
        name: 'Google',
        icon: 'socicon-google'
      },
      {
        name: 'LinkedIn',
        href: 'https://www.linkedin.com/company/akveo',
        icon: 'socicon-linkedin'
      },
      {
        name: 'GitHub',
        href: 'https://github.com/akveo',
        icon: 'socicon-github'
      },
      {
        name: 'StackOverflow',
        icon: 'socicon-stackoverflow'
      },
      {
        name: 'Dribbble',
        icon: 'socicon-dribble'
      },
      {
        name: 'Behance',
        icon: 'socicon-behace'
      }
    ];

    $scope.unconnect = function (item) {
      item.href = undefined;
    };

    $scope.showModal = function (item) {
      $uibModal.open({
        animation: false,
        controller: 'ProfileModalCtrl',
        templateUrl: 'app/pages/profile/profileModal.html'
      }).result.then(function (link) {
          item.href = link;
        });
    };

    $scope.getFile = function () {
      fileReader.readAsDataUrl($scope.file, $scope)
          .then(function (result) {
            $scope.picture = result;
          });
    };

    $scope.switches = [true, true, false, true, true, false];
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.seccionales')
    .controller('SeccionalesPageCtrl', SeccionalesPageCtrl);

  /** @ngInject */
  function SeccionalesPageCtrl($scope, toastr, fileReader, $timeout,moment, $filter,$rootScope,$state,datosApp,conexionesWebservices,editableOptions, editableThemes,$uibModal) {
    //Definiciones
    $scope.datos_seccional={};
    $scope.datos_seccional.seccional={};
    $scope.datos_seccional.smartTablePageSize = 10;
    $scope.datos_seccional.quantityRows=100;
    // ------------------------------------
    $scope.edicionForm={};
    $scope.datos_edicion={};
    $scope.datos_edicion.confirmar_password_invalid=false;
    // ------------------------------------
    $scope.adicionForm={};
    $scope.datos_adicion={};
    $scope.datos_adicion.habilitar_formulario=false;
    $scope.datos_adicion.confirmar_password_invalid=false;
    // ------------------------------------
    // $scope.rowform.$cancel();
    //Funciones
    $scope.editarSeccional = function(item) {
      //console.log("Upload Foto:",$scope.datos_edicion.foto);
      if($scope.datos_edicion.foto==undefined){
        $scope.actualizarSeccional(item);
      }
      else{
        $scope.datos_edicion.foto.upload=conexionesWebservices.seccionalesAPI.modificarSeccionalFoto(item);
        $scope.datos_edicion.foto.upload
        .then(function (response) {
          $timeout(function () {
            $scope.datos_edicion.foto.result = response.data;
          });
          if(response.data!=null){
            //console.log("Respuesta:",response.data);
            $scope.showSuccessMsg("Seccional actualizado");
          }
          else {
          }
        }, function (response) {
          if (response.status > 0)
            $scope.errorMsg = response.status + ': ' + response.data;
        }, function (evt) {
          // Math.min is to fix IE which reports 200% sometimes
          $scope.datos_edicion.foto.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }
    $scope.traerListadoPorRegistros=function(){
      //console.log("Cantidad Registros",$scope.datos_seccional.quantityRows);
      $scope.traerDatosSeccional($scope.datos_seccional.quantityRows);
    }
    $scope.grabarCambios= function(index,item) {
      //console.log($scope.datos_seccional.listado[index].nombre);
      item.id=$scope.datos_seccional.listado[index].id;
      //console.log("Cambios en línea",item);
      conexionesWebservices.seccionalesAPI.modificarseccional(item)
      .then(function (response) {
            if(response.data!=null){
              //console.log("Respuesta:",response.data);
              $scope.showSuccessMsg("Seccional modificado");
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.confirmarEliminacionSeccional=function(){
      $scope.datos_seccional.listado.splice($scope.datos_seccional.index_seccional_eliminacion, 1);
      conexionesWebservices.seccionalesAPI.eliminarseccional($scope.datos_seccional.id_seccional_eliminacion)
      .then(function (response) {
            if(response.data!=null){
              $scope.showInfoMsg("Seccional eliminado");
              $scope.modal_eliminar.dismiss();
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    }
    $scope.borrarSeccional = function(index) {
      $scope.datos_seccional.nombre_seccional_eliminacion=$scope.datos_seccional.listado[index].nombre;
      $scope.datos_seccional.index_seccional_eliminacion=index;
      $scope.datos_seccional.id_seccional_eliminacion=$scope.datos_seccional.listado[index].id;
      var page='app/pages/seccionales/eliminacionSeccional.html';
      var size='md';
      $scope.modal_eliminar = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.datosIniciales = function () {
    //  $scope.traerEstados('Todos');
      $scope.traerDatosSeccional('Todos');
    }
    $scope.traerDatosSeccional = function (cantidad) {
      conexionesWebservices.seccionalesAPI.traerseccionales(cantidad)
      .then(function (response) {
            //console.log("Respuesta Listado Seccional",response.data);
            if(response.data!=null){
              $scope.datos_seccional.listado=response.data;
              $scope.datos_seccional.safe_listado=[];
              $scope.datos_seccional.safe_listado=response.data;
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.traerEstados = function (cantidad) {
      $scope.datos_seccional.estados=[{
        id:1,
        nombre:'Activo',
        valor:1,
      },
      {
        id:2,
        nombre:'Inactivo',
        valor:0,
      }
    ]
    };
    $scope.abrirEdicion = function (item) {
      $scope.datos_edicion=item;
      //console.log("Item",item);
      //var tmp=$filter("filter")($scope.datos_seccional.estados, {valor:item.estado});
    //  $scope.datos_edicion.estados_objeto=tmp[0];
      //console.log("Datos Edición",$scope.datos_edicion);
      var page='app/pages/seccionales/edicionSeccional.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.actualizarSeccional= function(item) {
      //console.log("Item a modificar",item);
      conexionesWebservices.seccionalesAPI.modificarseccional(item)
      .then(function (response) {
            if(response.data!=null){
              //console.log("Respuesta Seccional:",response.data);
              $scope.showSuccessMsg("Seccional actualizado");
              $scope.traerEstados('Todos');
              $scope.traerDatosSeccional('Todos');
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    // Válida Password
    $scope.validarPassword=function(){
      if($scope.datos_edicion.password != $scope.datos_edicion.confirmar_password) {
        $scope.edicionForm.$invalid=true;
        $scope.datos_edicion.confirmar_password_invalid=true;
      } else {
        $scope.edicionForm.$invalid=false;
        $scope.datos_edicion.confirmar_password_invalid=false;
      }
    }
    $scope.validarPasswordAdicion=function(){
      if($scope.datos_adicion.password != $scope.datos_adicion.confirmar_password) {
        $scope.adicionForm.$invalid=true;
        $scope.datos_adicion.confirmar_password_invalid=true;
      } else {
        $scope.adicionForm.$invalid=false;
        $scope.datos_adicion.confirmar_password_invalid=false;
      }
    }
    //
    $scope.abrirNuevo = function () {
      $scope.datos_adicion={};
      var page='app/pages/seccionales/adicionSeccional.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.agregarSeccional= function(item) {
      //console.log("Item a agregar",item);
      conexionesWebservices.seccionalesAPI.agregarseccional(item)
      .then(function (response) {
            if(response.data!=null){
              //console.log("Respuesta:",response.data);
              $scope.showSuccessMsg("Seccional agregado");
              $scope.traerDatosSeccional('Todos');
              $scope.datos_adicion.habilitar_formulario=true;
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };

//----funcion para reiniciar el formulario---/////
    $scope.limpiarCampos_formSeccional = function(item) {
      $scope.datos_adicion={};
      if (item) {
        item.$setPristine();
        }
      $scope.datos_adicion.habilitar_formulario=false;
    };


    //Notificaciones
    $scope.showSuccessMsg = function(texto) {
      toastr.success(texto);
    };

    $scope.showInfoMsg = function(texto) {
      toastr.info(texto, 'Información');
    };

    $scope.showErrorMsg = function(texto) {
      toastr.error(texto, 'Error');
    };

    $scope.showWarningMsg = function(texto) {
      toastr.warning(texto, 'Alerta');
    };
  }//Fin del controller

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.soportes')
    .controller('SoportesPageCtrl', SoportesPageCtrl);

  /** @ngInject */
  function SoportesPageCtrl($scope, toastr, fileReader, permisosUsuario, $timeout,moment, $filter,$rootScope,$state,datosApp,conexionesWebservices,editableOptions, editableThemes,$uibModal) {
    //Definiciones
    $scope.datos_soporte={};
    $scope.idUsuario=$rootScope.$datosLogin.datos.id;
    $scope.idPerfil=parseFloat(permisosUsuario.id_perfil_administrativo);
    $scope.datos_soporte.mediateca=datosApp.mediateca;
    $scope.datos_soporte.soporte={};
    $scope.datos_soporte.smartTablePageSize = 10;
    $scope.datos_soporte.quantityRows=100;
    // ------------------------------------
    $scope.edicionForm={};
    $scope.datos_edicion={};
    $scope.datos_edicion.confirmar_password_invalid=false;
    // ------------------------------------
    $scope.adicionForm={};
    $scope.datos_adicion={};
    $scope.datos_adicion.habilitar_formulario=false;
    $scope.datos_adicion.confirmar_password_invalid=false;
    // ------------------------------------
    // $scope.rowform.$cancel();
    //Funciones
    $scope.editarSoporte = function(item) {
      //console.log("Upload Foto:",$scope.datos_edicion.foto);
      if($scope.datos_edicion.foto==undefined){
        $scope.actualizarSoporte(item);
      }
      else{
        $scope.datos_edicion.foto.upload=conexionesWebservices.soportesAPI.modificarSoporteFoto(item);
        $scope.datos_edicion.foto.upload
        .then(function (response) {
          $timeout(function () {
            $scope.datos_edicion.foto.result = response.data;
          });
          if(response.data!=null){
            //console.log("Respuesta:",response.data);
            $scope.showSuccessMsg("Soporte actualizado");
          }
          else {
          }
        }, function (response) {
          if (response.status > 0)
            $scope.errorMsg = response.status + ': ' + response.data;
        }, function (evt) {
          // Math.min is to fix IE which reports 200% sometimes
          $scope.datos_edicion.foto.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }
    $scope.traerListadoPorRegistros=function(){
      //console.log("Cantidad Registros",$scope.datos_soporte.quantityRows);
      $scope.traerDatosSoporte($scope.datos_soporte.quantityRows);
    }
    $scope.grabarCambios= function(index,item) {
      //console.log($scope.datos_soporte.listado[index].nombre);
      item.id=$scope.datos_soporte.listado[index].id;
      //console.log("Cambios en línea",item);
      conexionesWebservices.soportesAPI.modificarsoporte(item)
      .then(function (response) {
            if(response.data!=null){
              //console.log("Respuesta:",response.data);
              $scope.showSuccessMsg("Soporte modificado");
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.confirmarEliminacionSoporte=function(){
      $scope.datos_soporte.listado.splice($scope.datos_soporte.index_soporte_eliminacion, 1);
      conexionesWebservices.soportesAPI.eliminarsoporte($scope.datos_soporte.id_soporte_eliminacion)
      .then(function (response) {
            if(response.data!=null){
              $scope.showInfoMsg("Soporte eliminado");
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    }
    $scope.borrarSoporte = function(index) {
      $scope.datos_soporte.nombre_soporte_eliminacion=$scope.datos_soporte.listado[index].nombres + " " + $scope.datos_soporte.listado[index].apellidos;
      $scope.datos_soporte.index_soporte_eliminacion=index;
      $scope.datos_soporte.id_soporte_eliminacion=$scope.datos_soporte.listado[index].id;
      var page='app/pages/soportes/eliminacionSoporte.html';
      var size='md';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.actualizarRowsFiltradas=function(){
      // console.log($scope.datos_soporte.listado);
      // angular.forEach($scope.datos_soporte.listado, function(item) {
      //
      // });
    }
    $scope.datosIniciales = function () {
      $scope.traerEstados('Todos');
      $scope.traerTiposSoporte('Todos');
      $scope.traerListadoClientes('Todos');
      $scope.traerDatosSoporte('Todos');
    }
    $scope.traerTiposSoporte = function (cantidad) {
      conexionesWebservices.soportesAPI.traerTiposSoporte(cantidad)
      .then(function (response) {
            if(response.data!=null) {
              $scope.datos_soporte.tipos_soporte=response.data;
            }
        }, function (error) {

        });
    };
    $scope.traerListadoClientes = function (cantidad) {
      //console.log("acá clientes");
      conexionesWebservices.clientesAPI.traerclientes(cantidad)
      .then(function (response) {
            if(response.data!=null){
              $scope.datos_soporte.listado_clientes=response.data;
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.traerDatosSoporte = function (cantidad) {
      conexionesWebservices.soportesAPI.traersoportes(cantidad)
      .then(function (response) {
            console.log("Respuesta Listado Soporte",response.data);
            if(response.data!=null){
              $scope.datos_soporte.listado=response.data;
              $scope.datos_soporte.safe_listado=[];
              $scope.datos_soporte.safe_listado=response.data;
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.traerEstados = function (cantidad) {
      $scope.datos_soporte.estados=[{
        id:1,
        nombre:'Bueno',
        valor:1,
      },
      {
        id:2,
        nombre:'Malo',
        valor:0,
      }
    ]
    };
    $scope.abrirEdicion = function (item) {
      $scope.datos_edicion=item;
      //console.log("Item",item);
      var tmp=$filter("filter")($scope.datos_soporte.estados, {valor:item.estado});
      $scope.datos_edicion.estados_objeto=tmp[0];
      var tmp=$filter("filter")($scope.datos_soporte.tipos_soporte, {id:item.id_soporte});
      $scope.datos_edicion.tipo_soporte=tmp[0];
      //console.log("Datos Edición",$scope.datos_edicion);
      var page='app/pages/soportes/edicionSoporte.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.actualizarSoporte= function(item) {
      //console.log("Item a modificar",item);
      conexionesWebservices.soportesAPI.modificarsoporte(item)
      .then(function (response) {
            if(response.data!=null){
              //console.log("Respuesta Soporte:",response.data);
              $scope.showSuccessMsg("Soporte actualizado");
              $scope.traerDatosSoporte('Todos');
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    // Válida Password
    $scope.validarPassword=function(){
      if($scope.datos_edicion.password != $scope.datos_edicion.confirmar_password) {
        $scope.edicionForm.$invalid=true;
        $scope.datos_edicion.confirmar_password_invalid=true;
      } else {
        $scope.edicionForm.$invalid=false;
        $scope.datos_edicion.confirmar_password_invalid=false;
      }
    }
    $scope.validarPasswordAdicion=function(){
      if($scope.datos_adicion.password != $scope.datos_adicion.confirmar_password) {
        $scope.adicionForm.$invalid=true;
        $scope.datos_adicion.confirmar_password_invalid=true;
      } else {
        $scope.adicionForm.$invalid=false;
        $scope.datos_adicion.confirmar_password_invalid=false;
      }
    }
    //
    $scope.abrirNuevo = function () {
      $scope.datos_adicion={};
      $scope.datos_adicion.archivo={};
      var page='app/pages/soportes/adicionSoporte.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.agregarSoporte= function(item) {
      $scope.datos_adicion.id_usuario=$scope.idUsuario;
      $scope.datos_adicion.archivo.upload=conexionesWebservices.soportesAPI.agregarsoporte(item);
      $scope.datos_adicion.archivo.upload
      .then(function (response) {
        $timeout(function () {
          $scope.datos_adicion.archivo.result = response.data;
        });
        if(response.data!=null){
          console.log("A VER OME",$rootScope.$datosLogin);
          $scope.showSuccessMsg("Sopote guardado");
          var notificacion={
            id_asociacion:response.data.datos.id,
            tipo:3,//Soporte agregado
            id_implicado:0,
            fecha_notificacion: new Date(),
            nombres:$rootScope.$datosLogin.datos.nombres+" "+$rootScope.$datosLogin.datos.apellidos
          }
          // console.log("A VER OME",notificacion);
          $scope.$emit('agregarNotificacion',notificacion);
          $scope.traerDatosSoporte('Todos');
        }
        else {
        }
      }, function (response) {
        if (response.status > 0)
          $scope.errorMsg = response.status + ': ' + response.data;
      }, function (evt) {
        // Math.min is to fix IE which reports 200% sometimes
        $scope.datos_adicion.archivo.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
      });
    };

//----funcion para reiniciar el formulario---/////
    $scope.limpiarCampos_formSoporte = function(item) {
      $scope.datos_adicion={};
      if (item) {
        item.$setPristine();
        }
      $scope.datos_adicion.habilitar_formulario=false;
    };


    //Notificaciones
    $scope.showSuccessMsg = function(texto) {
      toastr.success(texto);
    };

    $scope.showInfoMsg = function(texto) {
      toastr.info(texto, 'Información');
    };

    $scope.showErrorMsg = function(texto) {
      toastr.error(texto, 'Error');
    };

    $scope.showWarningMsg = function(texto) {
      toastr.warning(texto, 'Alerta');
    };
  }//Fin del controller

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.tables')
      .controller('TablesPageCtrl', TablesPageCtrl);

  /** @ngInject */
  function TablesPageCtrl($scope, $filter, editableOptions, editableThemes) {

    $scope.smartTablePageSize = 10;

    $scope.smartTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30'
      },
      {
        id: 6,
        firstName: 'Ann',
        lastName: 'Smith',
        username: '@ann',
        email: 'ann@gmail.com',
        age: '21'
      },
      {
        id: 7,
        firstName: 'Barbara',
        lastName: 'Black',
        username: '@barbara',
        email: 'barbara@yandex.ru',
        age: '43'
      },
      {
        id: 8,
        firstName: 'Sevan',
        lastName: 'Bagrat',
        username: '@sevan',
        email: 'sevan@outlook.com',
        age: '13'
      },
      {
        id: 9,
        firstName: 'Ruben',
        lastName: 'Vardan',
        username: '@ruben',
        email: 'ruben@gmail.com',
        age: '22'
      },
      {
        id: 10,
        firstName: 'Karen',
        lastName: 'Sevan',
        username: '@karen',
        email: 'karen@yandex.ru',
        age: '33'
      },
      {
        id: 11,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mark',
        email: 'mark@gmail.com',
        age: '38'
      },
      {
        id: 12,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@jacob',
        email: 'jacob@yandex.ru',
        age: '48'
      },
      {
        id: 13,
        firstName: 'Haik',
        lastName: 'Hakob',
        username: '@haik',
        email: 'haik@outlook.com',
        age: '48'
      },
      {
        id: 14,
        firstName: 'Garegin',
        lastName: 'Jirair',
        username: '@garegin',
        email: 'garegin@gmail.com',
        age: '40'
      },
      {
        id: 15,
        firstName: 'Krikor',
        lastName: 'Bedros',
        username: '@krikor',
        email: 'krikor@yandex.ru',
        age: '32'
      },
      {
        "id": 16,
        "firstName": "Francisca",
        "lastName": "Brady",
        "username": "@Gibson",
        "email": "franciscagibson@comtours.com",
        "age": 11
      },
      {
        "id": 17,
        "firstName": "Tillman",
        "lastName": "Figueroa",
        "username": "@Snow",
        "email": "tillmansnow@comtours.com",
        "age": 34
      },
      {
        "id": 18,
        "firstName": "Jimenez",
        "lastName": "Morris",
        "username": "@Bryant",
        "email": "jimenezbryant@comtours.com",
        "age": 45
      },
      {
        "id": 19,
        "firstName": "Sandoval",
        "lastName": "Jacobson",
        "username": "@Mcbride",
        "email": "sandovalmcbride@comtours.com",
        "age": 32
      },
      {
        "id": 20,
        "firstName": "Griffin",
        "lastName": "Torres",
        "username": "@Charles",
        "email": "griffincharles@comtours.com",
        "age": 19
      },
      {
        "id": 21,
        "firstName": "Cora",
        "lastName": "Parker",
        "username": "@Caldwell",
        "email": "coracaldwell@comtours.com",
        "age": 27
      },
      {
        "id": 22,
        "firstName": "Cindy",
        "lastName": "Bond",
        "username": "@Velez",
        "email": "cindyvelez@comtours.com",
        "age": 24
      },
      {
        "id": 23,
        "firstName": "Frieda",
        "lastName": "Tyson",
        "username": "@Craig",
        "email": "friedacraig@comtours.com",
        "age": 45
      },
      {
        "id": 24,
        "firstName": "Cote",
        "lastName": "Holcomb",
        "username": "@Rowe",
        "email": "coterowe@comtours.com",
        "age": 20
      },
      {
        "id": 25,
        "firstName": "Trujillo",
        "lastName": "Mejia",
        "username": "@Valenzuela",
        "email": "trujillovalenzuela@comtours.com",
        "age": 16
      },
      {
        "id": 26,
        "firstName": "Pruitt",
        "lastName": "Shepard",
        "username": "@Sloan",
        "email": "pruittsloan@comtours.com",
        "age": 44
      },
      {
        "id": 27,
        "firstName": "Sutton",
        "lastName": "Ortega",
        "username": "@Black",
        "email": "suttonblack@comtours.com",
        "age": 42
      },
      {
        "id": 28,
        "firstName": "Marion",
        "lastName": "Heath",
        "username": "@Espinoza",
        "email": "marionespinoza@comtours.com",
        "age": 47
      },
      {
        "id": 29,
        "firstName": "Newman",
        "lastName": "Hicks",
        "username": "@Keith",
        "email": "newmankeith@comtours.com",
        "age": 15
      },
      {
        "id": 30,
        "firstName": "Boyle",
        "lastName": "Larson",
        "username": "@Summers",
        "email": "boylesummers@comtours.com",
        "age": 32
      },
      {
        "id": 31,
        "firstName": "Haynes",
        "lastName": "Vinson",
        "username": "@Mckenzie",
        "email": "haynesmckenzie@comtours.com",
        "age": 15
      },
      {
        "id": 32,
        "firstName": "Miller",
        "lastName": "Acosta",
        "username": "@Young",
        "email": "milleryoung@comtours.com",
        "age": 55
      },
      {
        "id": 33,
        "firstName": "Johnston",
        "lastName": "Brown",
        "username": "@Knight",
        "email": "johnstonknight@comtours.com",
        "age": 29
      },
      {
        "id": 34,
        "firstName": "Lena",
        "lastName": "Pitts",
        "username": "@Forbes",
        "email": "lenaforbes@comtours.com",
        "age": 25
      },
      {
        "id": 35,
        "firstName": "Terrie",
        "lastName": "Kennedy",
        "username": "@Branch",
        "email": "terriebranch@comtours.com",
        "age": 37
      },
      {
        "id": 36,
        "firstName": "Louise",
        "lastName": "Aguirre",
        "username": "@Kirby",
        "email": "louisekirby@comtours.com",
        "age": 44
      },
      {
        "id": 37,
        "firstName": "David",
        "lastName": "Patton",
        "username": "@Sanders",
        "email": "davidsanders@comtours.com",
        "age": 26
      },
      {
        "id": 38,
        "firstName": "Holden",
        "lastName": "Barlow",
        "username": "@Mckinney",
        "email": "holdenmckinney@comtours.com",
        "age": 11
      },
      {
        "id": 39,
        "firstName": "Baker",
        "lastName": "Rivera",
        "username": "@Montoya",
        "email": "bakermontoya@comtours.com",
        "age": 47
      },
      {
        "id": 40,
        "firstName": "Belinda",
        "lastName": "Lloyd",
        "username": "@Calderon",
        "email": "belindacalderon@comtours.com",
        "age": 21
      },
      {
        "id": 41,
        "firstName": "Pearson",
        "lastName": "Patrick",
        "username": "@Clements",
        "email": "pearsonclements@comtours.com",
        "age": 42
      },
      {
        "id": 42,
        "firstName": "Alyce",
        "lastName": "Mckee",
        "username": "@Daugherty",
        "email": "alycedaugherty@comtours.com",
        "age": 55
      },
      {
        "id": 43,
        "firstName": "Valencia",
        "lastName": "Spence",
        "username": "@Olsen",
        "email": "valenciaolsen@comtours.com",
        "age": 20
      },
      {
        "id": 44,
        "firstName": "Leach",
        "lastName": "Holcomb",
        "username": "@Humphrey",
        "email": "leachhumphrey@comtours.com",
        "age": 28
      },
      {
        "id": 45,
        "firstName": "Moss",
        "lastName": "Baxter",
        "username": "@Fitzpatrick",
        "email": "mossfitzpatrick@comtours.com",
        "age": 51
      },
      {
        "id": 46,
        "firstName": "Jeanne",
        "lastName": "Cooke",
        "username": "@Ward",
        "email": "jeanneward@comtours.com",
        "age": 59
      },
      {
        "id": 47,
        "firstName": "Wilma",
        "lastName": "Briggs",
        "username": "@Kidd",
        "email": "wilmakidd@comtours.com",
        "age": 53
      },
      {
        "id": 48,
        "firstName": "Beatrice",
        "lastName": "Perry",
        "username": "@Gilbert",
        "email": "beatricegilbert@comtours.com",
        "age": 39
      },
      {
        "id": 49,
        "firstName": "Whitaker",
        "lastName": "Hyde",
        "username": "@Mcdonald",
        "email": "whitakermcdonald@comtours.com",
        "age": 35
      },
      {
        "id": 50,
        "firstName": "Rebekah",
        "lastName": "Duran",
        "username": "@Gross",
        "email": "rebekahgross@comtours.com",
        "age": 40
      },
      {
        "id": 51,
        "firstName": "Earline",
        "lastName": "Mayer",
        "username": "@Woodward",
        "email": "earlinewoodward@comtours.com",
        "age": 52
      },
      {
        "id": 52,
        "firstName": "Moran",
        "lastName": "Baxter",
        "username": "@Johns",
        "email": "moranjohns@comtours.com",
        "age": 20
      },
      {
        "id": 53,
        "firstName": "Nanette",
        "lastName": "Hubbard",
        "username": "@Cooke",
        "email": "nanettecooke@comtours.com",
        "age": 55
      },
      {
        "id": 54,
        "firstName": "Dalton",
        "lastName": "Walker",
        "username": "@Hendricks",
        "email": "daltonhendricks@comtours.com",
        "age": 25
      },
      {
        "id": 55,
        "firstName": "Bennett",
        "lastName": "Blake",
        "username": "@Pena",
        "email": "bennettpena@comtours.com",
        "age": 13
      },
      {
        "id": 56,
        "firstName": "Kellie",
        "lastName": "Horton",
        "username": "@Weiss",
        "email": "kellieweiss@comtours.com",
        "age": 48
      },
      {
        "id": 57,
        "firstName": "Hobbs",
        "lastName": "Talley",
        "username": "@Sanford",
        "email": "hobbssanford@comtours.com",
        "age": 28
      },
      {
        "id": 58,
        "firstName": "Mcguire",
        "lastName": "Donaldson",
        "username": "@Roman",
        "email": "mcguireroman@comtours.com",
        "age": 38
      },
      {
        "id": 59,
        "firstName": "Rodriquez",
        "lastName": "Saunders",
        "username": "@Harper",
        "email": "rodriquezharper@comtours.com",
        "age": 20
      },
      {
        "id": 60,
        "firstName": "Lou",
        "lastName": "Conner",
        "username": "@Sanchez",
        "email": "lousanchez@comtours.com",
        "age": 16
      }
    ];

    $scope.editableTableData = $scope.smartTableData.slice(0, 36);

    $scope.peopleTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28',
        status: 'info'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45',
        status: 'primary'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18',
        status: 'success'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20',
        status: 'danger'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30',
        status: 'warning'
      }
    ];

    $scope.metricsTableData = [
      {
        image: 'app/browsers/chrome.svg',
        browser: 'Google Chrome',
        visits: '10,392',
        isVisitsUp: true,
        purchases: '4,214',
        isPurchasesUp: true,
        percent: '45%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/firefox.svg',
        browser: 'Mozilla Firefox',
        visits: '7,873',
        isVisitsUp: true,
        purchases: '3,031',
        isPurchasesUp: false,
        percent: '28%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/ie.svg',
        browser: 'Internet Explorer',
        visits: '5,890',
        isVisitsUp: false,
        purchases: '2,102',
        isPurchasesUp: false,
        percent: '17%',
        isPercentUp: false
      },
      {
        image: 'app/browsers/safari.svg',
        browser: 'Safari',
        visits: '4,001',
        isVisitsUp: false,
        purchases: '1,001',
        isPurchasesUp: false,
        percent: '14%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/opera.svg',
        browser: 'Opera',
        visits: '1,833',
        isVisitsUp: true,
        purchases: '83',
        isPurchasesUp: true,
        percent: '5%',
        isPercentUp: false
      }
    ];

    $scope.users = [
      {
        "id": 1,
        "name": "Esther Vang",
        "status": 4,
        "group": 3
      },
      {
        "id": 2,
        "name": "Leah Freeman",
        "status": 3,
        "group": 1
      },
      {
        "id": 3,
        "name": "Mathews Simpson",
        "status": 3,
        "group": 2
      },
      {
        "id": 4,
        "name": "Buckley Hopkins",
        "group": 4
      },
      {
        "id": 5,
        "name": "Buckley Schwartz",
        "status": 1,
        "group": 1
      },
      {
        "id": 6,
        "name": "Mathews Hopkins",
        "status": 4,
        "group": 2
      },
      {
        "id": 7,
        "name": "Leah Vang",
        "status": 4,
        "group": 1
      },
      {
        "id": 8,
        "name": "Vang Schwartz",
        "status": 4,
        "group": 2
      },
      {
        "id": 9,
        "name": "Hopkin Esther",
        "status": 1,
        "group": 2
      },
      {
        "id": 10,
        "name": "Mathews Schwartz",
        "status": 1,
        "group": 3
      }
    ];

    $scope.statuses = [
      {value: 1, text: 'Good'},
      {value: 2, text: 'Awesome'},
      {value: 3, text: 'Excellent'},
    ];

    $scope.groups = [
      {id: 1, text: 'user'},
      {id: 2, text: 'customer'},
      {id: 3, text: 'vip'},
      {id: 4, text: 'admin'}
    ];

    $scope.showGroup = function(user) {
      if(user.group && $scope.groups.length) {
        var selected = $filter('filter')($scope.groups, {id: user.group});
        return selected.length ? selected[0].text : 'Not set';
      } else return 'Not set'
    };

    $scope.showStatus = function(user) {
      var selected = [];
      if(user.status) {
        selected = $filter('filter')($scope.statuses, {value: user.status});
      }
      return selected.length ? selected[0].text : 'Not set';
    };


    $scope.removeUser = function(index) {
      $scope.users.splice(index, 1);
    };

    $scope.addUser = function() {
      $scope.inserted = {
        id: $scope.users.length+1,
        name: '',
        status: null,
        group: null
      };
      $scope.users.push($scope.inserted);
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-success btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.usuarios')
    .controller('UsuariosPageCtrl', UsuariosPageCtrl);

  /** @ngInject */
  function UsuariosPageCtrl($scope, toastr, fileReader, $timeout,moment, $filter,$rootScope,$state,datosApp,conexionesWebservices,editableOptions, editableThemes,$uibModal) {
    //Definiciones
    $scope.datos_usuario={};
    $scope.datos_usuario.usuario={};
    $scope.datos_usuario.smartTablePageSize = 10;
    $scope.datos_usuario.quantityRows=100;
    // ------------------------------------
    $scope.edicionForm={};
    $scope.datos_edicion={};
    $scope.datos_edicion.confirmar_password_invalid=false;
    // ------------------------------------
    $scope.adicionForm={};
    $scope.datos_adicion={};
    $scope.datos_adicion.habilitar_formulario=false;
    $scope.datos_adicion.confirmar_password_invalid=false;
    // ------------------------------------
    // $scope.rowform.$cancel();
    //Funciones
    $scope.traerDatosActividadeco = function (cantidad) {
      conexionesWebservices.actividadesecoAPI.traeractividadeseco(cantidad)
      .then(function (response) {
            //console.log("Respuesta Listado Actividadeco",response.data);
            if(response.data!=null){
              $scope.datos_usuario.actividades_economicas=response.data;
            }
            else {
            }
            $scope.traerPerfilesAdministrativos('Todos');
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.editarUsuario = function(item) {
      //console.log("Upload Foto:",$scope.datos_edicion.foto);
      if($scope.datos_edicion.foto==undefined){
        $scope.actualizarUsuario(item);
      }
      else{
        $scope.datos_edicion.foto.upload=conexionesWebservices.usuariosAPI.modificarUsuarioFoto(item);
        $scope.datos_edicion.foto.upload
        .then(function (response) {
          $timeout(function () {
            $scope.datos_edicion.foto.result = response.data;
          });
          if(response.data!=null){
            //console.log("Respuesta:",response.data);
            $scope.showSuccessMsg("Usuario actualizado");
            $scope.traerDatosUsuario('Todos');
          }
          else {
          }
        }, function (response) {
          if (response.status > 0)
            $scope.errorMsg = response.status + ': ' + response.data;
        }, function (evt) {
          // Math.min is to fix IE which reports 200% sometimes
          $scope.datos_edicion.foto.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }
    $scope.traerListadoPorRegistros=function(){
      //console.log("Cantidad Registros",$scope.datos_usuario.quantityRows);
      $scope.traerDatosUsuario($scope.datos_usuario.quantityRows);
    }
    $scope.grabarCambios= function(index,item) {
      //console.log($scope.datos_usuario.listado[index].nombres);
      item.id=$scope.datos_usuario.listado[index].id;
      //console.log("Cambios en línea",item);
      conexionesWebservices.usuariosAPI.modificarusuario(item)
      .then(function (response) {
            if(response.data!=null){
              //console.log("Respuesta:",response.data);
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.confirmarEliminacionUsuario=function(){
      $scope.datos_usuario.listado.splice($scope.datos_usuario.index_usuario_eliminacion, 1);
      conexionesWebservices.usuariosAPI.eliminarUsuario($scope.datos_usuario.id_usuario_eliminacion)
      .then(function (response) {
            if(response.data!=null){
              $scope.showInfoMsg("Usuario eliminado");
              $scope.modal_eliminar.dismiss();
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    }
    $scope.borrarUsuario = function(index) {
      $scope.datos_usuario.nombre_usuario_eliminacion=$scope.datos_usuario.listado[index].nombres + " " + $scope.datos_usuario.listado[index].apellidos;
      $scope.datos_usuario.index_usuario_eliminacion=index;
      $scope.datos_usuario.id_usuario_eliminacion=$scope.datos_usuario.listado[index].id;
      var page='app/pages/usuarios/eliminacionUsuario.html';
      var size='md';
      $scope.modal_eliminar = $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.datosIniciales = function () {
      $scope.traerDatosActividadeco("Todos");


    }
    $scope.traerDatosUsuario = function (cantidad) {
      conexionesWebservices.usuariosAPI.traerusuarios(cantidad)
      .then(function (response) {
            //console.log("Respuesta Listado Usuario",response.data);
            if(response.data!=null){
              $scope.datos_usuario.listado=response.data;
              $scope.datos_usuario.safe_listado=[];
              $scope.datos_usuario.safe_listado=response.data;
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.traerPerfilesAdministrativos = function (cantidad) {
      conexionesWebservices.perfilesAdministrativosAPI.traerPerfilesAdministrativos(cantidad)
      .then(function (response) {
            if(response.data!=null){
              $scope.datos_usuario.perfiles_administrativos=response.data;
              //console.log("Perfiles",$scope.datos_usuario.perfiles_administrativos);
            }
            else {
            }
            $scope.traerDatosUsuario("Todos");
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    $scope.abrirEdicion = function (item) {
      $scope.datos_edicion=item;
      //console.log("Item",item);
      var tmp=$filter("filter")($scope.datos_usuario.perfiles_administrativos, {id:item.id_perfil_administrativo});
      $scope.datos_edicion.perfil_administrativo_objeto=tmp[0];
      // --------------
      var tmp=$filter("filter")($scope.datos_usuario.actividades_economicas, {id:item.id_actividad_economica});
      $scope.datos_edicion.actividad_economica=tmp[0];
      // --------------
      //console.log("Datos Edición",$scope.datos_edicion);
      $scope.datos_edicion.foto={};
      // $scope.datos_edicion.foto.upload
      //console.log("Perfil Adm del usuario",$scope.datos_edicion.perfil_administrativo_objeto);
      var page='app/pages/usuarios/edicionUsuario.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.actualizarUsuario= function(item) {
      //console.log("Item a modificar",item);
      conexionesWebservices.usuariosAPI.modificarusuario(item)
      .then(function (response) {
            if(response.data!=null){
              //console.log("Respuesta Usuario:",response.data);
              $scope.showSuccessMsg("Usuario actualizado");
              $scope.traerDatosUsuario('Todos');
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };
    // Válida Password
    $scope.validarPassword=function(){
      if($scope.datos_edicion.password != $scope.datos_edicion.confirmar_password) {
        $scope.edicionForm.$invalid=true;
        $scope.datos_edicion.confirmar_password_invalid=true;
      } else {
        $scope.edicionForm.$invalid=false;
        $scope.datos_edicion.confirmar_password_invalid=false;
      }
    }
    $scope.validarPasswordAdicion=function(){
      if($scope.datos_adicion.password != $scope.datos_adicion.confirmar_password) {
        $scope.adicionForm.$invalid=true;
        $scope.datos_adicion.confirmar_password_invalid=true;
      } else {
        $scope.adicionForm.$invalid=false;
        $scope.datos_adicion.confirmar_password_invalid=false;
      }
    }
    //
    $scope.abrirNuevo = function () {
      $scope.datos_adicion={};
      var page='app/pages/usuarios/adicionUsuario.html';
      var size='lg';
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        scope: $scope,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.agregarUsuario= function(item) {
      //console.log("Item a agregar",item);
      conexionesWebservices.usuariosAPI.agregarusuario(item)
      .then(function (response) {
            if(response.data!=null){
              //console.log("Respuesta:",response.data);
              $scope.showSuccessMsg("Usuario agregado");
              $scope.traerDatosUsuario('Todos');
              $scope.datos_adicion.habilitar_formulario=true;
            }
            else {
            }
        }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
        });
    };


    //----funcion para reiniciar el formulario---/////
        $scope.limpiarCampos_formUsuario = function(item) {
          $scope.datos_adicion={};
          if (item) {
            item.$setPristine();
            }
          $scope.datos_adicion.habilitar_formulario=false;
        };

    //Notificaciones
    $scope.showSuccessMsg = function(texto) {
      toastr.success(texto);
    };

    $scope.showInfoMsg = function(texto) {
      toastr.info(texto, 'Información');
    };

    $scope.showErrorMsg = function(texto) {
      toastr.error(texto, 'Error');
    };

    $scope.showWarningMsg = function(texto) {
      toastr.warning(texto, 'Alerta');
    };
  }//Fin del controller

})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('Drenta.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('Drenta.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('Drenta.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('Drenta.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('Drenta.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('Drenta.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('Drenta.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('Drenta.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('Drenta.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('Drenta.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('Drenta.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs')
    .controller('chartJs1DCtrl', chartJs1DCtrl);

  /** @ngInject */
  function chartJs1DCtrl($scope, baConfig) {
    var layoutColors = baConfig.colors;

    $scope.labels =["Sleeping", "Designing", "Coding", "Cycling"];
    $scope.data = [20, 40, 5, 35];
    $scope.options = {
      elements: {
        arc: {
          borderWidth: 0
        }
      },
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          fontColor: layoutColors.defaultText
        }
      }
    };

    $scope.changeData = function () {
      $scope.data = shuffle($scope.data);
    };

    function shuffle(o){
      for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x){}
      return o;
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs')
    .controller('chartJs2DCtrl', chartJs2DCtrl);

  /** @ngInject */
  function chartJs2DCtrl($scope) {
    $scope.labels =["May", "Jun", "Jul", "Aug", "Sep"];
    $scope.data = [
      [65, 59, 90, 81, 56],
      [28, 48, 40, 19, 88]
    ];
    $scope.series = ['Product A', 'Product B'];


    $scope.changeData = function () {
      $scope.data[0] = shuffle($scope.data[0]);
      $scope.data[1] = shuffle($scope.data[1]);
    };

    function shuffle(o){
      for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x){}
      return o;
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs')
    .controller('chartJsWaveCtrl', chartJsWaveCtrl);

  /** @ngInject */
  function chartJsWaveCtrl($scope, $interval, stopableInterval) {
    $scope.labels =["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    $scope.data = [1, 9, 3, 4, 5, 6, 7, 8, 2].map(function(e){
      return Math.sin(e) * 25 +25;
    });

    stopableInterval.start($interval, function(){
      var tempArray = [];
      var lastElement = $scope.data[$scope.data.length-1];
      for(var i = $scope.data.length-1; i > 0; i--){
       tempArray[i] = $scope.data[i-1];
      }
      tempArray[0] = lastElement;
      $scope.data = tempArray;
    }, 400)
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartist')
    .controller('chartistCtrl', chartistCtrl);

  /** @ngInject */
  function chartistCtrl($scope, $timeout, baConfig) {

    $scope.simpleLineOptions = {
      color: baConfig.colors.defaultText,
      fullWidth: true,
      height: "300px",
      chartPadding: {
        right: 40
      }
    };

    $scope.simpleLineData = {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
      series: [
        [20, 20, 12, 45, 50],
        [10, 45, 30, 14, 12],
        [34, 12, 12, 40, 50],
        [10, 43, 25, 22, 16],
        [3, 6, 30, 33, 43]
      ]
    };

    $scope.areaLineData = {
      labels: [1, 2, 3, 4, 5, 6, 7, 8],
      series: [
        [5, 9, 7, 8, 5, 3, 5, 4]
      ]
    };

    $scope.areaLineOptions = {
      fullWidth: true,
      height: "300px",
      low: 0,
      showArea: true
    };

    $scope.biLineData = {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      series: [
        [1, 2, 3, 1, -2, 0, 1],
        [-2, -1, -2, -1, -2.5, -1, -2],
        [0, 0, 0, 1, 2, 2.5, 2],
        [2.5, 2, 1, 0.5, 1, 0.5, -1]
      ]
    };

    $scope.biLineOptions = {
      height: "300px",
      high: 3,
      low: -3,
      showArea: true,
      showLine: false,
      showPoint: false,
      fullWidth: true,
      axisX: {
        showGrid: false
      }
    };

    $scope.simpleBarData = {
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      series: [
        [15, 24, 43, 27, 5, 10, 23, 44, 68, 50, 26, 8],
        [13, 22, 49, 22, 4, 6, 24, 46, 57, 48, 22, 4]
      ]
    };

    $scope.simpleBarOptions = {
      fullWidth: true,
      height: "300px"
    };

    $scope.multiBarData = {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      series: [
        [5, 4, 3, 7],
        [3, 2, 9, 5],
        [1, 5, 8, 4],
        [2, 3, 4, 6],
        [4, 1, 2, 1]
      ]
    };

    $scope.multiBarOptions = {
      fullWidth: true,
      height: "300px",
      stackBars: true,
      axisX: {
        labelInterpolationFnc: function (value) {
          return value.split(/\s+/).map(function (word) {
            return word[0];
          }).join('');
        }
      },
      axisY: {
        offset: 20
      }
    };

    $scope.multiBarResponsive = [
      ['screen and (min-width: 400px)', {
        reverseData: true,
        horizontalBars: true,
        axisX: {
          labelInterpolationFnc: Chartist.noop
        },
        axisY: {
          offset: 60
        }
      }],
      ['screen and (min-width: 700px)', {
        stackBars: false,
        reverseData: false,
        horizontalBars: false,
        seriesBarDistance: 15
      }]
    ];

    $scope.stackedBarData = {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      series: [
        [800000, 1200000, 1400000, 1300000],
        [200000, 400000, 500000, 300000],
        [100000, 200000, 400000, 600000]
      ]
    };

    $scope.stackedBarOptions = {
      fullWidth: true,
      height: "300px",
      stackBars: true,
      axisY: {
        labelInterpolationFnc: function (value) {
          return (value / 1000) + 'k';
        }
      }
    };

    $scope.simplePieData = {
      series: [5, 3, 4]
    };

    $scope.simplePieOptions = {
      fullWidth: true,
      height: "300px",
      weight: "300px",
      labelInterpolationFnc: function (value) {
        return Math.round(value / 12 * 100) + '%';
      }
    };

    $scope.labelsPieData = {
      labels: ['Bananas', 'Apples', 'Grapes'],
      series: [20, 15, 40]
    };

    $scope.labelsPieOptions = {
      fullWidth: true,
      height: "300px",
      weight: "300px",
      labelDirection: 'explode',
      labelInterpolationFnc: function (value) {
        return value[0];
      }
    };

    $scope.simpleDonutData = {
      labels: ['Bananas', 'Apples', 'Grapes'],
      series: [20, 15, 40]
    };

    $scope.simpleDonutOptions = {
      fullWidth: true,
      donut: true,
      height: "300px",
      weight: "300px",
      labelDirection: 'explode',
      labelInterpolationFnc: function (value) {
        return value[0];
      }
    };

    $scope.donutResponsive = getResponsive(5, 40);

    $scope.pieResponsive = getResponsive(20, 80);

    function getResponsive(padding, offset){
      return [
        ['screen and (min-width: 1550px)', {
          chartPadding: padding,
          labelOffset: offset,
          labelDirection: 'explode',
          labelInterpolationFnc: function (value) {
            return value;
          }
        }],
        ['screen and (max-width: 1200px)', {
          chartPadding: padding,
          labelOffset: offset,
          labelDirection: 'explode',
          labelInterpolationFnc: function (value) {
            return value;
          }
        }],
        ['screen and (max-width: 600px)', {
          chartPadding: 0,
          labelOffset: 0,
          labelInterpolationFnc: function (value) {
            return value[0];
          }
        }]
      ];
    }

    $timeout(function(){
      new Chartist.Line('#line-chart', $scope.simpleLineData, $scope.simpleLineOptions);
      new Chartist.Line('#area-chart', $scope.areaLineData, $scope.areaLineOptions);
      new Chartist.Line('#bi-chart', $scope.biLineData, $scope.biLineOptions);

      new Chartist.Bar('#simple-bar', $scope.simpleBarData, $scope.simpleBarOptions);
      new Chartist.Bar('#multi-bar', $scope.multiBarData, $scope.multiBarOptions, $scope.multiBarResponsive);
      new Chartist.Bar('#stacked-bar', $scope.stackedBarData, $scope.stackedBarOptions);

      new Chartist.Pie('#simple-pie', $scope.simplePieData, $scope.simplePieOptions, $scope.pieResponsive);
      new Chartist.Pie('#label-pie', $scope.labelsPieData, $scope.labelsPieOptions);
      new Chartist.Pie('#donut', $scope.simpleDonutData, $scope.simpleDonutOptions, $scope.donutResponsive);
    });
  }
})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.morris')
    .controller('morrisCtrl', morrisCtrl);

  /** @ngInject */
  function morrisCtrl($scope, $window, baConfig) {
    var layoutColors = baConfig.colors;
    $scope.colors = [layoutColors.primary, layoutColors.warning, layoutColors.danger, layoutColors.info, layoutColors.success, layoutColors.primaryDark];
    $scope.lineData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.areaData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.barData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.donutData = [
      {label: "Download Sales", value: 12},
      {label: "In-Store Sales", value: 30},
      {label: "Mail-Order Sales", value: 20}
    ];

    angular.element($window).bind('resize', function () {
      //$window.Morris.Grid.prototype.redraw();
    });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
      .controller('MailTabCtrl', MailTabCtrl);

  /** @ngInject */
  function MailTabCtrl(composeModal, mailMessages) {

    var vm = this;
    vm.navigationCollapsed = true;
    vm.showCompose = function(subject, to , text){
      composeModal.open({
        subject : subject,
        to: to,
        text: text
      })
    };

    vm.tabs = mailMessages.getTabs();
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .service('mailMessages', mailMessages);

  /** @ngInject */
  function mailMessages($sce) {
    var messages = [
      {
        "id": "4563faass",
        "name": "Nasta Linnie",
        "subject": "Great text",
        "date": "2015-08-28T07:57:09",
        "body": $sce.trustAsHtml("<p>Hey John, </p><p>Check out this cool text.</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "attachment": "poem.txt",
        "position": "Great Employee",
        "tag": "friend",
        "labels": ['inbox']
      },
      {
        "id": "4563fdfvd",
        "name": "Nasta Linnie",
        "subject": "Lores ipsum",
        "date": "2015-11-19T03:30:45",
        "important": false,
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ex mauris, ultrices vel lectus quis, scelerisque hendrerit ipsum. Suspendisse ullamcorper turpis neque, eget dapibus magna placerat ac. Suspendisse rhoncus ligula ac mi tempus varius ut sed lacus. Sed et commodo nulla, et placerat leo. Nam rhoncus vulputate sem non pharetra. Praesent fringilla massa in laoreet convallis. Aliquam lobortis dui a congue facilisis. Aenean dapibus semper semper. Quisque aliquam, nibh dapibus interdum condimentum, ex velit tempor tortor, at vestibulum magna leo quis leo. Morbi pulvinar varius erat ac rutrum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In hac habitasse platea dictumst.</p>" +
          "<br><p>Cras rhoncus quam ipsum, vel dignissim nisl egestas sed. Aliquam erat volutpat. Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "position": "Great Employee",
        "tag": "study",
        "labels": ['inbox']
      },
      {
        "id": "4563zxcss",
        "name": "Nasta Linnie",
        "subject": "Lores ipsum",
        "date": "2015-10-19T03:30:45",
        "important": false,
        "body": $sce.trustAsHtml("<p>Hey Nasta, </p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "position": "Great Employee",
        "tag": "work",
        "labels": ['sent', 'important']
      },
      {
        "id": "8955sddf",
        "name": "Nick Cat",
        "subject": "New Design",
        "date": "2015-05-05T12:59:45",
        "body": $sce.trustAsHtml("<p>Hey John, Consectetur adipiscing elit</p><br>" +
          "<p>Cras rhoncus quam ipsum, vel dignissim nisl egestas sed. Aliquam erat volutpat. Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "attachment": "design.psd",
        "tag": "work",
        "labels": ['inbox']
      },
      {
        "id": "8955sdfcc",
        "name": "Nick Cat",
        "subject": "Gift card",
        "date": "2015-07-18T10:19:01",
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Consectetur adipiscing elit, Lorem ipsum dolor sit amet</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "tag": "study",
        "labels": ['inbox']
      },
      {
        "id": "8955asewf",
        "name": "Nick Cat",
        "subject": "Some news",
        "date": "2015-09-23T03:04:10",
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "tag": "work",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334uudsa",
        "name": "Kostya Danovsky",
        "subject": "Street Art",
        "date": "2015-11-22T10:05:09",
        "body": $sce.trustAsHtml("<p>Hey John, </p><p>Aliquam eu facilisis eros, quis varius est.</p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<p>Lorem ipsum dolor sit amet! Nullam imperdiet justo a ipsum laoreet euismod.</p>" +
          "<br><p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed." +
          "Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "attachment": "file.doc",
        "tag": "family",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334aefvv",
        "name": "Kostya Danovsky",
        "subject": "New product",
        "date": "2015-06-22T06:26:10",
        "body": $sce.trustAsHtml("<p>Hello John, </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<p>Aliquam eu facilisis eros, quis varius est. Nullam imperdiet justo a ipsum laoreet euismod.</p>" +
          "<br><p>Nulla facilisi. Nulla congue, arcu eget blandit lacinia, leo ante ullamcorper lectus, vel pulvinar justo ipsum vitae justo." +
          "Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "tag": "family",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334cvdss",
        "name": "Kostya Danovsky",
        "subject": "Old product",
        "date": "2015-06-22T06:26:10",
        "body": $sce.trustAsHtml("<p>Hello John, </p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<br>"+
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "tag": "study",
        "labels": ['trash']
      },
      {
        "id": "8223xzxfn",
        "name": "Andrey Hrabouski",
        "subject": "Skype moji",
        "date": "2015-07-16T06:47:53",
        "body": $sce.trustAsHtml("<p>Hello John, </p><p>Aliquam sodales sem in nibh pellentesque</p>" +
          "<p>Lorem ipsum dolor I find moji in skype sit amet!.</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": 'family',
        "labels": ['trash']
      },
      {
        "id": "8223sdffn",
        "name": "Andrey Hrabouski",
        "subject": "My App",
        "date": "2015-06-20T07:05:02",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Consectetur My Falasson App elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": 'family',
        "labels": ['spam']
      },
      {
        "id": "9391xdsff",
        "name": "Vlad Lugovsky",
        "subject": "Cool",
        "date": "2015-03-31T11:52:58",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Aliquam sodales sem in nibh pellentesque</p>" +
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed.</p>"),
        "pic": "img/Vlad.png",
        "email": "carlsongoodman@mail.com",
        "position": "Fullstack man",
        "tag": "study",
        "labels": ['draft']
      },
      {
        "id": "8223xsdaa",
        "name": "Andrey Hrabouski",
        "subject": "Car rent",
        "date": "2015-02-25T10:58:58",
        "body": $sce.trustAsHtml("<p>Hey Andrey. </p>" +
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": "family",
        "labels": ['draft']
      },
      {
        "id": "9391xdsff",
        "name": "Vlad Lugovsky",
        "subject": "What next",
        "date": "2015-03-31T11:52:58",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Esse esse labore tempor ullamco ullamco. Id veniam laborum c.</p>"),
        "pic": "img/Vlad.png",
        "email": "carlsongoodman@mail.com",
        "position": "Fullstack man",
        "tag": "study",
        "labels": ['sent']
      }
    ].sort(function (a, b) {
        if (a.date > b.date) return 1;
        if (a.date < b.date) return -1;
      }).reverse();
    var tabs = [{
      label: 'inbox',
      name: 'Inbox',
      newMails: 7
    }, {
      label: 'sent',
      name: 'Sent Mail'
    }, {
      label: 'important',
      name: 'Important'
    }, {
      label: 'draft',
      name: 'Draft',
      newMails: 2
    }, {
      label: 'spam',
      name: 'Spam'
    }, {
      label: 'trash',
      name: 'Trash'
    }];

    return{
      getTabs : function(){
        return tabs
      },
      getMessagesByLabel : function(label){
        return messages.filter(function(m){
          return m.labels.indexOf(label) != -1;
        });
      },
      getMessageById : function(id){
        return messages.filter(function(m){
          return m.id == id;
        })[0];
      }
    }

  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.tree')
    .controller('treeCtrl', treeCtrl);

  /** @ngInject */
  function treeCtrl($scope, $timeout) {

    $scope.ignoreChanges = false;
    var newId = 0;
    $scope.ignoreChanges = false;
    $scope.newNode = {};

    $scope.basicConfig = {
      core: {
        multiple: false,
        check_callback: true,
        worker: true
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-folder'
        },
        'default': {
          'icon': 'ion-document-text'
        }
      },
      'plugins': ['types'],
      'version': 1
    };

    $scope.dragConfig = {
      'core': {
        'check_callback': true,
        'themes': {
          'responsive': false
        }
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-folder'
        },
        'default': {
          'icon': 'ion-document-text'
        }
      },
      "plugins": ["dnd", 'types']
    };

    $scope.addNewNode = function () {
      $scope.ignoreChanges = true;
      var selected = this.basicTree.jstree(true).get_selected()[0];
      if (selected)
        $scope.treeData.push({
          id: (newId++).toString(),
          parent: selected,
          text: "New node " + newId,
          state: {opened: true}
        });
      $scope.basicConfig.version++;
    };


    $scope.refresh = function () {
      $scope.ignoreChanges = true;
      newId = 0;
      $scope.treeData = getDefaultData();
      $scope.basicConfig.version++;
    };

    $scope.expand = function () {
      $scope.ignoreChanges = true;
      $scope.treeData.forEach(function (n) {
        n.state.opened = true;
      });
      $scope.basicConfig.version++;
    };

    $scope.collapse = function () {
      $scope.ignoreChanges = true;
      $scope.treeData.forEach(function (n) {
        n.state.opened = false;
      });
      $scope.basicConfig.version++;
    };

    $scope.readyCB = function() {
      $timeout(function() {
        $scope.ignoreChanges = false;
      });
    };


    $scope.applyModelChanges = function() {
      return !$scope.ignoreChanges;
    };

    $scope.treeData = getDefaultData();
    $scope.dragData = [
      {
        "id": "nd1",
        "parent": "#",
        "type": "folder",
        "text": "Node 1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd2",
        "parent": "#",
        "type": "folder",
        "text": "Node 2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd3",
        "parent": "#",
        "type": "folder",
        "text": "Node 3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd4",
        "parent": "#",
        "type": "folder",
        "text": "Node 4",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd5",
        "parent": "nd1",
        "text": "Node 1.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd6",
        "parent": "nd1",
        "text": "Node 1.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd7",
        "parent": "nd1",
        "text": "Node 1.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd8",
        "parent": "nd2",
        "text": "Node 2.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd9",
        "parent": "nd2",
        "text": "Node 2.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd10",
        "parent": "nd2",
        "text": "Node 2.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd11",
        "parent": "nd3",
        "text": "Node 3.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd12",
        "parent": "nd3",
        "text": "Node 3.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd13",
        "parent": "nd3",
        "text": "Node 3.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd14",
        "parent": "nd4",
        "text": "Node 4.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd15",
        "parent": "nd4",
        "text": "Node 4.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd16",
        "parent": "nd4",
        "text": "Node 4.3",
        "state": {
          "opened": true
        }
      }
    ];

    function getDefaultData() {
      return [
        {
          "id": "n1",
          "parent": "#",
          "type": "folder",
          "text": "Node 1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n2",
          "parent": "#",
          "type": "folder",
          "text": "Node 2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n3",
          "parent": "#",
          "type": "folder",
          "text": "Node 3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n5",
          "parent": "n1",
          "text": "Node 1.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n6",
          "parent": "n1",
          "text": "Node 1.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n7",
          "parent": "n1",
          "text": "Node 1.3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n8",
          "parent": "n1",
          "text": "Node 1.4",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n9",
          "parent": "n2",
          "text": "Node 2.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n10",
          "parent": "n2",
          "text": "Node 2.2 (Custom icon)",
          "icon": "ion-help-buoy",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n12",
          "parent": "n3",
          "text": "Node 3.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n13",
          "parent": "n3",
          "type": "folder",
          "text": "Node 3.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n14",
          "parent": "n13",
          "text": "Node 3.2.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n15",
          "parent": "n13",
          "text": "Node 3.2.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n16",
          "parent": "n3",
          "text": "Node 3.3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n17",
          "parent": "n3",
          "text": "Node 3.4",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n18",
          "parent": "n3",
          "text": "Node 3.5",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n19",
          "parent": "n3",
          "text": "Node 3.6",
          "state": {
            "opened": true
          }
        }
      ]
    }


  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.timeline')
      .controller('TimelineCtrl', TimelineCtrl);

  /** @ngInject */
  function TimelineCtrl() {
    var timelineBlocks = $('.cd-timeline-block'),
        offset = 0.8;

    //hide timeline blocks which are outside the viewport
    hideBlocks(timelineBlocks, offset);

    //on scolling, show/animate timeline blocks when enter the viewport
    $(window).on('scroll', function () {
      if (!window.requestAnimationFrame) {
        setTimeout(function () {
          showBlocks(timelineBlocks, offset);
        }, 100);
      } else {
        window.requestAnimationFrame(function () {
          showBlocks(timelineBlocks, offset);
        });
      }
    });

    function hideBlocks(blocks, offset) {
      blocks.each(function () {
        ( $(this).offset().top > $(window).scrollTop() + $(window).height() * offset ) && $(this).find('.cd-timeline-img, .cd-timeline-content').addClass('is-hidden');
      });
    }

    function showBlocks(blocks, offset) {
      blocks.each(function () {
        ( $(this).offset().top <= $(window).scrollTop() + $(window).height() * offset && $(this).find('.cd-timeline-img').hasClass('is-hidden') ) && $(this).find('.cd-timeline-img, .cd-timeline-content').removeClass('is-hidden').addClass('bounce-in');
      });
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.dashboard')
      .controller('BlurFeedCtrl', BlurFeedCtrl);

  /** @ngInject */
  function BlurFeedCtrl($scope) {
    $scope.feed = [
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
        time: 'Today 11:55 pm',
        ago: '25 minutes ago',
        expanded: false,
      }, {
        type: 'video-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Added new video',
        text: '"Vader and Me"',
        preview: 'app/feed/vader-and-me-preview.png',
        link: 'https://www.youtube.com/watch?v=IfcpzBbbamk',
        time: 'Today 9:30 pm',
        ago: '3 hrs ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Added new image',
        text: '"My little kitten"',
        preview: 'app/feed/my-little-kitten.png',
        link: 'http://api.ning.com/files/DtcI2O2Ry7A7VhVxeiWfGU9WkHcMy4WSTWZ79oxJq*h0iXvVGndfD7CIYy-Ax-UAFCBCdqXI4GCBw3FOLKTTjQc*2cmpdOXJ/1082127884.jpeg',
        time: 'Today 2:20 pm',
        ago: '10 hrs ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'Haha lol',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'geo-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted location',
        text: '"New York, USA"',
        preview: 'app/feed/new-york-location.png',
        link: 'https://www.google.by/maps/place/New+York,+NY,+USA/@40.7201111,-73.9893872,14z',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Posted new message',
        text: "First snake: I hope I'm not poisonous. Second snake: Why? First snake: Because I bit my lip!",
        time: '12.11.2015',
        ago: '3 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Posted new message',
        text: 'How do you smuggle an elephant across the border? Put a slice of bread on each side, and call him "lunch".',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'When your hammer is C++, everything begins to look like a thumb.',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Alexander',
        surname: 'Demeshko',
        header: 'Posted new message',
        text: '“I mean, they say you die twice. One time when you stop breathing and a second time, a bit later on, when somebody says your name for the last time." ©',
        time: '15.11.2015',
        ago: '6 days ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted photo',
        text: '"Protein Heroes"',
        preview: 'app/feed/genom.png',
        link: 'https://dribbble.com/shots/2504810-Protein-Heroes',
        time: '16.11.2015',
        ago: '7 days ago',
        expanded: false,
      },
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Why did the CoffeeScript developer keep getting lost? Because he couldn\'t find his source without a map',
        time: '18.11.2015',
        ago: '9 days ago',
        expanded: false,
      }
    ];

    $scope.expandMessage = function(message){
      message.expanded = !message.expanded;
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.dashboard')
      .directive('blurFeed', blurFeed);

  /** @ngInject */
  function blurFeed() {
    return {
      restrict: 'E',
      controller: 'BlurFeedCtrl',
      templateUrl: 'app/pages/dashboard/blurFeed/blurFeed.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.dashboard')
      .service('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.dashboard')
      .controller('DashboardCalendarCtrl', DashboardCalendarCtrl);

  /** @ngInject */
  function DashboardCalendarCtrl(baConfig) {
    var dashboardColors = baConfig.colors.dashboard;
    var $element = $('#calendar').fullCalendar({
      //height: 335,
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month,agendaWeek,agendaDay'
      },
      defaultDate: '2016-03-08',
      selectable: true,
      selectHelper: true,
      select: function (start, end) {
        var title = prompt('Event Title:');
        var eventData;
        if (title) {
          eventData = {
            title: title,
            start: start,
            end: end
          };
          $element.fullCalendar('renderEvent', eventData, true); // stick? = true
        }
        $element.fullCalendar('unselect');
      },
      editable: true,
      eventLimit: true, // allow "more" link when too many events
      events: [
        {
          title: 'All Day Event',
          start: '2016-03-01',
          color: dashboardColors.silverTree
        },
        {
          title: 'Long Event',
          start: '2016-03-07',
          end: '2016-03-10',
          color: dashboardColors.blueStone
        },
        {
          title: 'Dinner',
          start: '2016-03-14T20:00:00',
          color: dashboardColors.surfieGreen
        },
        {
          title: 'Birthday Party',
          start: '2016-04-01T07:00:00',
          color: dashboardColors.gossipDark
        }
      ]
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.dashboard')
      .directive('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {
    return {
      restrict: 'E',
      controller: 'DashboardCalendarCtrl',
      templateUrl: 'app/pages/dashboard/dashboardCalendar/dashboardCalendar.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.dashboard')
      .controller('DashboardLineChartCtrl', DashboardLineChartCtrl);

  /** @ngInject */
  function DashboardLineChartCtrl(baConfig, layoutPaths, baUtil) {
    var layoutColors = baConfig.colors;
    var graphColor = baConfig.theme.blur ? '#000000' : layoutColors.primary;
    var chartData = [
      { date: new Date(2012, 11), value: 0, value0: 0 },
      { date: new Date(2013, 0), value: 15000, value0: 19000},
      { date: new Date(2013, 1), value: 30000, value0: 20000},

      { date: new Date(2013, 2), value: 25000, value0: 22000},
      { date: new Date(2013, 3), value: 21000, value0: 25000},
      { date: new Date(2013, 4), value: 24000, value0: 29000},
      { date: new Date(2013, 5), value: 31000, value0: 26000},
      { date: new Date(2013, 6), value: 40000, value0: 25000},
      { date: new Date(2013, 7), value: 37000, value0: 20000},
      { date: new Date(2013, 8), value: 18000, value0: 22000},
      { date: new Date(2013, 9), value: 5000, value0: 26000},
      { date: new Date(2013, 10), value: 40000, value0: 30000},
      { date: new Date(2013, 11), value: 20000, value0: 25000},
      { date: new Date(2014, 0), value: 5000, value0: 13000},

      { date: new Date(2014, 1), value: 3000, value0: 13000},
      { date: new Date(2014, 2), value: 1800, value0: 13000},
      { date: new Date(2014, 3), value: 10400, value0: 13000},
      { date: new Date(2014, 4), value: 25500, value0: 13000},
      { date: new Date(2014, 5), value: 2100, value0: 13000},
      { date: new Date(2014, 6), value: 6500, value0: 13000},
      { date: new Date(2014, 7), value: 1100, value0: 13000},
      { date: new Date(2014, 8), value: 17200, value0: 13000},
      { date: new Date(2014, 9), value: 26900, value0: 13000},
      { date: new Date(2014, 10), value: 14100, value0: 13000},
      { date: new Date(2014, 11), value: 35300, value0: 13000},
      { date: new Date(2015, 0), value: 54800, value0: 13000},
      { date: new Date(2015, 1), value: 49800, value0: 13000}
    ];

    var chart = AmCharts.makeChart('amchart', {
      type: 'serial',
      theme: 'blur',
      marginTop: 15,
      marginRight: 15,
      dataProvider: chartData,
      categoryField: 'date',
      categoryAxis: {
        parseDates: true,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText
      },
      valueAxes: [
        {
          minVerticalGap: 50,
          gridAlpha: 0,
          color: layoutColors.defaultText,
          axisColor: layoutColors.defaultText
        }
      ],
      graphs: [
        {
          id: 'g0',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.3),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value0',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        },
        {
          id: 'g1',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.5),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        }
      ],
      chartCursor: {
        categoryBalloonDateFormat: 'MM YYYY',
        categoryBalloonColor: '#4285F4',
        categoryBalloonAlpha: 0.7,
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5
      },
      dataDateFormat: 'MM YYYY',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      zoomOutButton: {
        backgroundColor: '#fff',
        backgroundAlpha: 0
      },
      zoomOutText: '',
      pathToImages: layoutPaths.images.amChart
    });

    function zoomChart() {
      chart.zoomToDates(new Date(2013, 3), new Date(2014, 0));
    }

    chart.addListener('rendered', zoomChart);
    zoomChart();
    if (chart.zoomChart) {
      chart.zoomChart();
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.dashboard')
      .directive('dashboardLineChart', dashboardLineChart);

  /** @ngInject */
  function dashboardLineChart() {
    return {
      restrict: 'E',
      controller: 'DashboardLineChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardLineChart/dashboardLineChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.dashboard')
      .controller('DashboardMapCtrl', DashboardMapCtrl);

  /** @ngInject */
  function DashboardMapCtrl(baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var map = AmCharts.makeChart('amChartMap', {
      type: 'map',
      theme: 'blur',
      zoomControl: { zoomControlEnabled: false, panControlEnabled: false },

      dataProvider: {
        map: 'worldLow',
        zoomLevel: 3.5,
        zoomLongitude: 10,
        zoomLatitude: 52,
        areas: [
          { title: 'Austria', id: 'AT', color: layoutColors.primary, customData: '1 244', groupId: '1'},
          { title: 'Ireland', id: 'IE', color: layoutColors.primary, customData: '1 342', groupId: '1'},
          { title: 'Denmark', id: 'DK', color: layoutColors.primary, customData: '1 973', groupId: '1'},
          { title: 'Finland', id: 'FI', color: layoutColors.primary, customData: '1 573', groupId: '1'},
          { title: 'Sweden', id: 'SE', color: layoutColors.primary, customData: '1 084', groupId: '1'},
          { title: 'Great Britain', id: 'GB', color: layoutColors.primary, customData: '1 452', groupId: '1'},
          { title: 'Italy', id: 'IT', color: layoutColors.primary, customData: '1 321', groupId: '1'},
          { title: 'France', id: 'FR', color: layoutColors.primary, customData: '1 112', groupId: '1'},
          { title: 'Spain', id: 'ES', color: layoutColors.primary, customData: '1 865', groupId: '1'},
          { title: 'Greece', id: 'GR', color: layoutColors.primary, customData: '1 453', groupId: '1'},
          { title: 'Germany', id: 'DE', color: layoutColors.primary, customData: '1 957', groupId: '1'},
          { title: 'Belgium', id: 'BE', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Luxembourg', id: 'LU', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Netherlands', id: 'NL', color: layoutColors.primary, customData: '1 213', groupId: '1'},
          { title: 'Portugal', id: 'PT', color: layoutColors.primary, customData: '1 291', groupId: '1'},
          { title: 'Lithuania', id: 'LT', color: layoutColors.successLight, customData: '567', groupId: '2'},
          { title: 'Latvia', id: 'LV', color: layoutColors.successLight, customData: '589', groupId: '2'},
          { title: 'Czech Republic ', id: 'CZ', color: layoutColors.successLight, customData: '785', groupId: '2'},
          { title: 'Slovakia', id: 'SK', color: layoutColors.successLight, customData: '965', groupId: '2'},
          { title: 'Estonia', id: 'EE', color: layoutColors.successLight, customData: '685', groupId: '2'},
          { title: 'Hungary', id: 'HU', color: layoutColors.successLight, customData: '854', groupId: '2'},
          { title: 'Cyprus', id: 'CY', color: layoutColors.successLight, customData: '754', groupId: '2'},
          { title: 'Malta', id: 'MT', color: layoutColors.successLight, customData: '867', groupId: '2'},
          { title: 'Poland', id: 'PL', color: layoutColors.successLight, customData: '759', groupId: '2'},
          { title: 'Romania', id: 'RO', color: layoutColors.success, customData: '302', groupId: '3'},
          { title: 'Bulgaria', id: 'BG', color: layoutColors.success, customData: '102', groupId: '3'},
          { title: 'Slovenia', id: 'SI', color: layoutColors.danger, customData: '23', groupId: '4'},
          { title: 'Croatia', id: 'HR', color: layoutColors.danger, customData: '96', groupId: '4'}
        ]
      },

      areasSettings: {
        rollOverOutlineColor: layoutColors.border,
        rollOverColor: layoutColors.primaryDark,
        alpha: 0.8,
        unlistedAreasAlpha: 0.2,
        unlistedAreasColor: layoutColors.defaultText,
        balloonText: '[[title]]: [[customData]] users'
      },


      legend: {
        width: '100%',
        marginRight: 27,
        marginLeft: 27,
        equalWidths: false,
        backgroundAlpha: 0.3,
        backgroundColor: layoutColors.border,
        borderColor: layoutColors.border,
        borderAlpha: 1,
        top: 362,
        left: 0,
        horizontalGap: 10,
        data: [
          {
            title: 'over 1 000 users',
            color: layoutColors.primary
          },
          {
            title: '500 - 1 000 users',
            color: layoutColors.successLight
          },
          {
            title: '100 - 500 users',
            color: layoutColors.success
          },
          {
            title: '0 - 100 users',
            color: layoutColors.danger
          }
        ]
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.dashboard')
      .directive('dashboardMap', dashboardMap);

  /** @ngInject */
  function dashboardMap() {
    return {
      restrict: 'E',
      controller: 'DashboardMapCtrl',
      templateUrl: 'app/pages/dashboard/dashboardMap/dashboardMap.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.dashboard')
      .controller('DashboardPieChartCtrl', DashboardPieChartCtrl);

  /** @ngInject */
  function DashboardPieChartCtrl($scope, $timeout, baConfig, baUtil) {
    var pieColor = baUtil.hexToRGB(baConfig.colors.defaultText, 0.2);
    $scope.charts = [{
      color: pieColor,
      description: 'New Visits',
      stats: '57,820',
      icon: 'person',
    }, {
      color: pieColor,
      description: 'Purchases',
      stats: '$ 89,745',
      icon: 'money',
    }, {
      color: pieColor,
      description: 'Active Users',
      stats: '178,391',
      icon: 'face',
    }, {
      color: pieColor,
      description: 'Returned',
      stats: '32,592',
      icon: 'refresh',
    }
    ];

    function getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    }

    function loadPieCharts() {
      $('.chart').each(function () {
        var chart = $(this);
        chart.easyPieChart({
          easing: 'easeOutBounce',
          onStep: function (from, to, percent) {
            $(this.el).find('.percent').text(Math.round(percent));
          },
          barColor: chart.attr('rel'),
          trackColor: 'rgba(0,0,0,0)',
          size: 84,
          scaleLength: 0,
          animation: 2000,
          lineWidth: 9,
          lineCap: 'round',
        });
      });

      $('.refresh-data').on('click', function () {
        updatePieCharts();
      });
    }

    function updatePieCharts() {
      $('.pie-charts .chart').each(function(index, chart) {
        $(chart).data('easyPieChart').update(getRandomArbitrary(55, 90));
      });
    }

    $timeout(function () {
      loadPieCharts();
      updatePieCharts();
    }, 1000);
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.dashboard')
      .directive('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {
    return {
      restrict: 'E',
      controller: 'DashboardPieChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardPieChart/dashboardPieChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.dashboard')
      .controller('DashboardTodoCtrl', DashboardTodoCtrl);

  /** @ngInject */
  function DashboardTodoCtrl($scope, baConfig) {

    $scope.transparent = baConfig.theme.blur;
    var dashboardColors = baConfig.colors.dashboard;
    var colors = [];
    for (var key in dashboardColors) {
      colors.push(dashboardColors[key]);
    }

    function getRandomColor() {
      var i = Math.floor(Math.random() * (colors.length - 1));
      return colors[i];
    }

    $scope.todoList = [
      { text: 'Check me out' },
      { text: 'Lorem ipsum dolor sit amet, possit denique oportere at his, etiam corpora deseruisse te pro' },
      { text: 'Ex has semper alterum, expetenda dignissim' },
      { text: 'Vim an eius ocurreret abhorreant, id nam aeque persius ornatus.' },
      { text: 'Simul erroribus ad usu' },
      { text: 'Ei cum solet appareat, ex est graeci mediocritatem' },
      { text: 'Get in touch with akveo team' },
      { text: 'Write email to business cat' },
      { text: 'Have fun with blur admin' },
      { text: 'What do you think?' },
    ];

    $scope.todoList.forEach(function(item) {
      item.color = getRandomColor();
    });

    $scope.newTodoText = '';

    $scope.addToDoItem = function (event, clickPlus) {
      if (clickPlus || event.which === 13) {
        $scope.todoList.unshift({
          text: $scope.newTodoText,
          color: getRandomColor(),
        });
        $scope.newTodoText = '';
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.dashboard')
      .directive('dashboardTodo', dashboardTodo);

  /** @ngInject */
  function dashboardTodo() {
    return {
      restrict: 'EA',
      controller: 'DashboardTodoCtrl',
      templateUrl: 'app/pages/dashboard/dashboardTodo/dashboardTodo.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.dashboard')
      .service('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.dashboard')
      .directive('popularApp', popularApp);

  /** @ngInject */
  function popularApp() {
    return {
      restrict: 'E',
      templateUrl: 'app/pages/dashboard/popularApp/popularApp.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.dashboard')
      .controller('TrafficChartCtrl', TrafficChartCtrl);

  /** @ngInject */
  function TrafficChartCtrl($scope, baConfig, colorHelper) {

      $scope.transparent = baConfig.theme.blur;
      var dashboardColors = baConfig.colors.dashboard;
      $scope.doughnutData = {
          labels: [
              'Other',
              'Search engines',
              'Referral Traffic',
              'Direct Traffic',
              'Ad Campaigns'
          ],
          datasets: [
              {
                  data: [2000, 1500, 1000, 1200, 400],
                  backgroundColor: [
                      dashboardColors.white,
                      dashboardColors.blueStone,
                      dashboardColors.surfieGreen,
                      dashboardColors.silverTree,
                      dashboardColors.gossip

                  ],
                  hoverBackgroundColor: [
                      colorHelper.shade(dashboardColors.white, 15),
                      colorHelper.shade(dashboardColors.blueStone, 15),
                      colorHelper.shade(dashboardColors.surfieGreen, 15),
                      colorHelper.shade(dashboardColors.silverTree, 15),
                      colorHelper.shade(dashboardColors.gossip, 15)
                  ],
                  percentage: [87, 22, 70, 38, 17]
              }]
      };

      var ctx = document.getElementById('chart-area').getContext('2d');
      window.myDoughnut = new Chart(ctx, {
          type: 'doughnut',
          data: $scope.doughnutData,
          options: {
              cutoutPercentage: 64,
              responsive: true,
              elements: {
                  arc: {
                      borderWidth: 0
                  }
              }
          }
      });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.dashboard')
      .directive('trafficChart', trafficChart);

  /** @ngInject */
  function trafficChart() {
    return {
      restrict: 'E',
      controller: 'TrafficChartCtrl',
      templateUrl: 'app/pages/dashboard/trafficChart/trafficChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.dashboard')
      .controller('WeatherCtrl', WeatherCtrl);

  /** @ngInject */
  function WeatherCtrl($scope, $http, $timeout, $element) {
    var url = 'http://api.openweathermap.org/data/2.5/forecast';
    var method = 'GET';
    var key = '2de143494c0b295cca9337e1e96b00e0';
    var middleOfTheDay = 15;
    $scope.units = 'metric';
    $scope.weatherIcons = {
      '01d': 'ion-ios-sunny-outline',
      '02d': 'ion-ios-partlysunny-outline',
      '03d': 'ion-ios-cloud-outline',
      '04d': 'ion-ios-cloud',
      '09d': 'ion-ios-rainy',
      '10d': 'ion-ios-rainy-outline',
      '11d': 'ion-ios-thunderstorm-outline',
      '13d': 'ion-ios-snowy',
      '50d': 'ion-ios-cloudy-outline',
      '01n': 'ion-ios-cloudy-night-outline',
      '02n': 'ion-ios-cloudy-night',
      '03n': 'ion-ios-cloud-outline',
      '04n': 'ion-ios-cloud',
      '09n': 'ion-ios-rainy',
      '10n': 'ion-ios-rainy-outline',
      '11n': 'ion-ios-thunderstorm',
      '13n': 'ion-ios-snowy',
      '50n': 'ion-ios-cloudy-outline'
    };
    $scope.weather = {};

    $scope.switchUnits = function (name) {
      $scope.units = name;
      $scope.updateWeather();
    };

    $scope.switchDay = function (day) {
      $scope.weather.current = day;
      makeChart($scope.weather.days[$scope.weather.current].timeTemp)
    };

    $scope.updateWeather = function () {
      $http({
        method: method, url: url, params: {
          appid: key,
          lat: $scope.geoData.geoplugin_latitude,
          lon: $scope.geoData.geoplugin_longitude,
          units: $scope.units
        }
      }).then(function success(response) {
        saveWeatherData(response.data);
        makeChart($scope.weather.days[$scope.weather.current].timeTemp)
      }, function error() {
        //console.log("WEATHER FAILED")
      });
    };

    function updateGeoData() {
      $http.jsonp('http://www.geoplugin.net/json.gp?jsoncallback=JSON_CALLBACK').then(function success(response) {
        $scope.geoData = response.data;
        $scope.updateWeather();
      }, function error() {
        //console.log("GEO FAILED")
      });
    }

    function makeChart(data) {
      AmCharts.makeChart('tempChart', {
        type: 'serial',
        theme: 'blur',
        handDrawn: true,
        categoryField: 'time',
        dataProvider: data,
        valueAxes: [
          {
            axisAlpha: 0.3,
            gridAlpha: 0
          }
        ],
        graphs: [
          {
            bullet: 'square',
            fillAlphas: 0.3,
            fillColorsField: 'lineColor',
            legendValueText: '[[value]]',
            lineColorField: 'lineColor',
            title: 'Temp',
            valueField: 'temp'
          }
        ],
        categoryAxis: {
          gridAlpha: 0,
          axisAlpha: 0.3
        }
      }).write('tempChart');
    }

    function saveWeatherData(data) {
      var firstItem = data.list[0];
      var weather = {
        days: [{
          date: new Date(),
          timeTemp: [],
          main: firstItem.weather[0].main,
          description: firstItem.weather[0].description,
          icon: firstItem.weather[0].icon,
          temp: firstItem.main.temp
        }], current: 0
      };
      data.list.forEach(function (item, i) {
        var itemDate = new Date(item.dt_txt);
        if (itemDate.getDate() !== weather.days[weather.days.length - 1].date.getDate()) {
          weather.days.push({date: itemDate, timeTemp: []});
        }
        var lastItem = weather.days[weather.days.length - 1];
        lastItem.timeTemp.push({
          time: itemDate.getHours(),
          temp: item.main.temp
        });
        if ((weather.days.length > 1 && itemDate.getHours() == middleOfTheDay) || i == data.list.length - 1) {
          lastItem.main = item.weather[0].main;
          lastItem.description = item.weather[0].description;
          lastItem.icon = item.weather[0].icon;
          lastItem.temp = item.main.temp;
          lastItem.date.setHours(i == data.list.length - 1 ? 0 : middleOfTheDay);
          lastItem.date.setMinutes(0);
        }
      });
      //console.log(weather.days[weather.current].date);
      weather.days = weather.days.slice(0, $element.attr('forecast') || 5);
      $scope.weather = weather;
    }

    updateGeoData();
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.pages.dashboard')
      .directive('weather', weather);

  /** @ngInject */
  function weather() {
    return {
      restrict: 'EA',
      controller: 'WeatherCtrl',
      templateUrl: 'app/pages/dashboard/weather/weather.html'
    };
  }
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('WizardCtrl', WizardCtrl);

  /** @ngInject */
  function WizardCtrl($scope) {
   var vm = this;

    vm.personalInfo = {};
    vm.productInfo = {};
    vm.shipment = {};

    vm.arePersonalInfoPasswordsEqual = function () {
      return vm.personalInfo.confirmPassword && vm.personalInfo.password == vm.personalInfo.confirmPassword;
    };
  }

})();


/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.buttons')
      .controller('ButtonPageCtrl', ButtonPageCtrl);

  /** @ngInject */
  function ButtonPageCtrl($scope, $timeout) {
    $scope.progressFunction = function() {
      return $timeout(function() {}, 3000);
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.icons')
      .controller('IconsPageCtrl', IconsPageCtrl);

  /** @ngInject */
  function IconsPageCtrl($scope) {
    $scope.icons = {
      kameleonIcons: [
        {
          name: 'Beach',
          img: 'Beach'
        },
        {
          name: 'Bus',
          img: 'Bus'
        },
        {
          name: 'Cheese',
          img: 'Cheese'
        },
        {
          name: 'Desert',
          img: 'Desert'
        },
        {
          name: 'Images',
          img: 'Images'
        },
        {
          name: 'Magician',
          img: 'Magician'
        },
        {
          name: 'Makeup',
          img: 'Makeup'
        },
        {
          name: 'Programming',
          img: 'Programming'
        },
        {
          name: 'Shop',
          img: 'Shop'
        },
        {
          name: 'Surfer',
          img: 'Surfer'
        },
        {
          name: 'Phone Booth',
          img: 'Phone-Booth'
        },
        {
          name: 'Ninja',
          img: 'Ninja'
        },
        {
          name: 'Apartment',
          img: 'Apartment'
        },
        {
          name: 'Batman',
          img: 'Batman'
        },
        {
          name: 'Medal',
          img: 'Medal-2'
        },
        {
          name: 'Money',
          img: 'Money-Increase'
        },
        {
          name: 'Street View',
          img: 'Street-View'
        },
        {
          name: 'Student',
          img: 'Student-3'
        },
        {
          name: 'Bell',
          img: 'Bell'
        },
        {
          name: 'Woman',
          img: 'Boss-5'
        },
        {
          name: 'Euro',
          img: 'Euro-Coin'
        },
        {
          name: 'Chessboard',
          img: 'Chessboard'
        },
        {
          name: 'Burglar',
          img: 'Burglar'
        },
        {
          name: 'Dna',
          img: 'Dna'
        },
        {
          name: 'Clipboard Plan',
          img: 'Clipboard-Plan'
        },
        {
          name: 'Boss',
          img: 'Boss-3'
        },
        {
          name: 'Key',
          img: 'Key'
        },
        {
          name: 'Surgeon',
          img: 'Surgeon'
        },
        {
          name: 'Hacker',
          img: 'Hacker'
        },
        {
          name: 'Santa',
          img: 'Santa'
        }
      ],
      kameleonRoundedIcons: [
        {
          color: 'success',
          img: 'Apartment',
          name: 'Apartment'
        },
        {
          color: 'warning',
          img: 'Bus',
          name: 'Bus'
        },
        {
          color: 'primary',
          img: 'Checklist',
          name: 'Checklist'
        },
        {
          color: 'warning',
          img: 'Desert',
          name: 'Desert'
        },
        {
          color: 'danger',
          img: 'Laptop-Signal',
          name: 'Laptop Signal'
        },
        {
          color: 'info',
          img: 'Love-Letter',
          name: 'Love Letter'
        },
        {
          color: 'success',
          img: 'Makeup',
          name: 'Makeup'
        },
        {
          color: 'primary',
          img: 'Santa',
          name: 'Santa'
        },
        {
          color: 'success',
          img: 'Surfer',
          name: 'Surfer'
        },
        {
          color: 'info',
          img: 'Vector',
          name: 'Vector'
        },
        {
          color: 'warning',
          img: 'Money-Increase',
          name: 'Money Increase'
        },
        {
          color: 'info',
          img: 'Alien',
          name: 'Alien'
        },
        {
          color: 'danger',
          img: 'Online-Shopping',
          name: 'Online Shopping'
        },
        {
          color: 'warning',
          img: 'Euro-Coin',
          name: 'Euro'
        },
        {
          color: 'info',
          img: 'Boss-3',
          name: 'Boss'
        }
      ],
      ionicons: ['ion-ionic', 'ion-arrow-right-b', 'ion-arrow-down-b', 'ion-arrow-left-b', 'ion-arrow-up-c', 'ion-arrow-right-c', 'ion-arrow-down-c', 'ion-arrow-left-c', 'ion-arrow-return-right', 'ion-arrow-return-left', 'ion-arrow-swap', 'ion-arrow-shrink', 'ion-arrow-expand', 'ion-arrow-move', 'ion-arrow-resize', 'ion-chevron-up', 'ion-chevron-right', 'ion-chevron-down', 'ion-chevron-left', 'ion-navicon-round', 'ion-navicon', 'ion-drag', 'ion-log-in', 'ion-log-out', 'ion-checkmark-round', 'ion-checkmark', 'ion-checkmark-circled', 'ion-close-round', 'ion-plus-round', 'ion-minus-round', 'ion-information', 'ion-help', 'ion-backspace-outline', 'ion-help-buoy', 'ion-asterisk', 'ion-alert', 'ion-alert-circled', 'ion-refresh', 'ion-loop', 'ion-shuffle', 'ion-home', 'ion-search', 'ion-flag', 'ion-star', 'ion-heart', 'ion-heart-broken', 'ion-gear-a', 'ion-gear-b', 'ion-toggle-filled', 'ion-toggle', 'ion-settings', 'ion-wrench', 'ion-hammer', 'ion-edit', 'ion-trash-a', 'ion-trash-b', 'ion-document', 'ion-document-text', 'ion-clipboard', 'ion-scissors', 'ion-funnel', 'ion-bookmark', 'ion-email', 'ion-email-unread', 'ion-folder', 'ion-filing', 'ion-archive', 'ion-reply', 'ion-reply-all', 'ion-forward'],
      fontAwesomeIcons: ['fa fa-adjust', 'fa fa-anchor', 'fa fa-archive', 'fa fa-area-chart', 'fa fa-arrows', 'fa fa-arrows-h', 'fa fa-arrows-v', 'fa fa-asterisk', 'fa fa-at', 'fa fa-automobile', 'fa fa-ban', 'fa fa-bank', 'fa fa-bar-chart', 'fa fa-bar-chart-o', 'fa fa-barcode', 'fa fa-bars', 'fa fa-bed', 'fa fa-beer', 'fa fa-bell', 'fa fa-bell-o', 'fa fa-bell-slash', 'fa fa-bell-slash-o', 'fa fa-bicycle', 'fa fa-binoculars', 'fa fa-birthday-cake', 'fa fa-bolt', 'fa fa-bomb', 'fa fa-book', 'fa fa-bookmark', 'fa fa-bookmark-o', 'fa fa-briefcase', 'fa fa-bug', 'fa fa-building', 'fa fa-building-o', 'fa fa-bullhorn'],
      socicon: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', ',', ';', ':', '+', '@', '=', '-', '^', '?', '$', '*', '&', '(', '#', '.', '_', ']', ')', '\'', '"', '}', '{']
    }
  }

})();

/**
 * @author a.demeshko
 * created on 18.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications')
    .controller('ModalsPageCtrl', ModalsPageCtrl);

  /** @ngInject */
  function ModalsPageCtrl($scope, $uibModal, baProgressModal) {
    $scope.open = function (page, size) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.openProgressDialog = baProgressModal.open;
  }


})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications')
      .controller('NotificationsPageCtrl', NotificationsPageCtrl);

  /** @ngInject */
  function NotificationsPageCtrl($scope, toastr, toastrConfig) {
    var defaultConfig = angular.copy(toastrConfig);
    $scope.types = ['success', 'error', 'info', 'warning'];

    $scope.quotes = [
      {
        title: 'Come to Freenode',
        message: 'We rock at <em>#angularjs</em>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Looking for bootstrap?',
        message: 'Try ui-bootstrap out!'
      },
      {
        title: 'Wants a better router?',
        message: 'We have you covered with ui-router'
      },
      {
        title: 'Angular 2',
        message: 'Is gonna rock the world'
      },
      {
        title: null,
        message: 'Titles are not always needed'
      },
      {
        title: null,
        message: 'Toastr rock!'
      },
      {
        title: 'What about nice html?',
        message: '<strong>Sure you <em>can!</em></strong>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Ionic is <em>cool</em>',
        message: 'Best mobile framework ever',
        options: {
          allowHtml: true
        }
      }
    ];

    var openedToasts = [];
    $scope.options = {
      autoDismiss: false,
      positionClass: 'toast-top-right',
      type: 'info',
      timeOut: '5000',
      extendedTimeOut: '2000',
      allowHtml: false,
      closeButton: false,
      tapToDismiss: true,
      progressBar: false,
      newestOnTop: true,
      maxOpened: 0,
      preventDuplicates: false,
      preventOpenDuplicates: false,
      title: "Some title here",
      msg: "Type your message here"
    };


    $scope.clearLastToast = function () {
      var toast = openedToasts.pop();
      toastr.clear(toast);
    };

    $scope.clearToasts = function () {
      toastr.clear();
    };

    $scope.openRandomToast = function () {
      var type = Math.floor(Math.random() * $scope.types.length);
      var quote = Math.floor(Math.random() * $scope.quotes.length);
      var toastType = $scope.types[type];
      var toastQuote = $scope.quotes[quote];
      openedToasts.push(toastr[toastType](toastQuote.message, toastQuote.title, toastQuote.options));
      $scope.optionsStr = "toastr." + toastType + "(\'" + toastQuote.message + "\', \'" + toastQuote.title + "', " + JSON.stringify(toastQuote.options || {}, null, 2) + ")";
    };

    $scope.openToast = function () {
      angular.extend(toastrConfig, $scope.options);
      openedToasts.push(toastr[$scope.options.type]($scope.options.msg, $scope.options.title));
      var strOptions = {};
      for (var o in  $scope.options) if (o != 'msg' && o != 'title')strOptions[o] = $scope.options[o];
      $scope.optionsStr = "toastr." + $scope.options.type + "(\'" + $scope.options.msg + "\', \'" + $scope.options.title + "\', " + JSON.stringify(strOptions, null, 2) + ")";
    };

    $scope.$on('$destroy', function iVeBeenDismissed() {
      angular.extend(toastrConfig, defaultConfig);
    })
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('Drenta.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('Drenta.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('Drenta.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('Drenta.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService) {

    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('Drenta.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('Drenta.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('Drenta.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('Drenta.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('Drenta.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce,notificionesApp) {    
    $scope.datosIniciales=function () {
      console.log("por acá viejo",notificionesApp.por_leer);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.theme.components')
    .controller('PageTopPageCtrl', PageTopPageCtrl);

  /** @ngInject */
  function PageTopPageCtrl($scope, fileReader, $filter, $window, conexionesWebservices, $uibModal,$state,$rootScope,datosApp,notificionesApp) {
    $scope.datos_pageTop={};
    $scope.listado_notificaciones={};
    $scope.datos_pageTop.datosApp=datosApp;
    $scope.datos_pageTop.datosLogin=$rootScope.$datosLogin;
    //console.log("dato login",$scope.datos_pageTop.datosLogin);
    if($scope.datos_pageTop.datosLogin.datos.foto=="" ||
    $scope.datos_pageTop.datosLogin.datos.foto==undefined ||
    isNaN($scope.datos_pageTop.datosLogin.datos.foto)) {
      $scope.datos_pageTop.datosLogin.datos.foto="media/personas/defecto-usuario.png";
    }
    if($rootScope.$pageLogin==0 || $rootScope.$pageLogin=="0"){
      //console.log("Login");
      $state.go('login');
    }
    // ------------------------
    $scope.$on("cargarNotificaciones", function(event) {
        $scope.datosIniciales();
    });
    $scope.$on("agregarNotificacion", function(event,datos) {
        $scope.agregarNotificacion(datos);
    });
    // ------------------------
    // ---------------
    $scope.marcarComoRevisada= function(item){
      console.log("Noti revisda",item);
      item.revisada=1;
      conexionesWebservices.notificacionesAPI.modificar(item)
      .then(function (response) {
        // console.log("Notificacion creada exitosamente",response.data);
        if(response.data!=null){
          // $scope.datos_patrimonio.entidades= response.data;
          // console.log("Hora actual",hora_actual);
          $scope.datosIniciales();
        }
        else {
          // $scope.datos_patrimonio.entidades= null;
        }
      }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
      });
    }
    $scope.agregarNotificacion=function (datos) {
      console.log("Daticos ome",datos);
      var hora_actual=datos.fecha_notificacion;
      hora_actual.setMinutes( hora_actual.getMinutes() - 10 );
      // console.log("hora nueva",hora_actual);
      var permitido=false;
      if((hora_actual<notificionesApp.ultima_notificacion) || notificionesApp.ultima_notificacion==null){
        permitido=true;
      }
      console.log("Es permitido",permitido);
      if(permitido){
        if(datos.tipo==1){
          datos.detalle="Tiene un certificado con cambios por revisar";
        }
        else if(datos.tipo==2){
          datos.detalle="Tiene un nuevo certificado por revisar";
        }
        else{
          datos.detalle="El cliente <strong>"+datos.nombres+"</strong> ha subido un nuevo soporte";
        }
        conexionesWebservices.notificacionesAPI.agregar(datos)
        .then(function (response) {
          // console.log("Notificacion creada exitosamente",response.data);
          if(response.data!=null){
            // $scope.datos_patrimonio.entidades= response.data;
            // console.log("Hora actual",hora_actual);
            notificionesApp.ultima_notificacion=hora_actual;
          }
          else {
            // $scope.datos_patrimonio.entidades= null;
          }
        }, function (error) {
              // $scope.status = 'Unable to load customer data: ' + error.message;
        });
      }
    }
    $scope.datosIniciales =function () {
      var notificacionesParaCliente;
      console.log("DAtos Usuario",$rootScope.$datosLogin);
      if($rootScope.$datosLogin!=null){
        if($rootScope.$datosLogin.datos.id_perfil_administrativo!=4){
          notificacionesParaCliente=0;
        }
        else{
          notificacionesParaCliente=$rootScope.$datosLogin.datos.id;
        }
        // console.log("En Page Top",notificacionesParaCliente);
        // console.log("notificacionesParaCliente",notificacionesParaCliente);
        $scope.traerNotificaciones(notificacionesParaCliente);
      }
    }
    $scope.traerNotificaciones=function(notificacionesParaCliente) {
      conexionesWebservices.notificacionesAPI.traer(notificacionesParaCliente)
      .then(function (response) {
        if(response.data.consulta_exitosa){
          notificionesApp.por_leer=response.data.datos;
          $scope.listado_notificaciones= response.data.datos;
          console.log("Listado Notificaciones",response.data.datos);
        }
        else {
          // $scope.datos_patrimonio.entidades= null;
        }
      }, function (error) {
            // $scope.status = 'Unable to load customer data: ' + error.message;
      });
    }
    // ----------------
    $scope.cerrarSesion=function() {
      //console.log("Cierre de sesión");
      // window.localStorage.removeItem("usuario_loggueado");
      // window.localStorage.removeItem("datos_de_usuario");
      window.localStorage.setItem("usuario_loggueado",0);
      window.localStorage.setItem("datos_de_usuario",null);
      $rootScope.$pageLogin=0;
      $rootScope.$datosLogin={};
      $window.location.href = '/';
    }
    $scope.irAProfile=function () {
      $scope.datosUsuario=angular.fromJson(window.localStorage.getItem("datos_de_usuario"));
      //console.log("DAtos de usuario",$scope.datosUsuario);
      $state.go("perfilusuario",{datosEdicion:$scope.datosUsuario.datos});
      // $state.go('login');
    }
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html',
      controller: 'PageTopPageCtrl',
    };
  }

})();

/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('Drenta.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('Drenta.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('Drenta.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('AreaChartCtrl', AreaChartCtrl);

  /** @ngInject */
  function AreaChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var areaChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      dataProvider: [
        {
          lineColor: layoutColors.info,
          date: '2012-01-01',
          duration: 408
        },
        {
          date: '2012-01-02',
          duration: 482
        },
        {
          date: '2012-01-03',
          duration: 562
        },
        {
          date: '2012-01-04',
          duration: 379
        },
        {
          lineColor: layoutColors.warning,
          date: '2012-01-05',
          duration: 501
        },
        {
          date: '2012-01-06',
          duration: 443
        },
        {
          date: '2012-01-07',
          duration: 405
        },
        {
          date: '2012-01-08',
          duration: 309,
          lineColor: layoutColors.danger
        },
        {
          date: '2012-01-09',
          duration: 287
        },
        {
          date: '2012-01-10',
          duration: 485
        },
        {
          date: '2012-01-11',
          duration: 890
        },
        {
          date: '2012-01-12',
          duration: 810
        }
      ],
      balloon: {
        cornerRadius: 6,
        horizontalPadding: 15,
        verticalPadding: 10
      },
      valueAxes: [
        {
          duration: 'mm',
          durationUnits: {
            hh: 'h ',
            mm: 'min'
          },
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      graphs: [
        {
          bullet: 'square',
          bulletBorderAlpha: 1,
          bulletBorderThickness: 1,
          fillAlphas: 0.5,
          fillColorsField: 'lineColor',
          legendValueText: '[[value]]',
          lineColorField: 'lineColor',
          title: 'duration',
          valueField: 'duration'
        }
      ],

      chartCursor: {
        categoryBalloonDateFormat: 'YYYY MMM DD',
        cursorAlpha: 0,
        fullWidth: true
      },
      dataDateFormat: 'YYYY-MM-DD',
      categoryField: 'date',
      categoryAxis: {
        dateFormats: [
          {
            period: 'DD',
            format: 'DD'
          },
          {
            period: 'WW',
            format: 'MMM DD'
          },
          {
            period: 'MM',
            format: 'MMM'
          },
          {
            period: 'YYYY',
            format: 'YYYY'
          }
        ],
        parseDates: true,
        autoGridCount: false,
        gridCount: 50,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      pathToImages: layoutPaths.images.amChart
    });

    areaChart.addListener('dataUpdated', zoomAreaChart);

    function zoomAreaChart() {
      areaChart.zoomToDates(new Date(2012, 0, 3), new Date(2012, 0, 11));
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('BarChartCtrl', BarChartCtrl);

  /** @ngInject */
  function BarChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var barChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      dataProvider: [
        {
          country: 'USA',
          visits: 3025,
          color: layoutColors.primary
        },
        {
          country: 'China',
          visits: 1882,
          color: layoutColors.danger

        },
        {
          country: 'Japan',
          visits: 1809,
          color: layoutColors.info
        },
        {
          country: 'Germany',
          visits: 1322,
          color: layoutColors.success
        },
        {
          country: 'UK',
          visits: 1122,
          color: layoutColors.warning
        },
        {
          country: 'France',
          visits: 1114,
          color: layoutColors.primaryLight
        }
      ],
      valueAxes: [
        {
          axisAlpha: 0,
          position: 'left',
          title: 'Visitors from country',
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      startDuration: 1,
      graphs: [
        {
          balloonText: '<b>[[category]]: [[value]]</b>',
          fillColorsField: 'color',
          fillAlphas: 0.7,
          lineAlpha: 0.2,
          type: 'column',
          valueField: 'visits'
        }
      ],
      chartCursor: {
        categoryBalloonEnabled: false,
        cursorAlpha: 0,
        zoomable: false
      },
      categoryField: 'country',
      categoryAxis: {
        gridPosition: 'start',
        labelRotation: 45,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      creditsPosition: 'top-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
    .controller('combinedChartCtrl', combinedChartCtrl);

  /** @ngInject */
  function combinedChartCtrl($element, baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var chart = AmCharts.makeChart(id, {
      "type": "serial",
      "theme": "none",
      "color": layoutColors.defaultText,
      "dataDateFormat": "YYYY-MM-DD",
      "precision": 2,
      "valueAxes": [{
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText,
        gridColor: layoutColors.defaultText,
        "id": "v1",
        "title": "Sales",
        "position": "left",
        "autoGridCount": false,
        "labelFunction": function(value) {
          return "$" + Math.round(value) + "M";
        }
      }, {
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText,
        gridColor: layoutColors.defaultText,
        "id": "v2",
        "title": "Market Days",
        "gridAlpha": 0,
        "position": "right",
        "autoGridCount": false
      }],
      "graphs": [{
        "id": "g3",
        color: layoutColors.defaultText,
        "valueAxis": "v1",
        "lineColor": layoutColors.primaryLight,
        "fillColors": layoutColors.primaryLight,
        "fillAlphas": 0.8,
        "lineAlpha": 0.8,
        "type": "column",
        "title": "Actual Sales",
        "valueField": "sales2",
        "clustered": false,
        "columnWidth": 0.5,
        "lineColorField" : layoutColors.defaultText,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g4",
        "valueAxis": "v1",
        color: layoutColors.defaultText,
        "lineColor": layoutColors.primary,
        "fillColors": layoutColors.primary,
        "fillAlphas": 0.9,
        "lineAlpha": 0.9,
        "type": "column",
        "title": "Target Sales",
        "valueField": "sales1",
        "clustered": false,
        "columnWidth": 0.3,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g1",
        "valueAxis": "v2",
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": layoutColors.defaultText,
        color: layoutColors.defaultText,
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": layoutColors.danger,
        "type": "smoothedLine",
        "title": "Market Days",
        "useLineColorForBulletBorder": true,
        "valueField": "market1",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
      }, {
        "id": "g2",
        "valueAxis": "v2",
        color: layoutColors.defaultText,
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": layoutColors.defaultText,
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": layoutColors.warning,
        "type": "smoothedLine",
        "dashLength": 5,
        "title": "Market Days ALL",
        "useLineColorForBulletBorder": true,
        "valueField": "market2",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
      }],
      "chartScrollbar": {
        "graph": "g1",
        "oppositeAxis": false,
        "offset": 30,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        scrollbarHeight: 50,
        backgroundAlpha: 0,
        selectedBackgroundAlpha: 0.05,
        selectedBackgroundColor: layoutColors.defaultText,
        graphFillAlpha: 0,
        autoGridCount: true,
        selectedGraphFillAlpha: 0,
        graphLineAlpha: 0.2,
        selectedGraphLineColor: layoutColors.defaultText,
        selectedGraphLineAlpha: 1
      },
      "chartCursor": {
        "pan": true,
        "cursorColor" : layoutColors.danger,
        "valueLineEnabled": true,
        "valueLineBalloonEnabled": true,
        "cursorAlpha": 0,
        "valueLineAlpha": 0.2
      },
      "categoryField": "date",
      "categoryAxis": {
        "axisColor": layoutColors.defaultText,
        "color": layoutColors.defaultText,
        "gridColor": layoutColors.defaultText,
        "parseDates": true,
        "dashLength": 1,
        "minorGridEnabled": true
      },
      "legend": {
        "useGraphSettings": true,
        "position": "top",
        "color": layoutColors.defaultText
      },
      "balloon": {
        "borderThickness": 1,
        "shadowAlpha": 0
      },
      "export": {
        "enabled": true
      },
      "dataProvider": [{
        "date": "2013-01-16",
        "market1": 71,
        "market2": 75,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-17",
        "market1": 74,
        "market2": 78,
        "sales1": 4,
        "sales2": 6
      }, {
        "date": "2013-01-18",
        "market1": 78,
        "market2": 88,
        "sales1": 5,
        "sales2": 2
      }, {
        "date": "2013-01-19",
        "market1": 85,
        "market2": 89,
        "sales1": 8,
        "sales2": 9
      }, {
        "date": "2013-01-20",
        "market1": 82,
        "market2": 89,
        "sales1": 9,
        "sales2": 6
      }, {
        "date": "2013-01-21",
        "market1": 83,
        "market2": 85,
        "sales1": 3,
        "sales2": 5
      }, {
        "date": "2013-01-22",
        "market1": 88,
        "market2": 92,
        "sales1": 5,
        "sales2": 7
      }, {
        "date": "2013-01-23",
        "market1": 85,
        "market2": 90,
        "sales1": 7,
        "sales2": 6
      }, {
        "date": "2013-01-24",
        "market1": 85,
        "market2": 91,
        "sales1": 9,
        "sales2": 5
      }, {
        "date": "2013-01-25",
        "market1": 80,
        "market2": 84,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-26",
        "market1": 87,
        "market2": 92,
        "sales1": 4,
        "sales2": 8
      }, {
        "date": "2013-01-27",
        "market1": 84,
        "market2": 87,
        "sales1": 3,
        "sales2": 4
      }, {
        "date": "2013-01-28",
        "market1": 83,
        "market2": 88,
        "sales1": 5,
        "sales2": 7
      }, {
        "date": "2013-01-29",
        "market1": 84,
        "market2": 87,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-30",
        "market1": 81,
        "market2": 85,
        "sales1": 4,
        "sales2": 7
      }],
      pathToImages: layoutPaths.images.amChart
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('FunnelChartCtrl', FunnelChartCtrl);

  /** @ngInject */
  function FunnelChartCtrl($scope, $element, layoutPaths, baConfig) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var funnelChart = AmCharts.makeChart(id, {
      type: 'funnel',
      theme: 'blur',
      color: layoutColors.defaultText,
      labelTickColor: layoutColors.borderDark,
      dataProvider: [
        {
          title: 'Website visits',
          value: 300
        },
        {
          title: 'Downloads',
          value: 123
        },
        {
          title: 'Requested prices',
          value: 98
        },
        {
          title: 'Contaced',
          value: 72
        },
        {
          title: 'Purchased',
          value: 35
        },
        {
          title: 'Asked for support',
          value: 25
        },
        {
          title: 'Purchased more',
          value: 18
        }
      ],
      titleField: 'title',
      marginRight: 160,
      marginLeft: 15,
      labelPosition: 'right',
      funnelAlpha: 0.9,
      valueField: 'value',
      startX: 0,
      alpha: 0.8,
      neckWidth: '0%',
      startAlpha: 0,
      outlineThickness: 1,
      neckHeight: '0%',
      balloonText: '[[title]]:<b>[[value]]</b>',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-left',
      pathToImages: layoutPaths
    });
  }
})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
    .controller('ganttChartCtrl', ganttChartCtrl);

  /** @ngInject */
  function ganttChartCtrl($element) {
    var id = $element[0].getAttribute('id');
    var chart = AmCharts.makeChart( id, {
      "type": "gantt",
      "theme": "light",
      "marginRight": 70,
      "period": "hh",
      "dataDateFormat":"YYYY-MM-DD",
      "balloonDateFormat": "JJ:NN",
      "columnWidth": 0.5,
      "valueAxis": {
        "type": "date",
        "minimum": 7,
        "maximum": 31
      },
      "brightnessStep": 10,
      "graph": {
        "fillAlphas": 1,
        "balloonText": "<b>[[task]]</b>: [[open]] [[value]]"
      },
      "rotate": true,
      "categoryField": "category",
      "segmentsField": "segments",
      "colorField": "color",
      "startDate": "2015-01-01",
      "startField": "start",
      "endField": "end",
      "durationField": "duration",
      "dataProvider": [
        {
        "category": "John",
        "segments": [ {
          "start": 7,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Smith",
        "segments": [ {
          "start": 10,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Ben",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Mike",
        "segments": [ {
          "start": 9,
          "duration": 6,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 4,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Lenny",
        "segments": [ {
          "start": 8,
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Scott",
        "segments": [ {
          "start": 15,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Julia",
        "segments": [ {
          "start": 9,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 1,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 8,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Bob",
        "segments": [ {
          "start": 9,
          "duration": 8,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 7,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Kendra",
        "segments": [ {
          "start": 11,
          "duration": 8,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Tom",
        "segments": [ {
          "start": 9,
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 5,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Kyle",
        "segments": [ {
          "start": 6,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Anita",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Jack",
        "segments": [ {
          "start": 8,
          "duration": 10,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Kim",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 3,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Aaron",
        "segments": [ {
          "start": 18,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Alan",
        "segments": [ {
          "start": 17,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Ruth",
        "segments": [ {
          "start": 13,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Simon",
        "segments": [ {
          "start": 10,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 17,
          "duration": 4,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      } ],
      "valueScrollbar": {
        "autoGridCount":true
      },
      "chartCursor": {
        "cursorColor":"#55bb76",
        "valueBalloonsEnabled": false,
        "cursorAlpha": 0,
        "valueLineAlpha":0.5,
        "valueLineBalloonEnabled": true,
        "valueLineEnabled": true,
        "zoomable":false,
        "valueZoomable":true
      },
      "export": {
        "enabled": true
      }
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('LineChartCtrl', LineChartCtrl);

  /** @ngInject */
  function LineChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var lineChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      marginTop: 0,
      marginRight: 15,
      dataProvider: [
        {
          year: '1990',
          value: -0.17
        },
        {
          year: '1991',
          value: -0.254
        },
        {
          year: '1992',
          value: 0.019
        },
        {
          year: '1993',
          value: -0.063
        },
        {
          year: '1994',
          value: 0.005
        },
        {
          year: '1995',
          value: 0.077
        },
        {
          year: '1996',
          value: 0.12
        },
        {
          year: '1997',
          value: 0.011
        },
        {
          year: '1998',
          value: 0.177
        },
        {
          year: '1999',
          value: -0.021
        },
        {
          year: '2000',
          value: -0.037
        },
        {
          year: '2001',
          value: 0.03
        },
        {
          year: '2002',
          value: 0.179
        },
        {
          year: '2003',
          value: 0.2
        },
        {
          year: '2004',
          value: 0.180
        },
        {
          year: '2005',
          value: 0.21
        }
      ],
      valueAxes: [
        {
          axisAlpha: 0,
          position: 'left',
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      graphs: [
        {
          id: 'g1',
          balloonText: '[[value]]',
          bullet: 'round',
          bulletSize: 8,
          lineColor: layoutColors.danger,
          lineThickness: 1,
          negativeLineColor: layoutColors.warning,
          type: 'smoothedLine',
          valueField: 'value'
        }
      ],
      chartScrollbar: {
        graph: 'g1',
        gridAlpha: 0,
        color: layoutColors.defaultText,
        scrollbarHeight: 55,
        backgroundAlpha: 0,
        selectedBackgroundAlpha: 0.05,
        selectedBackgroundColor: layoutColors.defaultText,
        graphFillAlpha: 0,
        autoGridCount: true,
        selectedGraphFillAlpha: 0,
        graphLineAlpha: 0.2,
        selectedGraphLineColor: layoutColors.defaultText,
        selectedGraphLineAlpha: 1
      },
      chartCursor: {
        categoryBalloonDateFormat: 'YYYY',
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5,
        fullWidth: true
      },
      dataDateFormat: 'YYYY',
      categoryField: 'year',
      categoryAxis: {
        minPeriod: 'YYYY',
        parseDates: true,
        minorGridAlpha: 0.1,
        minorGridEnabled: true,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });

    lineChart.addListener('rendered', zoomChart);
    if (lineChart.zoomChart) {
      lineChart.zoomChart();
    }

    function zoomChart() {
      lineChart.zoomToIndexes(Math.round(lineChart.dataProvider.length * 0.4), Math.round(lineChart.dataProvider.length * 0.55));
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('PieChartCtrl', PieChartCtrl);

  /** @ngInject */
  function PieChartCtrl($element, layoutPaths, baConfig) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var pieChart = AmCharts.makeChart(id, {
      type: 'pie',
      startDuration: 0,
      theme: 'blur',
      addClassNames: true,
      color: layoutColors.defaultText,
      labelTickColor: layoutColors.borderDark,
      legend: {
        position: 'right',
        marginRight: 100,
        autoMargins: false,
      },
      innerRadius: '40%',
      defs: {
        filter: [
          {
            id: 'shadow',
            width: '200%',
            height: '200%',
            feOffset: {
              result: 'offOut',
              in: 'SourceAlpha',
              dx: 0,
              dy: 0
            },
            feGaussianBlur: {
              result: 'blurOut',
              in: 'offOut',
              stdDeviation: 5
            },
            feBlend: {
              in: 'SourceGraphic',
              in2: 'blurOut',
              mode: 'normal'
            }
          }
        ]
      },
      dataProvider: [
        {
          country: 'Lithuania',
          litres: 501.9
        },
        {
          country: 'Czech Republic',
          litres: 301.9
        },
        {
          country: 'Ireland',
          litres: 201.1
        },
        {
          country: 'Germany',
          litres: 165.8
        },
        {
          country: 'Australia',
          litres: 139.9
        },
        {
          country: 'Austria',
          litres: 128.3
        },
        {
          country: 'UK',
          litres: 99
        },
        {
          country: 'Belgium',
          litres: 60
        }
      ],
      valueField: 'litres',
      titleField: 'country',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-left',

      autoMargins: false,
      marginTop: 10,
      alpha: 0.8,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
      pullOutRadius: 0,
      pathToImages: layoutPaths.images.amChart,
      responsive: {
        enabled: true,
        rules: [
          // at 900px wide, we hide legend
          {
            maxWidth: 900,
            overrides: {
              legend: {
                enabled: false
              }
            }
          },

          // at 200 px we hide value axis labels altogether
          {
            maxWidth: 200,
            overrides: {
              valueAxes: {
                labelsEnabled: false
              },
              marginTop: 30,
              marginBottom: 30,
              marginLeft: 30,
              marginRight: 30
            }
          }
        ]
      }
    });

    pieChart.addListener('init', handleInit);

    pieChart.addListener('rollOverSlice', function (e) {
      handleRollOver(e);
    });

    function handleInit() {
      pieChart.legend.addListener('rollOverItem', handleRollOver);
    }

    function handleRollOver(e) {
      var wedge = e.dataItem.wedge.node;
      wedge.parentNode.appendChild(wedge);
    }
  }

})();

/**
 * @author a.demeshko
 * created on 24/12/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .controller('composeBoxCtrl', composeBoxCtrl);

  /** @ngInject */
  function composeBoxCtrl(subject, to, text) {
    var vm = this;
    vm.subject = subject;
    vm.to = to;
    vm.text = text;
  }
})();
/**
 * @author a.demeshko
 * created on 12/24/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .service('composeModal', composeModal);

  /** @ngInject */
  function composeModal($uibModal) {
      this.open = function(options){
        return $uibModal.open({
          animation: false,
          templateUrl: 'app/pages/components/mail/composeBox/compose.html',
          controller: 'composeBoxCtrl',
          controllerAs: 'boxCtrl',
          size: 'compose',
          resolve: {
            subject: function () {
              return options.subject;
            },
            to: function () {
              return options.to;
            },
            text: function () {
              return options.text;
            }
          }
        });
      }

  }

})();
/**
 * @author a.demeshko
 * created on 28.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .controller('MailDetailCtrl', MailDetailCtrl);

  /** @ngInject */
  function MailDetailCtrl($stateParams, mailMessages) {
    var vm = this;
    vm.mail = mailMessages.getMessageById($stateParams.id);
    vm.label = $stateParams.label;
  }

})();

/**
 * @author a.demeshko
 * created on 28.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .controller('MailListCtrl', MailListCtrl);

  /** @ngInject */
  function MailListCtrl($stateParams,  mailMessages) {
    var vm = this;
    vm.messages = mailMessages.getMessagesByLabel($stateParams.label);
    vm.label = $stateParams.label;
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.modals')
      .controller('NotificationsCtrl', NotificationsCtrl);

  /** @ngInject */
  function NotificationsCtrl($scope, toastr) {
    $scope.showSuccessMsg = function() {
      toastr.success('Your information has been saved successfully!');
    };

    $scope.showInfoMsg = function() {
      toastr.info("You've got a new email!", 'Information');
    };

    $scope.showErrorMsg = function() {
      toastr.error("Your information hasn't been saved!", 'Error');
    };

    $scope.showWarningMsg = function() {
      toastr.warning('Your computer is about to explode!', 'Warning');
    };
  }

})();

/**
 * Created by n.poltoratsky
 * on 24.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.ui.modals')
        .controller('ProgressModalCtrl', ProgressModalCtrl);

    function ProgressModalCtrl($timeout, baProgressModal) {

        baProgressModal.setProgress(0);

        (function changeValue() {
            if (baProgressModal.getProgress() >= 100) {
                baProgressModal.close();
            } else {
                baProgressModal.setProgress(baProgressModal.getProgress() + 10);
                $timeout(changeValue, 300);
            }
        })();
    }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function(){
    'use strict';

    angular.module('BlurAdmin.pages.form')
        .controller('datepickerCtrl', datepickerCtrl);

    /** @ngInject */
    function datepickerCtrl($scope) {

        $scope.dt = new Date();
        $scope.options = {
            showWeeks: false
        };

    }
})();
/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function(){
    'use strict';

    angular.module('BlurAdmin.pages.form')
        .controller('datepickerpopupCtrl', datepickerpopupCtrl);

    /** @ngInject */
    function datepickerpopupCtrl($scope) {

        $scope.open = open;
        $scope.opened = false;
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.options = {
            showWeeks: false
        };

        function open() {
            $scope.opened = true;
        }
    }
})();
/**
 * @author v.lugovsky
 * created on 22.04.2016
 * @deprecated
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('OldSelectpickerPanelCtrl', OldSelectpickerPanelCtrl);

  /** @ngInject */
  function OldSelectpickerPanelCtrl() {
    var vm = this;

    vm.standardSelectItems = [
      { label: 'Option 1', value: 1 },
      { label: 'Option 2', value: 2 },
      { label: 'Option 3', value: 3 },
      { label: 'Option 4', value: 4 },
    ];

    vm.selectWithSearchItems = [
      { label: 'Hot Dog, Fries and a Soda', value: 1 },
      { label: 'Burger, Shake and a Smile', value: 2 },
      { label: 'Sugar, Spice and all things nice', value: 3 },
      { label: 'Baby Back Ribs', value: 4 },
    ];

    vm.groupedSelectItems = [
      { label: 'Group 1 - Option 1', value: 1, group: 'Group 1' },
      { label: 'Group 2 - Option 2', value: 2, group: 'Group 2' },
      { label: 'Group 1 - Option 3', value: 3, group: 'Group 1' },
      { label: 'Group 2 - Option 4', value: 4, group: 'Group 2' },
    ];

  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 * @deprecated
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('selectpicker', selectpicker);

  /** @ngInject */
  function selectpicker() {
    return {
      restrict: 'A',
      require: '?ngOptions',
      priority: 1500, // make priority bigger than ngOptions and ngRepeat
      link: {
        pre: function(scope, elem, attrs) {
          elem.append('<option data-hidden="true" disabled value="">' + (attrs.title || 'Select something') + '</option>')
        },
        post: function(scope, elem, attrs) {
          function refresh() {
            elem.selectpicker('refresh');
          }

          if (attrs.ngModel) {
            scope.$watch(attrs.ngModel, refresh);
          }

          if (attrs.ngDisabled) {
            scope.$watch(attrs.ngDisabled, refresh);
          }

          elem.selectpicker({ dropupAuto: false, hideDisabled: true });
        }
      }
    };
  }


})();
/**
 * @author v.lugovsky
 * created on 07.06.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('OldSwitchPanelCtrl', OldSwitchPanelCtrl);

  /** @ngInject */
  function OldSwitchPanelCtrl() {
    var vm = this;

    vm.switcherValues = {
      primary: true,
      warning: true,
      danger: true,
      info: true,
      success: true
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 *
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('switch', switchDirective);

  /** @ngInject */
  function switchDirective($timeout) {
    return {
      restrict: 'EA',
      replace: true,
      scope: {
        ngModel: '='
      },
      template: function(el, attrs) {
        return '<div class="switch-container ' + (attrs.color || '') + '"><input type="checkbox" ng-model="ngModel"></div>';
      },
      link: function (scope, elem, attr) {
        var input = $(elem).find('input');
        input.bootstrapSwitch({
          size: 'small',
          onColor: attr.color
        });
        input.on('switchChange.bootstrapSwitch', function(event, state) {
          scope.ngModel = state;
          scope.$apply();
        });

      }
    };
  }
})();

/**
 * @author p.maslava
 * created on 28.11.2016
 */

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.form')
    .filter('groupSelectpickerOptions', GroupSelectpickerOptions);

  /** @ngInject */
  function GroupSelectpickerOptions() {
    return function (items, props) {
      var out = [];

      if (angular.isArray(items)) {
        var keys = Object.keys(props);

        items.forEach(function (item) {
          var itemMatches = false;

          for (var i = 0; i < keys.length; i++) {
            var prop = keys[i];
            var text = props[prop].toLowerCase();
            if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
              itemMatches = true;
              break;
            }
          }

          if (itemMatches) {
            out.push(item);
          }
        });
      } else {
        // Let the output be the input untouched
        out = items;
      }

      return out;
    };
  }
})();
/**
 * @author p.maslava
 * created on 28.11.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
    .controller('SelectpickerPanelCtrl', SelectpickerPanelCtrl);

  /** @ngInject */
  function SelectpickerPanelCtrl() {

    var vm = this;
    vm.disabled = undefined;


    vm.standardItem = {};
    vm.standardSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4}
    ];

    vm.withSearchItem = {};

    vm.selectWithSearchItems = [
      {label: 'Hot Dog, Fries and a Soda', value: 1},
      {label: 'Burger, Shake and a Smile', value: 2},
      {label: 'Sugar, Spice and all things nice', value: 3},
      {label: 'Baby Back Ribs', value: 4}
    ];
    vm.groupedItem = {};
    vm.groupedSelectItems = [
      {label: 'Group 1 - Option 1', value: 1, group: 'Group 1'},
      {label: 'Group 2 - Option 2', value: 2, group: 'Group 2'},
      {label: 'Group 1 - Option 3', value: 3, group: 'Group 1'},
      {label: 'Group 2 - Option 4', value: 4, group: 'Group 2'}
    ];

    vm.groupedByItem = {};
    vm.groupedBySelectItems = [
      {name: 'Adam', country: 'United States'},
      {name: 'Amalie', country: 'Argentina'},
      {name: 'Estefanía', country: 'Argentina'},
      {name: 'Adrian', country: 'Ecuador'},
      {name: 'Wladimir', country: 'Ecuador'},
      {name: 'Samantha', country: 'United States'},
      {name: 'Nicole', country: 'Colombia'},
      {name: 'Natasha', country: 'Ecuador'},
      {name: 'Michael', country: 'Colombia'},
      {name: 'Nicolás', country: 'Colombia'}
    ];
    vm.someGroupFn = function (item) {

      if (item.name[0] >= 'A' && item.name[0] <= 'M')
        return 'From A - M';
      if (item.name[0] >= 'N' && item.name[0] <= 'Z')
        return 'From N - Z';
    };

    vm.disableItem = {};
    vm.disableItems = [];

    vm.multipleItem = {};
    vm.multipleSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4},
      {label: 'Option 5', value: 5},
      {label: 'Option 6', value: 6},
      {label: 'Option 7', value: 7},
      {label: 'Option 8', value: 8}
    ];
    vm.withDeleteItem = {};
    vm.withDeleteSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4},
      {label: 'Option 5', value: 5},
      {label: 'Option 6', value: 6},
      {label: 'Option 7', value: 7},
      {label: 'Option 8', value: 8}
    ];

  }
})();



/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('SwitchDemoPanelCtrl', SwitchDemoPanelCtrl);

  /** @ngInject */
  function SwitchDemoPanelCtrl() {
    var vm = this;
    vm.switches = {
      s1: true,
      s2: false,
      s3: true,
      s4: true,
      s5: false
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('tagInput', tagInput);

  /** @ngInject */
  function tagInput() {
    return {
      restrict: 'A',
      link: function( $scope, elem, attr) {
        $(elem).tagsinput({
          tagClass:  'label label-' + attr.tagInput
        });
      }
    };
  }
})();
angular.module('Drenta').run(['$templateCache', function($templateCache) {$templateCache.put('app/login/login.html','<div class="auth-block"><div class="logo_app"></div><h3 class="left inicar_sesion_titulo">Inicio de sesi\xF3n</h3><form class="form-horizontal" name="loginForm"><div class="form-group"><label for="inputEmail3" class="col-sm-2 control-label">Email</label><div class="col-sm-10" ng-class="{\'has-error has-feedback\':loginForm.email.$invalid && !loginForm.email.$pristine,\'has-success has-feedback\':loginForm.email.$valid}"><input type="email" class="form-control" id="inputEmail3" placeholder="Email" name="email" ng-model="datos_login.usuario.email" required=""> <i ng-show="loginForm.email.$invalid && !loginForm.email.$pristine" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="loginForm.email.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-2 control-label">Password</label><div class="col-sm-10" ng-class="{\'has-error has-feedback\':loginForm.password.$invalid && !loginForm.password.$pristine,\'has-success has-feedback\':loginForm.password.$valid}"><input type="password" class="form-control" id="inputPassword3" placeholder="Password" name="password" ng-model="datos_login.usuario.password" required=""> <i ng-show="loginForm.password.$invalid && !loginForm.password.$pristine" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="loginForm.password.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><button type="button" ng-click="iniciarSesion()" ng-disabled="loginForm.$invalid" class="btn btn-success btn-sm">Iniciar sesi\xF3n</button> <a href="" class="forgot-pass">Olvid\xF3 su contrase\xF1a?</a></div></div></form></div>');
$templateCache.put('app/login/loginModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Add Account</h4></div><form name="linkForm"><div class="modal-body"><p>Paste a link to your login into the box below</p><div class="form-group"><input type="text" class="form-control" placeholder="Link to Login" ng-model="link"></div></div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="ok(link)">Save changes</button></div></form></div>');
$templateCache.put('app/pages/actividadeseco/actividadeseco.html','<div class="widgets" ng-init="datosIniciales()"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Listado de actividades econ\xF3micas" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="col-lg-12"><div class="form-group select-page-size-wrap float-left"><label><strong>Total de registros</strong><select ng-change="traerListadoPorRegistros();" class="form-control selectpicker show-tick" title="Cantidad de registros" selectpicker="" ng-model="datos_actividadeco.quantityRows" ng-options="i for i in [100,500,1000,\'Todos\']"></select></label></div><div class="form-group select-page-size-wrap float-left"><label><strong>Filas por p\xE1gina</strong><select class="form-control selectpicker show-tick" title="Filas por p\xE1gina" selectpicker="" ng-model="datos_actividadeco.smartTablePageSize" ng-options="i for i in [10,50,100,500]"></select></label></div><div class="form-group item-opciones-modulo float-right"><button ng-click="abrirNuevo();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Nuevo</button></div></div><table class="table table-bordered table-hover table-condensed" st-table="datos_actividadeco.listado" st-safe-src="datos_actividadeco.safe_listado"><thead><tr class="sortable"><th>#</th><th class="tiene_sort" st-sort="codigo">C\xF3digo</th><th class="tiene_sort" st-sort="nombre">Descripci\xF3n</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat="item in datos_actividadeco.listado" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span>{{ item.codigo }}</span></td><td><span editable-text="item.descripcion" ng-model="actividadeco.descripcion" e-name="descripcion" e-form="rowform" e-required="">{{ item.descripcion }}</span></td><td><form editable-form="" name="rowform" onbeforesave="grabarCambios($index,$data)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-success editable-table-button btn-xs">Grabar</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-danger editable-table-button btn-xs">Cancelar</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-success editable-table-button btn-xs" ng-click="rowform.$show()">Modificar</button> <button class="btn btn-amarillo editable-table-button btn-xs" ng-click="abrirEdicion(item);">Editar</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="borrarActividadeco($index)">Borrar</button></div></td></tr></tbody><tfoot><tr><td colspan="7" class="text-center"><div st-pagination="" st-items-by-page="datos_actividadeco.smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/actividadeseco/adicionActividadeco.html','<div class="modal-content"><form name="adicionForm" ng-submit="agregarActividadeco(datos_adicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Agregar actividad econ\xF2mica</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.codigo.$invalid,\'has-success has-feedback\':adicionForm.codigo.$valid}"><label class="text-left full-width" for="codigo">C\xF2digo</label> <input ng-change="validarPasswordAdicion()" class="form-control" placeholder="Codigo de actividad econ\xF2mica" name="codigo" type="text" id="codigo" ng-model="datos_adicion.codigo" required="" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.codigo.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.codigo.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.descripcion.$invalid,\'has-success has-feedback\':adicionForm.descripcion.$valid}"><label class="text-left full-width" for="descripcion">Descripci\xF2n actividad econ\xF2mica</label> <input type="text" class="form-control" id="descripcion" name="descripcion" placeholder="Nombre del actividad econ\xF2mica" ng-model="datos_adicion.descripcion" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.descripcion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.descripcion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="adicionForm.$invalid || datos_adicion.confirmar_password_invalid || datos_adicion.habilitar_formulario" class="float-left btn btn-info">Agregar</button> <button type="button" ng-click="limpiarCampos_formActividadeco(adicionForm)" class="float-left btn btn-warning">Limpiar campos</button></div></form></div>');
$templateCache.put('app/pages/actividadeseco/edicionActividadeco.html','<div class="modal-content"><form name="edicionForm" ng-submit="actualizarActividadeco(datos_edicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Edici\xF3n de actividad econ\xF2mica: {{datos_edicion.descripcion}}</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.codigo.$invalid,\'has-success has-feedback\':edicionForm.codigo.$valid}"><label class="text-left full-width" for="codigo">C\xF3digo</label> <input ng-change="validarPasswordAdicion()" class="form-control" placeholder="C\xF3digo de actividad econ\xF2mica" name="codigo" type="text" id="codigo" ng-model="datos_edicion.codigo" value="{{datos_edicion.codigo}}" required="" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.codigo.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.codigo.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.descripcion.$invalid,\'has-success has-feedback\':edicionForm.descripcion.$valid}"><label class="text-left full-width" for="descripcion">Descripcion de actividad econ\xF2mica</label> <input type="text" class="form-control" id="descripcion" name="descripcion" placeholder="Descripcion del actividad econ\xF2mica" ng-model="datos_edicion.descripcion" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.descripcion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.descripcion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="edicionForm.$invalid || datos_edicion.confirmar_password_invalid" class="float-left btn btn-info">Actualizar</button></div></form></div>');
$templateCache.put('app/pages/actividadeseco/eliminacionActividadeco.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Eliminaci\xF3n de Actividad econ\xF2mica</span></div><div class="modal-body text-center">\xBFEst\xE1 seguro que desea eliminar actividad econ\xF2mica <strong>{{datos_actividadeco.descripcion_actividadeco_eliminacion}}?</strong></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-danger" ng-click="confirmarEliminacionActividadeco()">Eliminar</button></div></div>');
$templateCache.put('app/pages/bancos/adicionBanco.html','<div class="modal-content"><form name="adicionForm" ng-submit="agregarBanco(datos_adicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Agregar banco</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.nit.$invalid,\'has-success has-feedback\':adicionForm.nit.$valid}"><label class="text-left full-width" for="nit">Nit</label> <input ng-change="validarPasswordAdicion()" class="form-control" placeholder="Nit del banco" name="nit" type="text" id="nit" ng-model="datos_adicion.nit" required="" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.nit.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.nit.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.nombre.$invalid,\'has-success has-feedback\':adicionForm.nombre.$valid}"><label class="text-left full-width" for="nombre">Nombre del banco</label> <input type="text" class="form-control" id="nombre" name="nombre" placeholder="Nombre del banco" ng-model="datos_adicion.nombre" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.nombre.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.nombre.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width" for="estado">Estado</label><ui-select ng-model="datos_adicion.estados" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="seleccione estado del Banco">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_banco.estados | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="adicionForm.$invalid || datos_adicion.confirmar_password_invalid || datos_adicion.habilitar_formulario" class="float-left btn btn-info">Agregar</button> <button type="button" ng-click="limpiarCampos_formBanco(adicionForm)" class="float-left btn btn-warning">Limpiar campos</button></div></form></div>');
$templateCache.put('app/pages/bancos/bancos.html','<div class="widgets" ng-init="datosIniciales()"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Listado de los bancos" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="col-lg-12"><div class="form-group select-page-size-wrap float-left"><label><strong>Total de registros</strong><select ng-change="traerListadoPorRegistros();" class="form-control selectpicker show-tick" title="Cantidad de registros" selectpicker="" ng-model="datos_banco.quantityRows" ng-options="i for i in [100,500,1000,\'Todos\']"></select></label></div><div class="form-group select-page-size-wrap float-left"><label><strong>Filas por p\xE1gina</strong><select class="form-control selectpicker show-tick" title="Filas por p\xE1gina" selectpicker="" ng-model="datos_banco.smartTablePageSize" ng-options="i for i in [10,50,100,500]"></select></label></div><div class="form-group item-opciones-modulo float-right"><button ng-click="abrirNuevo();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Nuevo</button></div></div><table class="table table-bordered table-hover table-condensed" st-table="datos_banco.listado" st-safe-src="datos_banco.safe_listado"><thead><tr class="sortable"><th>#</th><th class="tiene_sort" st-sort="nit">Nit</th><th class="tiene_sort" st-sort="nombre">Nombre banco</th><th class="tiene_sort" st-sort="fecha_creacion">Fecha de creaci\xF3n</th><th class="tiene_sort" st-sort="estado">Estado banco</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat="item in datos_banco.listado" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.nit" ng-model="banco.nit" e-name="nit" e-form="rowform" e-required="">{{ item.nit || \'Vac\xEDo\' }}</span></td><td><span editable-text="item.nombre" ng-model="banco.nombre" e-name="nombre" e-form="rowform" e-required="">{{ item.nombre || \'Vac\xEDo\' }}</span></td><td><span>{{item.fecha_creacion | amDateFormat:\'dddd, MMMM Do YYYY\'}}</span></td><td><span>{{item.estado ==\'0\' ? \'Inactivo\' : \'Activo\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="grabarCambios($index,$data)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-success editable-table-button btn-xs">Grabar</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-danger editable-table-button btn-xs">Cancelar</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-success editable-table-button btn-xs" ng-click="rowform.$show()">Modificar</button> <button class="btn btn-amarillo editable-table-button btn-xs" ng-click="abrirEdicion(item);">Editar</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="borrarBanco($index)">Borrar</button></div></td></tr></tbody><tfoot><tr><td colspan="7" class="text-center"><div st-pagination="" st-items-by-page="datos_banco.smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/bancos/edicionBanco.html','<div class="modal-content"><form name="edicionForm" ng-submit="editarBanco(datos_edicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Edici\xF3n de banco: {{datos_edicion.nombre}}</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.identificacion.$invalid,\'has-success has-feedback\':adicionForm.identificacion.$valid}"><label class="text-left full-width" for="nit">Nit</label> <input ng-change="validarPasswordAdicion()" class="form-control" placeholder="Nit del banco" name="nit" type="text" id="nit" ng-model="datos_edicion.nit" value="{{datos_edicion.nit}}" required="" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.nombre.$invalid,\'has-success has-feedback\':adicionForm.nombre.$valid}"><label class="text-left full-width" for="nombre">Nombre del banco</label> <input type="text" class="form-control" id="nombre" name="nombre" placeholder="Nombre del banco" ng-model="datos_edicion.nombre" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.nombres.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.nombres.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width" for="estado">Estado</label><ui-select ng-model="datos_edicion.estados_objeto" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="seleccione estado del Banco">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_banco.estados | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="edicionForm.$invalid || datos_edicion.confirmar_password_invalid" class="float-left btn btn-info">Actualizar</button></div></form></div>');
$templateCache.put('app/pages/bancos/eliminacionBanco.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Eliminaci\xF3n de banco</span></div><div class="modal-body text-center">\xBFEst\xE1 seguro que desea eliminar al banco <strong>{{datos_banco.nombre_banco_eliminacion}}?</strong></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-danger" ng-click="confirmarEliminacionBanco()">Eliminar</button></div></div>');
$templateCache.put('app/pages/certificados/adicionCertificado.html','<div class="modal-content"><form name="adicionForm" ng-submit="agregarCertificado(datos_adicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Agregar certificado</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width" for="cliente">Cliente</label><ui-select ng-model="datos_adicion.listado_clientes" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true" required=""><ui-select-match placeholder="Seleccione cliente">{{$select.selected.nombres}}</ui-select-match><ui-select-choices repeat="item in datos_certificado.listado_clientes | filter: {nombres:$select.search}"><span ng-bind-html="item.nombres"></span> <span ng-bind-html="item.apellidos"></span></ui-select-choices></ui-select></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><p class="input-group" ng-class="{\'has-error has-feedback\':adicionForm.ano_declaracion.$invalid,\'has-success has-feedback\':adicionForm.ano_declaracion.$valid}"><label class="text-left full-width" for="ano_declaracion">A\xF1o de declaraci\xF3n</label> <input type="text" class="form-control" placeholder="A\xF1o de declaraci\xF3n" name="ano_declaracion" uib-datepicker-popup="{{format}}" ng-model="datos_adicion.ano_declaracion" is-open="popup2.opened" datepicker-options="dateOptions" ng-required="true" close-text="Cerrar"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open2()"><i class="glyphicon glyphicon-calendar"></i></button></span> <i ng-show="adicionForm.ano_declaracion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.ano_declaracion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></p></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.direccion_seccional.$invalid,\'has-success has-feedback\':adicionForm.direccion_seccional.$valid}"><label class="text-left full-width" for="perfil_administrativo">Cod. Direcci\xF3n Seccional</label><ui-select name="direccion_seccional" ng-model="datos_adicion.direccion_seccional" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true" required=""><ui-select-match placeholder="Cod. Direcci\xF3n Seccional">{{$select.selected.descripcion}} - ({{$select.selected.codigo}})</ui-select-match><ui-select-choices repeat="item in datos_certificado.listado_dir_seccional | filter: {codigo:$select.search,descripcion:$select.search}"><span>{{item.descripcion}} - ({{item.codigo}})</span></ui-select-choices></ui-select><i ng-show="adicionForm.direccion_seccional.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.direccion_seccional.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="adicionForm.$invalid || datos_adicion.confirmar_password_invalid" class="float-left btn btn-info">Agregar</button></div></form></div>');
$templateCache.put('app/pages/certificados/certificados.html','<div class="widgets" ng-init="datosIniciales()"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Listado de certificados" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="col-lg-12"><div class="form-group select-page-size-wrap float-left"><label><strong>Total de registros</strong><select ng-change="traerListadoPorRegistros();" class="form-control selectpicker show-tick" title="Cantidad de registros" selectpicker="" ng-model="datos_certificado.quantityRows" ng-options="i for i in [100,500,1000,\'Todos\']"></select></label></div><div class="form-group select-page-size-wrap float-left"><label><strong>Filas por p\xE1gina</strong><select class="form-control selectpicker show-tick" title="Filas por p\xE1gina" selectpicker="" ng-model="datos_certificado.smartTablePageSize" ng-options="i for i in [10,50,100,500]"></select></label></div><div ng-show="datos_certificado.id_perfil_administrativo!=4" class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width" for="cliente">Cliente</label><ui-select ng-model="datos_certificado.filtro_cliente" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true" required=""><ui-select-match allow-clear="true" placeholder="Seleccione cliente">{{$select.selected.nombres}}</ui-select-match><ui-select-choices repeat="item in datos_certificado.listado_clientes | filter: {nombres:$select.search}"><span ng-bind-html="item.nombres"></span> <span ng-bind-html="item.apellidos"></span></ui-select-choices></ui-select></div></div></div><div class="form-group item-opciones-modulo float-right"><button ng-show="datos_certificado.id_perfil_administrativo!=4" ng-click="abrirNuevo();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Nuevo</button></div></div><table class="table table-bordered table-hover table-condensed" st-table="datos_certificado.listado" st-safe-src="datos_certificado.safe_listado"><thead><tr class="sortable"><th>#</th><th class="tiene_sort" st-sort="numero_formulario"># formulario</th><th class="tiene_sort" st-sort="ano_declaracion">A\xF1o declaraci\xF3n</th><th class="tiene_sort" st-sort="nit_identificacion">Nit/Identificaci\xF3n</th><th class="tiene_sort" st-sort="nombres_cliente">Nombres</th><th class="tiene_sort" st-sort="apellidos_cliente">Apellidos</th><th class="tiene_sort" st-sort="otros_nombres">Otros nombres</th><th class="tiene_sort" st-sort="actividad_economica">Actividad econ\xF3mica</th><th class="tiene_sort" st-sort="fecha_creacion" st-sort-default="reverse">Creado en</th><th>Acciones</th></tr></thead><tbody><tr ng-show="esAdmin!=4 || item.id_cliente==idUsuario" ng-repeat="item in datos_certificado.listado | filter: {nombres_cliente:datos_certificado.filtro_cliente.nombres,apellidos_cliente:datos_certificado.filtro_cliente.apellidos}" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.numero_formulario" ng-model="certificado.numero_formulario" e-name="numero_formulario" e-form="rowform" e-required="">{{ item.numero_formulario || \'Vac\xEDo\' }}</span></td><td><span>{{item.ano_declaracion_ok | amDateFormat:\'YYYY\'}}</span></td><td><span>{{ item.identificacion || \'Vac\xEDo\' }}</span></td><td><span>{{ item.nombres_cliente || \'Vac\xEDo\' }}</span></td><td><span>{{ item.apellidos_cliente || \'Vac\xEDo\' }}</span></td><td><span>{{item.otros_nombres}}</span></td><td><span>{{item.actividad_economica}}</span></td><td><span>{{item.creacion | amDateFormat:\'dddd, MMMM Do YYYY\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="grabarCambios($index,$data)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-success editable-table-button btn-xs">Grabar</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-danger editable-table-button btn-xs">Cancelar</button></form><div class="buttons" ng-show="!rowform.$visible"><button ng-show="datos_certificado.id_perfil_administrativo!=4" class="btn btn-success editable-table-button btn-xs" ng-click="rowform.$show()">Modificar</button> <button ng-show="datos_certificado.id_perfil_administrativo!=4" class="btn btn-amarillo editable-table-button btn-xs" ng-click="abrirEdicion(item,false);">Editar</button> <button ng-show="datos_certificado.id_perfil_administrativo==4" class="btn btn-success editable-table-button btn-xs" ng-click="abrirEdicion(item,true);">Ver</button> <button ng-show="datos_certificado.id_perfil_administrativo!=4" class="btn btn-danger editable-table-button btn-xs" ng-click="borrarCertificado($index)">Borrar</button> <a href="{{datosApp.url_api_raiz}}index.php/inicio/exportarpdf1/{{item.id}}"><button class="btn btn-danger editable-table-button btn-xs">PDF</button></a></div></td></tr></tbody><tfoot><tr><td colspan="7" class="text-center"><div st-pagination="" st-items-by-page="datos_certificado.smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/certificados/edicionCertificado.html','<div class="modal-content"><form name="edicionForm" ng-submit="uploadPic(datos_edicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Edici\xF3n de usuario: {{datos_edicion.nombres}} {{datos_edicion.apellidos}}</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.nombres.$invalid,\'has-success has-feedback\':edicionForm.nombres.$valid}"><label class="text-left full-width" for="nombres">Nombres</label> <input type="text" class="form-control" id="nombres" name="nombres" placeholder="Nombres" ng-model="datos_edicion.nombres" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.nombres.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.nombres.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.apellidos.$invalid,\'has-success has-feedback\':edicionForm.apellidos.$valid}"><label class="text-left full-width" for="apellidos">Apellidos</label> <input type="text" class="form-control" id="apellidos" name="apellidos" placeholder="Apellidos" ng-model="datos_edicion.apellidos" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.apellidos.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.apellidos.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.email.$invalid && !edicionForm.email.$pristine,\'has-success has-feedback\':edicionForm.email.$valid}"><label class="text-left full-width" for="email">Email</label> <input type="email" class="form-control" id="email" name="email" placeholder="Email" ng-model="datos_edicion.email" required=""> <i ng-show="edicionForm.email.$invalid && !edicionForm.email.$pristine" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.email.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.identificacion.$invalid,\'has-success has-feedback\':edicionForm.identificacion.$valid}"><label class="text-left full-width" for="identificacion">N\xFAmero de Identificaci\xF3n</label> <input ng-change="validarPassword()" class="form-control" placeholder="N\xFAmero de Identificaci\xF3n" name="identificacion" type="identificacion" id="identificacion" ng-model="datos_edicion.identificacion" value="{{datos_edicion.identificacion}}" required="" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.password.$invalid,\'has-success has-feedback\':edicionForm.password.$valid}"><label class="text-left full-width" for="password">Contrase\xF1a <small>Ej: Cesar123!</small></label> <input ng-change="validarPassword()" class="form-control" placeholder="Contrase\xF1a" name="password" type="password" id="password" ng-model="datos_edicion.password" value="{{datos_edicion.password}}"> <i ng-show="edicionForm.password.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.password.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.confirmar_password.$invalid || datos_edicion.confirmar_password_invalid,\'has-success has-feedback\':edicionForm.confirmar_password.$valid && !datos_edicion.confirmar_password_invalid}"><label class="text-left full-width" for="confirmar_password">Confirmar Contrase\xF1a</label> <input ng-change="validarPassword()" class="form-control" placeholder="Contrase\xF1a" name="confirmar_password" type="password" id="confirmar_password" ng-model="datos_edicion.confirmar_password" value="{{datos_edicion.password}}"> <i ng-show="edicionForm.confirmar_password.$invalid || datos_edicion.confirmar_password_invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.confirmar_password.$valid && !datos_edicion.confirmar_password_invalid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.telefono.$invalid,\'has-success has-feedback\':edicionForm.telefono.$valid}" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"><label class="text-left full-width" for="telefono">Tel\xE9fono <small>Ej:(+57) 3147023030</small></label> <input type="text" class="form-control" id="telefono" name="telefono" placeholder="Tel\xE9fono" ng-model="datos_edicion.telefono" required=""> <i ng-show="edicionForm.telefono.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.telefono.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.telefono_alternativo.$invalid,\'has-success has-feedback\':edicionForm.telefono_alternativo.$valid}" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"><label class="text-left full-width" for="telefono_alternativo">Tel\xE9fono Alternativo <small>Ej:(+57) 3147023030</small></label> <input type="text" class="form-control" id="telefono_alternativo" name="telefono_alternativo" placeholder="Tel\xE9fono" ng-model="datos_edicion.telefono_alternativo" required=""> <i ng-show="edicionForm.telefono_alternativo.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.telefono_alternativo.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.foto.$invalid,\'has-success has-feedback\':edicionForm.foto.$valid}"><label class="text-left full-width" for="foto">Fotograf\xEDa</label> <input type="file" ngf-select="" accept="image/*" ngf-max-size="50MB" ngf-model-invalid="errorFile" class="form-control" id="foto" name="foto" placeholder="Fotograf\xEDa" ng-model="datos_edicion.foto"> <i ng-show="edicionForm.foto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.foto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div><span class="progress" ng-show="datos_edicion.foto.progress >= 0"><div style="width:{{datos_edicion.foto.progress}}%" ng-bind="datos_edicion.foto.progress + \'%\'"></div></span><div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="{{datos_edicion.foto.progress}}" aria-valuemin="0" aria-valuemax="100" style="width: {{datos_edicion.foto.progress}}%"><span class="sr-only">{{datos_edicion.foto.progress}} %</span></div></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width" for="telefono">Perfil Administrativo</label><ui-select ng-model="datos_edicion.perfil_administrativo_objeto" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione perfil administrativo">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_usuario.perfiles_administrativos | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="edicionForm.$invalid || datos_edicion.confirmar_password_invalid" class="float-left btn btn-info">Actualizar</button></div></form></div>');
$templateCache.put('app/pages/certificados/eliminacionCertificado.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Eliminaci\xF3n de certificado</span></div><div class="modal-body text-center">\xBFEst\xE1 seguro que desea eliminar el certificado <strong># {{datos_certificado.numero_formulario}}?</strong></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-danger" ng-click="confirmarEliminacionCertificado()">Eliminar</button></div></div>');
$templateCache.put('app/pages/certificados/layout.html','<div ui-view="listado"></div><div ui-view="edicion"></div>');
$templateCache.put('app/pages/clientes/adicionCliente.html','<div class="modal-content"><form name="adicionForm" ng-submit="agregarCliente(datos_adicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Agregar cliente</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.nombres.$invalid,\'has-success has-feedback\':adicionForm.nombres.$valid}"><label class="text-left full-width" for="nombres">Nombres</label> <input type="text" class="form-control" id="nombres" name="nombres" placeholder="Nombres" ng-model="datos_adicion.nombres" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.nombres.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.nombres.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.apellidos.$invalid,\'has-success has-feedback\':adicionForm.apellidos.$valid}"><label class="text-left full-width" for="apellidos">Apellidos</label> <input type="text" class="form-control" id="apellidos" name="apellidos" placeholder="Apellidos" ng-model="datos_adicion.apellidos" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.apellidos.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.apellidos.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.email.$invalid && !adicionForm.email.$pristine,\'has-success has-feedback\':adicionForm.email.$valid}"><label class="text-left full-width" for="email">Email</label> <input type="email" class="form-control" id="email" name="email" placeholder="Email" ng-model="datos_adicion.email" required=""> <i ng-show="adicionForm.email.$invalid && !adicionForm.email.$pristine" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.email.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.identificacion.$invalid,\'has-success has-feedback\':adicionForm.identificacion.$valid}"><label class="text-left full-width" for="identificacion">N\xFAmero de Identificaci\xF3n</label> <input ng-change="validarPasswordAdicion()" class="form-control" placeholder="N\xFAmero de Identificaci\xF3n" name="identificacion" type="text" id="identificacion" ng-model="datos_adicion.identificacion" value="{{datos_adicion.identificacion}}" required="" pattern="[0-9]+"> <i ng-show="adicionForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.password.$invalid,\'has-success has-feedback\':adicionForm.password.$valid}"><label class="text-left full-width" for="password">Contrase\xF1a <small>Ej: Cesar123!</small></label> <input ng-change="validarPassword()" class="form-control" placeholder="Contrase\xF1a" name="password" type="password" id="password" ng-model="datos_adicion.password" value="{{datos_adicion.password}}"> <i ng-show="adicionForm.password.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.password.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.confirmar_password.$invalid || datos_adicion.confirmar_password_invalid,\'has-success has-feedback\':adicionForm.confirmar_password.$valid && !datos_adicion.confirmar_password_invalid}"><label class="text-left full-width" for="confirmar_password">Confirmar Contrase\xF1a</label> <input ng-change="validarPasswordAdicion()" class="form-control" placeholder="Contrase\xF1a" name="confirmar_password" type="password" id="confirmar_password" ng-model="datos_adicion.confirmar_password" value="{{datos_adicion.password}}"> <i ng-show="adicionForm.confirmar_password.$invalid || datos_adicion.confirmar_password_invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.confirmar_password.$valid && !datos_adicion.confirmar_password_invalid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.telefono.$invalid,\'has-success has-feedback\':adicionForm.telefono.$valid}" pattern="[()+-_0-9]+"><label class="text-left full-width" for="telefono">Tel\xE9fono <small>Ej:(+57) 3147023030</small></label> <input type="text" class="form-control" id="telefono" name="telefono" placeholder="Tel\xE9fono" ng-model="datos_adicion.telefono" required=""> <i ng-show="adicionForm.telefono.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.telefono.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.telefono_alternativo.$invalid,\'has-success has-feedback\':adicionForm.telefono_alternativo.$valid}" pattern="[()+-_0-9]+"><label class="text-left full-width" for="telefono_alternativo">Tel\xE9fono Alternativo <small>Ej:(+57) 3147023030</small></label> <input type="text" class="form-control" id="telefono_alternativo" name="telefono_alternativo" placeholder="Tel\xE9fono" ng-model="datos_adicion.telefono_alternativo" required=""> <i ng-show="adicionForm.telefono_alternativo.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.telefono_alternativo.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.actividad_economica.$invalid,\'has-success has-feedback\':adicionForm.actividad_economica.$valid}"><label class="text-left full-width" for="actividad_economica">Actividad Econ\xF3mica</label><ui-select name="actividad_economica" ng-model="datos_adicion.actividad_economica" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true" required=""><ui-select-match placeholder="Actividad Econ\xF3mica">{{$select.selected.descripcion}} - ({{$select.selected.codigo}})</ui-select-match><ui-select-choices repeat="item in datos_cliente.actividades_economicas | filter: {codigo:$select.search,descripcion:$select.search}"><span>{{item.descripcion}} - ({{item.codigo}})</span></ui-select-choices></ui-select><i ng-show="adicionForm.actividad_economica.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.actividad_economica.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="adicionForm.$invalid || datos_adicion.confirmar_password_invalid" class="float-left btn btn-info">Agregar</button> <button type="button" ng-click="limpiarCampos_formCliente(adicionForm)" class="float-left btn btn-warning">Limpiar campos</button></div></form></div>');
$templateCache.put('app/pages/clientes/clientes.html','<div class="widgets" ng-init="datosIniciales()"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Listado de los clientes" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="col-lg-12"><div class="form-group select-page-size-wrap float-left"><label><strong>Total de registros</strong><select ng-change="traerListadoPorRegistros();" class="form-control selectpicker show-tick" title="Cantidad de registros" selectpicker="" ng-model="datos_cliente.quantityRows" ng-options="i for i in [100,500,1000,\'Todos\']"></select></label></div><div class="form-group select-page-size-wrap float-left"><label><strong>Filas por p\xE1gina</strong><select class="form-control selectpicker show-tick" title="Filas por p\xE1gina" selectpicker="" ng-model="datos_cliente.smartTablePageSize" ng-options="i for i in [10,50,100,500]"></select></label></div><div class="form-group item-opciones-modulo float-right"><button ng-click="abrirNuevo();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Nuevo</button></div></div><table class="table table-bordered table-hover table-condensed" st-table="datos_cliente.listado" st-safe-src="datos_cliente.safe_listado"><thead><tr><th></th><th><input st-search="nombres" placeholder="Buscar por nombres" class="input-sm form-control" type="search"></th><th><input st-search="apellidos" placeholder="Buscar por apellidos" class="input-sm form-control" type="search"></th><th></th><th></th><th></th><th></th><th></th><th></th></tr><tr class="sortable"><th>#</th><th class="tiene_sort" st-sort="nombres">Nombres</th><th class="tiene_sort" st-sort="apellidos">Apellidos</th><th class="tiene_sort" st-sort="identificacion">Identificacion</th><th class="tiene_sort" st-sort="actividad_economica">Actividad econ\xF3mica</th><th class="tiene_sort" st-sort="email">Email</th><th>Tel\xE9fonos</th><th class="tiene_sort" st-sort="fecha_creacion" st-sort-default="reverse">Creado en</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat="item in datos_cliente.listado" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span>{{ item.nombres || \'Vac\xEDo\' }}</span></td><td><span>{{ item.apellidos || \'Vac\xEDo\' }}</span></td><td><span>{{item.identificacion || \'Vac\xEDo\'}}</span></td><td><span>{{item.codigo_actividad_economica == "" || item.codigo_actividad_economica == NULL ? "Sin asignar" : item.descripcion_actividad_economica + " - (" + item.codigo_actividad_economica+")"}}</span></td><td><span editable-text="item.email" e-name="email" e-form="rowform" e-required=""><a class="email-link" ng-href="mailto:{{item.email}}">{{ item.email || \'vac\xEDo\' }}</a></span></td><td><label>Principal:</label> <span editable-text="item.telefono" e-ng-model="cliente.telefono" e-name="telefono" e-form="rowform" e-required="">{{ item.telefono || \'vac\xEDo\' }}</span> <label>Alternativo:</label> <span editable-text="item.telefono_alternativo" e-ng-model="cliente.telefono_alternativo" e-name="telefono_alternativo" e-form="rowform" e-required="">{{ item.telefono_alternativo || \'vac\xEDo\' }}</span></td><td><span>{{item.fecha_creacion | amDateFormat:\'dddd, MMMM Do YYYY\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="grabarCambios($index,$data)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-success editable-table-button btn-xs">Grabar</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-danger editable-table-button btn-xs">Cancelar</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-success editable-table-button btn-xs" ng-click="rowform.$show()">Modificar</button> <button class="btn btn-amarillo editable-table-button btn-xs" ng-click="abrirEdicion(item);">Editar</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="borrarCliente($index)">Borrar</button></div></td></tr></tbody><tfoot><tr><td colspan="7" class="text-center"><div st-pagination="" st-items-by-page="datos_cliente.smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/clientes/edicionCliente.html','<div class="modal-content"><form name="edicionForm" ng-submit="editarCliente(datos_edicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Edici\xF3n de cliente: {{datos_edicion.nombres}} {{datos_edicion.apellidos}}</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.nombres.$invalid,\'has-success has-feedback\':edicionForm.nombres.$valid}"><label class="text-left full-width" for="nombres">Nombres</label> <input type="text" class="form-control" id="nombres" name="nombres" placeholder="Nombres" ng-model="datos_edicion.nombres" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.nombres.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.nombres.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.apellidos.$invalid,\'has-success has-feedback\':edicionForm.apellidos.$valid}"><label class="text-left full-width" for="apellidos">Apellidos</label> <input type="text" class="form-control" id="apellidos" name="apellidos" placeholder="Apellidos" ng-model="datos_edicion.apellidos" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.apellidos.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.apellidos.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.email.$invalid && !edicionForm.email.$pristine,\'has-success has-feedback\':edicionForm.email.$valid}"><label class="text-left full-width" for="email">Email</label> <input type="email" class="form-control" id="email" name="email" placeholder="Email" ng-model="datos_edicion.email" required=""> <i ng-show="edicionForm.email.$invalid && !edicionForm.email.$pristine" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.email.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.identificacion.$invalid,\'has-success has-feedback\':edicionForm.identificacion.$valid}"><label class="text-left full-width" for="identificacion">N\xFAmero de Identificaci\xF3n</label> <input ng-change="validarPassword()" class="form-control" placeholder="N\xFAmero de Identificaci\xF3n" name="identificacion" type="identificacion" id="identificacion" ng-model="datos_edicion.identificacion" value="{{datos_edicion.identificacion}}" required="" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.password.$invalid,\'has-success has-feedback\':edicionForm.password.$valid}"><label class="text-left full-width" for="password">Contrase\xF1a <small>Ej: Cesar123!</small></label> <input ng-change="validarPassword()" class="form-control" placeholder="Contrase\xF1a" name="password" type="password" id="password" ng-model="datos_edicion.password" value="{{datos_edicion.password}}"> <i ng-show="edicionForm.password.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.password.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.confirmar_password.$invalid || datos_edicion.confirmar_password_invalid,\'has-success has-feedback\':edicionForm.confirmar_password.$valid && !datos_edicion.confirmar_password_invalid}"><label class="text-left full-width" for="confirmar_password">Confirmar Contrase\xF1a</label> <input ng-change="validarPassword()" class="form-control" placeholder="Contrase\xF1a" name="confirmar_password" type="password" id="confirmar_password" ng-model="datos_edicion.confirmar_password" value="{{datos_edicion.password}}"> <i ng-show="edicionForm.confirmar_password.$invalid || datos_edicion.confirmar_password_invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.confirmar_password.$valid && !datos_edicion.confirmar_password_invalid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.telefono.$invalid,\'has-success has-feedback\':edicionForm.telefono.$valid}" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"><label class="text-left full-width" for="telefono">Tel\xE9fono <small>Ej:(+57) 3147023030</small></label> <input type="text" class="form-control" id="telefono" name="telefono" placeholder="Tel\xE9fono" ng-model="datos_edicion.telefono" required=""> <i ng-show="edicionForm.telefono.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.telefono.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.telefono_alternativo.$invalid,\'has-success has-feedback\':edicionForm.telefono_alternativo.$valid}" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"><label class="text-left full-width" for="telefono_alternativo">Tel\xE9fono Alternativo <small>Ej:(+57) 3147023030</small></label> <input type="text" class="form-control" id="telefono_alternativo" name="telefono_alternativo" placeholder="Tel\xE9fono" ng-model="datos_edicion.telefono_alternativo" required=""> <i ng-show="edicionForm.telefono_alternativo.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.telefono_alternativo.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.actividad_economica.$invalid,\'has-success has-feedback\':edicionForm.actividad_economica.$valid}"><label class="text-left full-width" for="perfil_administrativo">Actividad Econ\xF3mica</label><ui-select name="actividad_economica" ng-model="datos_edicion.actividad_economica" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true" required=""><ui-select-match placeholder="Actividad Econ\xF3mica">{{$select.selected.descripcion}} - ({{$select.selected.codigo}})</ui-select-match><ui-select-choices repeat="item in datos_cliente.actividades_economicas | filter: {codigo:$select.search,descripcion:$select.search}"><span>{{item.descripcion}} - ({{item.codigo}})</span></ui-select-choices></ui-select><i ng-show="edicionForm.actividad_economica.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.actividad_economica.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.foto.$invalid,\'has-success has-feedback\':edicionForm.foto.$valid}"><label class="text-left full-width" for="foto">Fotograf\xEDa</label> <input type="file" ngf-select="" accept="image/*" ngf-max-size="50MB" ngf-model-invalid="errorFile" class="form-control" id="foto" name="foto" placeholder="Fotograf\xEDa" ng-model="datos_edicion.foto"> <i ng-show="edicionForm.foto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.foto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div><span class="progress" ng-show="datos_edicion.foto.progress >= 0"><div style="width:{{datos_edicion.foto.progress}}%" ng-bind="datos_edicion.foto.progress + \'%\'"></div></span><div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="{{datos_edicion.foto.progress}}" aria-valuemin="0" aria-valuemax="100" style="width: {{datos_edicion.foto.progress}}%"><span class="sr-only">{{datos_edicion.foto.progress}} %</span></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="edicionForm.$invalid || datos_edicion.confirmar_password_invalid" class="float-left btn btn-info">Actualizar</button></div></form></div>');
$templateCache.put('app/pages/clientes/eliminacionCliente.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Eliminaci\xF3n de cliente</span></div><div class="modal-body text-center">\xBFEst\xE1 seguro que desea eliminar al cliente <strong>{{datos_cliente.nombre_cliente_eliminacion}}?</strong></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-danger" ng-click="confirmarEliminacionCliente()">Eliminar</button></div></div>');
$templateCache.put('app/pages/dashboard/dashboard.html','<dashboard-pie-chart></dashboard-pie-chart><div class="row"><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Acquisition Channels" ba-panel-class="medium-panel traffic-panel"><traffic-chart></traffic-chart></div><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Users by Country" ba-panel-class="medium-panel"><dashboard-map></dashboard-map></div></div><div class="row"><div class="col-xlg-9 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="row"><div class="col-xlg-8 col-lg-12 col-md-12 col-sm-7 col-xs-12" ba-panel="" ba-panel-title="Revenue" ba-panel-class="medium-panel"><dashboard-line-chart></dashboard-line-chart></div><div class="col-xlg-4 col-lg-12 col-md-12 col-sm-5 col-xs-12" ba-panel="" ba-panel-class="popular-app medium-panel"><popular-app></popular-app></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-12 col-xs-12" ba-panel="" ba-panel-title="Feed" ba-panel-class="large-panel with-scroll feed-panel"><blur-feed></blur-feed></div></div><div class="row shift-up"><div class="col-xlg-3 col-lg-6 col-md-6 col-xs-12" ba-panel="" ba-panel-title="To Do List" ba-panel-class="xmedium-panel feed-comply-panel with-scroll todo-panel"><dashboard-todo></dashboard-todo></div><div class="col-xlg-6 col-lg-6 col-md-6 col-xs-12" ba-panel="" ba-panel-title="Calendar" ba-panel-class="xmedium-panel feed-comply-panel with-scroll calendar-panel"><dashboard-calendar></dashboard-calendar></div></div>');
$templateCache.put('app/pages/entidades/adicionEntidad.html','<div class="modal-content"><form name="adicionForm" ng-submit="agregarEntidad(datos_adicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Agregar entidad</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.identificacion.$invalid,\'has-success has-feedback\':adicionForm.identificacion.$valid}"><label class="text-left full-width" for="identificacion">Identificacion entidad</label> <input ng-change="validarPasswordAdicion()" class="form-control" placeholder="# de entidad" name="identificacion" type="text" id="identificacion" ng-model="datos_adicion.identificacion" required="" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.nombre.$invalid,\'has-success has-feedback\':adicionForm.nombre.$valid}"><label class="text-left full-width" for="nombre">Nombre de entidad</label> <input type="text" class="form-control" id="nombre" name="nombre" placeholder="Nombre de entidad" ng-model="datos_adicion.nombre" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.nombre.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.nombre.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width" for="tipo_entidad">Tipo de entidad</label><ui-select ng-model="datos_adicion.tipo_entidades" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione tipo de Entidad">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_entidad.tipo_entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width" for="estado">Estado</label><ui-select ng-model="datos_adicion.estados" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione estado">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_entidad.estados | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="adicionForm.$invalid || datos_adicion.habilitar_formulario" class="float-left btn btn-info">Agregar</button> <button type="button" ng-click="limpiarCampos_formEntidad(adicionForm)" class="float-left btn btn-warning">Limpiar campos</button></div></form></div>');
$templateCache.put('app/pages/entidades/edicionEntidad.html','<div class="modal-content"><form name="edicionForm" ng-submit="editarEntidad(datos_edicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Edici\xF3n de entidad: {{datos_edicion.nombre}}</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.identificacion.$invalid,\'has-success has-feedback\':adicionForm.identificacion.$valid}"><label class="text-left full-width" for="identificacion">Identificacion entidad</label> <input ng-change="validarPasswordAdicion()" class="form-control" placeholder="# de entidad" name="identificacion" type="text" id="identificacion" ng-model="datos_edicion.identificacion" value="{{datos_edicion.identificacion}}" required="" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.nombre.$invalid,\'has-success has-feedback\':adicionForm.nombre.$valid}"><label class="text-left full-width" for="nombre">Nombre de entidad</label> <input type="text" class="form-control" id="nombre" name="nombre" placeholder="Nombre de entidad" ng-model="datos_edicion.nombre" value="{{datos_edicion.nombre}}" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.nombre.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.nombre.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width" for="tipo_entidad">Tipo de entidad</label><ui-select ng-model="datos_edicion.tipo_entidades" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione tipo de Entidad">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_entidad.tipo_entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width" for="estado">Estado</label><ui-select ng-model="datos_edicion.estados" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione estado de la Entidad">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_entidad.estados | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="edicionForm.$invalid || datos_edicion.confirmar_password_invalid" class="float-left btn btn-info">Actualizar</button></div></form></div>');
$templateCache.put('app/pages/entidades/eliminacionEntidad.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Eliminaci\xF3n de Entidad</span></div><div class="modal-body text-center">\xBFEst\xE1 seguro que desea eliminar esta Entidad? <strong>{{datos_entidad.nombre_entidad_eliminacion}}?</strong></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-danger" ng-click="confirmarEliminacionEntidad()">Eliminar</button></div></div>');
$templateCache.put('app/pages/entidades/entidades.html','<div class="widgets" ng-init="datosIniciales()"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Listado de los entidades" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="col-lg-12"><div class="form-group select-page-size-wrap float-left"><label><strong>Total de registros</strong><select ng-change="traerListadoPorRegistros();" class="form-control selectpicker show-tick" title="Cantidad de registros" selectpicker="" ng-model="datos_entidad.quantityRows" ng-options="i for i in [100,500,1000,\'Todos\']"></select></label></div><div class="form-group select-page-size-wrap float-left"><label><strong>Filas por p\xE1gina</strong><select class="form-control selectpicker show-tick" title="Filas por p\xE1gina" selectpicker="" ng-model="datos_entidad.smartTablePageSize" ng-options="i for i in [10,50,100,500]"></select></label></div><div class="form-group item-opciones-modulo float-right"><button ng-click="abrirNuevo();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Nuevo</button></div></div><table class="table table-bordered table-hover table-condensed" st-table="datos_entidad.listado" st-safe-src="datos_entidad.safe_listado"><thead><tr class="sortable"><th>#</th><th class="tiene_sort" st-sort="identificacion">Identificaci\xF3n</th><th class="tiene_sort" st-sort="nombre">Nombre entidad</th><th class="tiene_sort" st-sort="tipo_entidad">Tipo entidad</th><th class="tiene_sort" st-sort="fecha_creacion">Fecha de creaci\xF3n</th><th class="tiene_sort" st-sort="estado">Estado entidad</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat="item in datos_entidad.listado" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.identificacion" ng-model="entidad.identificacion" e-name="identificacion" e-form="rowform" e-required="">{{ item.identificacion || \'Vac\xEDo\' }}</span></td><td><span editable-text="item.nombre" ng-model="entidad.nombre" e-name="nombre" e-form="rowform" e-required="">{{ item.nombre || \'Vac\xEDo\' }}</span></td><td><span>{{ item.tipo_entidad || \'Vac\xEDo\' }}</span></td><td><span>{{item.fecha_creacion | amDateFormat:\'dddd, MMMM Do YYYY\'}}</span></td><td><span>{{item.estado ==\'0\' ? \'Inactivo\' : \'Activo\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="grabarCambios($index,$data)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-success editable-table-button btn-xs">Grabar</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-danger editable-table-button btn-xs">Cancelar</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-success editable-table-button btn-xs" ng-click="rowform.$show()">Modificar</button> <button class="btn btn-amarillo editable-table-button btn-xs" ng-click="abrirEdicion(item);">Editar</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="borrarEntidad($index)">Borrar</button></div></td></tr></tbody><tfoot><tr><td colspan="7" class="text-center"><div st-pagination="" st-items-by-page="datos_entidad.smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/indicadores/adicionIndicador.html','<div class="modal-content"><form name="adicionForm" ng-submit="agregarIndicador(datos_adicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Agregar indicador</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.nombre.$invalid,\'has-success has-feedback\':adicionForm.nombre.$valid}"><label class="text-left full-width" for="nombre">Nombre</label> <input type="text" class="form-control" id="nombres" name="nombre" placeholder="Nombre" ng-model="datos_adicion.nombre" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA 0-9,.-_\\s]+"> <i ng-show="adicionForm.nombre.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.nombre.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.valor.$invalid,\'has-success has-feedback\':adicionForm.valor.$valid}"><label class="text-left full-width" for="valor">valor</label> <input type="text" class="form-control" id="valor" name="valor" placeholder="valor" ng-model="datos_adicion.valor" required="" pattern="[0-9.,]+"> <i ng-show="adicionForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="adicionForm.$invalid || datos_adicion.confirmar_password_invalid" class="float-left btn btn-info">Agregar</button> <button type="button" ng-click="limpiarCampos_formIndicador(adicionForm)" class="float-left btn btn-warning">Limpiar campos</button></div></form></div>');
$templateCache.put('app/pages/indicadores/edicionIndicador.html','<div class="modal-content"><form name="edicionForm" ng-submit="actualizarIndicador(datos_edicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Edici\xF3n de indicador: {{datos_edicion.nombre}}</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.nombre.$invalid,\'has-success has-feedback\':adicionForm.nombre.$valid}"><label class="text-left full-width" for="nombre">Nombre</label> <input type="text" class="form-control" id="nombres" name="nombre" placeholder="Nombre" ng-model="datos_edicion.nombre" value="{{datos_edicion.nombre}}" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA 0-9,.-_\\s]+"> <i ng-show="adicionForm.nombre.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.nombre.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.valor.$invalid,\'has-success has-feedback\':adicionForm.valor.$valid}"><label class="text-left full-width" for="valor">valor</label> <input type="text" class="form-control" id="valor" name="valor" placeholder="valor" ng-model="datos_edicion.valor" value="{{datos_edicion.valor}}" required="" pattern="[0-9.,]+"> <i ng-show="adicionForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="edicionForm.$invalid || datos_edicion.confirmar_password_invalid" class="float-left btn btn-info">Actualizar</button></div></form></div>');
$templateCache.put('app/pages/indicadores/eliminacionIndicador.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Eliminaci\xF3n de indicador</span></div><div class="modal-body text-center">\xBFEst\xE1 seguro que desea eliminar al indicador <strong>{{datos_indicador.nombre_indicador_eliminacion}}?</strong></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-danger" ng-click="confirmarEliminacionIndicador()">Eliminar</button></div></div>');
$templateCache.put('app/pages/indicadores/indicadores.html','<div class="widgets" ng-init="datosIniciales()"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Listado de los indicadores" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="col-lg-12"><div class="form-group select-page-size-wrap float-left"><label><strong>Total de registros</strong><select ng-change="traerListadoPorRegistros();" class="form-control selectpicker show-tick" title="Cantidad de registros" selectpicker="" ng-model="datos_indicador.quantityRows" ng-options="i for i in [100,500,1000,\'Todos\']"></select></label></div><div class="form-group select-page-size-wrap float-left"><label><strong>Filas por p\xE1gina</strong><select class="form-control selectpicker show-tick" title="Filas por p\xE1gina" selectpicker="" ng-model="datos_indicador.smartTablePageSize" ng-options="i for i in [10,50,100,500]"></select></label></div><div class="form-group item-opciones-modulo float-right"><button ng-click="abrirNuevo();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Nuevo</button></div></div><table class="table table-bordered table-hover table-condensed" st-table="datos_indicador.listado" st-safe-src="datos_indicador.safe_listado"><thead><tr class="sortable"><th>#</th><th class="tiene_sort" st-sort="nombre">Nombre</th><th class="tiene_sort" st-sort="valor">Valor</th><th class="tiene_sort" st-sort="fecha_creacion" st-sort-default="reverse">Creado en</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat="item in datos_indicador.listado" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span>{{ item.nombre || \'Vac\xEDo\' }}</span></td><td><span editable-text="item.valor" e-ng-model="indicador.valor" e-name="valor" e-form="rowform" e-required="">{{ item.valor || \'Vac\xEDo\' }}</span></td><td><span>{{item.fecha_creacion | amDateFormat:\'dddd, MMMM Do YYYY\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="grabarCambios($index,$data)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-success editable-table-button btn-xs">Grabar</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-danger editable-table-button btn-xs">Cancelar</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-success editable-table-button btn-xs" ng-click="rowform.$show()">Modificar</button> <button class="btn btn-amarillo editable-table-button btn-xs" ng-click="abrirEdicion(item);">Editar</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="borrarIndicador($index)">Borrar</button></div></td></tr></tbody><tfoot><tr><td colspan="7" class="text-center"><div st-pagination="" st-items-by-page="datos_indicador.smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/perfilusuario/perfilusuario.html','<div class="widgets" ng-init="abrirEdicion()"><div class="row"><div class="col-md-12"><form name="edicionForm" ng-submit="editarUsuario()"><div ba-panel="" ba-panel-title="Edici\xF3n del perfil de usuario" ba-panel-class="with-scroll"><div class="horizontal-scroll"><br><br><div class="col-lg-12"><button type="submit" ng-disabled="edicionForm.$invalid || datos_edicion.confirmar_password_invalid" class="float-right btn btn-info">Actualizar</button></div><div class="col-lg-12"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.nombres.$invalid,\'has-success has-feedback\':edicionForm.nombres.$valid}"><label class="text-left full-width" for="nombres">Nombres</label> <input type="text" class="form-control" id="nombres" name="nombres" placeholder="Nombres" ng-model="datos_edicion.nombres" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.nombres.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.nombres.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.apellidos.$invalid,\'has-success has-feedback\':edicionForm.apellidos.$valid}"><label class="text-left full-width" for="apellidos">Apellidos</label> <input type="text" class="form-control" id="apellidos" name="apellidos" placeholder="Apellidos" ng-model="datos_edicion.apellidos" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.apellidos.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.apellidos.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.email.$invalid && !edicionForm.email.$pristine,\'has-success has-feedback\':edicionForm.email.$valid}"><label class="text-left full-width" for="email">Email</label> <input type="email" class="form-control" id="email" name="email" placeholder="Email" ng-model="datos_edicion.email" required=""> <i ng-show="edicionForm.email.$invalid && !edicionForm.email.$pristine" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.email.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.identificacion.$invalid,\'has-success has-feedback\':edicionForm.identificacion.$valid}"><label class="text-left full-width" for="identificacion">N\xFAmero de Identificaci\xF3n</label> <input ng-change="validarPassword()" class="form-control" placeholder="N\xFAmero de Identificaci\xF3n" name="identificacion" type="identificacion" id="identificacion" ng-model="datos_edicion.identificacion" value="{{datos_edicion.identificacion}}" required="" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.password.$invalid,\'has-success has-feedback\':edicionForm.password.$valid}"><label class="text-left full-width" for="password">Contrase\xF1a <small>Ej: Cesar123!</small></label> <input ng-change="validarPassword()" class="form-control" placeholder="Contrase\xF1a" name="password" type="password" id="password" ng-model="datos_edicion.password" value="{{datos_edicion.password}}"> <i ng-show="edicionForm.password.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.password.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.confirmar_password.$invalid || datos_edicion.confirmar_password_invalid,\'has-success has-feedback\':edicionForm.confirmar_password.$valid && !datos_edicion.confirmar_password_invalid}"><label class="text-left full-width" for="confirmar_password">Confirmar Contrase\xF1a</label> <input ng-change="validarPassword()" class="form-control" placeholder="Contrase\xF1a" name="confirmar_password" type="password" id="confirmar_password" ng-model="datos_edicion.confirmar_password" value="{{datos_edicion.password}}"> <i ng-show="edicionForm.confirmar_password.$invalid || datos_edicion.confirmar_password_invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.confirmar_password.$valid && !datos_edicion.confirmar_password_invalid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.telefono.$invalid,\'has-success has-feedback\':edicionForm.telefono.$valid}" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"><label class="text-left full-width" for="telefono">Tel\xE9fono <small>Ej:(+57) 3147023030</small></label> <input type="text" class="form-control" id="telefono" name="telefono" placeholder="Tel\xE9fono" ng-model="datos_edicion.telefono" required=""> <i ng-show="edicionForm.telefono.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.telefono.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.telefono_alternativo.$invalid,\'has-success has-feedback\':edicionForm.telefono_alternativo.$valid}" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"><label class="text-left full-width" for="telefono_alternativo">Tel\xE9fono Alternativo <small>Ej:(+57) 3147023030</small></label> <input type="text" class="form-control" id="telefono_alternativo" name="telefono_alternativo" placeholder="Tel\xE9fono" ng-model="datos_edicion.telefono_alternativo" required=""> <i ng-show="edicionForm.telefono_alternativo.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.telefono_alternativo.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.actividad_economica.$invalid,\'has-success has-feedback\':edicionForm.actividad_economica.$valid}"><label class="text-left full-width" for="perfil_administrativo">Actividad Econ\xF3mica</label><ui-select name="actividad_economica" ng-model="datos_edicion.actividad_economica" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true" required=""><ui-select-match placeholder="Actividad Econ\xF3mica">{{$select.selected.descripcion}} - ({{$select.selected.codigo}})</ui-select-match><ui-select-choices repeat="item in datos_perfilusuario.actividades_economicas | filter: {codigo:$select.search,descripcion:$select.search}"><span>{{item.descripcion}} - ({{item.codigo}})</span></ui-select-choices></ui-select><i ng-show="edicionForm.actividad_economica.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.actividad_economica.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.foto.$invalid,\'has-success has-feedback\':edicionForm.foto.$valid}"><label class="text-left full-width" for="foto">Fotograf\xEDa</label> <input type="file" ngf-select="" accept="image/*" ngf-max-size="50MB" ngf-model-invalid="errorFile" class="form-control" id="foto" name="foto" placeholder="Fotograf\xEDa" ng-model="datos_edicion.foto"> <i ng-show="edicionForm.foto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.foto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div><span class="progress" ng-show="datos_edicion.foto.progress >= 0"><div style="width:{{datos_edicion.foto.progress}}%" ng-bind="datos_edicion.foto.progress + \'%\'"></div></span><div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="{{datos_edicion.foto.progress}}" aria-valuemin="0" aria-valuemax="100" style="width: {{datos_edicion.foto.progress}}%"><span class="sr-only">{{datos_edicion.foto.progress}} %</span></div></div></div></div></div></div></form></div></div></div>');
$templateCache.put('app/pages/profile/profile.html','<div ba-panel="" ba-panel-class="profile-page"><div class="panel-content"><div class="progress-info">Your profile is 70% Complete</div><div class="progress"><div class="progress-bar progress-bar-primary progress-bar-striped active" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style="width: 70%"></div></div><h3 class="with-line">General Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Picture</label><div class="col-sm-9"><div class="userpic"><div class="userpic-wrapper"><img ng-src="{{ picture }}" ng-click="uploadPicture()"></div><i class="ion-ios-close-outline" ng-click="removePicture()" ng-if="!noPicture"></i> <a href="" class="change-userpic" ng-click="uploadPicture()">Change Profile Picture</a> <input type="file" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"></div></div></div></div><div class="col-md-6"></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">First Name</label><div class="col-sm-9"><input type="text" class="form-control" id="inputFirstName" placeholder="" value="Anastasiya"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Last Name</label><div class="col-sm-9"><input type="text" class="form-control" id="inputLastName" placeholder="" value=""></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Department</label><div class="col-sm-9"><select class="form-control" selectpicker=""><option>Web Development</option><option>System Development</option><option>Sales</option><option>Human Resources</option></select></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Occupation</label><div class="col-sm-9"><input type="text" class="form-control" id="inputOccupation" placeholder="" value="Front End Web Developer"></div></div></div></div><h3 class="with-line">Change Password</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Password</label><div class="col-sm-9"><input type="password" class="form-control" id="inputPassword" placeholder="" value="12345678"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputConfirmPassword" class="col-sm-3 control-label">Confirm Password</label><div class="col-sm-9"><input type="password" class="form-control" id="inputConfirmPassword" placeholder=""></div></div></div></div><h3 class="with-line">Contact Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputEmail3" class="col-sm-3 control-label">Email</label><div class="col-sm-9"><input type="email" class="form-control" id="inputEmail3" placeholder="" value="contact@akveo.com"></div></div><div class="form-group row clearfix"><label for="inputPhone" class="col-sm-3 control-label">Phone</label><div class="col-sm-9"><input type="text" class="form-control" id="inputPhone" placeholder="" value="+1 (23) 456 7890"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Office Location</label><div class="col-sm-9"><select class="form-control" title="Standard Select" selectpicker=""><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class="form-group row clearfix"><label for="inputRoom" class="col-sm-3 control-label">Room</label><div class="col-sm-9"><input type="text" class="form-control" id="inputRoom" placeholder="" value="303"></div></div></div></div><h3 class="with-line">Social Profiles</h3><div class="social-profiles row clearfix"><div class="col-md-3 col-sm-4" ng-repeat="item in socialProfiles"><a class="sn-link" href="" ng-click="showModal(item)" ng-if="!item.href"><i class="socicon {{ item.icon }}"></i> <span>{{ item.name }}</span></a> <a class="sn-link connected" href="{{ item.href }}" target="_blank" ng-if="item.href"><i class="socicon {{ item.icon }}"></i> <span>{{ item.name }}</span> <em class="ion-ios-close-empty sn-link-close" ng-mousedown="unconnect(item)"></em></a></div></div><h3 class="with-line">Send Email Notifications</h3><div class="notification row clearfix"><div class="col-sm-6"><div class="form-group row clearfix"><label class="col-xs-8">When I receive a message</label><div class="col-xs-4"><switch color="primary" ng-model="switches[0]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">When Someone sends me an invitation</label><div class="col-xs-4"><switch color="primary" ng-model="switches[1]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">When profile information changes</label><div class="col-xs-4"><switch color="primary" ng-model="switches[2]"></switch></div></div></div><div class="col-sm-6"><div class="form-group row clearfix"><label class="col-xs-8">When anyone logs into your account from a new device or browser</label><div class="col-xs-4"><switch color="primary" ng-model="switches[3]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">Weekly Reports</label><div class="col-xs-4"><switch color="primary" ng-model="switches[4]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">Daily Reports</label><div class="col-xs-4"><switch color="primary" ng-model="switches[5]"></switch></div></div></div></div><button type="button" class="btn btn-success btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Update Profile</button></div></div>');
$templateCache.put('app/pages/profile/profileModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Add Account</h4></div><form name="linkForm"><div class="modal-body"><p>Paste a link to your profile into the box below</p><div class="form-group"><input type="text" class="form-control" placeholder="Link to Profile" ng-model="link"></div></div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="ok(link)">Save changes</button></div></form></div>');
$templateCache.put('app/pages/seccionales/adicionSeccional.html','<div class="modal-content"><form name="adicionForm" ng-submit="agregarSeccional(datos_adicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Agregar seccional</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.codigo.$invalid,\'has-success has-feedback\':adicionForm.codigo.$valid}"><label class="text-left full-width" for="codigo">C\xF2digo</label> <input ng-change="validarPasswordAdicion()" class="form-control" placeholder="Codigo de seccional" name="codigo" type="text" id="codigo" ng-model="datos_adicion.codigo" required="" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.codigo.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.codigo.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.descripcion.$invalid,\'has-success has-feedback\':adicionForm.descripcion.$valid}"><label class="text-left full-width" for="descripcion">Descripci\xF2n seccional</label> <input type="text" class="form-control" id="descripcion" name="descripcion" placeholder="Nombre del seccional" ng-model="datos_adicion.descripcion" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.descripcion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.descripcion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="adicionForm.$invalid || datos_adicion.confirmar_password_invalid || datos_adicion.habilitar_formulario" class="float-left btn btn-info">Agregar</button> <button type="button" ng-click="limpiarCampos_formSeccional(adicionForm)" class="float-left btn btn-warning">Limpiar campos</button></div></form></div>');
$templateCache.put('app/pages/seccionales/edicionSeccional.html','<div class="modal-content"><form name="edicionForm" ng-submit="actualizarSeccional(datos_edicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Edici\xF3n de seccional: {{datos_edicion.descripcion}}</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.codigo.$invalid,\'has-success has-feedback\':edicionForm.codigo.$valid}"><label class="text-left full-width" for="codigo">C\xF3digo</label> <input ng-change="validarPasswordAdicion()" class="form-control" placeholder="C\xF3digo de seccional" name="codigo" type="text" id="codigo" ng-model="datos_edicion.codigo" value="{{datos_edicion.codigo}}" required="" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.codigo.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.codigo.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.descripcion.$invalid,\'has-success has-feedback\':edicionForm.descripcion.$valid}"><label class="text-left full-width" for="descripcion">Descripcion de seccional</label> <input type="text" class="form-control" id="descripcion" name="descripcion" placeholder="Descripcion del seccional" ng-model="datos_edicion.descripcion" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.descripcion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.descripcion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="edicionForm.$invalid || datos_edicion.confirmar_password_invalid" class="float-left btn btn-info">Actualizar</button></div></form></div>');
$templateCache.put('app/pages/seccionales/eliminacionSeccional.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Eliminaci\xF3n de Seccional</span></div><div class="modal-body text-center">\xBFEst\xE1 seguro que desea eliminar seccional <strong>{{datos_seccional.descripcion_seccional_eliminacion}}?</strong></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-danger" ng-click="confirmarEliminacionSeccional()">Eliminar</button></div></div>');
$templateCache.put('app/pages/seccionales/seccionales.html','<div class="widgets" ng-init="datosIniciales()"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Listado las seccionalas" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="col-lg-12"><div class="form-group select-page-size-wrap float-left"><label><strong>Total de registros</strong><select ng-change="traerListadoPorRegistros();" class="form-control selectpicker show-tick" title="Cantidad de registros" selectpicker="" ng-model="datos_seccional.quantityRows" ng-options="i for i in [100,500,1000,\'Todos\']"></select></label></div><div class="form-group select-page-size-wrap float-left"><label><strong>Filas por p\xE1gina</strong><select class="form-control selectpicker show-tick" title="Filas por p\xE1gina" selectpicker="" ng-model="datos_seccional.smartTablePageSize" ng-options="i for i in [10,50,100,500]"></select></label></div><div class="form-group item-opciones-modulo float-right"><button ng-click="abrirNuevo();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Nuevo</button></div></div><table class="table table-bordered table-hover table-condensed" st-table="datos_seccional.listado" st-safe-src="datos_seccional.safe_listado"><thead><tr class="sortable"><th>#</th><th class="tiene_sort" st-sort="codigo">C\xF3digo</th><th class="tiene_sort" st-sort="nombre">Descripci\xF3n</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat="item in datos_seccional.listado" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span>{{ item.codigo }}</span></td><td><span editable-text="item.descripcion" ng-model="seccional.descripcion" e-name="descripcion" e-form="rowform" e-required="">{{ item.descripcion }}</span></td><td><form editable-form="" name="rowform" onbeforesave="grabarCambios($index,$data)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-success editable-table-button btn-xs">Grabar</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-danger editable-table-button btn-xs">Cancelar</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-success editable-table-button btn-xs" ng-click="rowform.$show()">Modificar</button> <button class="btn btn-amarillo editable-table-button btn-xs" ng-click="abrirEdicion(item);">Editar</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="borrarSeccional($index)">Borrar</button></div></td></tr></tbody><tfoot><tr><td colspan="7" class="text-center"><div st-pagination="" st-items-by-page="datos_seccional.smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/soportes/adicionSoporte.html','<div class="modal-content"><form name="adicionForm" ng-submit="agregarSoporte(datos_adicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Agregar soporte</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.comentario.$invalid,\'has-success has-feedback\':adicionForm.comentario.$valid}"><label class="text-left full-width" for="comentario">Comentario</label> <textarea class="form-control" placeholder="Comentario del soporte" name="comentario" id="comentario" ng-model="datos_adicion.comentario" required="" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"></textarea> <i ng-show="adicionForm.comentario.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.comentario.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.archivo.$invalid,\'has-success has-feedback\':adicionForm.archivo.$valid}"><label class="text-left full-width" for="archivo">Archivo</label> <input type="file" ngf-select="" accept="*" ngf-max-size="50MB" ngf-model-invalid="errorFile" class="form-control" id="archivo" name="archivo" placeholder="Archivo" ng-model="datos_adicion.archivo"> <i ng-show="adicionForm.archivo.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.archivo.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div><span class="progress" ng-show="datos_adicion.archivo.progress >= 0"><div style="width:{{datos_adicion.archivo.progress}}%" ng-bind="datos_adicion.archivo.progress + \'%\'"></div></span><div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="{{datos_adicion.archivo.progress}}" aria-valuemin="0" aria-valuemax="100" style="width: {{datos_adicion.archivo.progress}}%"><span class="sr-only">{{datos_adicion.archivo.progress}} %</span></div></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.estado.$invalid,\'has-success has-feedback\':adicionForm.estado.$valid}"><label class="text-left full-width" for="estado">Estado del archivo</label><ui-select ng-model="datos_adicion.estados_objeto" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true" name="estado"><ui-select-match placeholder="seleccione estado del arhcivo">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_soporte.estados | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select><i ng-show="adicionForm.estado.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.estado.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.tipo_soporte.$invalid,\'has-success has-feedback\':adicionForm.tipo_soporte.$valid}"><label class="text-left full-width" for="estado">Tipo de soporte</label><ui-select ng-model="datos_adicion.tipo_soporte" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true" name="tipo_soporte"><ui-select-match placeholder="seleccione tipo de soporte">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_soporte.tipos_soporte | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select><i ng-show="adicionForm.tipo_soporte.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.tipo_soporte.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="adicionForm.$invalid || datos_adicion.confirmar_password_invalid || datos_adicion.habilitar_formulario" class="float-left btn btn-info">Agregar</button> <button type="button" ng-click="limpiarCampos_formSoporte(adicionForm)" class="float-left btn btn-warning">Limpiar campos</button></div></form></div>');
$templateCache.put('app/pages/soportes/edicionSoporte.html','<div class="modal-content"><form name="edicionForm" ng-submit="editarSoporte(datos_edicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Edici\xF3n de soporte: {{datos_edicion.nombre}}</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.comentario.$invalid,\'has-success has-feedback\':adicionForm.comentario.$valid}"><label class="text-left full-width" for="comentario">Comentario</label> <textarea class="form-control" placeholder="Comentario del soporte" name="comentario" id="comentario" ng-model="datos_edicion.comentario" required="" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"></textarea> <i ng-show="adicionForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.archivo.$invalid,\'has-success has-feedback\':edicionForm.archivo.$valid}"><label class="text-left full-width" for="archivo">Archivo</label> <input type="file" ngf-select="" accept="*" ngf-max-size="50MB" ngf-model-invalid="errorFile" class="form-control" id="archivo" name="archivo" placeholder="Soporte" require="" ng-model="datos_edicion.archivo"> <i ng-show="edicionForm.archivo.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.archivo.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div><span class="progress" ng-show="datos_edicion.archivo.progress >= 0"><div style="width:{{datos_edicion.archivo.progress}}%" ng-bind="datos_edicion.archivo.progress + \'%\'"></div></span><div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="{{datos_edicion.archivo.progress}}" aria-valuemin="0" aria-valuemax="100" style="width: {{datos_edicion.archivo.progress}}%"><span class="sr-only">{{datos_edicion.archivo.progress}} %</span></div></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width" for="estado">Estado del archivo</label><ui-select ng-model="datos_edicion.estados_objeto" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="seleccione estado del archivo">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_soporte.estados | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.tipo_soporte.$invalid,\'has-success has-feedback\':adicionForm.tipo_soporte.$valid}"><label class="text-left full-width" for="estado">Tipo de soporte</label><ui-select ng-model="datos_edicion.tipo_soporte" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true" name="tipo_soporte"><ui-select-match placeholder="seleccione tipo de soporte">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_soporte.tipos_soporte | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select><i ng-show="adicionForm.tipo_soporte.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.tipo_soporte.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="edicionForm.$invalid || datos_edicion.confirmar_password_invalid" class="float-left btn btn-info">Actualizar</button></div></form></div>');
$templateCache.put('app/pages/soportes/eliminacionSoporte.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Eliminaci\xF3n de soporte</span></div><div class="modal-body text-center">\xBFEst\xE1 seguro que desea eliminar al soporte <strong>{{datos_soporte.nombre_soporte_eliminacion}}?</strong></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-danger" ng-click="confirmarEliminacionSoporte()">Eliminar</button></div></div>');
$templateCache.put('app/pages/soportes/soportes.html','<div class="widgets" ng-init="datosIniciales()"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Listado de los soportes" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="col-lg-12"><div class="form-group select-page-size-wrap float-left"><label><strong>Total de registros</strong><select ng-change="traerListadoPorRegistros();" class="form-control selectpicker show-tick" title="Cantidad de registros" selectpicker="" ng-model="datos_soporte.quantityRows" ng-options="i for i in [100,500,1000,\'Todos\']"></select></label></div><div class="form-group select-page-size-wrap float-left"><label><strong>Filas por p\xE1gina</strong><select class="form-control selectpicker show-tick" title="Filas por p\xE1gina" selectpicker="" ng-model="datos_soporte.smartTablePageSize" ng-options="i for i in [10,50,100,500]"></select></label></div><div ng-show="item.id_usuario==idUsuario || idPerfil!=4" class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width" for="cliente">Cliente</label><ui-select ng-model="datos_soporte.filtro_cliente" ng-change="actualizarRowsFiltradas();" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true" required=""><ui-select-match allow-clear="true" placeholder="Seleccione cliente">{{$select.selected.nombres}}</ui-select-match><ui-select-choices repeat="item in datos_soporte.listado_clientes | filter: {nombres:$select.search}"><span ng-bind-html="item.nombres"></span> <span ng-bind-html="item.apellidos"></span></ui-select-choices></ui-select></div></div></div><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width" for="cliente">Tipo de soporte</label><ui-select ng-model="datos_soporte.filtro_tiposoporte" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true" required=""><ui-select-match allow-clear="true" placeholder="Seleccione tipo de soporte">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_soporte.tipos_soporte | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div></div><div class="form-group item-opciones-modulo float-right"><button ng-click="abrirNuevo();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Nuevo</button></div></div><table class="table table-bordered table-hover table-condensed" st-table="datos_soporte.listado" st-safe-src="datos_soporte.safe_listado"><thead><tr class="sortable"><th>#</th><th class="tiene_sort" st-sort="comentario">Comentario</th><th class="tiene_sort" st-sort="usuario">Usuario (Cliente)</th><th class="tiene_sort" st-sort="usuario">Archivo</th><th class="tiene_sort" st-sort="tipo_soporte">Tipo de Soporte</th><th class="tiene_sort" st-sort="fecha_creacion">Fecha de creaci\xF3n</th><th class="tiene_sort" st-sort="fecha_marcado_malo">Marcado como malo</th><th class="tiene_sort" st-sort="estado">Estado del adjunto</th><th>Acciones</th></tr></thead><tbody><tr ng-show="item.id_usuario==idUsuario || idPerfil!=4" ng-repeat="item in datos_soporte.listado | filter: {nombres:datos_soporte.filtro_cliente.nombres,apellidos:datos_soporte.filtro_cliente.apellidos,nombre_soporte:datos_soporte.filtro_tiposoporte.nombre}" class="editable-row"><td class="table-id">{{$index+1}}</td><td>{{ item.comentario || \'Vac\xEDo\' }}</td><td>{{ item.nombres }} {{ item.apellidos }}</td><td><a href="/{{item.adjunto}}" target="_blank">Adjunto</a></td><td>{{ item.nombre_soporte }}</td><td><span>{{item.fecha_creacion | amDateFormat:\'dddd, MMMM Do YYYY\'}}</span></td><td><span>{{item.fecha_marcado_malo | amDateFormat:\'dddd, MMMM Do YYYY\'}}</span></td><td><span editable-text="item.estado" ng-model="soporte.estado" e-name="estado" e-form="rowform" e-required="">{{item.estado ==\'0\' ? \'Malo\' : \'Bueno\'}}</span></td><td><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-amarillo editable-table-button btn-xs" ng-click="abrirEdicion(item);">Editar</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="borrarSoporte($index)">Borrar</button></div></td></tr></tbody><tfoot><tr><td colspan="7" class="text-center"><div st-pagination="" st-items-by-page="datos_soporte.smartTablePageSize" st-displayed-pages=""></div></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/usuarios/adicionUsuario.html','<div class="modal-content"><form name="adicionForm" ng-submit="agregarUsuario(datos_adicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Agregar usuario</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.nombres.$invalid,\'has-success has-feedback\':adicionForm.nombres.$valid}"><label class="text-left full-width" for="nombres">Nombres</label> <input type="text" class="form-control" id="nombres" name="nombres" placeholder="Nombres" ng-model="datos_adicion.nombres" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.nombres.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.nombres.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.apellidos.$invalid,\'has-success has-feedback\':adicionForm.apellidos.$valid}"><label class="text-left full-width" for="apellidos">Apellidos</label> <input type="text" class="form-control" id="apellidos" name="apellidos" placeholder="Apellidos" ng-model="datos_adicion.apellidos" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.apellidos.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.apellidos.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.email.$invalid && !adicionForm.email.$pristine,\'has-success has-feedback\':adicionForm.email.$valid}"><label class="text-left full-width" for="email">Email</label> <input type="email" class="form-control" id="email" name="email" placeholder="Email" ng-model="datos_adicion.email" required=""> <i ng-show="adicionForm.email.$invalid && !adicionForm.email.$pristine" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.email.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.identificacion.$invalid,\'has-success has-feedback\':adicionForm.identificacion.$valid}"><label class="text-left full-width" for="identificacion">N\xFAmero de Identificaci\xF3n</label> <input ng-change="validarPasswordAdicion()" class="form-control" placeholder="N\xFAmero de Identificaci\xF3n" name="identificacion" type="text" id="identificacion" ng-model="datos_adicion.identificacion" value="{{datos_adicion.identificacion}}" required="" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="adicionForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.password.$invalid,\'has-success has-feedback\':adicionForm.password.$valid}"><label class="text-left full-width" for="password">Contrase\xF1a <small>Ej: Cesar123!</small></label> <input ng-change="validarPassword()" class="form-control" placeholder="Contrase\xF1a" name="password" type="password" id="password" ng-model="datos_adicion.password" value="{{datos_adicion.password}}"> <i ng-show="adicionForm.password.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.password.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.confirmar_password.$invalid || datos_adicion.confirmar_password_invalid,\'has-success has-feedback\':adicionForm.confirmar_password.$valid && !datos_adicion.confirmar_password_invalid}"><label class="text-left full-width" for="confirmar_password">Confirmar Contrase\xF1a</label> <input ng-change="validarPasswordAdicion()" class="form-control" placeholder="Contrase\xF1a" name="confirmar_password" type="password" id="confirmar_password" ng-model="datos_adicion.confirmar_password" value="{{datos_adicion.password}}"> <i ng-show="adicionForm.confirmar_password.$invalid || datos_adicion.confirmar_password_invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.confirmar_password.$valid && !datos_adicion.confirmar_password_invalid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.telefono.$invalid,\'has-success has-feedback\':adicionForm.telefono.$valid}" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"><label class="text-left full-width" for="telefono">Tel\xE9fono <small>Ej:(+57) 3147023030</small></label> <input type="text" class="form-control" id="telefono" name="telefono" placeholder="Tel\xE9fono" ng-model="datos_adicion.telefono" required=""> <i ng-show="adicionForm.telefono.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.telefono.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.telefono_alternativo.$invalid,\'has-success has-feedback\':adicionForm.telefono_alternativo.$valid}" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"><label class="text-left full-width" for="telefono_alternativo">Tel\xE9fono Alternativo <small>Ej:(+57) 3147023030</small></label> <input type="text" class="form-control" id="telefono_alternativo" name="telefono_alternativo" placeholder="Tel\xE9fono" ng-model="datos_adicion.telefono_alternativo" required=""> <i ng-show="adicionForm.telefono_alternativo.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.telefono_alternativo.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':adicionForm.actividad_economica.$invalid,\'has-success has-feedback\':adicionForm.actividad_economica.$valid}"><label class="text-left full-width" for="actividad_economica">Actividad Econ\xF3mica</label><ui-select name="actividad_economica" ng-model="datos_adicion.actividad_economica" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true" required=""><ui-select-match placeholder="Actividad Econ\xF3mica">{{$select.selected.descripcion}} - ({{$select.selected.codigo}})</ui-select-match><ui-select-choices repeat="item in datos_usuario.actividades_economicas | filter: {codigo:$select.search,descripcion:$select.search}"><span>{{item.descripcion}} - ({{item.codigo}})</span></ui-select-choices></ui-select><i ng-show="adicionForm.actividad_economica.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="adicionForm.actividad_economica.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width" for="perfil_administrativo">Seleccione perfil administrativo</label><ui-select ng-model="datos_adicion.perfil_administrativo" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione perfil administrativo">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_usuario.perfiles_administrativos | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="adicionForm.$invalid || datos_adicion.confirmar_password_invalid" class="float-left btn btn-info">Agregar</button> <button type="button" ng-click="limpiarCampos_formUsuario(adicionForm)" class="float-left btn btn-warning">Limpiar campos</button></div></form></div>');
$templateCache.put('app/pages/usuarios/edicionUsuario.html','<div class="modal-content"><form name="edicionForm" ng-submit="editarUsuario(datos_edicion)"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Edici\xF3n de usuario: {{datos_edicion.nombres}} {{datos_edicion.apellidos}}</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.nombres.$invalid,\'has-success has-feedback\':edicionForm.nombres.$valid}"><label class="text-left full-width" for="nombres">Nombres</label> <input type="text" class="form-control" id="nombres" name="nombres" placeholder="Nombres" ng-model="datos_edicion.nombres" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.nombres.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.nombres.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.apellidos.$invalid,\'has-success has-feedback\':edicionForm.apellidos.$valid}"><label class="text-left full-width" for="apellidos">Apellidos</label> <input type="text" class="form-control" id="apellidos" name="apellidos" placeholder="Apellidos" ng-model="datos_edicion.apellidos" required="" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.apellidos.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.apellidos.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.email.$invalid && !edicionForm.email.$pristine,\'has-success has-feedback\':edicionForm.email.$valid}"><label class="text-left full-width" for="email">Email</label> <input type="email" class="form-control" id="email" name="email" placeholder="Email" ng-model="datos_edicion.email" required=""> <i ng-show="edicionForm.email.$invalid && !edicionForm.email.$pristine" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.email.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.identificacion.$invalid,\'has-success has-feedback\':edicionForm.identificacion.$valid}"><label class="text-left full-width" for="identificacion">N\xFAmero de Identificaci\xF3n</label> <input ng-change="validarPassword()" class="form-control" placeholder="N\xFAmero de Identificaci\xF3n" name="identificacion" type="identificacion" id="identificacion" ng-model="datos_edicion.identificacion" value="{{datos_edicion.identificacion}}" required="" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="edicionForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.password.$invalid,\'has-success has-feedback\':edicionForm.password.$valid}"><label class="text-left full-width" for="password">Contrase\xF1a <small>Ej: Cesar123!</small></label> <input ng-change="validarPassword()" class="form-control" placeholder="Contrase\xF1a" name="password" type="password" id="password" ng-model="datos_edicion.password" value="{{datos_edicion.password}}"> <i ng-show="edicionForm.password.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.password.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.confirmar_password.$invalid || datos_edicion.confirmar_password_invalid,\'has-success has-feedback\':edicionForm.confirmar_password.$valid && !datos_edicion.confirmar_password_invalid}"><label class="text-left full-width" for="confirmar_password">Confirmar Contrase\xF1a</label> <input ng-change="validarPassword()" class="form-control" placeholder="Contrase\xF1a" name="confirmar_password" type="password" id="confirmar_password" ng-model="datos_edicion.confirmar_password" value="{{datos_edicion.password}}"> <i ng-show="edicionForm.confirmar_password.$invalid || datos_edicion.confirmar_password_invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.confirmar_password.$valid && !datos_edicion.confirmar_password_invalid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.telefono.$invalid,\'has-success has-feedback\':edicionForm.telefono.$valid}" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"><label class="text-left full-width" for="telefono">Tel\xE9fono <small>Ej:(+57) 3147023030</small></label> <input type="text" class="form-control" id="telefono" name="telefono" placeholder="Tel\xE9fono" ng-model="datos_edicion.telefono" required=""> <i ng-show="edicionForm.telefono.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.telefono.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.telefono_alternativo.$invalid,\'has-success has-feedback\':edicionForm.telefono_alternativo.$valid}" pattern="[()+-_0-9A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"><label class="text-left full-width" for="telefono_alternativo">Tel\xE9fono Alternativo <small>Ej:(+57) 3147023030</small></label> <input type="text" class="form-control" id="telefono_alternativo" name="telefono_alternativo" placeholder="Tel\xE9fono" ng-model="datos_edicion.telefono_alternativo" required=""> <i ng-show="edicionForm.telefono_alternativo.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.telefono_alternativo.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.actividad_economica.$invalid,\'has-success has-feedback\':edicionForm.actividad_economica.$valid}"><label class="text-left full-width" for="perfil_administrativo">Actividad Econ\xF3mica</label><ui-select name="actividad_economica" ng-model="datos_edicion.actividad_economica" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true" required=""><ui-select-match placeholder="Actividad Econ\xF3mica">{{$select.selected.descripcion}} - ({{$select.selected.codigo}})</ui-select-match><ui-select-choices repeat="item in datos_usuario.actividades_economicas | filter: {codigo:$select.search,descripcion:$select.search}"><span>{{item.descripcion}} - ({{item.codigo}})</span></ui-select-choices></ui-select><i ng-show="edicionForm.actividad_economica.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.actividad_economica.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width" for="perfil_administrativo">Seleccione perfil administrativo</label><ui-select ng-model="datos_edicion.perfil_administrativo_objeto" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione perfil administrativo">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_usuario.perfiles_administrativos | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.foto.$invalid,\'has-success has-feedback\':edicionForm.foto.$valid}"><label class="text-left full-width" for="foto">Fotograf\xEDa</label> <input type="file" ngf-select="" accept="image/*" ngf-max-size="50MB" ngf-model-invalid="errorFile" class="form-control" id="foto" name="foto" placeholder="Fotograf\xEDa" ng-model="datos_edicion.foto"> <i ng-show="edicionForm.foto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.foto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div><span class="progress" ng-show="datos_edicion.foto.progress >= 0"><div style="width:{{datos_edicion.foto.progress}}%" ng-bind="datos_edicion.foto.progress + \'%\'"></div></span><div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="{{datos_edicion.foto.progress}}" aria-valuemin="0" aria-valuemax="100" style="width: {{datos_edicion.foto.progress}}%"><span class="sr-only">{{datos_edicion.foto.progress}} %</span></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button> <button type="submit" ng-disabled="edicionForm.$invalid || datos_edicion.confirmar_password_invalid" class="float-left btn btn-info">Actualizar</button></div></form></div>');
$templateCache.put('app/pages/usuarios/eliminacionUsuario.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Eliminaci\xF3n de usuario</span></div><div class="modal-body text-center">\xBFEst\xE1 seguro que desea eliminar al usuario <strong>{{datos_usuario.nombre_usuario_eliminacion}}?</strong></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">Cancelar</button> <button type="button" class="btn btn-danger" ng-click="confirmarEliminacionUsuario()">Eliminar</button></div></div>');
$templateCache.put('app/pages/usuarios/usuarios.html','<div class="widgets" ng-init="datosIniciales()"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Listado de los usuarios" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="col-lg-12"><div class="form-group select-page-size-wrap float-left"><label><strong>Total de registros</strong><select ng-change="traerListadoPorRegistros();" class="form-control selectpicker show-tick" title="Cantidad de registros" selectpicker="" ng-model="datos_usuario.quantityRows" ng-options="i for i in [100,500,1000,\'Todos\']"></select></label></div><div class="form-group select-page-size-wrap float-left"><label><strong>Filas por p\xE1gina</strong><select class="form-control selectpicker show-tick" title="Filas por p\xE1gina" selectpicker="" ng-model="datos_usuario.smartTablePageSize" ng-options="i for i in [10,50,100,500]"></select></label></div><div class="form-group item-opciones-modulo float-right"><button ng-click="abrirNuevo();" type="button" class="btn btn-success btn-with-icon"><i class="ion-plus-circled"></i>Nuevo</button></div></div><table class="table table-bordered table-hover table-condensed" st-table="datos_usuario.listado" st-safe-src="datos_usuario.safe_listado"><thead><tr class="sortable"><th>#</th><th class="tiene_sort" st-sort="nombres">Nombres</th><th class="tiene_sort" st-sort="apellidos">Apellidos</th><th class="tiene_sort" st-sort="nombreusuario">Nombre de Usuario</th><th class="tiene_sort" st-sort="identificacion">Identificacion</th><th class="tiene_sort" st-sort="actividad_economica">Actividad econ\xF3mica</th><th class="tiene_sort" st-sort="email">Email</th><th class="tiene_sort" st-sort="perfil_administrativo">Perfil Administrativo</th><th>Tel\xE9fonos</th><th class="tiene_sort" st-sort="fecha_creacion" st-sort-default="reverse">Creado en</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat="item in datos_usuario.listado" class="editable-row"><td class="table-id">{{$index+1}}</td><td><span editable-text="item.nombres" ng-model="usuario.nombres" e-name="nombres" e-form="rowform" e-required="">{{ item.nombres || \'Vac\xEDo\' }}</span></td><td><span editable-text="item.apellidos" e-ng-model="usuario.apellidos" e-name="apellidos" e-form="rowform" e-required="">{{ item.apellidos || \'Vac\xEDo\' }}</span></td><td><span>{{item.nombreusuario}}</span></td><td><span>{{item.identificacion}}</span></td><td>{{item.codigo_actividad_economica == "" || item.codigo_actividad_economica == NULL ? "Sin asignar" : item.descripcion_actividad_economica + " - (" + item.codigo_actividad_economica+")"}}</td><td><span editable-text="item.email" e-name="email" e-form="rowform" e-required=""><a class="email-link" ng-href="mailto:{{item.email}}">{{ item.email || \'vac\xEDo\' }}</a></span></td><td><span>{{ item.perfil_administrativo }}</span></td><td><label>Principal:</label> <span editable-text="item.telefono" e-ng-model="usuario.telefono" e-name="telefono" e-form="rowform" e-required="">{{ item.telefono || \'vac\xEDo\' }}</span> <label>Alternativo:</label> <span editable-text="item.telefono_alternativo" e-ng-model="usuario.telefono_alternativo" e-name="telefono_alternativo" e-form="rowform" e-required="">{{ item.telefono_alternativo || \'vac\xEDo\' }}</span></td><td><span>{{item.fecha_creacion | amDateFormat:\'dddd, MMMM Do YYYY\'}}</span></td><td><form editable-form="" name="rowform" onbeforesave="grabarCambios($index,$data)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-success editable-table-button btn-xs">Grabar</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-danger editable-table-button btn-xs">Cancelar</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-success editable-table-button btn-xs" ng-click="rowform.$show()">Modificar</button> <button class="btn btn-amarillo editable-table-button btn-xs" ng-click="abrirEdicion(item);">Editar</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="borrarUsuario($index)">Borrar</button></div></td></tr></tbody><tfoot><tr><td colspan="7" class="text-center"><div st-pagination="" st-items-by-page="datos_usuario.smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/charts/amCharts/charts.html','<div class="widgets"><div class="row"><div class="col-lg-4 col-md-6" ba-panel="" ba-panel-title="Bar Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/barChart/barChart.html\'"></div></div><div class="col-lg-4 col-md-6" ba-panel="" ba-panel-title="Area Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/areaChart/areaChart.html\'"></div></div><div class="col-lg-4 col-md-12" ba-panel="" ba-panel-title="Line Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/lineChart/lineChart.html\'"></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Pie Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/pieChart/pieChart.html\'"></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Funnel Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/funnelChart/funnelChart.html\'"></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Combined bullet/column and line graphs with multiple value axes" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/combinedChart/combinedChart.html\'"></div></div></div></div>');
$templateCache.put('app/pages/charts/chartJs/chartJs.html','<div class="row"><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Pie" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="pie" class="chart chart-pie" chart-options="options" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Doughnut" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" chart-options="options" class="chart chart-doughnut" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Polar" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="polar-area" class="chart chart-polar-area" chart-data="data" chart-options="options" chart-labels="labels" chart-click="changeData"></canvas></div></div></div></div><div class="row"><div class="col-md-6" ng-controller="chartJsWaveCtrl"><div ba-panel="" ba-panel-title="Animated Radar" ba-panel-class="col-eq-height"><div class="chartjs-canvas-holder-second-row"><canvas id="waveLine" class="chart chart-radar" chart-data="[data]" chart-labels="labels"></canvas></div></div></div><div class="col-md-6" ng-controller="chartJsWaveCtrl"><div ba-panel="" ba-panel-title="Animated Bars" ba-panel-class="col-eq-height"><div class="chartjs-canvas-holder-second-row"><canvas id="waveBars" class="chart chart-bar" chart-data="[data]" chart-labels="labels"></canvas></div></div></div></div><div class="row"><div class="col-lg-4 col-md-6" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Radar" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="radar" class="chart chart-radar" chart-series="series" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-lg-4 col-md-6" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Line" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="line" class="chart chart-line" chart-data="data" chart-labels="labels" chart-series="series" chart-click="changeData"></canvas></div></div></div><div class="col-lg-4 col-md-12" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Bars" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="bar" class="chart chart-bar" chart-data="data" chart-labels="labels" chart-series="series" chart-click="changeData" chart-update="updateC"></canvas></div></div></div></div>');
$templateCache.put('app/pages/charts/chartist/chartist.html','<section ng-controller="chartistCtrl" class="chartist"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Lines" ba-panel-class="with-scroll"><h5>Simple line chart</h5><div id="line-chart" class="ct-chart"></div><h5>Line chart with area</h5><div id="area-chart" class="ct-chart"></div><h5>Bi-polar line chart with area only</h5><div id="bi-chart" class="ct-chart"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Bars" ba-panel-class="with-scroll"><h5>Simple bar chart</h5><div id="simple-bar" class="ct-chart"></div><h5>Multi-line labels bar chart</h5><div id="multi-bar" class="ct-chart"></div><h5>Stacked bar chart</h5><div id="stacked-bar" class="ct-chart stacked-bar"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Pies & Donuts" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12 col-lg-4"><h5>Simple Pie</h5><div id="simple-pie" class="ct-chart"></div></div><div class="col-md-12 col-lg-4"><h5>Pie with labels</h5><div id="label-pie" class="ct-chart"></div></div><div class="col-md-12 col-lg-4"><h5>Donut</h5><div id="donut" class="ct-chart"></div></div></div></div></div></div></section>');
$templateCache.put('app/pages/charts/morris/morris.html','<section ng-controller="morrisCtrl"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Line Chart" ba-panel-class="with-scroll"><div line-chart="" line-data="lineData" line-xkey="y" line-ykeys=\'["a", "b"]\' line-labels=\'["Serie A", "Serie B"]\' line-colors="colors"></div></div></div></div><div class="row"><div class="col-md-4"><div ba-panel="" ba-panel-title="Donut" ba-panel-class="with-scroll"><div donut-chart="" donut-data="donutData" donut-colors="colors" donut-formatter=\'"currency"\'></div></div></div><div class="col-md-8"><div ba-panel="" ba-panel-title="Bar Chart" ba-panel-class="with-scroll"><div bar-chart="" bar-data="barData" bar-x="y" bar-y=\'["a", "b"]\' bar-labels=\'["Series A", "Series B"]\' bar-colors="colors"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Area Chart" ba-panel-class="with-scroll"><div area-chart="" area-data="areaData" area-xkey="y" area-ykeys=\'["a", "b"]\' %="" area-labels=\'["Serie A", "Serie B"]\' line-colors="colors"></div></div></div></div></section>');
$templateCache.put('app/pages/certificados/edicion/layout.html','<div class="row" ng-init="datosIniciales();"><div class="col-lg-12 col-md-12 col-xs-12 col-sm-12"><form name="edicionForm"><div class="widgets"><div class="titulo_edicion row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="float-left"><h3><strong>Cliente:</strong> {{datos_edicion.nombres_cliente}} {{datos_edicion.apellidos_cliente}}</h3></div><div class="form-group item-opciones-modulo float-right"><button ng-click="regresarAListado();" type="button" class="btn btn-success btn-with-icon"><i class="ion-cash"></i>Ver listado</button></div><div class="form-group item-opciones-modulo float-right"><a href="{{datosApp.url_api_raiz}}index.php/inicio/exportarpdf1/{{datos_edicion.id}}" target="_blank" class="btn btn-success btn-with-icon"><i class="ion-printer"></i>PDF General</a> <a href="{{datosApp.url_api_raiz}}index.php/inicio/exportarpdf/{{datos_edicion.id}}" target="_blank" class="btn btn-success btn-with-icon"><i class="ion-printer"></i>Detalles declaraci\xF3n</a> <button ng-show="!soloLectura" ng-click="actualizarCertificado(datos_edicion);" type="button" class="btn btn-success btn-with-icon"><i class="ion-android-create"></i>Actualizar</button></div></div></div></div><div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="panel-info" ba-panel-title="Datos del declarante"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left" for="ano_declaracion">N\xFAmero de identificaci\xF3n</label><br>{{datos_edicion.identificacion}}</div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left" for="actividad_economica">Actividad econ\xF3mica</label><br>{{datos_edicion.codigo_actividad_economica == "" || datos_edicion.codigo_actividad_economica == NULL ? "Sin asignar" : datos_edicion.descripcion_actividad_economica + " - (" + datos_edicion.codigo_actividad_economica+")"}}</div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.numero_formulario.$invalid,\'has-success has-feedback\':edicionForm.numero_formulario.$valid}"><label class="text-left" for="numero_formulario">N\xFAmero de formulario</label> <input ng-readonly="soloLectura" type="text" class="form-control" id="numero_formulario" name="numero_formulario" placeholder="N\xFAmero de formulario" ng-model="datos_edicion.numero_formulario" pattern="[A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA 0-9\\s]+"> <i ng-show="edicionForm.numero_formulario.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.numero_formulario.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left" for="ano_declaracion">A\xF1o de declaraci\xF3n</label><br>{{datos_edicion.ano_declaracion_ok | amDateFormat:\'YYYY\'}}</div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.direccion_seccional.$invalid,\'has-success has-feedback\':edicionForm.direccion_seccional.$valid}"><label class="text-left full-width" for="perfil_administrativo">Cod. Direcci\xF3n Seccional</label><ui-select name="direccion_seccional" ng-model="datos_edicion.direccion_seccional" class="btn-group bootstrap-select form-control" ng-disabled="soloLectura" search-enabled="true" required=""><ui-select-match placeholder="Cod. Direcci\xF3n Seccional">{{$select.selected.descripcion}} - ({{$select.selected.codigo}})</ui-select-match><ui-select-choices repeat="item in datos_certificado.listado_dir_seccional | filter: {codigo:$select.search,descripcion:$select.search}"><span>{{item.descripcion}} - ({{item.codigo}})</span></ui-select-choices></ui-select><i ng-show="edicionForm.direccion_seccional.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.direccion_seccional.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div></div></div></div></div></div><div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="panel-info" ba-panel-title="Datos principales"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="panel-dentro-panel panel-primary" ba-panel-title="Patrimonio"><div class="form-group col-lg-6"><label class="text-left">Total patrimonio bruto</label><br>{{datos_edicion.total_patrimonio_bruto | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo30();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Deudas</label><br>{{datos_edicion.total_deudas_patrimonio | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo31();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Total patrimonio l\xEDquido</label><br>{{datos_edicion.total_patrimonio_liquido | currency:"$":2 || \'$0.0\' }}</div></div><div ba-panel="" ba-panel-class="panel-dentro-panel panel-primary" ba-panel-title="Ingresos"><div class="form-group col-lg-6"><label class="text-left">Recibidos como empleado (33)</label><br>{{datos_edicion.total_recibidos_empleados_ingresos | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo33();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Recibidos por pensiones jubilaci\xF3n, invalidez, vejez, de sobreviviente y riesgos laborales (34)</label><br>{{datos_edicion.total_recibidos_pensiones_ingresos | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo34();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Honorarios, comisiones y servicios (35)</label><br>{{datos_edicion.total_honorarios | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo35();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Intereses y rendimientos financieros (36)</label><br>{{datos_edicion.total_intereses | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo36();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Dividendos y participaciones (37)</label><br>{{datos_edicion.total_dividendos | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo37();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Otros (Ventas, arrendamientos, etc.) (38)</label><br>{{datos_edicion.total_otrosetc | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo38();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Obtenidos en el exterior (39)</label><br>{{datos_edicion.total_obtenidosext | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo39();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Total ingresos recibidos por concepto de renta (40)</label><br>{{datos_edicion.total_ingresos_recibidos_renta | currency:"$":2 || \'$0.0\' }}</div><p>no constitutivos renta ni ganancia ocasional</p><div class="form-group col-lg-6"><label class="text-left">Dividendos y participantes (41)</label><br>{{datos_edicion.total_dividendosnoconsti | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo41();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Donaciones (42)</label><br>{{datos_edicion.total_donaciones | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo42();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Pagos a terceros por alimentaci\xF3n (43)</label><br>{{datos_edicion.total_tercerosali | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo43();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Otros ingresos no constitutivos de renta (44)</label><br>{{datos_edicion.total_otrosingresosnoconsti | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo44();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Total ingresos no constitutivos de renta ni ganancia ocasional (45)</label><br>{{datos_edicion.total_ingresos_noconsti_renta | currency:"$":2 || \'$0.0\' }}</div><p>--------------------////------------</p><div class="form-group col-lg-6"><label class="text-left">Total ingresos netos (46)</label><br>{{datos_edicion.total_ingresos_neto | currency:"$":2 || \'$0.0\' }}</div></div><div ba-panel="" ba-panel-class="panel-dentro-panel panel-primary" ba-panel-title="Costos y deducciones"><div class="form-group col-lg-6"><label class="text-left">Gastos de nomina incluidos los aportes a la seguridad social y parafiscales (47)</label><br>{{datos_edicion.total_nomina | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo47();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Deducci\xF3n por dependientes economicos (48)</label><br>{{datos_edicion.total_deducciondependientes| currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo48();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Deduccion por pago de intereses de vivenda (49)</label><br>{{datos_edicion.total_intvivienda | currency:"$":2 || \'$0.0\' }}<button ng-show="!soloLectura" ng-click="abrirCampo49();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Otros costos y deducciones (50)</label><br>{{datos_edicion.total_otroscostos | currency:"$":2 || \'$0.0\' }}<button ng-show="!soloLectura" ng-click="abrirCampo50();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Costos y gastos incurridos en el exterior (51)</label><br>{{datos_edicion.total_cygexterior | currency:"$":2 || \'$0.0\' }}<button ng-show="!soloLectura" ng-click="abrirCampo51();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><p>--------------------////------------</p><div class="form-group col-lg-6"><label class="text-left">Total costos y deducciones (52)</label><br>{{datos_edicion.total_costos_y_deducciones | currency:"$":2 || \'$0.0\' }}</div></div><div ba-panel="" ba-panel-class="panel-dentro-panel panel-primary" ba-panel-title="Renta"><div class="row"><div class="col-lg-12"><div class="form-group col-lg-6"><label class="text-left">Renta liquida ordinaria del ejercicio (53)</label><br>{{datos_edicion.renta_liquidaord | currency:"$":2 || \'$0.0\' }}</div><div class="form-group col-lg-6"><label class="text-left">Perdida liquida del ejercicio (54)</label><br>{{datos_edicion.perdida_liquidaejer | currency:"$":2 || \'$0.0\' }}</div><div class="form-group col-lg-6"><label class="text-left">Compensaciones (por exeso de renta presuntiva) (55)</label><br>{{datos_edicion.compensaciones_presuntiva | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo55();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-search"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Renta l\xEDquida (56)</label><br>{{datos_edicion.renta_liquida | currency:"$":2 || \'$0.0\' }}</div><div class="form-group col-lg-6"><label class="text-left">Renta presuntiva (57)</label><br>{{datos_edicion.renta_presuntiva | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo57();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-search"></i></button></div></div></div><div class="row"><div class="col-lg-12"><div ba-panel="" ba-panel-class="panel-dentro-panel panel-success" ba-panel-title="Renta exenta"><div class="form-group col-lg-6"><label class="text-left">Gastos de representaci\xF3n y otras rentas de trabajo (58)</label><br>{{datos_edicion.total_rentastrabajo | currency:"$":2 || \'$0.0\' }}<button ng-show="!soloLectura" ng-click="abrirCampo58();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Aportes obligatorios al fondo de pensi\xF3n (59)</label><br>{{datos_edicion.total_pensionobli | currency:"$":2 || \'$0.0\' }}<button ng-show="!soloLectura" ng-click="abrirCampo59();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Aportes a fondo de pensiones voluntarios (60)</label><br>{{datos_edicion.total_pensionvol | currency:"$":2 || \'$0.0\' }}<button ng-show="!soloLectura" ng-click="abrirCampo60();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Aportes a cuentas AFC (61)</label><br>{{datos_edicion.total_cuentasafc | currency:"$":2 || \'$0.0\' }}<button ng-show="!soloLectura" ng-click="abrirCampo61();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Otras rentas exentas (62)</label><br>{{datos_edicion.total_rtexentas | currency:"$":2 || \'$0.0\' }}<button ng-show="!soloLectura" ng-click="abrirCampo62();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Por pagos laborales (25%) y pensiones (63)</label><br>{{datos_edicion.total_laborypension | currency:"$":2 || \'$0.0\' }}<button ng-show="!soloLectura" ng-click="abrirCampo63();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Total renta exenta (58+...+63)(64)</label><br>{{datos_edicion.total_rentaexenta | currency:"$":2 || \'$0.0\' }}</div></div></div></div><div class="form-group col-lg-6"><label class="text-left">Rentas gravables (65)</label><br>{{datos_edicion.total_rentasgravables | currency:"$":2 || \'$0.0\' }}<button ng-show="!soloLectura" ng-click="abrirCampo65();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><p>--------------------////------------</p><div class="form-group col-lg-6"><label class="text-left">Renta liquida gravable (66)</label><br>{{datos_edicion.total_renta_liquida_gravable | currency:"$":2 || \'$0.0\' }}</div></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="panel-dentro-panel panel-primary" ba-panel-title="Ganancia ocasional"><div class="form-group col-lg-6"><label class="text-left">Ingresos por ganancias ocasionales en el pais (67)</label><br>{{datos_edicion.total_gananciapais | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo67();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Ingresos por ganancias ocasionales en el exterior (68)</label><br>{{datos_edicion.total_gananciaexterior | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo68();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Costos por ganancias ocasionales (69)</label><br>{{datos_edicion.total_gananciasocasionales | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo69();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Ganancias ocasionales no gravadas y exentas (70)</label><br>{{datos_edicion.total_gananciasocasionalesexentas | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo70();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><p>--------------------////------------</p><div class="form-group col-lg-6"><label class="text-left">Ganancias ocasionales gravables (67+68-69-70) (71)</label><br>{{datos_edicion.total_gananciasocasionalesgravables | currency:"$":2 || \'$0.0\' }}</div></div><div ba-panel="" ba-panel-class="panel-dentro-panel panel-primary" ba-panel-title="Determinacion de la renta gravable alternativa -IMAN, para empleados"><div class="form-group col-lg-6"><label class="text-left">Total ingresos obtenidos periodo gravable (72)</label><br>{{datos_edicion.total_ingresosobtenidosgravables | currency:"$":2 || \'$0.0\' }}</div><div class="form-group col-lg-6"><label class="text-left">Dividendos y participaciones no gravados (73)</label><br>{{datos_edicion.total_dividendosparticipaciones | currency:"$":2 || \'$0.0\' }}</div><div class="form-group col-lg-6"><label class="text-left">Indemnizaciones en dinero o en especie por seguro de da\xF1o (74)</label><br>{{datos_edicion.total_indemseguro | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo74();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Aportes obligatorios al sistema general de seguridad social a cargo del empleado (75)</label><br>{{datos_edicion.total_aportesss | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo75();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Gastos de representaci\xF3n exentos (76)</label><br>{{datos_edicion.total_gtrepreexento | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo76();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Pagos catastr\xF3ficos en salud efectivamente certificados no cubiertos por el POS (77)</label><br>{{datos_edicion.total_saludnopos | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo77();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">P\xE9rdidas por desastres o calamidades p\xFAblicas (78)</label><br>{{datos_edicion.total_desastreycal | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo78();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Aportes obligatorios a seguridad social de un empleado del servicio domestico (79)</label><br>{{datos_edicion.total_empleadodomestico | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo79();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Costo fiscal de los bienes enajenados (80)</label><br>{{datos_edicion.total_bienesenaje | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo80();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Indemnizaciones y otros Lit. i) Art332 E.T. (81)</label><br>{{datos_edicion.total_indemnizaciones | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo81();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Retiros fondos de pensi\xF3n de jubilaci\xF3n e invalidez; fondos de cesant\xEDas y cuentas AFC (82)</label><br>{{datos_edicion.total_retirosfondos | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo82();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><p>--------------------////------------</p><div class="form-group col-lg-6"><label class="text-left">Renta gravable alternativa (Base del IMAN) (72+...+82) (83)</label><br>{{datos_edicion.total_rentagravablealternativa | currency:"$":2 || \'$0.0\' }}</div></div><div ba-panel="" ba-panel-class="panel-dentro-panel panel-primary" ba-panel-title="Liquidaci\xF3n privada"><div class="row"><div class="col-lg-12"><div class="form-group col-lg-6"><label class="text-left">Impuesto sobre la renta liquida gravable (84)</label><br>{{datos_edicion.total_impuestorentaliquidagravable | currency:"$":2 || \'$0.0\' }}</div><div class="form-group col-lg-6"><label class="text-left">Impuesto minimo alternativo nacional - IMAN, para empleados (85)</label><br>{{datos_edicion.total_impuestoiman | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo85();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div></div></div><div class="row"><div class="col-lg-12"><div ba-panel="" ba-panel-class="panel-dentro-panel panel-success" ba-panel-title="Descuentos"><div class="form-group col-lg-6"><label class="text-left">Impuestos pagados en el exterior sobre dividendos y participaciones lit. a), b) y c) acr254 E.T. (86)</label><br>{{datos_edicion.total_impuexteriorabc | currency:"$":2 || \'$0.0\' }}<button ng-show="!soloLectura" ng-click="abrirCampo86();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Impuestos pagados en el exterior sobre dividendos y participaciones lit. d) acr254 E.T. (87)</label><br>{{datos_edicion.total_impuexteriord | currency:"$":2 || \'$0.0\' }}<button ng-show="!soloLectura" ng-click="abrirCampo87();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Por impuestos pagados en el exterior, distintos a los registrados anteriormente (88)</label><br>{{datos_edicion.total_impuexteriordistinto | currency:"$":2 || \'$0.0\' }}<button ng-show="!soloLectura" ng-click="abrirCampo88();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Otros (89)</label><br>{{datos_edicion.total_otrosdesc | currency:"$":2 || \'$0.0\' }}<button ng-show="!soloLectura" ng-click="abrirCampo89();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><p>--------------------////------------</p><div class="form-group col-lg-6"><label class="text-left">Total descuentos tributarios (90)</label><br>{{datos_edicion.total_descuentostributarios | currency:"$":2 || \'$0.0\' }}</div></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group col-lg-6"><label class="text-left">Impuesto neto de Renta (91)</label><br>{{datos_edicion.total_impuestonetorenta | currency:"$":2 || \'$0.0\' }}</div><div class="form-group col-lg-6"><label class="text-left">Impuesto de ganancias ocasionales (92)</label><br>{{datos_edicion.total_impuestogananciaocasional | currency:"$":2 || \'$0.0\' }}</div><div class="form-group col-lg-6"><label class="text-left">Descuento por impuestos pagados en el exterior por ganancias ocasionales (93)</label><br>{{datos_edicion.total_impextocasional | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo93();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Total impuesto a cargo (91+92-93)(94)</label><br>{{datos_edicion.total_impuestoacargo | currency:"$":2 || \'$0.0\' }}</div><div class="form-group col-lg-6"><label class="text-left">Anticipo renta por el a\xF1o gravable {{ano_anterior}} (95)</label><br>{{datos_edicion.total_liquidacion_anticipo_renta_ano_anterior | currency:"$":2 || \'$0.0\' }}</div><div class="form-group col-lg-6"><label class="text-left">Saldo a favor del a\xF1o {{ano_anterior_anterior}} sin solicitud de devoluci\xF3n o compensaci\xF3n (Casilla 102 declaracion 2014) (96)</label><br>{{datos_edicion.total_saldo_a_favor_anterior_anterior | currency:"$":2}}</div><div class="form-group col-lg-6"><label class="text-left">Total retenciones a\xF1o gravable {{ano_anterior}} (97)</label><br>{{datos_edicion.total_retencionesanoanterior | currency:"$":2 || \'$0.0\' }} <button ng-show="!soloLectura" ng-click="abrirCampo97();" type="button" class="btn btn-xs btn-danger btn-icon"><i class="ion-edit"></i></button></div><div class="form-group col-lg-6"><label class="text-left">Anticipo renta por el a\xF1o gravable {{ano_actual}} (98)</label><br>{{datos_edicion.anticipo_rentagravable | currency:"$":2 || \'$0.0\' }}</div><div class="form-group col-lg-6"><label class="text-left">Saldo a pagar por impuesto (94+98-95-96-97) (99)</label><br>{{datos_edicion.total_saldopagarimpuesto | currency:"$":2 || \'$0.0\' }}</div><div class="form-group col-lg-6"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.sanciones.$invalid,\'has-success has-feedback\':edicionForm.sanciones.$valid}"><label class="text-left" for="sanciones">(100) Sanciones</label> <input ng-blur="actualizarLiquidacion();" ng-readonly="soloLectura" type="text" class="form-control" id="sanciones" name="sanciones" placeholder="Sanciones" ng-model="datos_edicion.total_sanciones" required="" pattern="[0-9,.\\s]+"> <i ng-show="edicionForm.sanciones.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.sanciones.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="form-group col-lg-6"><label class="text-left">Total saldo a pagar (101)</label><br>{{datos_edicion.total_saldo_pagar | currency:"$":2 || \'$0.0\' }}</div><div class="form-group col-lg-6"><label class="text-left">Total saldo a favor (102)</label><br>{{datos_edicion.total_saldo_favor | currency:"$":2 || \'$0.0\' }}</div></div></div></div></div></div></div></div></div></div></div><div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="panel-info" ba-panel-title="Datos finales"><div class="col-lg-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.codigo_representacion.$invalid,\'has-success has-feedback\':edicionForm.codigo_representacion.$valid}"><label class="text-left" for="codigo_representacion">C\xF3digo representaci\xF3n</label> <input ng-readonly="soloLectura" type="text" class="form-control" id="codigo_representacion" name="codigo_representacion" placeholder="C\xF3digo representaci\xF3n" ng-model="datos_edicion.codigo_representacion" pattern="[0-9\\s]+"> <i ng-show="edicionForm.codigo_representacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.codigo_representacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':edicionForm.pago_total.$invalid,\'has-success has-feedback\':edicionForm.pago_total.$valid}"><label class="text-left" for="pago_total">Pago total: {{datos_edicion.pago_total | currency:"$":2}}</label> <input ng-readonly="soloLectura" type="text" class="form-control" id="pago_total" name="pago_total" placeholder="Pago total" ng-model="datos_edicion.pago_total" pattern="[0-9,.\\s]+"> <i ng-show="edicionForm.pago_total.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="edicionForm.pago_total.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></div></div></div></div></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="form-group item-opciones-modulo float-right"><button ng-show="!soloLectura" ng-click="actualizarCertificado(datos_edicion);" type="button" class="btn btn-success btn-with-icon"><i class="ion-android-create"></i>Actualizar</button></div></div></div></div></form></div></div>');
$templateCache.put('app/pages/components/mail/mail.html','<div class="row mail-client-container transparent"><div class="col-md-12"><div ba-panel="" ba-panel-class="xmedium-panel mail-panel"><div class="letter-layout"><div class="mail-navigation-container" ng-class="{\'expanded\' : !tabCtrl.navigationCollapsed}"><div class="text-center"><button type="button" class="btn btn-default compose-button" ng-click="tabCtrl.showCompose(\'\',\'\',\'\')">Compose</button></div><div ng-repeat="t in tabCtrl.tabs" ui-sref-active="active" class="mail-navigation" ui-sref="components.mail.label({label: t.label})" ng-click="selectTab(t.label)">{{t.name}}<span class="new-mails" ng-show="t.newMails">{{t.newMails}}</span></div><div class="labels"><div class="labels-title"></div><div class="labels-container"><div class="label-item"><span class="tag label work">Work</span></div><div class="label-item"><span class="tag label family">Family</span></div><div class="label-item"><span class="tag label friend">Friend</span></div><div class="label-item"><span class="tag label study">Study</span></div></div></div><div class="add-label-container"><i class="ion-plus-round"></i><span class="label-input-stub">Add new label</span></div></div><ui-view></ui-view></div></div></div></div>');
$templateCache.put('app/pages/components/timeline/timeline.html','<div ba-panel=""><section id="cd-timeline" class="cd-container cssanimations" ng-controller="TimelineCtrl"><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Euro-Coin\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 1</h5><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto, optio, dolorum provident rerum aut hic quasi placeat iure tempora laudantium ipsa ad debitis unde? Iste voluptatibus minus veritatis qui ut.</p><span class="cd-date">Jan 14</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Laptop-Signal\' | kameleonImg )}}"></div></div><div class="cd-timeline-content danger"><h5>Title of section 2</h5><p>Donec dapibus at leo eget volutpat. Praesent dolor tellus, ultricies venenatis molestie eu, luctus eget nibh. Curabitur ullamcorper eleifend nisl.</p><span class="cd-date">Jan 18</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg primary"><img ng-src="{{::( \'Checklist\' | kameleonImg )}}"></div></div><div class="cd-timeline-content primary"><h5>Title of section 3</h5><p>Phasellus auctor tellus eget lacinia condimentum. Cum sociis natoque penatibus et magnis dis parturient montes.</p><span class="cd-date">Feb 18</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Boss-3\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 4</h5><p>Morbi fringilla in massa ac posuere. Fusce non sagittis massa, id accumsan odio. Nullam eget tempor est. Etiam eu felis eu purus aliquam tristique id quis nisl. Nam eros nibh, consequat sed pulvinar eu, ultrices ornare ligula. Aenean interdum sed nunc sed hendrerit.</p><span class="cd-date">Feb 20</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Online-Shopping\' | kameleonImg )}}"></div></div><div class="cd-timeline-content danger"><h5>Title of section 5</h5><p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Curabitur eget mattis metus. Nullam egestas eros metus, quis fringilla urna accumsan sed. Aliquam ultrices at arcu vitae tincidunt.</p><span class="cd-date">Feb 21</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg primary"><img ng-src="{{::( \'Money-Increase\' | kameleonImg )}}"></div></div><div class="cd-timeline-content primary"><h5>Title of section 6</h5><p>Praesent bibendum ante mattis augue consectetur, ut commodo turpis consequat. Donec ligula eros, porta in iaculis vel, semper ac sem. Integer at mauris lorem.</p><span class="cd-date">Feb 23</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Vector\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 7</h5><p>Vivamus ut laoreet erat, vitae eleifend eros. Sed varius id tellus non lobortis. Sed dolor ante, cursus non scelerisque sed, euismod id eros.</p><span class="cd-date">Feb 24</span></div></div></section></div>');
$templateCache.put('app/pages/components/tree/tree.html','<div class="row" ng-controller="treeCtrl"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic Action" ba-panel-class="with-scroll tree-panel"><div class="row"><div class="col-sm-4"><div class="control-side text-center"><div><button class="btn btn-success" ng-click="addNewNode()">Add</button></div><div><button class="btn btn-success" ng-click="collapse()">Collapse All</button></div><div><button class="btn btn-success" ng-click="expand()">Expand All</button></div><div><button class="btn btn-success" ng-click="refresh()">Refresh</button></div></div></div><div class="col-sm-8"><div js-tree="basicConfig" ng-model="treeData" should-apply="applyModelChanges()" tree="basicTree" tree-events="ready:readyCB"></div></div></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Drag & Drop" ba-panel-class="with-scroll tree-panel"><div js-tree="dragConfig" ng-model="dragData"></div></div></div></div>');
$templateCache.put('app/pages/dashboard/blurFeed/blurFeed.html','<div class="feed-messages-container" track-width="smallContainerWidth" min-width="360"><div class="feed-message" ng-repeat="message in feed" ng-click="expandMessage(message)"><div class="message-icon" ng-if="message.type == \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"></div><div class="message-icon" ng-if="message.type != \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"> <span class="sub-photo-icon" ng-class="::message.type"></span></div><div class="text-block text-message"><div class="message-header"><span class="author">{{ ::message.author }} {{ ::message.surname}}</span></div><div class="message-content line-clamp" ng-class="{\'line-clamp-2\' : !message.expanded}"><span ng-if="message.preview">{{message.header}}</span>{{::message.text}}</div><div class="preview" ng-show="message.expanded" ng-if="message.preview"><a href="{{::message.link}}" target="_blank"><img ng-src="{{ ::( message.preview | appImage )}}"></a></div><div ng-show="message.expanded" class="message-time"><div class="post-time">{{::message.time}}</div><div class="ago-time">{{::message.ago}}</div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardCalendar/dashboardCalendar.html','<div id="calendar" class="blurCalendar"></div>');
$templateCache.put('app/pages/dashboard/dashboardLineChart/dashboardLineChart.html','<div id="amchart"></div>');
$templateCache.put('app/pages/dashboard/dashboardMap/dashboardMap.html','<div id="amChartMap"></div>');
$templateCache.put('app/pages/dashboard/dashboardPieChart/dashboardPieChart.html','<div class="row pie-charts"><div class="pie-chart-item-container" ng-repeat="chart in charts"><div ba-panel=""><div class="pie-chart-item"><div class="chart" rel="{{ ::chart.color }}" data-percent="60"><span class="percent"></span></div><div class="description"><div>{{ ::chart.description }}</div><div class="description-stats">{{ ::chart.stats }}</div></div><i class="chart-icon i-{{ ::chart.icon }}"></i></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardTodo/dashboardTodo.html','<div class="task-todo-container" ng-class="{\'transparent\': transparent}"><input type="text" value="" class="form-control task-todo" placeholder="Task to do.." ng-keyup="addToDoItem($event)" ng-model="newTodoText"> <i ng-click="addToDoItem(\'\',true)" class="add-item-icon ion-plus-round"></i><div class="box-shadow-border"></div><ul class="todo-list" ui-sortable="" ng-model="todoList"><li ng-repeat="item in todoList" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false"><div class="blur-container"><div class="blur-box"></div></div><i class="mark" style="background-color: {{::item.color}}"></i> <label class="todo-checkbox custom-checkbox custom-input-success"><input type="checkbox" ng-model="isChecked"> <span class="cut-with-dots">{{ item.text }}</span></label> <i class="remove-todo ion-ios-close-empty" ng-click="item.deleted = true"></i></li></ul></div>');
$templateCache.put('app/pages/dashboard/popularApp/popularApp.html','<div class="popular-app-img-container"><div class="popular-app-img"><img ng-src="{{::( \'app/my-app-logo.png\' | appImage )}}"> <span class="logo-text">Super&nbspApp</span></div></div><div class="popular-app-cost row"><div class="col-xs-9">Most Popular App</div><div class="col-xs-3 text-right">175$</div></div><div class="popular-app-info row"><div class="col-xs-4 text-left"><div class="info-label">Total Visits</div><div>47,512</div></div><div class="col-xs-4 text-center"><div class="info-label">New Visits</div><div>9,217</div></div><div class="col-xs-4 text-right"><div class="info-label">Sales</div><div>2,928</div></div></div>');
$templateCache.put('app/pages/dashboard/trafficChart/trafficChart.html','<div class="channels-block" ng-class="{\'transparent\': transparent}"><div class="chart-bg"></div><div class="traffic-chart" id="trafficChart"><div class="canvas-holder"><canvas id="chart-area" width="280" height="280"></canvas><div class="traffic-text">1,900,128 <span>Views Total</span></div></div></div><div class="channels-info"><div><div class="channels-info-item" ng-repeat="label in doughnutData.labels" ng-init="i = $index; data = doughnutData.datasets[0]"><div class="legend-color" style="background-color: {{::data.backgroundColor[i]}}"></div><p>{{::label}}<span class="channel-number">+{{data.percentage[i]}}%</span></p><div class="progress progress-sm channel-progress"><div class="progress-bar" role="progressbar" aria-valuenow="{{data.percentage[i]}}" aria-valuemin="0" aria-valuemax="100" style="width: {{item.percentage}}%"></div></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/weather/weather.html','<div class="weather-wrapper"><div class="weather-main-info"><h5 class="city-date font-x1dot5"><div>{{geoData.geoplugin_city}} - {{geoData.geoplugin_countryName | uppercase}}</div><div>{{ weather.days[weather.current].date | date : \'EEEE h:mm\'}}</div></h5><div class="weather-description font-x1dot5"><i class="font-x3 {{weatherIcons[weather.days[weather.current].icon]}}"></i><div class="weather-info">{{weather.days[weather.current].main}} - {{weather.days[weather.current].description}}</div></div><div class="weather-temp font-x1dot5"><i class="font-x2 ion-thermometer"></i><div class="weather-info" ng-switch="" on="units"><span ng-switch-when="metric">{{weather.days[weather.current].temp}} \xB0C | <a ng-click="switchUnits(\'imperial\')" href="">\xB0F</a></span> <span ng-switch-when="imperial">{{weather.days[weather.current].temp}} \xB0F | <a ng-click="switchUnits(\'metric\')" href="">\xB0C</a></span></div></div></div><div id="tempChart" class="temp-by-time"></div><div class="select-day"><div class="day" ng-repeat="day in weather.days" ng-click="switchDay($index)"><div><span class="font-x1dot25">{{day.temp}}</span></div><div><i class="weatherIcon font-x2 {{weatherIcons[day.icon]}}"></i> <span class="select-day-info">{{day.main}}</span></div><div><span>{{day.date | date : \'EEE\'}}</span></div></div></div></div>');
$templateCache.put('app/pages/form/inputs/inputs.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Standard Fields" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/standardFields.html\'"></div></div><div ba-panel="" ba-panel-title="Tags Input" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/tagsInput/tagsInput.html\'"></div></div><div ba-panel="" ba-panel-title="Input Groups" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/inputGroups.html\'"></div></div><div ba-panel="" ba-panel-title="Checkboxes & Radios" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/checkboxesRadios.html\'"></div></div><div ba-panel="" ba-panel-title="On/Off Switches" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/switches/switch.html\'"></div></div><div ba-panel="" ba-panel-title="Old On/Off Switches (Deprecated)" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/oldSwitches/switch.html\'"></div></div><div ba-panel="" ba-panel-title="Datepicker" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/datePickers/datePickers.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Validation States" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/validationStates.html\'"></div></div><div ba-panel="" ba-panel-title="Selects" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/select/select.html\'"></div></div><div ba-panel="" ba-panel-title="Old selects(deprecated)" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/oldSelect/select.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/form/wizard/wizard.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Form Wizard" ba-panel-class="with-scroll"><ba-wizard><ba-wizard-step title="Personal info" form="vm.personalInfoForm"><form name="vm.personalInfoForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.personalInfoForm.username.$invalid && (vm.personalInfoForm.username.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleUsername1">Username</label> <input type="text" class="form-control" id="exampleUsername1" name="username" placeholder="Username" ng-model="vm.personalInfo.username" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': vm.personalInfoForm.email.$invalid && (vm.personalInfoForm.email.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputEmail1">Email address</label> <input type="email" class="form-control" id="exampleInputEmail1" name="email" placeholder="Email" ng-model="vm.personalInfo.email" required=""> <span class="help-block error-block basic-block">Proper email required</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.personalInfoForm.password.$invalid && (vm.personalInfoForm.password.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputPassword1">Password</label> <input type="password" class="form-control" id="exampleInputPassword1" name="password" placeholder="Password" ng-model="vm.personalInfo.password" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': !vm.arePersonalInfoPasswordsEqual() && (vm.personalInfoForm.confirmPassword.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputConfirmPassword1">Confirm Password</label> <input type="password" class="form-control" id="exampleInputConfirmPassword1" name="confirmPassword" placeholder="Confirm Password" ng-model="vm.personalInfo.confirmPassword" required=""> <span class="help-block error-block basic-block">Passwords should match</span></div></div></div></form></ba-wizard-step><ba-wizard-step title="Product Info" form="vm.productInfoForm"><form name="vm.productInfoForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.productInfoForm.productName.$invalid && (vm.productInfoForm.productName.$dirty || vm.productInfoForm.$submitted)}"><label for="productName">Product name</label> <input type="text" class="form-control" id="productName" name="productName" placeholder="Product name" ng-model="vm.productInfo.productName" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': vm.productInfoForm.productId.$invalid && (vm.productInfoForm.productId.$dirty || vm.productInfoForm.$submitted)}"><label for="productId">Product id</label> <input type="text" class="form-control" id="productId" name="productId" placeholder="productId" ng-model="vm.productInfo.productId" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group"><label for="productName">Category</label><select class="form-control" title="Category" selectpicker=""><option selected="">Electronics</option><option>Toys</option><option>Accessories</option></select></div></div></div></form></ba-wizard-step><ba-wizard-step title="Shipment" form="vm.addressForm"><form name="vm.addressForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addressForm.address.$invalid && (vm.addressForm.address.$dirty || vm.addressForm.$submitted)}"><label for="productName">Shipment address</label> <input type="text" class="form-control" id="address" name="address" placeholder="Shipment address" ng-model="vm.shipment.address" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group"><label for="productName">Shipment method</label><select class="form-control" title="Category" selectpicker=""><option selected="">Fast & expensive</option><option>Cheap & free</option></select></div></div></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Save shipment info</span></label></div></form></ba-wizard-step><ba-wizard-step title="Finish"><form class="form-horizontal" name="vm.finishForm" novalidate="">Congratulations! You have successfully filled the form!</form></ba-wizard-step></ba-wizard></div></div></div></div>');
$templateCache.put('app/pages/form/layouts/layouts.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Inline Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/inlineForm.html\'"></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/basicForm.html\'"></div></div><div ba-panel="" ba-panel-title="Horizontal Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/horizontalForm.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Form Without Labels" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/formWithoutLabels.html\'"></div></div><div ba-panel="" ba-panel-title="Block Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/blockForm.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/tables/basic/tables.html','<div class="widgets"><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Hover Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/hoverRows.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Bordered Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/borderedTable.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Condensed Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/condensedTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Striped Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/stripedRows.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Contextual Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/contextualTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Responsive Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/responsiveTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/tables/widgets/basicTable.html','<div class="horizontal-scroll"><table class="table"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Downloads</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">DAU</th><th class="table-arr"></th><th class="align-right">MAU</th><th class="table-arr"></th><th class="align-right">LTV</th><th class="table-arr"></th><th class="align-right">Users %</th><th class="table-arr"></th></tr></thead><tbody><tr><td><img src="img/chrome.svg" width="20" height="20"></td><td class="nowrap">Google Chrome</td><td class="align-right">10,392</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">3,822</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,214</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">899</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">7,098</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">178</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">45%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/firefox.svg" width="20" height="20"></td><td class="nowrap">Mozilla Firefox</td><td class="align-right">7,873</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">6,003</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,031</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">897</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">8,997</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">28%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/ie.svg" width="20" height="20"></td><td class="nowrap">Internet Explorer</td><td class="align-right">5,890</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,492</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">2,102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">27</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,039</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">99</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">17%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/safari.svg" width="20" height="20"></td><td class="nowrap">Safari</td><td class="align-right">4,001</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">2,039</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">1,001</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">104</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,983</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">209</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">14%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/opera.svg" width="20" height="20"></td><td class="nowrap">Opera</td><td class="align-right">1,833</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">983</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">83</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">19</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">1,099</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">103</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">5%</td><td class="table-arr"><i class="icon-up"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/borderedTable.html','<div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="align-right">Purchases</th><th class="align-right">%</th></tr></thead><tbody><tr ng-repeat="item in metricsTableData"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="align-right">{{item.purchases}}</td><td class="align-right">{{item.percent}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/condensedTable.html','<div class="horizontal-scroll"><table class="table table-condensed"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Status</th></tr></thead><tbody><tr ng-repeat="item in peopleTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><button class="status-button btn btn-xs btn-{{item.status}}">{{item.status}}</button></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/contextualTable.html','<table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr class="primary"><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr class="success"><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr class="warning"><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr class="danger"><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr class="info"><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableRowTable.html','<div class="add-row-editable-table"><button class="btn btn-success" ng-click="addUser()">Add row</button></div><table class="table table-bordered table-hover table-condensed"><tr><td></td><td>Name</td><td>Status</td><td>Group</td><td>Actions</td></tr><tr ng-repeat="user in users" class="editable-row"><td>{{$index}}</td><td><span editable-text="user.name" e-name="name" e-form="rowform" e-required="">{{ user.name || \'empty\' }}</span></td><td class="select-td"><span editable-select="user.status" e-name="status" e-form="rowform" e-selectpicker="" e-ng-options="s.value as s.text for s in statuses">{{ showStatus(user) }}</span></td><td class="select-td"><span editable-select="user.group" e-name="group" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.text for g in groups">{{ showGroup(user) }}</span></td><td><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == user"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-success editable-table-button btn-xs">Save</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-success editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="removeUser($index)">Delete</button></div></td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableTable.html','<div class="horizontal-scroll"><table class="table table-hover" st-table="editableTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr></thead><tbody><tr ng-repeat="item in editableTableData" class="editable-tr-wrap"><td class="table-id">{{item.id}}</td><td><span editable-text="item.firstName" blur="cancel">{{item.firstName}}</span></td><td><span editable-text="item.lastName" blur="cancel">{{item.lastName}}</span></td><td><span editable-text="item.username" blur="cancel">{{item.username}}</span></td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><span editable-text="item.age" blur="cancel">{{item.age}}</span></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="12" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/hoverRows.html','<div class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">%</th><th class="table-arr"></th></tr></thead><tbody><tr ng-repeat="item in metricsTableData" class="no-top-border"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isVisitsUp, \'icon-down\': !item.isVisitsUp }"></i></td><td class="align-right">{{item.purchases}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPurchasesUp, \'icon-down\': !item.isPurchasesUp }"></i></td><td class="align-right">{{item.percent}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPercentUp, \'icon-down\': !item.isPercentUp }"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/responsiveTable.html','<div class="table-responsive"><table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table></div>');
$templateCache.put('app/pages/tables/widgets/smartTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table class="table" st-table="smartTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr><tr><th></th><th><input st-search="firstName" placeholder="Search First Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastName" placeholder="Search Last Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="username" placeholder="Search Username" class="input-sm form-control search-input" type="search"></th><th><input st-search="email" placeholder="Search Email" class="input-sm form-control search-input" type="search"></th><th><input st-search="age" placeholder="Search Age" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/stripedRows.html','<div class="vertical-scroll"><table class="table table-striped"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/ui/alerts/alerts.html','<div class="widgets"><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Basic" ba-panel-class="with-scroll"><div><div class="alert bg-success"><strong>Well done!</strong> You successfully read this important alert message.</div><div class="alert bg-info"><strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class="alert bg-warning"><strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class="alert bg-danger"><strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Dismissible alerts" ba-panel-class="with-scroll"><div><div class="alert bg-success closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Well done!</strong> You successfully read this important alert message.</div><div class="alert bg-info closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class="alert bg-warning closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class="alert bg-danger closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Links in alerts" ba-panel-class="with-scroll"><div><div class="alert bg-success"><strong>Well done!</strong> You successfully read <a href="" class="alert-link">this important alert message</a>.</div><div class="alert bg-info"><strong>Heads up!</strong> This <a href="" class="alert-link">alert needs your attention</a>, but it\'s not super important.</div><div class="alert bg-warning"><strong>Warning!</strong> Better check yourself, you\'re <a href="" class="alert-link">not looking too good</a>.</div><div class="alert bg-danger"><strong>Oh snap!</strong> <a href="" class="alert-link">Change a few things up</a> and try submitting again.</div></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Composite alerts" ba-panel-class="with-scroll"><div><div class="alert bg-warning"><h4>Warning!</h4><strong>Pay attention.</strong> Change a few things up and try submitting again.<div class="control-alert"><button type="button" class="btn btn-danger">Pay Attention</button> <button type="button" class="btn btn-success">Ignore</button></div></div></div></div></div></div>');
$templateCache.put('app/pages/tables/smart/tables.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Rows" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableRowTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Cells" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Smart Table With Filtering, Sorting And Pagination" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/smartTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/ui/buttons/buttons.html','<div class="widgets"><div class="row"><div class="col-md-3" ba-panel="" ba-panel-title="Flat Buttons" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-success">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Raised Buttons" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default btn-raised">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-success btn-raised">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success btn-raised">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info btn-raised">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning btn-raised">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger btn-raised">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Different sizes" ba-panel-class="with-scroll button-panel df-size-button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default btn-xs">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-success btn-sm">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success btn-mm">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info btn-md">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning btn-xm">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger btn-lg">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Disabled" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default" disabled="disabled">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-success" disabled="disabled">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success" disabled="disabled">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info" disabled="disabled">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning" disabled="disabled">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger" disabled="disabled">Danger</button></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Icon Buttons" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/iconButtons.html\'"></div></div><div ba-panel="" ba-panel-title="Large Buttons" ba-panel-class="with-scroll large-buttons-panel"><div ng-include="\'app/pages/ui/buttons/widgets/largeButtons.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Button Dropdowns" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/dropdowns.html\'"></div></div><div ba-panel="" ba-panel-title="Button Groups" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/buttonGroups.html\'"></div></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Progress Buttons" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/progressButtons.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/grid/baseGrid.html','<h4 class="grid-h">Stacked to horizontal</h4><div class="row show-grid"><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div></div><div class="row show-grid"><div class="col-md-8"><div>.col-md-8</div></div><div class="col-md-4"><div>.col-md-4</div></div></div><div class="row show-grid"><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4"><div>.col-md-4</div></div></div><div class="row show-grid"><div class="col-md-6"><div>.col-md-6</div></div><div class="col-md-6"><div>.col-md-6</div></div></div><h4 class="grid-h">Mobile and desktop</h4><div class="row show-grid"><div class="col-xs-12 col-md-8"><div>xs-12 .col-md-8</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6"><div>.col-xs-6</div></div><div class="col-xs-6"><div>.col-xs-6</div></div></div><h4 class="grid-h">Mobile, tablet, desktop</h4><div class="row show-grid"><div class="col-xs-12 col-sm-6 col-md-8"><div>.col-xs-12 .col-sm-6 .col-md-8</div></div><div class="col-xs-6 col-md-4"><div>.col-xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div><div class="clearfix visible-xs-block"></div><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div></div><h4 class="grid-h">Column wrapping</h4><div class="row show-grid"><div class="col-xs-9"><div>.col-xs-9</div></div><div class="col-xs-4"><div>.col-xs-4<br>Since 9 + 4 = 13 &gt; 12, this 4-column-wide div gets wrapped onto a new line as one contiguous unit.</div></div><div class="col-xs-6"><div>.col-xs-6<br>Subsequent columns continue along the new line.</div></div></div><h4 class="grid-h">Responsive column resets</h4><div class="row show-grid"><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3<p>Resize your viewport or check it out on your phone for an example.</p></div></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div><div class="clearfix visible-xs-block"></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div></div><h4 class="grid-h">Offsetting columns</h4><div class="row show-grid"><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4 col-md-offset-4"><div>.col-md-4 .col-md-offset-4</div></div></div><div class="row show-grid"><div class="col-md-3 col-md-offset-3"><div>.col-md-3 .col-md-offset-3</div></div><div class="col-md-3 col-md-offset-3"><div>.col-md-3 .col-md-offset-3</div></div></div><div class="row show-grid"><div class="col-md-6 col-md-offset-3"><div>.col-md-6 .col-md-offset-3</div></div></div><h4 class="grid-h">Grid options</h4><div class="table-responsive"><table class="table table-bordered table-striped"><thead><tr><th></th><th>Extra small devices <small>Phones (&lt;768px)</small></th><th>Small devices <small>Tablets (\u2265768px)</small></th><th>Medium devices <small>Desktops (\u2265992px)</small></th><th>Large devices <small>Desktops (\u22651200px)</small></th></tr></thead><tbody><tr><th class="text-nowrap" scope="row">Grid behavior</th><td>Horizontal at all times</td><td colspan="3">Collapsed to start, horizontal above breakpoints</td></tr><tr><th class="text-nowrap" scope="row">Container width</th><td>None (auto)</td><td>750px</td><td>970px</td><td>1170px</td></tr><tr><th class="text-nowrap" scope="row">Class prefix</th><td><code>.col-xs-</code></td><td><code>.col-sm-</code></td><td><code>.col-md-</code></td><td><code>.col-lg-</code></td></tr><tr><th class="text-nowrap" scope="row"># of columns</th><td colspan="4">12</td></tr><tr><th class="text-nowrap" scope="row">Column width</th><td class="text-muted">Auto</td><td>~62px</td><td>~81px</td><td>~97px</td></tr><tr><th class="text-nowrap" scope="row">Gutter width</th><td colspan="4">30px (15px on each side of a column)</td></tr><tr><th class="text-nowrap" scope="row">Nestable</th><td colspan="4">Yes</td></tr><tr><th class="text-nowrap" scope="row">Offsets</th><td colspan="4">Yes</td></tr><tr><th class="text-nowrap" scope="row">Column ordering</th><td colspan="4">Yes</td></tr></tbody></table></div>');
$templateCache.put('app/pages/ui/grid/grid.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Inline Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/grid/baseGrid.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/icons/icons.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Kameleon SVG Icons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/kameleon.html"></div></div><div ba-panel="" ba-panel-title="Socicon" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/socicon.html"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Icons With Rounded Background" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/kameleonRounded.html"></div></div><div ba-panel="" ba-panel-title="ionicons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/ionicons.html"></div></div><div ba-panel="" ba-panel-title="Font Awesome Icons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/fontAwesomeIcons.html"></div></div></div></div></div>');
$templateCache.put('app/pages/ui/modals/modals.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Modals" ba-panel-class="with-scroll"><div class="modal-buttons clearfix"><button type="button" class="btn btn-success" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/basicModal.html\', \'md\')">Default modal</button> <button type="button" class="btn btn-success" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/largeModal.html\', \'lg\')">Large modal</button> <button type="button" class="btn btn-warning" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/smallModal.html\', \'sm\')">Small modal</button></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Message Modals" ba-panel-class="with-scroll"><div class="modal-buttons same-width clearfix"><button type="button" class="btn btn-success" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/successModal.html\')">Success Message</button> <button type="button" class="btn btn-info" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/infoModal.html\')">Info Message</button> <button type="button" class="btn btn-warning" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/warningModal.html\')">Warning Message</button> <button type="button" class="btn btn-danger" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/dangerModal.html\')">Danger Message</button></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Notifications" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/modals/notifications/notifications.html\'"></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Progress dialogs" ba-panel-class="with-scroll"><div class="modal-buttons same-width clearfix"><button type="button" class="btn btn-info" data-toggle="modal" ng-click="openProgressDialog()">Progress dialog</button></div></div></div></div>');
$templateCache.put('app/pages/ui/notifications/notifications.html','<div ba-panel="" ba-panel-class="with-scroll notification-panel"><div class="row"><div class="col-md-3 col-sm-4"><div class="control"><label for="title">Title</label> <input ng-model="options.title" type="text" class="form-control" id="title" placeholder="Enter a title ..."></div><div class="control"><label for="message">Message</label> <textarea ng-model="options.msg" class="form-control" id="message" rows="3" placeholder="Enter a message ..."></textarea></div><div class="control-group"><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.closeButton" type="checkbox" id="closeButton"> <span>Close Button</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.allowHtml" type="checkbox" id="html"> <span>Allow html</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.progressBar" type="checkbox" id="progressBar"> <span>Progress bar</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.preventDuplicates" type="checkbox" id="preventDuplicates"> <span>Prevent duplicates</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.preventOpenDuplicates" type="checkbox" id="preventOpenDuplicates"> <span>Prevent open duplicates</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.tapToDismiss" type="checkbox" id="tapToDismiss"> <span>Tap to dismiss</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.newestOnTop" type="checkbox" id="newestOnTop"> <span>Newest on top</span></label></div></div></div><div class="col-md-2 col-sm-3 toastr-radio-setup"><div id="toastTypeGroup"><div class="controls radio-controls"><label class="radio-header">Toast Type</label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="success"><span>Success</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="info"><span>Info</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="warning"><span>Warning</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="error"><span>Error</span></label></div></div><div id="positionGroup"><div class="controls radio-controls"><label class="radio-header position-header">Position</label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-right"> <span>Top Right</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-right"> <span>Bottom Right</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-left"> <span>Bottom Left</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-left"> <span>Top Left</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-full-width"> <span>Top Full Width</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-full-width"> <span>Bottom Full Width</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-center"> <span>Top Center</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-center"> <span>Bottom Center</span></label></div></div></div><div class="col-md-2 col-sm-3"><div class="control"><label for="timeOut">Time out</label> <input type="text" class="form-control" id="timeOut" ng-model="options.timeOut" placeholder="ms"> <label class="sub-label" for="timeOut">If you set it to 0, it will stick</label></div><div class="control"><label for="extendedTimeOut">Extended time out</label> <input type="text" class="form-control" id="extendedTimeOut" ng-model="options.extendedTimeOut" placeholder="ms"></div><div class="control"><label for="maxOpened">Maximum number of toasts</label> <input type="text" class="form-control" id="maxOpened" ng-model="options.maxOpened" value="0"> <label for="maxOpened" class="sub-label">0 means no limit</label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.autoDismiss" type="checkbox" id="autoDismiss"> <span>Auto dismiss</span></label></div></div><div class="col-md-5 col-sm-12"><label>Result:</label><pre class="result-toastr" id="toastrOptions">{{optionsStr}}</pre></div></div><div class="row"><div class="col-md-12 button-row"><button ng-click="openToast()" class="btn btn-success">Open Toast</button> <button ng-click="openRandomToast()" class="btn btn-success">Random Toast</button> <button ng-click="clearToasts()" class="btn btn-danger">Clear Toasts</button> <button ng-click="clearLastToast()" class="btn btn-danger">Clear Last Toast</button></div></div></div>');
$templateCache.put('app/pages/ui/panels/panels.html','<h2>Default panels</h2><div class="row"><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-class="xsmall-panel light-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ac mi erat. Phasellus placerat, elit a laoreet semper, enim ipsum ultricies orci, ac tincidunt tellus massa eu est. Nam non porta purus, sed facilisis justo. Nam pulvinar sagittis quam.</div></div><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-title="Panel with header" ba-panel-class="xsmall-panel light-text">Phasellus maximus venenatis augue, et vestibulum neque aliquam ut. Morbi mattis libero vitae vulputate dignissim. Praesent placerat, sem non dapibus cursus, lacus nisi blandit quam, vitae porttitor lectus lacus non turpis. Donec suscipit consequat tellus.</div></div><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-title="Panel with header & scroll" ba-panel-class="xsmall-panel with-scroll light-text"><p>Suspendisse nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Sed dapibus, purus vel hendrerit consectetur, lectus orci gravida massa, sed bibendum dui mauris et eros. Nulla dolor massa, posuere et dictum sit amet, dignissim quis odio. Fusce mollis finibus dignissim. Integer sodales augue erat. Pellentesque laoreet vestibulum urna at iaculis. Nulla libero augue, euismod at diam eget, aliquam condimentum ligula. Donec a leo eu est molestie lacinia hendrerit sed lorem. Duis id diam eu metus sodales consequat vel eu elit. Praesent dolor nibh, convallis eleifend feugiat a, finibus porttitor nibh. Ut non libero vel velit pulvinar scelerisque non vel lorem. Integer porta tempor nulla. Sed nibh erat, ultrices vel lorem eu, rutrum vehicula sem.</p><p>Donec nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque fermentum nec ligula egestas rhoncus. Sed dignissim, augue vel scelerisque vulputate, nisi ante posuere lorem, quis iaculis eros dolor eu nisl. Etiam sagittis, ipsum ac tempor iaculis, justo neque mattis ante, ac maximus sapien risus eu sapien. Morbi erat urna, varius et lectus vel, porta dictum orci. Duis bibendum euismod elit, et lobortis purus venenatis in. Mauris eget lacus enim. Cras quis sem et magna fringilla convallis. Proin hendrerit nulla vel gravida mollis. Interdum et malesuada fames ac ante ipsum primis in faucibus. Vestibulum consectetur quis purus vel aliquam.</p></div></div></div><h2>Bootstrap panels</h2><div class="row"><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel xsmall-panel"><div class="panel-body"><p>A panel in bootstrap is a bordered box with some padding around its content.</p><p class="p-with-code">Panels are created with the <code>.panel</code> class, and content inside the panel has a <code>.panel-body</code> class. The <code>.panel-default .panel-primary .panel-danger</code> and other classes are used to style the color of the panel. See the next example on this page for more contextual classes.</p></div></div></div><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel xsmall-panel"><div class="panel-heading">Panel Heading</div><div class="panel-body"><p class="p-with-code">The <code>.panel-heading</code> class adds a heading to the panel.Easily add a heading container to your panel with .panel-heading. You may also include any <code>h1-h6</code> with a <code>.panel-title</code> class to add a pre-styled heading.</p></div></div></div><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel"><div class="panel-body footer-panel"><p class="p-with-code">Wrap buttons or secondary text in <code>.panel-footer</code>. Note that panel footers do not inherit colors and borders when using contextual variations as they are not meant to be in the foreground.</p></div><div class="panel-footer">Panel Footer</div></div></div></div><h2>Panels with Contextual Classes</h2><div class="row"><div class="col-md-6 col-lg-4"><div class="panel panel-default contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-default class</div><div class="panel-body">To color the panel, use contextual classes. This is sample <code>.panel-default</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-primary contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-primary class</div><div class="panel-body">Sample <code>.panel-primary</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-success contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-success class</div><div class="panel-body">Sample <code>.panel-success</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-info contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-info class</div><div class="panel-body">Sample <code>.panel-info</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-warning contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-warning class</div><div class="panel-body">Sample <code>.panel-warning</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-danger contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-danger class</div><div class="panel-body">Sample <code>.panel-danger</code> panel</div></div></div></div><div class="row"><div class="col-md-12"><h2>Panel Group</h2><div class="panel-group"><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Panel group 1</div><div class="panel-body"><p>To group many panels together, wrap a <code>&lt;div&gt;</code> with class <code>\n            .panel-group</code> around them.</p></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Panel group 2</div><div class="panel-body"><p>The <code>.panel-group</code> class clears the bottom-margin of each panel.</p></div></div></div></div></div>');
$templateCache.put('app/pages/ui/progressBars/progressBars.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/basic.html\'"></div></div><div ba-panel="" ba-panel-title="Striped" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/striped.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="With label" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/label.html\'"></div></div><div ba-panel="" ba-panel-title="Animated" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/animated.html\'"></div></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Stacked" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/stacked.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/slider/slider.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Ion Range Slider" ba-panel-class="with-scroll"><div class="slider-box"><h5>Basic</h5><ion-slider type="single" grid="false" min="0" max="100" from="45" disable="false"></ion-slider></div><div class="slider-box"><h5>With prefix</h5><ion-slider type="single" grid="true" min="100" max="1200" prefix="$" from="420" disable="false"></ion-slider></div><div class="slider-box"><h5>With postfix</h5><ion-slider type="single" grid="true" min="-90" max="90" postfix="\xB0" from="36" disable="false"></ion-slider></div><div class="slider-box"><h5>Two way range</h5><ion-slider type="double" grid="true" min="100" max="1200" from="420" to="900" disable="false"></ion-slider></div><div class="slider-box"><h5>With Steps</h5><ion-slider type="single" grid="true" min="0" max="1000" from="300" step="50" disable="false"></ion-slider></div><div class="slider-box"><h5>Decorating numbers</h5><ion-slider type="single" grid="true" min="0" max="1000000" from="300000" step="1000" prettify-separator="." prettify="true" disable="false"></ion-slider></div><div class="slider-box"><h5>Using custom values array</h5><ion-slider type="single" grid="true" from="5" step="1000" values="[\'January\', \'February\', \'March\', \'April\', \'May\', \'June\', \'July\', \'August\', \'September\', \'October\', \'November\', \'December\']" disable="false"></ion-slider></div><div class="slider-box"><h5>Disabled</h5><ion-slider type="single" grid="false" min="0" max="100" from="45" disable="true"></ion-slider></div></div></div></div>');
$templateCache.put('app/pages/ui/tabs/contextualAccordion.html','<uib-accordion><uib-accordion-group heading="Primary" panel-class="panel-primary bootstrap-panel accordion-panel">Primary <i class="ion-heart"></i></uib-accordion-group><uib-accordion-group heading="Success" panel-class="panel-success bootstrap-panel accordion-panel">Success <i class="ion-checkmark-round"></i></uib-accordion-group><uib-accordion-group heading="Info" panel-class="panel-info bootstrap-panel accordion-panel">Info <i class="ion-information-circled"></i></uib-accordion-group><uib-accordion-group heading="Warning" panel-class="panel-warning bootstrap-panel accordion-panel">Warning <i class="ion-alert"></i></uib-accordion-group><uib-accordion-group heading="Danger" panel-class="panel-danger bootstrap-panel accordion-panel">Danger <i class="ion-nuclear"></i></uib-accordion-group></uib-accordion>');
$templateCache.put('app/pages/ui/tabs/mainTabs.html','<uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Start"><p>Take up one idea. Make that one idea your life--think of it, dream of it, live on that idea. Let the brain, muscles, nerves, every part of your body, be full of that idea, and just leave every other idea alone. This is the way to success.</p><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed. Similarly, when someone is failing, the tendency is to get on a downward spiral that can even become a self-fulfilling prophecy.</p><div class="text-center"><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Shop\' | kameleonImg )}}"></div><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Programming\' | kameleonImg )}}"></div><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Dna\' | kameleonImg )}}"></div></div><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Getting Done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab ng-init="$dropdownTabActive = 1" class="with-dropdown"><uib-tab-heading uib-dropdown=""><a uib-dropdown-toggle="" ng-click="$event.stopPropagation()">Dropdown tab <i class="caret"></i></a><ul class="dropdown-menu" uib-dropdown-menu=""><li><a ng-click="$dropdownTabActive = 1; $tabSetStatus.activeTab = 3">Tab 1</a></li><li><a ng-click="$dropdownTabActive = 2; $tabSetStatus.activeTab = 3">Tab 2</a></li></ul></uib-tab-heading><div ng-show="$dropdownTabActive == 1"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></div><div ng-show="$dropdownTabActive == 2"><p class="text-center"><button class="btn btn-danger">I\'m just a dummy button</button></p></div></uib-tab></uib-tabset>');
$templateCache.put('app/pages/ui/tabs/sampleAccordion.html','<uib-accordion><uib-accordion-group is-open="true" heading="Static Header, initially expanded" panel-class="bootstrap-panel accordion-panel panel-default">This content is straight in the template.</uib-accordion-group><uib-accordion-group heading="Dynamic Body Content" panel-class="bootstrap-panel accordion-panel panel-default"><p>The body of the uib-accordion group grows to fit the contents</p><button type="button" class="btn btn-success btn-sm">Add Item</button></uib-accordion-group><uib-accordion-group heading="Custom template" panel-class="bootstrap-panel accordion-panel panel-default">Hello</uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading>I can have markup, too! <i class="fa pull-right ion-settings"></i></uib-accordion-heading>This is just some content to illustrate fancy headings.</uib-accordion-group></uib-accordion>');
$templateCache.put('app/pages/ui/tabs/sideTabs.html','<div ba-panel="" ba-panel-class="tabs-panel xsmall-panel with-scroll"><uib-tabset class="tabs-left"><uib-tab heading="Start"><p class="text-center">Take up one idea.</p><div class="kameleon-icon-tabs kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Key\' | kameleonImg )}}"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading="Get it done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Achieve"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div><div ba-panel="" ba-panel-class="tabs-panel xsmall-panel with-scroll"><uib-tabset class="tabs-right"><uib-tab heading="Start"><p class="text-center">Take up one idea.</p><div class="kameleon-icon-tabs kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Phone-Booth\' | kameleonImg )}}"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading="Get it done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Achieve"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/ui/tabs/tabs.html','<div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel medium-panel"><div ng-include="\'app/pages/ui/tabs/mainTabs.html\'"></div></div></div><div class="col-md-6 tabset-group" ng-include="\'app/pages/ui/tabs/sideTabs.html\'"></div></div><div class="row accordions-row"><div class="col-md-6" ng-include="\'app/pages/ui/tabs/sampleAccordion.html\'"></div><div class="col-md-6" ng-include="\'app/pages/ui/tabs/contextualAccordion.html\'"></div></div></div>');
$templateCache.put('app/pages/ui/typography/typography.html','<div class="typography-document-samples row-fluid"><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll heading-widget" ba-panel-title="Text Size"><div class="section-block"><h1>H1. Heading 1</h1><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h2>H2. Heading 2</h2><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h3>H3. Heading 3</h3><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h4>H4. Heading 4</h4><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra,.</p></div><div class="section-block"><h5>H5. Heading 5</h5><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</p></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll more-text-widget" ba-panel-title="Some more text"><div class="section-block light-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis.</p></div><div class="section-block regular-text"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id.</p></div><div class="section-block upper-text bold-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class="section-block bold-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullam-corper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class="section-block small-text"><p>Secondary text. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar,</p><p>lacinia scelerisque pharetra, placerat vestibulum eleifend</p><p>pellentesque, mi nam.</p></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll lists-widget" ba-panel-title="Lists"><div class="section-block"><h5 class="list-header">Unordered list:</h5><ul class="blur"><li>Lorem ipsum dolor sit amet</li><li>\u0421lacinia scelerisque pharetra<ul><li>Dui rhoncus quisque integer lorem<ul><li>Libero iaculis vestibulum eu vitae</li></ul></li></ul></li><li>Nisl lectus nibh habitasse suspendisse ut</li><li><span>Posuere cursus hac, vestibulum wisi nulla bibendum</span></li></ul><h5 class="list-header">Ordered Lists:</h5><ol class="blur"><li><span>Eu non nec cursus quis mollis, amet quam nec</span></li><li><span>Et suspendisse, adipiscing fringilla ornare sit ligula sed</span><ol><li><span>Interdum et justo nulla</span><ol><li><span>Magna amet, suscipit suscipit non amet</span></li></ol></li></ol></li><li><span>Metus duis eu non eu ridiculus turpis</span></li><li><span>Neque egestas id fringilla consectetuer justo curabitur, wisi magna neque commodo volutpat</span></li></ol><div class="accent">Important text fragment. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</div></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll color-widget" ba-panel-title="Text Color"><div class="section-block red-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p></div><div class="section-block yellow-text"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id nibh ultricies vehicula ut id elit. In sed ornare nulla.</p></div><div class="section-block links"><p>Lorem ipsum <a href="">dolor</a> sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis <a href="">ullamcorper</a> ligula sodales at. Nulla tellus elit, varius non commodo eget, <a href="">mattis</a> vel eros. In sed ornare nulla.</p></div><div class="section-block links"><p><a href="">Active link \u2014 #209e91</a></p><p class="hovered"><a href="">Hover link \u2014 #17857a</a></p></div></div></div></div><div class="row-fluid"><div class="col-lg-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="banner-column-panel"><div class="banner"><div class="large-banner-wrapper"><img ng-src="{{::( \'app/typography/banner.png\' | appImage )}}" alt=""></div><div class="banner-text-wrapper"><div class="banner-text"><h1>Simple Banner Text</h1><p>Lorem ipsum dolor sit amet</p><p>Odio amet viverra rutrum</p></div></div></div><div class="section"><h2>Columns</h2><div class="row"><div class="col-sm-6"><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo03.png\' | appImage )}}" alt="" title=""></div><p>Vel elit, eros elementum, id lacinia, duis non ut ut tortor blandit. Mauris <a href="">dapibus</a> magna rutrum. Ornare neque suspendisse <a href="">phasellus wisi</a>, quam cras pede rutrum suspendisse, <a href="">felis amet eu</a>. Congue magna elit quisque quia, nullam justo sagittis, ante erat libero placerat, proin condimentum consectetuer lacus. Velit condimentum velit, sed penatibus arcu nulla.</p></div><div class="col-sm-6"><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo01.png\' | appImage )}}" alt="" title=""></div><p>Et suspendisse, adipiscing fringilla ornare sit ligula sed, vel nam. Interdum et justo nulla, fermentum lobortis purus ut eu, duis nibh dolor massa tristique elementum, nibh iste potenti risus fusce aliquet fusce, ullamcorper debitis primis arcu tellus vestibulum ac.</p></div></div><div class="separator"></div><div class="row"><div class="col-sm-4"><h4>Column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo04.png\' | appImage )}}" alt=""></div><p>Eget augue, lacus erat ante egestas scelerisque aliquam, metus molestie leo in habitasse magna maecenas</p><a href="" class="learn-more">Lean more</a></div><div class="col-sm-4"><h4>Yet another column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo05.png\' | appImage )}}" alt=""></div><p>Augue massa et parturient, suspendisse orci nec scelerisque sit, integer nam mauris pede consequat in velit</p><a href="" class="learn-more">Lean more</a></div><div class="col-sm-4"><h4>Third column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo06.png\' | appImage )}}" alt=""></div><p>Eget turpis, tortor lobortis porttitor, vestibulum nullam vehicula aliquam</p><a href="" class="learn-more">Lean more</a></div></div><div class="separator"></div></div></div></div></div>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-success"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-success">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title">{{ activePageTitle }}</h1><ul class="breadcrumb al-breadcrumb"><li><a href="#/dashboard">Home</a></li><li>{{ activePageTitle }}</li></ul></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix" ng-init="datosInicialesNotificaciones()"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notificaciones</strong></div><div class="msg-list"><a href="" class="clearfix"><div class="msg-area"><div ng-bind-html=""></div></div></a></div><a href="">See all notifications</a></div></li></ul>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div ng-init="datosIniciales()" class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a href="#/dashboard" class="al-logo clearfix"><span>{{datos_pageTop.datosApp.nombre}}</span>{{datos_pageTop.datosApp.apellido}}</a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div class="search"><i class="ion-ios-search-strong" ng-click="startSearch()"></i> <input id="searchInput" type="text" placeholder="Buscar ..."></div><div class="user-profile clearfix"><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><img ng-src="{{datos_pageTop.datosApp.url_api_raiz}}{{datos_pageTop.datosLogin.datos.foto}}"></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><a ng-click="irAProfile();"><i class="fa fa-user"></i>Perfil</a></li><li><a ng-click="cerrarSesion();"><i class="fa fa-power-off"></i>Cerrar sesi\xF3n</a></li></ul></div><ul class="al-msg-center clearfix"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span ng-show="listado_notificaciones.length>0">{{listado_notificaciones.length}}</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notificaciones</strong></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="item in listado_notificaciones"><div class="img-area"><i class="ion-ios-paper"></i></div><div class="msg-area"><div ng-click="marcarComoRevisada(item);" ng-bind-html="item.detalle"></div></div></a></div></div></li></ul></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');
$templateCache.put('app/pages/charts/amCharts/barChart/barChart.html','<div id="barChart" class="admin-chart" ng-controller="BarChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/areaChart/areaChart.html','<div id="areaChart" class="admin-chart" ng-controller="AreaChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/combinedChart/combinedChart.html','<div id="zoomAxisChart" class="admin-chart" ng-controller="combinedChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/funnelChart/funnelChart.html','<div id="funnelChart" class="admin-chart" ng-controller="FunnelChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/ganttChart/ganttChart.html','<div id="gnattChart" class="admin-chart" ng-controller="ganttChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/lineChart/lineChart.html','<div id="lineChart" class="admin-chart" ng-controller="LineChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/pieChart/pieChart.html','<div id="pieChart" class="admin-chart" ng-controller="PieChartCtrl"></div>');
$templateCache.put('app/pages/components/mail/composeBox/compose.html','<div class="compose-header"><span>New message</span> <span class="header-controls"><i class="ion-minus-round"></i> <i class="ion-arrow-resize"></i> <i ng-click="$dismiss()" class="ion-close-round"></i></span></div><div><input type="text" class="form-control compose-input default-color" placeholder="To" ng-model="boxCtrl.to"> <input type="text" class="form-control compose-input default-color" placeholder="Subject" ng-model="boxCtrl.subject"><div class="compose-container"><text-angular-toolbar ta-toolbar-class="toolbarMain" name="toolbarMain" ta-toolbar="[[\'h1\',\'h2\',\'h3\',\'bold\',\'italics\', \'underline\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\']]"></text-angular-toolbar><text-angular name="htmlcontent" ta-target-toolbars="toolbarMain,toolbarFooter" ng-model="boxCtrl.text"></text-angular></div></div><div class="compose-footer clearfix"><button type="button" ng-click="$dismiss()" class="btn btn-send">Send</button><text-angular-toolbar ta-toolbar-class="toolbarFooter" name="toolbarFooter" ta-toolbar="[[\'insertLink\', \'insertImage\', \'html\', \'quote\',\'insertVideo\']]"></text-angular-toolbar><div class="footer-controls"><i class="footer-control-first compose-footer-icon ion-arrow-down-b"></i> <i ng-click="$dismiss()" class="compose-footer-icon ion-android-delete"></i></div></div>');
$templateCache.put('app/pages/components/mail/detail/mailDetail.html','<div class="message-container" ng-class="{\'expanded\': tabCtrl.navigationCollapsed}"><div class="message"><div class="row"><div class="toggle-navigation-container detail-page"><a href="" class="collapse-navigation-link ion-navicon" ng-click="tabCtrl.navigationCollapsed=!tabCtrl.navigationCollapsed"></a></div><button ui-sref="components.mail.label({label : detailCtrl.label})" type="button" class="back-button btn btn-default btn-with-icon"><i class="ion-chevron-left"></i>Back</button></div><div class="person-info row"><div class="col-lg-4 col-md-12 no-padding"><img ng-src="{{detailCtrl.mail.name.split(\' \')[0] | profilePicture}}" class="human-picture"><div class="name"><h2 class="name-h">{{detailCtrl.mail.name.split(\' \')[0]}}</h2><h2 class="name-h second-name">{{detailCtrl.mail.name.split(\' \')[1]}}</h2><div><span class="mail-tag tag label {{detailCtrl.mail.tag}}">{{detailCtrl.mail.tag}}</span></div></div></div><div class="col-lg-4 col-md-6 col-xs-12 no-padding"><div class="contact-info phone-email"><div><i class="ion-iphone"></i> <span class="phone">777-777-7777</span></div><div><i class="ion-email"></i> <span class="email">{{detailCtrl.mail.email}}</span></div></div></div><div class="col-lg-4 col-md-6 col-xs-12 no-padding"><div class="contact-info position-address"><div><span class="position">{{detailCtrl.mail.position}}</span></div><div><span class="address">12 Nezavisimosti st. Vilnius, Lithuania</span></div></div></div></div><div class="row"></div><div class="line"></div><div class="message-details"><span class="subject">{{detailCtrl.mail.subject}}</span> <span class="date">\u2022 {{detailCtrl.mail.date | date : \'h:mm a MMMM d \'}}</span></div><div class="line"></div><div ng-bind-html="detailCtrl.mail.body" class="message-body"></div><div class="line"></div><div class="attachment" ng-show="detailCtrl.mail.attachment"><span class="file-links">1 Attachment - <a href="">View</a> | <a href="">Download</a></span><div><i class="file-icon ion-document"></i> <span class="file-name">{{detailCtrl.mail.attachment}}</span></div></div><div class="line" ng-show="detailCtrl.mail.attachment"></div><div class="answer-container"><button type="button" class="btn btn-with-icon" ng-click="tabCtrl.showCompose(detailCtrl.mail.subject,detailCtrl.mail.email,\'\')"><i class="ion-reply"></i>Reply</button> <button type="button" class="btn btn-with-icon" ng-click="tabCtrl.showCompose(detailCtrl.mail.subject,\'\',detailCtrl.mail.body)"><i class="ion-forward"></i>Forward</button> <button type="button" class="btn btn-with-icon"><i class="ion-printer"></i>Print</button> <button type="button" class="btn btn-with-icon"><i class="ion-android-remove-circle"></i>Spam</button> <button type="button" class="btn btn-with-icon"><i class="ion-android-delete"></i>Delete</button></div></div><div ng-show="!detailCtrl.mail"><h5 ng-class="text-center">Nothing to show</h5></div></div>');
$templateCache.put('app/pages/components/mail/list/mailList.html','<div class="side-message-navigation" ng-class="{\'expanded\': tabCtrl.navigationCollapsed}"><div class="mail-messages-control side-message-navigation-item"><div class="toggle-navigation-container"><a href="" class="collapse-navigation-link ion-navicon" ng-click="tabCtrl.navigationCollapsed=!tabCtrl.navigationCollapsed"></a></div><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox01" value="option1"> <span class="select-all-label">Select All</span></label> <button type="button" class="btn btn-icon refresh-button"><i class="ion-refresh"></i></button><div class="btn-group" uib-dropdown=""><button type="button" class="btn more-button" uib-dropdown-toggle="">More <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="messages"><table><tr ng-repeat="m in listCtrl.messages track by m.id | orderBy:\'-date\'" class="side-message-navigation-item little-human shineHover {{m.tag}}"><td class="check-td"><div class="mail-checkbox"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox"> <span></span></label></div></td><td class="photo-td" ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><img ng-src="{{m.name.split(\' \')[0] | profilePicture}}" class="little-human-picture"></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="name-container"><div><span class="name">{{m.name}}</span></div><div><span class="tag label label-primary {{m.tag}}">{{m.tag}}</span></div></div></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="additional-info"><span class="subject">{{m.subject}}</span></div></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="mail-body-part">{{m.body | plainText}}</div></td><td class="date"><span>{{m.date | date : \'MMM d HH:mm\'}}</span></td></tr></table></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/checkboxesRadios.html','<div class="checkbox-demo-row"><div class="input-demo checkbox-demo row"><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox01" value="option1"> <span>Check 1</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox02" value="option2"> <span>Check 2</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Check 3</span></label></div></div><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span>Option 1</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2"> <span>Option 2</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio3" value="option3"> <span>Option3</span></label></div></div></div><div><div class="checkbox disabled"><label class="custom-checkbox nowrap"><input type="checkbox" value="" disabled=""> <span>Checkbox is disabled</span></label></div><div class="radio disabled"><label class="custom-radio nowrap"><input type="radio" name="optionsRadios" id="optionsRadios3" value="option3" disabled=""> <span>Disabled option</span></label></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/inputGroups.html','<div class="input-group"><span class="input-group-addon input-group-addon-primary addon-left" id="basic-addon1">@</span> <input type="text" class="form-control with-primary-addon" placeholder="Username" aria-describedby="basic-addon1"></div><div class="input-group"><input type="text" class="form-control with-warning-addon" placeholder="Recipient\'s username" aria-describedby="basic-addon2"> <span class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2">@example.com</span></div><div class="input-group"><span class="input-group-addon addon-left input-group-addon-success">$</span> <input type="text" class="form-control with-success-addon" aria-label="Amount (to the nearest dollar)"> <span class="input-group-addon addon-right input-group-addon-success">.00</span></div><div class="input-group"><input type="text" class="form-control with-danger-addon" placeholder="Search for..."> <span class="input-group-btn"><button class="btn btn-danger" type="button">Go!</button></span></div>');
$templateCache.put('app/pages/form/inputs/widgets/standardFields.html','<form><div class="form-group"><label for="input01">Text</label> <input type="text" class="form-control" id="input01" placeholder="Text"></div><div class="form-group"><label for="input02">Password</label> <input type="password" class="form-control" id="input02" placeholder="Password"></div><div class="form-group"><label for="input03">Rounded Corners</label> <input type="text" class="form-control form-control-rounded" id="input03" placeholder="Rounded Corners"></div><div class="form-group"><label for="input04">With help</label> <input type="text" class="form-control" id="input04" placeholder="With help"> <span class="help-block sub-little-text">A block of help text that breaks onto a new line and may extend beyond one line.</span></div><div class="form-group"><label for="input05">Disabled Input</label> <input type="text" class="form-control" id="input05" placeholder="Disabled Input" disabled=""></div><div class="form-group"><label for="textarea01">Textarea</label> <textarea placeholder="Default Input" class="form-control" id="textarea01"></textarea></div><div class="form-group"><input type="text" class="form-control input-sm" id="input2" placeholder="Small Input"></div><div class="form-group"><input type="text" class="form-control input-lg" id="input4" placeholder="Large Input"></div></form>');
$templateCache.put('app/pages/form/inputs/widgets/validationStates.html','<div class="form-group has-success"><label class="control-label" for="inputSuccess1">Input with success</label> <input type="text" class="form-control" id="inputSuccess1"></div><div class="form-group has-warning"><label class="control-label" for="inputWarning1">Input with warning</label> <input type="text" class="form-control" id="inputWarning1"></div><div class="form-group has-error"><label class="control-label" for="inputError1">Input with error</label> <input type="text" class="form-control" id="inputError1"></div><div class="has-success"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxSuccess" value="option1"> <span>Checkbox with success</span></label></div></div><div class="has-warning"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxWarning" value="option1"> <span>Checkbox with warning</span></label></div></div><div class="has-error"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxError" value="option1"> <span>Checkbox with error</span></label></div></div><div class="form-group has-success has-feedback"><label class="control-label" for="inputSuccess2">Input with success</label> <input type="text" class="form-control" id="inputSuccess2" aria-describedby="inputSuccess2Status"> <i class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i> <span id="inputSuccess2Status" class="sr-only">(success)</span></div><div class="form-group has-warning has-feedback"><label class="control-label" for="inputWarning2">Input with warning</label> <input type="text" class="form-control" id="inputWarning2" aria-describedby="inputWarning2Status"> <i class="ion-alert-circled form-control-feedback" aria-hidden="true"></i> <span id="inputWarning2Status" class="sr-only">(warning)</span></div><div class="form-group has-error has-feedback"><label class="control-label" for="inputError2">Input with error</label> <input type="text" class="form-control" id="inputError2" aria-describedby="inputError2Status"> <i class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <span id="inputError2Status" class="sr-only">(error)</span></div><div class="form-group has-success has-feedback"><label class="control-label" for="inputGroupSuccess1">Input group with success</label><div class="input-group"><span class="input-group-addon addon-left">@</span> <input type="text" class="form-control" id="inputGroupSuccess1" aria-describedby="inputGroupSuccess1Status"></div><i class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i> <span id="inputGroupSuccess1Status" class="sr-only">(success)</span></div>');
$templateCache.put('app/pages/form/layouts/widgets/basicForm.html','<form><div class="form-group"><label for="exampleInputEmail1">Email address</label> <input type="email" class="form-control" id="exampleInputEmail1" placeholder="Email"></div><div class="form-group"><label for="exampleInputPassword1">Password</label> <input type="password" class="form-control" id="exampleInputPassword1" placeholder="Password"></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Check me out</span></label></div><button type="submit" class="btn btn-danger">Submit</button></form>');
$templateCache.put('app/pages/form/layouts/widgets/blockForm.html','<div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputFirstName">First Name</label> <input type="text" class="form-control" id="inputFirstName" placeholder="First Name"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputLastName">Last Name</label> <input type="text" class="form-control" id="inputLastName" placeholder="Last Name"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputFirstName">Email</label> <input type="email" class="form-control" id="inputEmail" placeholder="Email"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputWebsite">Website</label> <input type="text" class="form-control" id="inputWebsite" placeholder="Website"></div></div></div><button type="submit" class="btn btn-success">Submit</button>');
$templateCache.put('app/pages/form/layouts/widgets/formWithoutLabels.html','<form><div class="form-group"><input type="text" class="form-control" placeholder="Recipients"></div><div class="form-group"><input type="text" class="form-control" placeholder="Subject"></div><div class="form-group"><textarea class="form-control" placeholder="Message"></textarea></div><button type="submit" class="btn btn-success">Send</button></form>');
$templateCache.put('app/pages/form/layouts/widgets/horizontalForm.html','<form class="form-horizontal"><div class="form-group"><label for="inputEmail3" class="col-sm-2 control-label">Email</label><div class="col-sm-10"><input type="email" class="form-control" id="inputEmail3" placeholder="Email"></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-2 control-label">Password</label><div class="col-sm-10"><input type="password" class="form-control" id="inputPassword3" placeholder="Password"></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Remember me</span></label></div></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><button type="submit" class="btn btn-warning">Sign in</button></div></div></form>');
$templateCache.put('app/pages/form/layouts/widgets/inlineForm.html','<form class="row form-inline"><div class="form-group col-sm-3 col-xs-6"><input type="text" class="form-control" id="exampleInputName2" placeholder="Name"></div><div class="form-group col-sm-3 col-xs-6"><input type="email" class="form-control" id="exampleInputEmail2" placeholder="Email"></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Remember me</span></label></div><button type="submit" class="btn btn-success">Send invitation</button></form>');
$templateCache.put('app/pages/ui/buttons/widgets/buttonGroups.html','<div class="btn-group-example"><div class="btn-group" role="group" aria-label="Basic example"><button type="button" class="btn btn-danger">Left</button> <button type="button" class="btn btn-danger">Middle</button> <button type="button" class="btn btn-danger">Right</button></div></div><div class="btn-toolbar-example"><div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups"><div class="btn-group" role="group" aria-label="First group"><button type="button" class="btn btn-success">1</button> <button type="button" class="btn btn-success">2</button> <button type="button" class="btn btn-success">3</button> <button type="button" class="btn btn-success">4</button></div><div class="btn-group" role="group" aria-label="Second group"><button type="button" class="btn btn-success">5</button> <button type="button" class="btn btn-success">6</button> <button type="button" class="btn btn-success">7</button></div><div class="btn-group" role="group" aria-label="Third group"><button type="button" class="btn btn-success">8</button></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/buttons.html','<div class="basic-btns"><div class="row"><div class="col-md-2"><h5>Default button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5 class="row-sm">Small button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-sm">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default btn-sm">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-sm">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info btn-sm">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning btn-sm">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger btn-sm">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5 class="row-xs">Extra small button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-xs">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default btn-xs">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-xs">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info btn-xs">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning btn-xs">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger btn-xs">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5>Disabled button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success" disabled="disabled">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default" disabled="disabled">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success" disabled="disabled">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info" disabled="disabled">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning" disabled="disabled">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger" disabled="disabled">Danger</button></div></div></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/dropdowns.html','<div class="row btns-row"><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success" uib-dropdown-toggle="">Primary <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success" uib-dropdown-toggle="">Success <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-info" uib-dropdown-toggle="">Info <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-default" uib-dropdown-toggle="">Default <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-warning" uib-dropdown-toggle="">Warning <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-danger" uib-dropdown-toggle="">Danger <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div></div><h5 class="panel-subtitle">Split button dropdowns</h5><div class="row btns-row"><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success">Primary</button> <button type="button" class="btn btn-success" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success">Success</button> <button type="button" class="btn btn-success" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-info">Info</button> <button type="button" class="btn btn-info" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-default">Default</button> <button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-warning">Warning</button> <button type="button" class="btn btn-warning" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-danger">Danger</button> <button type="button" class="btn btn-danger" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/iconButtons.html','<ul class="btn-list clearfix"><li><button type="button" class="btn btn-success btn-icon"><i class="ion-android-download"></i></button></li><li><button type="button" class="btn btn-default btn-icon"><i class="ion-stats-bars"></i></button></li><li><button type="button" class="btn btn-success btn-icon"><i class="ion-android-checkmark-circle"></i></button></li><li><button type="button" class="btn btn-info btn-icon"><i class="ion-information"></i></button></li><li><button type="button" class="btn btn-warning btn-icon"><i class="ion-android-warning"></i></button></li><li><button type="button" class="btn btn-danger btn-icon"><i class="ion-nuclear"></i></button></li></ul><h5 class="panel-subtitle">Buttons with icons</h5><ul class="btn-list clearfix"><li><button type="button" class="btn btn-success btn-with-icon"><i class="ion-android-download"></i>Primary</button></li><li><button type="button" class="btn btn-default btn-with-icon"><i class="ion-stats-bars"></i>Default</button></li><li><button type="button" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Success</button></li><li><button type="button" class="btn btn-info btn-with-icon"><i class="ion-information"></i>Info</button></li><li><button type="button" class="btn btn-warning btn-with-icon"><i class="ion-android-warning"></i>Warning</button></li><li><button type="button" class="btn btn-danger btn-with-icon"><i class="ion-nuclear"></i>Danger</button></li></ul>');
$templateCache.put('app/pages/ui/buttons/widgets/largeButtons.html','<div class="row btns-row btns-same-width-lg"><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-success btn-lg">Primary</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-success btn-lg">Success</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-info btn-lg">Info</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-default btn-lg">Default</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-warning btn-lg">Warning</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-danger btn-lg">Danger</button></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/progressButtons.html','<div class="progress-buttons-container text-center default-text"><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">fill horizontal</span> <button progress-button="progressFunction()" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">fill vertical</span> <button progress-button="progressFunction()" pb-direction="vertical" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">shrink horizontal</span> <button progress-button="progressFunction()" pb-style="shrink" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">shrink vertical</span> <button progress-button="progressFunction()" pb-style="shrink" pb-direction="vertical" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-bottom<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-bottom" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-top<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-top" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-left<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-left" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-right<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-right" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-down<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-down" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-up<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-up" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-left<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-left" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-right<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-right" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-back<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-back" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">flip-open<br>perspective</span> <button progress-button="progressFunction()" pb-style="flip-open" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">slide-down<br>horizontal</span> <button progress-button="progressFunction()" pb-style="slide-down" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">move-up<br>horizontal</span> <button progress-button="progressFunction()" pb-style="move-up" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6"><span class="button-title">top-line<br>horizontal</span> <button progress-button="progressFunction()" pb-style="top-line" class="btn btn-success">Submit</button></section><section class="col-md-6"><span class="button-title">lateral-lines<br>vertical</span> <button progress-button="progressFunction()" pb-style="lateral-lines" class="btn btn-info">Submit</button></section></div></div>');
$templateCache.put('app/pages/ui/icons/widgets/fontAwesomeIcons.html','<div class="row icons-list success awesomeIcons"><div class="col-xs-2" ng-repeat="icon in icons.fontAwesomeIcons"><i class="fa {{icon}}"></i></div></div><a href="http://fortawesome.github.io/Font-Awesome/icons/" target="_blank" class="see-all-icons">See all Font Awesome icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/ionicons.html','<div class="row icons-list primary"><div class="col-xs-2" ng-repeat="icon in icons.ionicons"><i class="{{icon}}"></i></div></div><a href="http://ionicons.com/" target="_blank" class="see-all-icons">See all ionicons icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/kameleon.html','<div class="row clearfix"><div class="kameleon-row" ng-repeat="icon in icons.kameleonIcons"><div class="kameleon-icon"><img ng-src="{{:: (icon.img | kameleonImg )}}"><span>{{icon.name}}</span></div></div></div><a href="http://www.kameleon.pics/" target="_blank" class="see-all-icons">See all Kamaleon icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/kameleonRounded.html','<div class="row clearfix"><div class="kameleon-row" ng-repeat="icon in icons.kameleonRoundedIcons"><div class="kameleon-icon with-round-bg {{icon.color}}"><img ng-src="{{::( icon.img | kameleonImg )}}"><span>{{ icon.name }}</span></div></div></div><a href="http://www.kameleon.pics/" target="_blank" class="see-all-icons">See all Kamaleon icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/socicon.html','<div class="row icons-list danger"><div class="col-xs-2" ng-repeat="icon in icons.socicon"><i class="socicon">{{ icon }}</i></div></div><a href="http://www.socicon.com/chart.php" target="_blank" class="see-all-icons">See all Socicon icons</a>');
$templateCache.put('app/pages/ui/modals/modalTemplates/basicModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Error</span></div><div class="modal-body text-center">Your information hasn\'t been saved!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/infoModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Information</span></div><div class="modal-body text-center">You\'ve got a new email!</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/largeModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/smallModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/successModal.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-checkmark modal-icon"></i><span>Success</span></div><div class="modal-body text-center">Your information has been saved successfully</div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/warningModal.html','<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-android-warning modal-icon"></i><span>Warning</span></div><div class="modal-body text-center">Your computer is about to explode!</div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/notifications/notifications.html','<div class="modal-buttons same-width clearfix" ng-controller="NotificationsCtrl"><button type="button" class="btn btn-success" ng-click="showSuccessMsg()">Success Notification</button> <button type="button" class="btn btn-info" ng-click="showInfoMsg()">Info Notification</button> <button type="button" class="btn btn-warning" ng-click="showWarningMsg()">Warning Notification</button> <button type="button" class="btn btn-danger" ng-click="showErrorMsg()">Danger Notification</button></div>');
$templateCache.put('app/pages/ui/modals/progressModal/progressModal.html','<div class="modal-content" ng-controller="ProgressModalCtrl"><div class="modal-body"><progress-bar-round></progress-bar-round></div><div class="modal-footer"></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/animated.html','<div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning progress-bar-striped active" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger progress-bar-striped active" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/basic.html','<div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/label.html','<div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%">40% Complete (success)</div></div><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%">20% Complete</div></div><div class="progress"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%">60% Complete (warning)</div></div><div class="progress"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%">80% Complete (danger)</div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/stacked.html','<div class="progress"><div class="progress-bar progress-bar-success" style="width: 35%"><span class="sr-only">35% Complete (success)</span></div><div class="progress-bar progress-bar-warning progress-bar-striped" style="width: 20%"><span class="sr-only">20% Complete (warning)</span></div><div class="progress-bar progress-bar-danger" style="width: 10%"><span class="sr-only">10% Complete (danger)</span></div><div class="progress-bar progress-bar-info progress-bar-striped active" style="width: 20%"><span class="sr-only">20% Complete (warning)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/striped.html','<div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info progress-bar-striped" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning progress-bar-striped" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger progress-bar-striped" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/costosydeducciones/dependienteeconomico.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Deducci\xF3n por dependientes economicos (48)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="deducciondependientesForm"><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':deducciondependientesForm.concepto.$invalid,\'has-success has-feedback\':deducciondependientesForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_costos.deducciondependientes.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="deducciondependientesForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="deducciondependientesForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':deducciondependientesForm.persona_natural.$invalid,\'has-success has-feedback\':deducciondependientesForm.persona_natural.$valid}"><label class="text-left full-width" for="persona_natural">Persona Natural</label> <input class="form-control" placeholder="Persona Natural" name="persona_natural" type="text" id="persona_natural" ng-model="datos_costos.deducciondependientes.persona_natural" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="deducciondependientesForm.persona_natural.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="deducciondependientesForm.persona_natural.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':deducciondependientesForm.identificacion.$invalid,\'has-success has-feedback\':deducciondependientesForm.identificacion.$valid}"><label class="text-left full-width" for="identificacion">Identificaci\xF3n</label> <input class="form-control" placeholder="Identificaci\xF3n" name="identificacion" type="text" id="identificacion" ng-model="datos_costos.deducciondependientes.identificacion" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="deducciondependientesForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="deducciondependientesForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':deducciondependientesForm.valor.$invalid,\'has-success has-feedback\':deducciondependientesForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_costos.deducciondependientes.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="deducciondependientesForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="deducciondependientesForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarCampo48(deducciondependientesForm);" ng-disabled="deducciondependientesForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(deducciondependientesForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Persona Natural</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_costos.detalles_deducciondependientes.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.persona_natural}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo48(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/costosydeducciones/incurridoexterior.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Costos y gastos incurridos en el exterior (51)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="cygexteriorForm"><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':cygexteriorForm.concepto.$invalid,\'has-success has-feedback\':cygexteriorForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_costos.cygexterior.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="cygexteriorForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="cygexteriorForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="datos_costos.cygexterior.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_costos.cygexterior.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div ng-if="!datos_costos.cygexterior.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':cygexteriorForm.entidad.$invalid,\'has-success has-feedback\':cygexteriorForm.entidad.$valid}"><label class="text-left full-width" for="entidad">Entidad</label> <input class="form-control" placeholder="Entidad" name="entidad" type="text" id="entidad" ng-model="datos_costos.cygexterior.entidad" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="cygexteriorForm.entidad.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="cygexteriorForm.entidad.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="!datos_costos.cygexterior.es_selector" class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':cygexteriorForm.identificacion.$invalid,\'has-success has-feedback\':cygexteriorForm.identificacion.$valid}"><label class="text-left full-width" for="identificacion">Identificaci\xF3n</label> <input class="form-control" placeholder="Identificaci\xF3n" name="identificacion" type="text" id="identificacion" ng-model="datos_costos.cygexterior.identificacion" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="cygexteriorForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="cygexteriorForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':cygexteriorForm.valor.$invalid,\'has-success has-feedback\':cygexteriorForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_costos.cygexterior.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="cygexteriorForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="cygexteriorForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="cambiarDatosCampo51();" ng-disabled="accionesForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-shuffle"></i></button> <button ng-click="agregarCampo51(cygexteriorForm);" ng-disabled="cygexteriorForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(cygexteriorForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_costos.detalles_cygexterior.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo51(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/costosydeducciones/interesesvivienda.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Decucciones por pagos de intereses de vivienda (49)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="intviviendaForm"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':intviviendaForm.concepto.$invalid,\'has-success has-feedback\':intviviendaForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_costos.intvivienda.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="intviviendaForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="intviviendaForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_costos.intvivienda.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':intviviendaForm.valor.$invalid,\'has-success has-feedback\':intviviendaForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_costos.intvivienda.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="intviviendaForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="intviviendaForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarCampo49(intviviendaForm);" ng-disabled="intviviendaForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(intviviendaForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_costos.detalles_intvivienda.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo49(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/costosydeducciones/nomina.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Gastos de nomina incluidos los aprotes a la seguridad social y parafiscales (47)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="nominaForm"><div class="col-lg-4 col-md-4 col-sm-6 col-xs-6"><div class="form-group" ng-class="{\'has-error has-feedback\':nominaForm.nombres.$invalid,\'has-success has-feedback\':nominaForm.nombres.$valid}"><label class="text-left full-width" for="nombres">Empleado</label> <input class="form-control" placeholder="Nombre empleado" name="nombres" type="text" id="nombres" ng-model="datos_costos.nomina.nombres" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="nominaForm.nombres.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="nominaForm.nombres.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-4 col-md-4 col-sm-6 col-xs-6"><div class="form-group" ng-class="{\'has-error has-feedback\':nominaForm.identificacion.$invalid,\'has-success has-feedback\':nominaForm.identificacion.$valid}"><label class="text-left full-width" for="identificacion">Identificaci\xF3n</label> <input class="form-control" placeholder="Identificacion empleado" name="identificacion" type="text" id="identificacion" ng-model="datos_costos.nomina.identificacion" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="nominaForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="nominaForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-6 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':nominaForm.salario.$invalid,\'has-success has-feedback\':nominaForm.salario.$valid}"><label class="text-left full-width" for="salario">Salario</label> <input class="form-control" ng-keypress="actualizarTotalCampo47();" ng-blur="actualizarTotalCampo47();" placeholder="Salario" name="salario" type="text" id="salario" ng-model="datos_costos.nomina.salario" required="" pattern="[0-9.,\\s]+"> <i ng-show="nominaForm.salario.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="nominaForm.salario.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-6 col-xs-6"><div class="form-group" ng-class="{\'has-error has-feedback\':nominaForm.prestaciones.$invalid,\'has-success has-feedback\':nominaForm.prestaciones.$valid}"><label class="text-left full-width" for="prestaciones">Prerstaciones</label> <input class="form-control" ng-keypress="actualizarTotalCampo47();" ng-blur="actualizarTotalCampo47();" placeholder="Prestaciones" name="prestaciones" type="text" id="prestaciones" ng-model="datos_costos.nomina.prestaciones" required="" pattern="[0-9.,\\s]+"> <i ng-show="nominaForm.prestaciones.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="nominaForm.prestaciones.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-6 col-xs-6"><div class="form-group" ng-class="{\'has-error has-feedback\':nominaForm.aportes.$invalid,\'has-success has-feedback\':nominaForm.aportes.$valid}"><label class="text-left full-width" for="aportes">Aportes</label> <input class="form-control" ng-keypress="actualizarTotalCampo47();" ng-blur="actualizarTotalCampo47();" placeholder="Aportes" name="aportes" type="text" id="aportes" ng-model="datos_costos.nomina.aportes" required="" pattern="[0-9.,\\s]+"> <i ng-show="nominaForm.aportes.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="nominaForm.aportes.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-6 col-xs-6"><div class="form-group"><label class="text-left full-width" for="total">Total</label> <input class="form-control" readonly="" placeholder="Total" name="total" type="text" id="total" ng-model="datos_costos.nomina.total" required="" pattern="[0-9.,\\s]+"></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-6"><button ng-click="agregarCampo47(nominaForm);" ng-disabled="nominaForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(nominaForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Empleado</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Salario</th><th class="align-right">Prestaciones</th><th class="align-right">Aportes</th><th class="align-right">Total</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_costos.detalles_nomina.listado"><td ng-class="nowrap">{{item.empleado}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.salario | currency:"$":2}}</td><td class="align-right">{{item.prestaciones | currency:"$":2}}</td><td class="align-right">{{item.aportes | currency:"$":2}}</td><td class="align-right">{{item.total | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo47(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/costosydeducciones/otroscostos.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Otros costos y deducciones (50)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="otroscostosForm"><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':otroscostosForm.concepto.$invalid,\'has-success has-feedback\':otroscostosForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_costos.otroscostos.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="otroscostosForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="otroscostosForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="datos_costos.otroscostos.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Persona Natural/Jur\xEDdica</label><ui-select ng-model="datos_costos.otroscostos.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div ng-if="!datos_costos.otroscostos.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':otroscostosForm.entidad.$invalid,\'has-success has-feedback\':otroscostosForm.entidad.$valid}"><label class="text-left full-width" for="entidad">Persona Natural/Jur\xEDdica</label> <input class="form-control" placeholder="Entidad" name="entidad" type="text" id="entidad" ng-model="datos_costos.otroscostos.entidad" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="otroscostosForm.entidad.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="otroscostosForm.entidad.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="!datos_costos.otroscostos.es_selector" class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':otroscostosForm.identificacion.$invalid,\'has-success has-feedback\':otroscostosForm.identificacion.$valid}"><label class="text-left full-width" for="identificacion">Identificaci\xF3n</label> <input class="form-control" placeholder="Identificaci\xF3n" name="identificacion" type="text" id="identificacion" ng-model="datos_costos.otroscostos.identificacion" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="otroscostosForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="otroscostosForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':otroscostosForm.valor.$invalid,\'has-success has-feedback\':otroscostosForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_costos.otroscostos.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="otroscostosForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="otroscostosForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="cambiarDatosCampo50();" ng-disabled="accionesForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-shuffle"></i></button> <button ng-click="agregarCampo50(otroscostosForm);" ng-disabled="otroscostosForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(otroscostosForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Persona Natural</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_costos.detalles_otroscostos.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo50(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/gananciaocasional/gananciaexterior.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Ingresos por ganancias ocasionales en el exterior (68)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="gananciaexteriorForm"><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':gananciaexteriorForm.concepto.$invalid,\'has-success has-feedback\':gananciaexteriorForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_ganancias.gananciaexterior.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="gananciaexteriorForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="gananciaexteriorForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="datos_ganancias.gananciaexterior.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_ganancias.gananciaexterior.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div ng-if="!datos_ganancias.gananciaexterior.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':gananciaexteriorForm.entidad.$invalid,\'has-success has-feedback\':gananciaexteriorForm.entidad.$valid}"><label class="text-left full-width" for="entidad">Entidad</label> <input class="form-control" placeholder="Entidad" name="entidad" type="text" id="entidad" ng-model="datos_ganancias.gananciaexterior.entidad" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="gananciaexteriorForm.entidad.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="gananciaexteriorForm.entidad.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="!datos_ganancias.gananciaexterior.es_selector" class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':gananciaexteriorForm.identificacion.$invalid,\'has-success has-feedback\':gananciaexteriorForm.identificacion.$valid}"><label class="text-left full-width" for="identificacion">Identificaci\xF3n</label> <input class="form-control" placeholder="Identificaci\xF3n" name="identificacion" type="text" id="identificacion" ng-model="datos_ganancias.gananciaexterior.identificacion" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="gananciaexteriorForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="gananciaexteriorForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':gananciaexteriorForm.valor.$invalid,\'has-success has-feedback\':gananciaexteriorForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_ganancias.gananciaexterior.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="gananciaexteriorForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="gananciaexteriorForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="cambiarDatosCampo68();" ng-disabled="accionesForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-shuffle"></i></button> <button ng-click="agregarCampo68(gananciaexteriorForm);" ng-disabled="gananciaexteriorForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(gananciaexteriorForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_ganancias.detalles_gananciaexterior.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo68(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/gananciaocasional/gananciapais.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Ingresos por ganancias ocasionales en el pa\xEDs (67)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="gananciapaisForm"><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':gananciapaisForm.concepto.$invalid,\'has-success has-feedback\':gananciapaisForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_ganancias.gananciapais.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="gananciapaisForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="gananciapaisForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="datos_ganancias.gananciapais.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_ganancias.gananciapais.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div ng-if="!datos_ganancias.gananciapais.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':gananciapaisForm.entidad.$invalid,\'has-success has-feedback\':gananciapaisForm.entidad.$valid}"><label class="text-left full-width" for="entidad">Entidad</label> <input class="form-control" placeholder="Entidad" name="entidad" type="text" id="entidad" ng-model="datos_ganancias.gananciapais.entidad" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="gananciapaisForm.entidad.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="gananciapaisForm.entidad.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="!datos_ganancias.gananciapais.es_selector" class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':gananciapaisForm.identificacion.$invalid,\'has-success has-feedback\':gananciapaisForm.identificacion.$valid}"><label class="text-left full-width" for="identificacion">Identificaci\xF3n</label> <input class="form-control" placeholder="Identificaci\xF3n" name="identificacion" type="text" id="identificacion" ng-model="datos_ganancias.gananciapais.identificacion" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="gananciapaisForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="gananciapaisForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':gananciapaisForm.valor.$invalid,\'has-success has-feedback\':gananciapaisForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_ganancias.gananciapais.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="gananciapaisForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="gananciapaisForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="cambiarDatosCampo67();" ng-disabled="accionesForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-shuffle"></i></button> <button ng-click="agregarCampo67(gananciapaisForm);" ng-disabled="gananciapaisForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(gananciapaisForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_ganancias.detalles_gananciapais.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo67(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/gananciaocasional/gananciasocasionales.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Costos por ganancias ocasionales (69)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="gananciasocasionalesForm"><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':gananciasocasionalesForm.concepto.$invalid,\'has-success has-feedback\':gananciasocasionalesForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_ganancias.gananciasocasionales.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="gananciasocasionalesForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="gananciasocasionalesForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="datos_ganancias.gananciasocasionales.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_ganancias.gananciasocasionales.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div ng-if="!datos_ganancias.gananciasocasionales.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':gananciasocasionalesForm.entidad.$invalid,\'has-success has-feedback\':gananciasocasionalesForm.entidad.$valid}"><label class="text-left full-width" for="entidad">Entidad</label> <input class="form-control" placeholder="Entidad" name="entidad" type="text" id="entidad" ng-model="datos_ganancias.gananciasocasionales.entidad" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="gananciasocasionalesForm.entidad.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="gananciasocasionalesForm.entidad.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="!datos_ganancias.gananciasocasionales.es_selector" class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':gananciasocasionalesForm.identificacion.$invalid,\'has-success has-feedback\':gananciasocasionalesForm.identificacion.$valid}"><label class="text-left full-width" for="identificacion">Identificaci\xF3n</label> <input class="form-control" placeholder="Identificaci\xF3n" name="identificacion" type="text" id="identificacion" ng-model="datos_ganancias.gananciasocasionales.identificacion" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="gananciasocasionalesForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="gananciasocasionalesForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':gananciasocasionalesForm.valor.$invalid,\'has-success has-feedback\':gananciasocasionalesForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_ganancias.gananciasocasionales.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="gananciasocasionalesForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="gananciasocasionalesForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="cambiarDatosCampo69();" ng-disabled="accionesForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-shuffle"></i></button> <button ng-click="agregarCampo69(gananciasocasionalesForm);" ng-disabled="gananciasocasionalesForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(gananciasocasionalesForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_ganancias.detalles_gananciasocasionales.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo69(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/gananciaocasional/nogravadasyexentas.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Ganancias ocasionales no gravadas y exentas (70)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="gananciasocasionalesexentasForm"><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':gananciasocasionalesexentasForm.concepto.$invalid,\'has-success has-feedback\':gananciasocasionalesexentasForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_ganancias.gananciasocasionalesexentas.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="gananciasocasionalesexentasForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="gananciasocasionalesexentasForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="datos_ganancias.gananciasocasionalesexentas.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_ganancias.gananciasocasionalesexentas.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div ng-if="!datos_ganancias.gananciasocasionalesexentas.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':gananciasocasionalesexentasForm.entidad.$invalid,\'has-success has-feedback\':gananciasocasionalesexentasForm.entidad.$valid}"><label class="text-left full-width" for="entidad">Entidad</label> <input class="form-control" placeholder="Entidad" name="entidad" type="text" id="entidad" ng-model="datos_ganancias.gananciasocasionalesexentas.entidad" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="gananciasocasionalesexentasForm.entidad.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="gananciasocasionalesexentasForm.entidad.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="!datos_ganancias.gananciasocasionalesexentas.es_selector" class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':gananciasocasionalesexentasForm.identificacion.$invalid,\'has-success has-feedback\':gananciasocasionalesexentasForm.identificacion.$valid}"><label class="text-left full-width" for="identificacion">Identificaci\xF3n</label> <input class="form-control" placeholder="Identificaci\xF3n" name="identificacion" type="text" id="identificacion" ng-model="datos_ganancias.gananciasocasionalesexentas.identificacion" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="gananciasocasionalesexentasForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="gananciasocasionalesexentasForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':gananciasocasionalesexentasForm.valor.$invalid,\'has-success has-feedback\':gananciasocasionalesexentasForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_ganancias.gananciasocasionalesexentas.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="gananciasocasionalesexentasForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="gananciasocasionalesexentasForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="cambiarDatosCampo70();" ng-disabled="accionesForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-shuffle"></i></button> <button ng-click="agregarCampo70(gananciasocasionalesexentasForm);" ng-disabled="gananciasocasionalesexentasForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(gananciasocasionalesexentasForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_ganancias.detalles_gananciasocasionalesexentas.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo70(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/iman/aportesss.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Aportes obligatorios al sistema general de seguridad social a cargo del empleado (75)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="aportesssForm"><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':aportesssForm.concepto.$invalid,\'has-success has-feedback\':aportesssForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_iman.aportesss.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="aportesssForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="aportesssForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="datos_iman.aportesss.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_iman.aportesss.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div ng-if="!datos_iman.aportesss.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':aportesssForm.entidad.$invalid,\'has-success has-feedback\':aportesssForm.entidad.$valid}"><label class="text-left full-width" for="entidad">Entidad</label> <input class="form-control" placeholder="Entidad" name="entidad" type="text" id="entidad" ng-model="datos_iman.aportesss.entidad" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="aportesssForm.entidad.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="aportesssForm.entidad.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="!datos_iman.aportesss.es_selector" class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':aportesssForm.identificacion.$invalid,\'has-success has-feedback\':aportesssForm.identificacion.$valid}"><label class="text-left full-width" for="identificacion">Identificaci\xF3n</label> <input class="form-control" placeholder="Identificaci\xF3n" name="identificacion" type="text" id="identificacion" ng-model="datos_iman.aportesss.identificacion" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="aportesssForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="aportesssForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':aportesssForm.valor.$invalid,\'has-success has-feedback\':aportesssForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_iman.aportesss.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="aportesssForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="aportesssForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="cambiarDatosCampo75();" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-shuffle"></i></button> <button ng-click="agregarCampo75(aportesssForm);" ng-disabled="aportesssForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(aportesssForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_iman.detalles_aportesss.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo75(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/iman/bienesenaje.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Costo fiscal de los bienes enajenados (80)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="bienesenajeForm"><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':bienesenajeForm.concepto.$invalid,\'has-success has-feedback\':bienesenajeForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_iman.bienesenaje.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="bienesenajeForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="bienesenajeForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="datos_iman.bienesenaje.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_iman.bienesenaje.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div ng-if="!datos_iman.bienesenaje.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':bienesenajeForm.entidad.$invalid,\'has-success has-feedback\':bienesenajeForm.entidad.$valid}"><label class="text-left full-width" for="entidad">Entidad</label> <input class="form-control" placeholder="Entidad" name="entidad" type="text" id="entidad" ng-model="datos_iman.bienesenaje.entidad" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="bienesenajeForm.entidad.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="bienesenajeForm.entidad.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="!datos_iman.bienesenaje.es_selector" class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':bienesenajeForm.identificacion.$invalid,\'has-success has-feedback\':bienesenajeForm.identificacion.$valid}"><label class="text-left full-width" for="identificacion">Identificaci\xF3n</label> <input class="form-control" placeholder="Identificaci\xF3n" name="identificacion" type="text" id="identificacion" ng-model="datos_iman.bienesenaje.identificacion" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="bienesenajeForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="bienesenajeForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':bienesenajeForm.valor.$invalid,\'has-success has-feedback\':bienesenajeForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_iman.bienesenaje.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="bienesenajeForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="bienesenajeForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="cambiarDatosCampo80();" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-shuffle"></i></button> <button ng-click="agregarCampo80(bienesenajeForm);" ng-disabled="bienesenajeForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(bienesenajeForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_iman.detalles_bienesenaje.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo80(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/iman/desastreycalamidad.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>P\xE9rdidas por desastres o calamidades p\xFAblicas (78)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="desastreycalForm"><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':desastreycalForm.concepto.$invalid,\'has-success has-feedback\':desastreycalForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_iman.desastreycal.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="desastreycalForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="desastreycalForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="datos_iman.desastreycal.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_iman.desastreycal.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div ng-if="!datos_iman.desastreycal.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':desastreycalForm.entidad.$invalid,\'has-success has-feedback\':desastreycalForm.entidad.$valid}"><label class="text-left full-width" for="entidad">Entidad</label> <input class="form-control" placeholder="Entidad" name="entidad" type="text" id="entidad" ng-model="datos_iman.desastreycal.entidad" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="desastreycalForm.entidad.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="desastreycalForm.entidad.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="!datos_iman.desastreycal.es_selector" class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':desastreycalForm.identificacion.$invalid,\'has-success has-feedback\':desastreycalForm.identificacion.$valid}"><label class="text-left full-width" for="identificacion">Identificaci\xF3n</label> <input class="form-control" placeholder="Identificaci\xF3n" name="identificacion" type="text" id="identificacion" ng-model="datos_iman.desastreycal.identificacion" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="desastreycalForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="desastreycalForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':desastreycalForm.valor.$invalid,\'has-success has-feedback\':desastreycalForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_iman.desastreycal.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="desastreycalForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="desastreycalForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="cambiarDatosCampo78();" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-shuffle"></i></button> <button ng-click="agregarCampo78(desastreycalForm);" ng-disabled="desastreycalForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(desastreycalForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_iman.detalles_desastreycal.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo78(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/iman/empleadodomestico.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Aportes obligatorios a seguridad social de un empleado del servicio domestico (79)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="empleadodomesticoForm"><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':empleadodomesticoForm.concepto.$invalid,\'has-success has-feedback\':empleadodomesticoForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_iman.empleadodomestico.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="empleadodomesticoForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="empleadodomesticoForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="datos_iman.empleadodomestico.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_iman.empleadodomestico.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div ng-if="!datos_iman.empleadodomestico.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':empleadodomesticoForm.entidad.$invalid,\'has-success has-feedback\':empleadodomesticoForm.entidad.$valid}"><label class="text-left full-width" for="entidad">Entidad</label> <input class="form-control" placeholder="Entidad" name="entidad" type="text" id="entidad" ng-model="datos_iman.empleadodomestico.entidad" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="empleadodomesticoForm.entidad.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="empleadodomesticoForm.entidad.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="!datos_iman.empleadodomestico.es_selector" class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':empleadodomesticoForm.identificacion.$invalid,\'has-success has-feedback\':empleadodomesticoForm.identificacion.$valid}"><label class="text-left full-width" for="identificacion">Identificaci\xF3n</label> <input class="form-control" placeholder="Identificaci\xF3n" name="identificacion" type="text" id="identificacion" ng-model="datos_iman.empleadodomestico.identificacion" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="empleadodomesticoForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="empleadodomesticoForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':empleadodomesticoForm.valor.$invalid,\'has-success has-feedback\':empleadodomesticoForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_iman.empleadodomestico.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="empleadodomesticoForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="empleadodomesticoForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="cambiarDatosCampo79();" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-shuffle"></i></button> <button ng-click="agregarCampo79(empleadodomesticoForm);" ng-disabled="empleadodomesticoForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(empleadodomesticoForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_iman.detalles_empleadodomestico.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo79(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/iman/gtrepreexento.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Gastos de representaci\xF3n exentos (76)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="gtrepreexentoForm"><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':gtrepreexentoForm.concepto.$invalid,\'has-success has-feedback\':gtrepreexentoForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_iman.gtrepreexento.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="gtrepreexentoForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="gtrepreexentoForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="datos_iman.gtrepreexento.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_iman.gtrepreexento.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div ng-if="!datos_iman.gtrepreexento.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':gtrepreexentoForm.entidad.$invalid,\'has-success has-feedback\':gtrepreexentoForm.entidad.$valid}"><label class="text-left full-width" for="entidad">Entidad</label> <input class="form-control" placeholder="Entidad" name="entidad" type="text" id="entidad" ng-model="datos_iman.gtrepreexento.entidad" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="gtrepreexentoForm.entidad.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="gtrepreexentoForm.entidad.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="!datos_iman.gtrepreexento.es_selector" class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':gtrepreexentoForm.identificacion.$invalid,\'has-success has-feedback\':gtrepreexentoForm.identificacion.$valid}"><label class="text-left full-width" for="identificacion">Identificaci\xF3n</label> <input class="form-control" placeholder="Identificaci\xF3n" name="identificacion" type="text" id="identificacion" ng-model="datos_iman.gtrepreexento.identificacion" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="gtrepreexentoForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="gtrepreexentoForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':gtrepreexentoForm.valor.$invalid,\'has-success has-feedback\':gtrepreexentoForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_iman.gtrepreexento.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="gtrepreexentoForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="gtrepreexentoForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="cambiarDatosCampo76();" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-shuffle"></i></button> <button ng-click="agregarCampo76(gtrepreexentoForm);" ng-disabled="gtrepreexentoForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(gtrepreexentoForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_iman.detalles_gtrepreexento.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo76(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/iman/indemnizaciones.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Indemnizaciones y otros Lit. i) Art332 E.T. (81)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="indemnizacionesForm"><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':indemnizacionesForm.concepto.$invalid,\'has-success has-feedback\':indemnizacionesForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_iman.indemnizaciones.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="indemnizacionesForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="indemnizacionesForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="datos_iman.indemnizaciones.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_iman.indemnizaciones.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div ng-if="!datos_iman.indemnizaciones.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':indemnizacionesForm.entidad.$invalid,\'has-success has-feedback\':indemnizacionesForm.entidad.$valid}"><label class="text-left full-width" for="entidad">Entidad</label> <input class="form-control" placeholder="Entidad" name="entidad" type="text" id="entidad" ng-model="datos_iman.indemnizaciones.entidad" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="indemnizacionesForm.entidad.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="indemnizacionesForm.entidad.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="!datos_iman.indemnizaciones.es_selector" class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':indemnizacionesForm.identificacion.$invalid,\'has-success has-feedback\':indemnizacionesForm.identificacion.$valid}"><label class="text-left full-width" for="identificacion">Identificaci\xF3n</label> <input class="form-control" placeholder="Identificaci\xF3n" name="identificacion" type="text" id="identificacion" ng-model="datos_iman.indemnizaciones.identificacion" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="indemnizacionesForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="indemnizacionesForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':indemnizacionesForm.valor.$invalid,\'has-success has-feedback\':indemnizacionesForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_iman.indemnizaciones.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="indemnizacionesForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="indemnizacionesForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="cambiarDatosCampo81();" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-shuffle"></i></button> <button ng-click="agregarCampo81(indemnizacionesForm);" ng-disabled="indemnizacionesForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(indemnizacionesForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_iman.detalles_indemnizaciones.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo81(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/iman/indemseguro.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Indemnizaciones en dinero o en especie por seguro de da\xF1o (74)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="indemseguroForm"><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':indemseguroForm.concepto.$invalid,\'has-success has-feedback\':indemseguroForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_iman.indemseguro.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="indemseguroForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="indemseguroForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="datos_iman.indemseguro.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_iman.indemseguro.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div ng-if="!datos_iman.indemseguro.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':indemseguroForm.entidad.$invalid,\'has-success has-feedback\':indemseguroForm.entidad.$valid}"><label class="text-left full-width" for="entidad">Entidad</label> <input class="form-control" placeholder="Entidad" name="entidad" type="text" id="entidad" ng-model="datos_iman.indemseguro.entidad" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="indemseguroForm.entidad.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="indemseguroForm.entidad.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="!datos_iman.indemseguro.es_selector" class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':indemseguroForm.identificacion.$invalid,\'has-success has-feedback\':indemseguroForm.identificacion.$valid}"><label class="text-left full-width" for="identificacion">Identificaci\xF3n</label> <input class="form-control" placeholder="Identificaci\xF3n" name="identificacion" type="text" id="identificacion" ng-model="datos_iman.indemseguro.identificacion" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="indemseguroForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="indemseguroForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':indemseguroForm.valor.$invalid,\'has-success has-feedback\':indemseguroForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_iman.indemseguro.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="indemseguroForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="indemseguroForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="cambiarDatosCampo74();" ng-disabled="accionesForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-shuffle"></i></button> <button ng-click="agregarCampo74(indemseguroForm);" ng-disabled="indemseguroForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(indemseguroForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_iman.detalles_indemseguro.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo74(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/iman/retirosfondos.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Retiros fondos de pensi\xF3n de jubilaci\xF3n e invalidez; fondos de cesant\xEDas y cuentas AFC (82)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="retirosfondosForm"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':retirosfondosForm.concepto.$invalid,\'has-success has-feedback\':retirosfondosForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_iman.retirosfondos.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="retirosfondosForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="retirosfondosForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_iman.retirosfondos.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':retirosfondosForm.valor.$invalid,\'has-success has-feedback\':retirosfondosForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_iman.retirosfondos.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="retirosfondosForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="retirosfondosForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarCampo82(retirosfondosForm);" ng-disabled="retirosfondosForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(retirosfondosForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_iman.detalles_retirosfondos.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo82(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/iman/saludnopos.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Pagos catastr\xF3ficos en salud efectivamente certificados no cubiertos por el POS (77)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="saludnoposForm"><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':saludnoposForm.concepto.$invalid,\'has-success has-feedback\':saludnoposForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_iman.saludnopos.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="saludnoposForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="saludnoposForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="datos_iman.saludnopos.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_iman.saludnopos.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div ng-if="!datos_iman.saludnopos.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':saludnoposForm.entidad.$invalid,\'has-success has-feedback\':saludnoposForm.entidad.$valid}"><label class="text-left full-width" for="entidad">Entidad</label> <input class="form-control" placeholder="Entidad" name="entidad" type="text" id="entidad" ng-model="datos_iman.saludnopos.entidad" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="saludnoposForm.entidad.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="saludnoposForm.entidad.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="!datos_iman.saludnopos.es_selector" class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':saludnoposForm.identificacion.$invalid,\'has-success has-feedback\':saludnoposForm.identificacion.$valid}"><label class="text-left full-width" for="identificacion">Identificaci\xF3n</label> <input class="form-control" placeholder="Identificaci\xF3n" name="identificacion" type="text" id="identificacion" ng-model="datos_iman.saludnopos.identificacion" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="saludnoposForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="saludnoposForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':saludnoposForm.valor.$invalid,\'has-success has-feedback\':saludnoposForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_iman.saludnopos.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="saludnoposForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="saludnoposForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="cambiarDatosCampo77();" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-shuffle"></i></button> <button ng-click="agregarCampo77(saludnoposForm);" ng-disabled="saludnoposForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(saludnoposForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_iman.detalles_saludnopos.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo77(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/ingresos/dividendos.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Dividendos y participaciones (37)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="dividendosForm"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':dividendosForm.concepto.$invalid,\'has-success has-feedback\':dividendosForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_ingresos.dividendos.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="dividendosForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="dividendosForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_ingresos.dividendos.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':dividendosForm.valor.$invalid,\'has-success has-feedback\':dividendosForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_ingresos.dividendos.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="dividendosForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="dividendosForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarCampo37(dividendosForm);" ng-disabled="dividendosForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(dividendosForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_ingresos.detalles_dividendos.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo37(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/ingresos/dividendosnoconsti.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Dividendos y participaciones no constitutivos (41)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="dividendosnoconstiForm"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':dividendosnoconstiForm.concepto.$invalid,\'has-success has-feedback\':dividendosnoconstiForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_ingresos.dividendosnoconsti.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="dividendosnoconstiForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="dividendosnoconstiForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_ingresos.dividendosnoconsti.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':dividendosnoconstiForm.valor.$invalid,\'has-success has-feedback\':dividendosnoconstiForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_ingresos.dividendosnoconsti.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="dividendosnoconstiForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="dividendosnoconstiForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarCampo41(dividendosnoconstiForm);" ng-disabled="dividendosnoconstiForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(dividendosnoconstiForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_ingresos.detalles_dividendosnoconsti.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo41(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/ingresos/donaciones.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Donaciones (42)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="donacionesForm"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':donacionesForm.concepto.$invalid,\'has-success has-feedback\':donacionesForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_ingresos.donaciones.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="donacionesForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="donacionesForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_ingresos.donaciones.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':donacionesForm.valor.$invalid,\'has-success has-feedback\':donacionesForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_ingresos.donaciones.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="donacionesForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="donacionesForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarCampo42(donacionesForm);" ng-disabled="donacionesForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(donacionesForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_ingresos.detalles_donaciones.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo42(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/ingresos/honorarios.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Honorarios, comisiones y servicios (35)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="honorariosForm"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':honorariosForm.concepto.$invalid,\'has-success has-feedback\':honorariosForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_ingresos.honorarios.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="honorariosForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="honorariosForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_ingresos.honorarios.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':honorariosForm.valor.$invalid,\'has-success has-feedback\':honorariosForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_ingresos.honorarios.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="honorariosForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="honorariosForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarCampo35(honorariosForm);" ng-disabled="honorariosForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(honorariosForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_ingresos.detalles_honorarios.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo35(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/ingresos/intereses.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Intereses y rendimientos financieros (36)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="interesesForm"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':interesesForm.concepto.$invalid,\'has-success has-feedback\':interesesForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_ingresos.intereses.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="interesesForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="interesesForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_ingresos.intereses.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':interesesForm.valor.$invalid,\'has-success has-feedback\':interesesForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_ingresos.intereses.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="interesesForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="interesesForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarCampo36(interesesForm);" ng-disabled="interesesForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(interesesForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_ingresos.detalles_intereses.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo36(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/ingresos/obtenidosext.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Obtenidos en el exterior (39)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="obtenidosextForm"><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':obtenidosextForm.concepto.$invalid,\'has-success has-feedback\':obtenidosextForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_ingresos.obtenidosext.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="obtenidosextForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="obtenidosextForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="datos_ingresos.obtenidosext.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_ingresos.obtenidosext.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div ng-if="!datos_ingresos.obtenidosext.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':obtenidosextForm.entidad.$invalid,\'has-success has-feedback\':obtenidosextForm.entidad.$valid}"><label class="text-left full-width" for="entidad">Entidad</label> <input class="form-control" placeholder="Entidad" name="entidad" type="text" id="entidad" ng-model="datos_ingresos.obtenidosext.entidad" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="obtenidosextForm.entidad.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="obtenidosextForm.entidad.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="!datos_ingresos.obtenidosext.es_selector" class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':obtenidosextForm.identificacion.$invalid,\'has-success has-feedback\':obtenidosextForm.identificacion.$valid}"><label class="text-left full-width" for="identificacion">Identificaci\xF3n</label> <input class="form-control" placeholder="Identificaci\xF3n" name="identificacion" type="text" id="identificacion" ng-model="datos_ingresos.obtenidosext.identificacion" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="obtenidosextForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="obtenidosextForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':obtenidosextForm.valor.$invalid,\'has-success has-feedback\':obtenidosextForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_ingresos.obtenidosext.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="obtenidosextForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="obtenidosextForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="cambiarDatosCampo39();" ng-disabled="accionesForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-shuffle"></i></button> <button ng-click="agregarCampo39(obtenidosextForm);" ng-disabled="obtenidosextForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(obtenidosextForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_ingresos.detalles_obtenidosext.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo39(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/ingresos/otrosetc.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Otros (Ventas, Arrendamientos, etc.) (38)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="otrosetcForm"><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':otrosetcForm.concepto.$invalid,\'has-success has-feedback\':otrosetcForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_ingresos.otrosetc.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="otrosetcForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="otrosetcForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="datos_ingresos.otrosetc.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_ingresos.otrosetc.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div ng-if="!datos_ingresos.otrosetc.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':otrosetcForm.entidad.$invalid,\'has-success has-feedback\':otrosetcForm.entidad.$valid}"><label class="text-left full-width" for="entidad">Entidad</label> <input class="form-control" placeholder="Entidad" name="entidad" type="text" id="entidad" ng-model="datos_ingresos.otrosetc.entidad" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="otrosetcForm.entidad.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="otrosetcForm.entidad.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="!datos_ingresos.otrosetc.es_selector" class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':otrosetcForm.identificacion.$invalid,\'has-success has-feedback\':otrosetcForm.identificacion.$valid}"><label class="text-left full-width" for="identificacion">Identificaci\xF3n</label> <input class="form-control" placeholder="Identificaci\xF3n" name="identificacion" type="text" id="identificacion" ng-model="datos_ingresos.otrosetc.identificacion" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="otrosetcForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="otrosetcForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':otrosetcForm.valor.$invalid,\'has-success has-feedback\':otrosetcForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_ingresos.otrosetc.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="otrosetcForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="otrosetcForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="cambiarDatosCampo38();" ng-disabled="accionesForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-shuffle"></i></button> <button ng-click="agregarCampo38(otrosetcForm);" ng-disabled="otrosetcForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(otrosetcForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_ingresos.detalles_otrosetc.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo38(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/ingresos/otrosingresosnoconsti.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Otros ingresos no consitutivos de renta (44)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="otrosingresosnoconstiForm"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':otrosingresosnoconstiForm.concepto.$invalid,\'has-success has-feedback\':otrosingresosnoconstiForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_ingresos.otrosingresosnoconsti.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="otrosingresosnoconstiForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="otrosingresosnoconstiForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_ingresos.otrosingresosnoconsti.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':otrosingresosnoconstiForm.valor.$invalid,\'has-success has-feedback\':otrosingresosnoconstiForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_ingresos.otrosingresosnoconsti.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="otrosingresosnoconstiForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="otrosingresosnoconstiForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarCampo44(otrosingresosnoconstiForm);" ng-disabled="otrosingresosnoconstiForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(otrosingresosnoconstiForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_ingresos.detalles_otrosingresosnoconsti.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo44(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/ingresos/recibidos_empleados.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Recibidos como empleado (33)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="recibidosEmpleadosForm"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':recibidosEmpleadosForm.concepto.$invalid,\'has-success has-feedback\':recibidosEmpleadosForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_ingresos.recibidos_empleados.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="recibidosEmpleadosForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="recibidosEmpleadosForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_ingresos.recibidos_empleados.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':recibidosEmpleadosForm.valor.$invalid,\'has-success has-feedback\':recibidosEmpleadosForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_ingresos.recibidos_empleados.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="recibidosEmpleadosForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="recibidosEmpleadosForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarCampo33(recibidosEmpleadosForm);" ng-disabled="recibidosEmpleadosForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(recibidosEmpleadosForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_ingresos.detalles_recibidos_empleados_ingresos.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo33(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/ingresos/recibidos_pensiones.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Recibidos por pensiones jubilaci\xF3n, invalidez, vejez, de sobreviviente y riesgos laborales (34)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="recibidosPensionesForm"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':recibidosPensionesForm.concepto.$invalid,\'has-success has-feedback\':recibidosPensionesForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_ingresos.recibidos_pensiones.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="recibidosPensionesForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="recibidosPensionesForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_ingresos.recibidos_pensiones.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':recibidosPensionesForm.valor.$invalid,\'has-success has-feedback\':recibidosPensionesForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_ingresos.recibidos_pensiones.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="recibidosPensionesForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="recibidosPensionesForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarCampo34(recibidosPensionesForm);" ng-disabled="recibidosPensionesForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(recibidosPensionesForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_ingresos.detalles_recibidos_pensiones_ingresos.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo34(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/ingresos/tercerosali.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Pago a terceros por alimentacion (43)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="tercerosaliForm"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':tercerosaliForm.concepto.$invalid,\'has-success has-feedback\':tercerosaliForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_ingresos.tercerosali.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="tercerosaliForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="tercerosaliForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':tercerosaliForm.tercero.$invalid,\'has-success has-feedback\':tercerosaliForm.tercero.$valid}"><label class="text-left full-width" for="tercero">Tercero</label> <input class="form-control" placeholder="Tercero" name="tercero" type="text" id="tercero" ng-model="datos_ingresos.tercerosali.tercero" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="tercerosaliForm.tercero.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="tercerosaliForm.tercero.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':tercerosaliForm.identificacion.$invalid,\'has-success has-feedback\':tercerosaliForm.identificacion.$valid}"><label class="text-left full-width" for="identificacion">Identificaci\xF3n</label> <input class="form-control" placeholder="Identificaci\xF3n" name="identificacion" type="text" id="identificacion" ng-model="datos_ingresos.tercerosali.identificacion" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="tercerosaliForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="tercerosaliForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':tercerosaliForm.valor.$invalid,\'has-success has-feedback\':tercerosaliForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_ingresos.tercerosali.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="tercerosaliForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="tercerosaliForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarCampo43(tercerosaliForm);" ng-disabled="tercerosaliForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(tercerosaliForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_ingresos.detalles_tercerosali.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo43(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/liquidacion/impextocasional.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Descuento por impuestos pagados en el exterior por ganancias ocasionales (93)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="impextocasionalForm"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':impextocasionalForm.concepto.$invalid,\'has-success has-feedback\':impextocasionalForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_liquidacion.impextocasional.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="impextocasionalForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="impextocasionalForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_liquidacion.impextocasional.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':impextocasionalForm.valor.$invalid,\'has-success has-feedback\':impextocasionalForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_liquidacion.impextocasional.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="impextocasionalForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="impextocasionalForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarCampo93(impextocasionalForm);" ng-disabled="impextocasionalForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(impextocasionalForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_liquidacion.detalles_impextocasional.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo93(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/liquidacion/impuestoiman.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Impuesto M\xEDnimo Alternativo Nacional - IMAN, para empleados (85)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="impuestoimanForm"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':impuestoimanForm.concepto.$invalid,\'has-success has-feedback\':impuestoimanForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_liquidacion.impuestoiman.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="impuestoimanForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="impuestoimanForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':impuestoimanForm.valor.$invalid,\'has-success has-feedback\':impuestoimanForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_liquidacion.impuestoiman.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="impuestoimanForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="impuestoimanForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarCampo85(impuestoimanForm);" ng-disabled="impuestoimanForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(impuestoimanForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_liquidacion.detalles_impuestoiman.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo85(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/liquidacion/impuestorentaliquidagravable.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Impuesto sobre la renta l\xEDquida gravable (84)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="impuestorentaliquidagravableForm"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':impuestorentaliquidagravableForm.concepto.$invalid,\'has-success has-feedback\':impuestorentaliquidagravableForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_liquidacion.impuestorentaliquidagravable.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="impuestorentaliquidagravableForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="impuestorentaliquidagravableForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':impuestorentaliquidagravableForm.valor.$invalid,\'has-success has-feedback\':impuestorentaliquidagravableForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_liquidacion.impuestorentaliquidagravable.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="impuestorentaliquidagravableForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="impuestorentaliquidagravableForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarCampo84(impuestorentaliquidagravableForm);" ng-disabled="impuestorentaliquidagravableForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(impuestorentaliquidagravableForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_liquidacion.detalles_impuestorentaliquidagravable.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo84(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/liquidacion/impuexteriorabc.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Impuestos pagados en el exterior sobre dividendos y participaciones lit. a), b) y c) acr254 E.T. (86)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="impuexteriorabcForm"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':impuexteriorabcForm.concepto.$invalid,\'has-success has-feedback\':impuexteriorabcForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_liquidacion.impuexteriorabc.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="impuexteriorabcForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="impuexteriorabcForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_liquidacion.impuexteriorabc.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':impuexteriorabcForm.valor.$invalid,\'has-success has-feedback\':impuexteriorabcForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_liquidacion.impuexteriorabc.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="impuexteriorabcForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="impuexteriorabcForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarCampo86(impuexteriorabcForm);" ng-disabled="impuexteriorabcForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(impuexteriorabcForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_liquidacion.detalles_impuexteriorabc.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo86(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/liquidacion/impuexteriord.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Impuestos pagados en el exterior sobre dividendos y participaciones lit. d) acr254 E.T. (87)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="impuexteriordForm"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':impuexteriordForm.concepto.$invalid,\'has-success has-feedback\':impuexteriordForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_liquidacion.impuexteriord.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="impuexteriordForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="impuexteriordForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_liquidacion.impuexteriord.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':impuexteriordForm.valor.$invalid,\'has-success has-feedback\':impuexteriordForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_liquidacion.impuexteriord.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="impuexteriordForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="impuexteriordForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarCampo87(impuexteriordForm);" ng-disabled="impuexteriordForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(impuexteriordForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_liquidacion.detalles_impuexteriord.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo87(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/liquidacion/impuexteriordistinto.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Por impuestos pagados en el exterior, distintos a los registrados anteriormente (88)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="impuexteriordistintoForm"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':impuexteriordistintoForm.concepto.$invalid,\'has-success has-feedback\':impuexteriordistintoForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_liquidacion.impuexteriordistinto.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="impuexteriordistintoForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="impuexteriordistintoForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_liquidacion.impuexteriordistinto.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':impuexteriordistintoForm.valor.$invalid,\'has-success has-feedback\':impuexteriordistintoForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_liquidacion.impuexteriordistinto.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="impuexteriordistintoForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="impuexteriordistintoForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarCampo88(impuexteriordistintoForm);" ng-disabled="impuexteriordistintoForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(impuexteriordistintoForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_liquidacion.detalles_impuexteriordistinto.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo88(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/liquidacion/otrosdesc.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Otros (89)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="otrosdescForm"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':otrosdescForm.concepto.$invalid,\'has-success has-feedback\':otrosdescForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_liquidacion.otrosdesc.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="otrosdescForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="otrosdescForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_liquidacion.otrosdesc.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':otrosdescForm.valor.$invalid,\'has-success has-feedback\':otrosdescForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_liquidacion.otrosdesc.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="otrosdescForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="otrosdescForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarCampo89(otrosdescForm);" ng-disabled="otrosdescForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(otrosdescForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_liquidacion.detalles_otrosdesc.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo89(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/liquidacion/retencionesanoanterior.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Total retenciones a\xF1o gravable {{ano_anterior}} (97)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="retencionesanoanteriorForm"><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':retencionesanoanteriorForm.concepto.$invalid,\'has-success has-feedback\':retencionesanoanteriorForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_liquidacion.retencionesanoanterior.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="retencionesanoanteriorForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="retencionesanoanteriorForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="datos_liquidacion.retencionesanoanterior.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_liquidacion.retencionesanoanterior.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div ng-if="!datos_liquidacion.retencionesanoanterior.es_selector" class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':retencionesanoanteriorForm.entidad.$invalid,\'has-success has-feedback\':retencionesanoanteriorForm.entidad.$valid}"><label class="text-left full-width" for="entidad">Entidad</label> <input class="form-control" placeholder="Entidad" name="entidad" type="text" id="entidad" ng-model="datos_liquidacion.retencionesanoanterior.entidad" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="retencionesanoanteriorForm.entidad.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="retencionesanoanteriorForm.entidad.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div ng-if="!datos_liquidacion.retencionesanoanterior.es_selector" class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':retencionesanoanteriorForm.identificacion.$invalid,\'has-success has-feedback\':retencionesanoanteriorForm.identificacion.$valid}"><label class="text-left full-width" for="identificacion">Identificaci\xF3n</label> <input class="form-control" placeholder="Identificaci\xF3n" name="identificacion" type="text" id="identificacion" ng-model="datos_liquidacion.retencionesanoanterior.identificacion" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="retencionesanoanteriorForm.identificacion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="retencionesanoanteriorForm.identificacion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':retencionesanoanteriorForm.valor.$invalid,\'has-success has-feedback\':retencionesanoanteriorForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_liquidacion.retencionesanoanterior.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="retencionesanoanteriorForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="retencionesanoanteriorForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="cambiarDatosCampo97();" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-shuffle"></i></button> <button ng-click="agregarCampo97(retencionesanoanteriorForm);" ng-disabled="retencionesanoanteriorForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(retencionesanoanteriorForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_liquidacion.detalles_retencionesanoanterior.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo97(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/patrimonio/deudas.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Deudas</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><label class="text-left full-width label-titulo-seccion-modal label-titulo-seccion-modal-borde" for="concepto">Deudas</label></div><form name="deudasForm"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':deudasForm.concepto.$invalid,\'has-success has-feedback\':deudasForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_patrimonio.deudas.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="deudasForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="deudasForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_patrimonio.deudas.deuda" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':deudasForm.valor.$invalid,\'has-success has-feedback\':deudasForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_patrimonio.deudas.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="deudasForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="deudasForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarDeudaCampo31(deudasForm);" ng-disabled="deudasForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(deudasForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_patrimonio.detalles_deudas_patrimonio.deudas"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarDeudaCampo31(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/patrimonio/total_patrimonio_bruto.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Total patrimonio bruto</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><label class="text-left full-width label-titulo-seccion-modal" for="tipo_inversion">Caja</label></div><form name="cajaForm"><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':cajaForm.caja.$invalid,\'has-success has-feedback\':cajaForm.caja.$valid}"><input class="form-control" placeholder="Caja" name="caja" type="text" id="caja" ng-model="datos_patrimonio.detalles_total_patrimonio_bruto.caja" pattern="[() +-_0-9.,\\s]+"> <i ng-show="cajaForm.caja.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="cajaForm.caja.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div></form></div><div class="formulario_modales"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><label class="text-left full-width label-titulo-seccion-modal label-titulo-seccion-modal-borde" for="tipo_inversion">Bancos</label></div><form name="bancosForm"><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Banco</label><ui-select ng-model="datos_patrimonio.bancos.banco" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.bancos.listado | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Tipo de cuenta</label><ui-select ng-model="datos_patrimonio.bancos.tipo_cuenta" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.tipos_cuenta | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':bancosForm.numero_cuenta.$invalid,\'has-success has-feedback\':bancosForm.numero_cuenta.$valid}"><label class="text-left full-width" for="numero_cuenta"># de Cuenta</label> <input class="form-control" placeholder="# de Cuenta" name="numero_cuenta" type="text" id="numero_cuenta" ng-model="datos_patrimonio.bancos.numero_cuenta" required="" pattern="[()+-_ 0-9.,A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="bancosForm.numero_cuenta.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="bancosForm.numero_cuenta.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':bancosForm.valor.$invalid,\'has-success has-feedback\':bancosForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_patrimonio.bancos.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="bancosForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="bancosForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarBancoCampo30(bancosForm);" ng-disabled="bancosForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(bancosForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th>Banco</th><th class="align-right">Tipo de cuenta</th><th class="align-right"># de cuenta</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_patrimonio.detalles_total_patrimonio_bruto.bancos"><td ng-class="nowrap">{{item.banco}}</td><td class="align-right">{{item.tipo_cuenta}}</td><td class="align-right">{{item.numero_cuenta}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarBancoCampo30(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div><div class="formulario_modales"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><label class="text-left full-width label-titulo-seccion-modal label-titulo-seccion-modal-borde" for="tipo_inversion">Inversiones</label></div><form name="inversionesForm"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':inversionesForm.tipo_inversion.$invalid,\'has-success has-feedback\':inversionesForm.tipo_inversion.$valid}"><label class="text-left full-width" for="tipo_inversion">Tipo de inversi\xF3n</label> <input class="form-control" placeholder="Tipo de inversi\xF3n" name="tipo_inversion" type="text" id="tipo_inversion" ng-model="datos_patrimonio.inversiones.tipo_inversion" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="inversionesForm.tipo_inversion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="inversionesForm.tipo_inversion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_patrimonio.inversiones.inversion" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':inversionesForm.valor.$invalid,\'has-success has-feedback\':inversionesForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_patrimonio.inversiones.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="inversionesForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="inversionesForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarInversionCampo30(inversionesForm);" ng-disabled="inversionesForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(inversionesForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Tipo de inversi\xF3n</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_patrimonio.detalles_total_patrimonio_bruto.inversiones"><td ng-class="nowrap">{{item.tipo_inversion}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarInversionCampo30(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div><div class="formulario_modales"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><label class="text-left full-width label-titulo-seccion-modal label-titulo-seccion-modal-borde" for="tipo_inversion">Inversiones exterior</label></div><form name="inversionesExteriorForm"><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':inversionesExteriorForm.tipo_inversion.$invalid,\'has-success has-feedback\':inversionesExteriorForm.tipo_inversion.$valid}"><label class="text-left full-width" for="tipo_inversion">Tipo de inversi\xF3n</label> <input class="form-control" placeholder="Tipo de inversi\xF3n" name="tipo_inversion" type="text" id="tipo_inversion" ng-model="datos_patrimonio.inversiones_exterior.tipo_inversion" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="inversionesExteriorForm.tipo_inversion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="inversionesExteriorForm.tipo_inversion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_patrimonio.inversiones_exterior.inversion" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':inversionesExteriorForm.valor_usd.$invalid,\'has-success has-feedback\':inversionesExteriorForm.valor_usd.$valid}"><label class="text-left full-width" for="valor_usd">Valor TRM</label> <input class="form-control" placeholder="Valor TRM" name="valor_usd" type="text" id="valor_usd" ng-model="datos_patrimonio.inversiones_exterior.valor_usd" required="" pattern="[0-9.,\\s]+"> <i ng-show="inversionesExteriorForm.valor_usd.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="inversionesExteriorForm.valor_usd.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':inversionesExteriorForm.valor.$invalid,\'has-success has-feedback\':inversionesExteriorForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_patrimonio.inversiones_exterior.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="inversionesExteriorForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="inversionesExteriorForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarInversionExteriorCampo30(inversionesExteriorForm);" ng-disabled="inversionesExteriorForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(inversionesExteriorForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Tipo de inversi\xF3n</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor (USD)</th><th class="align-right">Valor (COP)</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_patrimonio.detalles_total_patrimonio_bruto.inversiones_exterior"><td ng-class="nowrap">{{item.tipo_inversion}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor_usd | currency:"$":2}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarInversionExteriorCampo30(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div><div class="formulario_modales"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><label class="text-left full-width label-titulo-seccion-modal label-titulo-seccion-modal-borde" for="tipo_inversion">Cuentas por cobrar</label></div><form name="cuentasCobrarForm"><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_patrimonio.cuentas_cobrar.cuenta_cobrar" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':cuentasCobrarForm.valor.$invalid,\'has-success has-feedback\':cuentasCobrarForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_patrimonio.cuentas_cobrar.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="cuentasCobrarForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="cuentasCobrarForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarCuentasPorCobrarCampo30(cuentasCobrarForm);" ng-disabled="cuentasCobrarForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(cuentasCobrarForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_patrimonio.detalles_total_patrimonio_bruto.cuentas_cobrar"><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCuentasPorCobrarCampo30(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div><div class="formulario_modales"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><label class="text-left full-width label-titulo-seccion-modal label-titulo-seccion-modal-borde" for="tipo_inversion">Veh\xEDculos</label></div><form name="vehiculosForm"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':vehiculosForm.descripcion.$invalid,\'has-success has-feedback\':vehiculosForm.descripcion.$valid}"><label class="text-left full-width" for="descripcion">Descripci\xF3n</label> <textarea placeholder="Descripci\xF3n" class="form-control" id="descripcion" name="descripcion" ng-model="datos_patrimonio.vehiculos.descripcion" required=""></textarea> <i ng-show="vehiculosForm.descripcion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="vehiculosForm.descripcion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':vehiculosForm.ano_adquisicion.$invalid,\'has-success has-feedback\':vehiculosForm.ano_adquisicion.$valid}"><label class="text-left full-width" for="ano_adquisicion">A\xF1o de adquisici\xF3n</label> <input class="form-control" placeholder="A\xF1o de adquisici\xF3n" name="ano_adquisicion" type="text" id="ano_adquisicion" ng-model="datos_patrimonio.vehiculos.ano_adquisicion" required="" pattern="[0-9.,\\s]+"> <i ng-show="vehiculosForm.ano_adquisicion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="vehiculosForm.ano_adquisicion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':vehiculosForm.valor.$invalid,\'has-success has-feedback\':vehiculosForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_patrimonio.vehiculos.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="vehiculosForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="vehiculosForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarVehiculosCampo30(vehiculosForm);" ng-disabled="vehiculosForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(vehiculosForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Descripci\xF3n</th><th class="align-right">A\xF1o de adquisici\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_patrimonio.detalles_total_patrimonio_bruto.vehiculos"><td class="align-right">{{item.descripcion}}</td><td class="align-right">{{item.ano_adquisicion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarVehiculosCampo30(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div><div class="formulario_modales"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><label class="text-left full-width label-titulo-seccion-modal label-titulo-seccion-modal-borde" for="tipo_inversion">Inmuebles</label></div><form name="inmueblesForm"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':inmueblesForm.descripcion.$invalid,\'has-success has-feedback\':inmueblesForm.descripcion.$valid}"><label class="text-left full-width" for="descripcion">Descripci\xF3n</label> <textarea placeholder="Descripci\xF3n" class="form-control" id="descripcion" name="descripcion" ng-model="datos_patrimonio.inmuebles.descripcion" required=""></textarea> <i ng-show="inmueblesForm.descripcion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="inmueblesForm.descripcion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':inmueblesForm.ano_adquisicion.$invalid,\'has-success has-feedback\':inmueblesForm.ano_adquisicion.$valid}"><label class="text-left full-width" for="ano_adquisicion">A\xF1o de adquisici\xF3n</label> <input class="form-control" placeholder="A\xF1o de adquisici\xF3n" name="ano_adquisicion" type="text" id="ano_adquisicion" ng-model="datos_patrimonio.inmuebles.ano_adquisicion" required="" pattern="[0-9.,\\s]+"> <i ng-show="inmueblesForm.ano_adquisicion.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="inmueblesForm.ano_adquisicion.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':inmueblesForm.valor.$invalid,\'has-success has-feedback\':inmueblesForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_patrimonio.inmuebles.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="inmueblesForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="inmueblesForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarInmueblesCampo30(inmueblesForm);" ng-disabled="inmueblesForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(inmueblesForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Descripci\xF3n</th><th class="align-right">A\xF1o de adquisici\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_patrimonio.detalles_total_patrimonio_bruto.inmuebles"><td class="align-right">{{item.descripcion}}</td><td class="align-right">{{item.ano_adquisicion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarInmueblesCampo30(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div><div class="formulario_modales"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><label class="text-left full-width label-titulo-seccion-modal label-titulo-seccion-modal-borde" for="tipo_inversion">Acciones</label></div><form name="accionesForm"><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':accionesForm.especie.$invalid,\'has-success has-feedback\':accionesForm.especie.$valid}"><label class="text-left full-width" for="especie">Especie</label> <input class="form-control" placeholder="Especie" name="especie" type="text" id="especie" ng-model="datos_patrimonio.acciones.especie" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="accionesForm.especie.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="accionesForm.especie.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':accionesForm.cantidad.$invalid,\'has-success has-feedback\':accionesForm.cantidad.$valid}"><label class="text-left full-width" for="cantidad">Cantidad</label> <input class="form-control" ng-blur="calcularTotalAcciones();" ng-keypress="calcularTotalAcciones();" placeholder="Cantidad" name="cantidad" type="text" id="cantidad" ng-model="datos_patrimonio.acciones.cantidad" pattern="[0-9.,\\s]+"> <i ng-show="accionesForm.cantidad.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="accionesForm.cantidad.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':accionesForm.valor.$invalid,\'has-success has-feedback\':accionesForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" ng-blur="calcularTotalAcciones();" ng-keypress="calcularTotalAcciones();" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_patrimonio.acciones.valor" pattern="[0-9.,\\s]+"> <i ng-show="accionesForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="accionesForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':accionesForm.total.$invalid,\'has-success has-feedback\':accionesForm.total.$valid}"><label class="text-left full-width" for="total">Total</label> <input class="form-control" placeholder="total" name="total" type="text" id="total" ng-model="datos_patrimonio.acciones.total" required="" pattern="[0-9.,\\s]+"> <i ng-show="accionesForm.total.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="accionesForm.total.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarAccionesCampo30(accionesForm);" ng-disabled="accionesForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(accionesForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Especie</th><th class="align-right">Cantidad</th><th class="align-right">Valor</th><th class="align-right">Total</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_patrimonio.detalles_total_patrimonio_bruto.acciones"><td class="align-right">{{item.especie}}</td><td class="align-right">{{item.cantidad}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right">{{item.total | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarAccionesCampo30(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/renta/aportesafc.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Aportes a cuentas AFC (61)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="cuentasafcForm"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':cuentasafcForm.concepto.$invalid,\'has-success has-feedback\':cuentasafcForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_rentas.cuentasafc.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="cuentasafcForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="cuentasafcForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_rentas.cuentasafc.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':cuentasafcForm.valor.$invalid,\'has-success has-feedback\':cuentasafcForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_rentas.cuentasafc.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="cuentasafcForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="cuentasafcForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarCampo61(cuentasafcForm);" ng-disabled="cuentasafcForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(cuentasafcForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_rentas.detalles_cuentasafc.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo61(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/renta/compensaciones.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Compensaciones (Por exceso de renta presuntiva) (55)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="text-center"></th><th class="text-center">{{renderizarAnoAnterior(0)}}</th><th class="text-center">{{renderizarAnoAnterior(1)}}</th><th class="text-center">{{renderizarAnoAnterior(2)}}</th><th class="text-center">{{renderizarAnoAnterior(3)}}</th><th class="text-center">{{renderizarAnoAnterior(4)}}</th></tr></thead><tbody><tr><td>Renta presuntiva</td><td ng-repeat="item in datos_rentas.certificadosAnosAnterioresArray">{{filtroMoneda(item.renta_presuntiva)}}</td></tr><tr><td>Renta l\xEDq. ord.</td><td ng-repeat="item in datos_rentas.certificadosAnosAnterioresArray">{{filtroMoneda(item.renta_liquida)}}</td></tr><tr><td>Deducci\xF3n</td><td ng-repeat="item in datos_rentas.certificadosAnosAnterioresArray">{{calculoDeduccion(item.renta_presuntiva,item.renta_liquida)}}</td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/renta/exentas.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Otras rentas exentas (62)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="rtexentasForm"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':rtexentasForm.concepto.$invalid,\'has-success has-feedback\':rtexentasForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_rentas.rtexentas.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="rtexentasForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="rtexentasForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_rentas.rtexentas.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':rtexentasForm.valor.$invalid,\'has-success has-feedback\':rtexentasForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_rentas.rtexentas.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="rtexentasForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="rtexentasForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarCampo62(rtexentasForm);" ng-disabled="rtexentasForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(rtexentasForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_rentas.detalles_rtexentas.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo62(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/renta/laboralesypensiones.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Por pagos laborales (25%) y pensiones (63)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="laborypensionForm"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':laborypensionForm.concepto.$invalid,\'has-success has-feedback\':laborypensionForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_rentas.laborypension.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="laborypensionForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="laborypensionForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_rentas.laborypension.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':laborypensionForm.valor.$invalid,\'has-success has-feedback\':laborypensionForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_rentas.laborypension.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="laborypensionForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="laborypensionForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarCampo63(laborypensionForm);" ng-disabled="laborypensionForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(laborypensionForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_rentas.detalles_laborypension.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo63(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/renta/obligatoriopension.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Aportes obligatorios al fondo de pensi\xF3n (59)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="pensionobliForm"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':pensionobliForm.concepto.$invalid,\'has-success has-feedback\':pensionobliForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_rentas.pensionobli.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="pensionobliForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="pensionobliForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_rentas.pensionobli.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':pensionobliForm.valor.$invalid,\'has-success has-feedback\':pensionobliForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_rentas.pensionobli.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="pensionobliForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="pensionobliForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarCampo59(pensionobliForm);" ng-disabled="pensionobliForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(pensionobliForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_rentas.detalles_pensionobli.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo59(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/renta/rentapresuntiva.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Renta presuntiva (57)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales" ng-if="certificadosInmediatamenteAnteriorValidador"><div class="row"><form name="renta_presuntivaForm"><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':renta_presuntivaForm.casa.$invalid,\'has-success has-feedback\':renta_presuntivaForm.casa.$valid}"><label class="text-left full-width" for="bienes_vinculados">Casa de habitaci\xF3n</label> <input class="form-control" placeholder="casa" name="casa" type="text" id="casa" ng-model="datos_rentas.detalles_rentapresuntiva.casa" pattern="[() +-_0-9.,\\s]+"> <i ng-show="renta_presuntivaForm.casa.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="renta_presuntivaForm.casa.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-center full-width" for="bienes_fuerzamayor">Patrimonio l\xEDqido a\xF1o anterior</label><br>{{certificadosInmediatamenteAnterior.total_patrimonio_liquido | currency:"$":2}}</div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-center full-width" for="bienes_fuerzamayor">Patrimonio bruto a\xF1o anterior</label><br>{{certificadosInmediatamenteAnterior.total_patrimonio_bruto | currency:"$":2}}</div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-center full-width" for="bienes_fuerzamayor">Valor patrimonial neto</label><br>{{datos_rentas.detalles_rentapresuntiva.valor_patrimonialneto}}</div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-center full-width" for="bienes_fuerzamayor">UVT a\xF1o {{datos_rentas.uvtanoanteriorano}}</label><br>{{datos_rentas.uvtanoanterior.valor | currency:"$":2}}</div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-center full-width">Aportes y Acciones Sociedades Nacionales</label><br>{{datos_rentas.detalles_rentapresuntiva.aportes_nacionales | currency:"$":2}}</div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':renta_presuntivaForm.bienes_fuerzamayor.$invalid,\'has-success has-feedback\':renta_presuntivaForm.bienes_fuerzamayor.$valid}"><label class="text-left full-width" for="bienes_fuerzamayor">Bienes afectados por fuerza mayor o caso fortuito ({{datos_rentas.detalles_rentapresuntiva.bienes_fuerzamayor | currency:"$":2}})</label> <input ng-blur="caluculosSubtotalesRentaPresuntiva()" ng-keyup="caluculosSubtotalesRentaPresuntiva()" class="form-control" placeholder="Valor" name="bienes_fuerzamayor" type="text" id="bienes_fuerzamayor" ng-model="datos_rentas.detalles_rentapresuntiva.bienes_fuerzamayor_tmp" required="" pattern="[0-9.,\\s]+"> <i ng-show="renta_presuntivaForm.bienes_fuerzamayor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="renta_presuntivaForm.bienes_fuerzamayor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':renta_presuntivaForm.valor_patrimonialneto_bienes.$invalid,\'has-success has-feedback\':renta_presuntivaForm.valor_patrimonialneto_bienes.$valid}"><label class="text-left full-width" for="valor_patrimonialneto_bienes">Valor patrimonial neto de bienes vinculados a empresas en periodo improductivo ({{datos_rentas.detalles_rentapresuntiva.valor_patrimonialneto_bienes | currency:"$":2}})</label> <input ng-blur="caluculosSubtotalesRentaPresuntiva()" ng-keyup="caluculosSubtotalesRentaPresuntiva()" class="form-control" placeholder="Valor" name="valor_patrimonialneto_bienes" type="text" id="valor_patrimonialneto_bienes" ng-model="datos_rentas.detalles_rentapresuntiva.valor_patrimonialneto_bienes_tmp" required="" pattern="[0-9.,\\s]+"> <i ng-show="renta_presuntivaForm.valor_patrimonialneto_bienes.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="renta_presuntivaForm.valor_patrimonialneto_bienes.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':renta_presuntivaForm.bienes_vinculados.$invalid,\'has-success has-feedback\':renta_presuntivaForm.bienes_vinculados.$valid}"><label class="text-left full-width" for="bienes_vinculados">Bienes vinculados a empresas con objeto social exclusivo mineria (menos hidrocarburos l\xEDquidos o gaseosos) ({{datos_rentas.detalles_rentapresuntiva.bienes_vinculados | currency:"$":2}})</label> <input ng-blur="caluculosSubtotalesRentaPresuntiva()" ng-keyup="caluculosSubtotalesRentaPresuntiva()" class="form-control" placeholder="Valor" name="bienes_vinculados" type="text" id="bienes_vinculados" ng-model="datos_rentas.detalles_rentapresuntiva.bienes_vinculados_tmp" required="" pattern="[0-9.,\\s]+"> <i ng-show="renta_presuntivaForm.bienes_vinculados.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="renta_presuntivaForm.bienes_vinculados.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-center full-width" for="primeras_8000uvt">Primeras 8000 UVT vivienda</label><br>{{datos_rentas.detalles_rentapresuntiva.primeras_8000uvt_calculada | currency:"$":2}}</div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':renta_presuntivaForm.primeras_19000uvt_calculada_tmp.$invalid,\'has-success has-feedback\':renta_presuntivaForm.primeras_19000uvt_calculada_tmp.$valid}"><label class="text-left full-width" for="primeras_19000uvt_calculada_tmp">Primeras 19000 UVT (sector agropecuario) ({{datos_rentas.detalles_rentapresuntiva.primeras_19000uvt_calculada | currency:"$":2 }})</label> <input ng-blur="calcular19000UVT()" ng-keyup="calcular19000UVT()" class="form-control" placeholder="Valor" name="primeras_19000uvt_calculada_tmp" type="text" id="primeras_19000uvt_calculada_tmp" ng-model="datos_rentas.detalles_rentapresuntiva.primeras_19000uvt_calculada_tmp" required="" pattern="[0-9.,\\s]+"> <i ng-show="renta_presuntivaForm.primeras_19000uvt_calculada_tmp.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="renta_presuntivaForm.primeras_19000uvt_calculada_tmp.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-center full-width">Patrimonio base</label><br>{{datos_rentas.detalles_rentapresuntiva.patrimonio_base | currency:"$":2}}</div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-center full-width">Subtotal renta presuntiva</label><br>{{datos_rentas.detalles_rentapresuntiva.subtotal_renta_presuntiva | currency:"$":2}}</div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':renta_presuntivaForm.mas_renta_producida_bienes_excluidos.$invalid,\'has-success has-feedback\':renta_presuntivaForm.mas_renta_producida_bienes_excluidos.$valid}"><label class="text-left full-width" for="mas_renta_producida_bienes_excluidos">M\xE1s renta producida, bienes producidos</label> <input ng-blur="caluculosSubtotalesRentaPresuntiva()" ng-keyup="caluculosSubtotalesRentaPresuntiva()" class="form-control" placeholder="Valor" name="mas_renta_producia_bienes_excluidos" type="text" id="mas_renta_producida_bienes_excluidos" ng-model="datos_rentas.detalles_rentapresuntiva.mas_renta_producida_bienes_excluidos" required="" pattern="[0-9.,\\s]+"> <i ng-show="renta_presuntivaForm.mas_renta_producida_bienes_excluidos.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="renta_presuntivaForm.mas_renta_producida_bienes_excluidos.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><p>--------------------////------------</p><div class="form-group"><label class="text-center full-width">Total renta presuntiva</label><br>{{datos_rentas.total_rentapresuntiva | currency:"$":2}}</div></div></form></div></div><div class="formulario_modales" ng-if="!certificadosInmediatamenteAnteriorValidador"><div class="row"><h3>No hay datos de a\xF1o anterior</h3></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/renta/rentasgravables.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Rentas gravables (65)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="rentasgravablesForm"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':rentasgravablesForm.concepto.$invalid,\'has-success has-feedback\':rentasgravablesForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_rentas.rentasgravables.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="rentasgravablesForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="rentasgravablesForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_rentas.rentasgravables.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':rentasgravablesForm.valor.$invalid,\'has-success has-feedback\':rentasgravablesForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_rentas.rentasgravables.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="rentasgravablesForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="rentasgravablesForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarCampo65(rentasgravablesForm);" ng-disabled="rentasgravablesForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(rentasgravablesForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_rentas.detalles_rentasgravables.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo65(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/renta/representacionyotrasrentas.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Gastos de representacion y otras rentas de trabajo (58)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="rentastrabajoForm"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':rentastrabajoForm.concepto.$invalid,\'has-success has-feedback\':rentastrabajoForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_rentas.rentastrabajo.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="rentastrabajoForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="rentastrabajoForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_rentas.rentastrabajo.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':rentastrabajoForm.valor.$invalid,\'has-success has-feedback\':rentastrabajoForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_rentas.rentastrabajo.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="rentastrabajoForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="rentastrabajoForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarCampo58(rentastrabajoForm);" ng-disabled="rentastrabajoForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(rentastrabajoForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_rentas.detalles_rentastrabajo.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo58(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/certificados/edicion/modales/renta/voluntariopension.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-edit modal-icon"></i><span>Aportes a fondos de pensiones voluntarios (60)</span></div><div class="modal-body text-center"><div class="col-lg-12"><div class="formulario_modales"><div class="row"><form name="pensionvolForm"><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':pensionvolForm.concepto.$invalid,\'has-success has-feedback\':pensionvolForm.concepto.$valid}"><label class="text-left full-width" for="concepto">Concepto</label> <input class="form-control" placeholder="Concepto" name="concepto" type="text" id="concepto" ng-model="datos_rentas.pensionvol.concepto" required="" pattern="[()+-_0-9., A-Za-z\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\\s]+"> <i ng-show="pensionvolForm.concepto.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="pensionvolForm.concepto.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="form-group"><label class="text-left full-width">Entidades</label><ui-select ng-model="datos_rentas.pensionvol.item" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="true"><ui-select-match placeholder="Seleccione...">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat="item in datos_patrimonio.entidades | filter: {nombre:$select.search}"><span ng-bind-html="item.nombre"></span></ui-select-choices></ui-select></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><div class="form-group" ng-class="{\'has-error has-feedback\':pensionvolForm.valor.$invalid,\'has-success has-feedback\':pensionvolForm.valor.$valid}"><label class="text-left full-width" for="valor">Valor</label> <input class="form-control" placeholder="Valor" name="valor" type="text" id="valor" ng-model="datos_rentas.pensionvol.valor" required="" pattern="[0-9.,\\s]+"> <i ng-show="pensionvolForm.valor.$invalid" class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <i ng-show="pensionvolForm.valor.$valid" class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i></div></div><div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"><button ng-click="agregarCampo60(pensionvolForm);" ng-disabled="pensionvolForm.$invalid" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-plus"></i></button> <button ng-click="limiarFormulario(pensionvolForm);" type="button" class="boton-especial-modales btn btn-success btn-icon"><i class="ion-loop"></i></button></div></form></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="align-right">Concepto</th><th class="align-right">Entidad</th><th class="align-right">Identificaci\xF3n</th><th class="align-right">Valor</th><th class="align-right"></th></tr></thead><tbody><tr ng-repeat="item in datos_rentas.detalles_pensionvol.listado"><td ng-class="nowrap">{{item.concepto}}</td><td class="align-right">{{item.entidad}}</td><td class="align-right">{{item.identificacion}}</td><td class="align-right">{{item.valor | currency:"$":2}}</td><td class="align-right"><button ng-click="eliminarCampo60(item);" type="button" class="bonton-especial-lista-modales btn btn-danger btn-icon"><i class="ion-android-delete"></i></button></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" ng-click="$dismiss()" class="float-left btn btn-danger">Cerrar</button></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/datePickers/datePickers.html','<div class="datepicker row"><div class="col-xlg-6 col-md-12 col-sm-6" ng-controller="datepickerCtrl"><h4>Inline</h4><label>Selected date is: <em>{{dt | date:\'fullDate\' }}</em></label><div class="uib-datepicker-wrap"><uib-datepicker ng-model="dt" datepicker-options="options"></uib-datepicker></div></div><div class="col-xlg-6 col-md-12 col-sm-6" ng-controller="datepickerpopupCtrl"><h4>Popup</h4><label>Selected date is: <em>{{dt | date:\'fullDate\' }}</em></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label>Format: <span class="muted-text">(manual alternate <em>{{altInputFormats[0]}}</em>)</span></label><select class="form-control" ng-model="format" ng-options="f for f in formats"><option></option></select></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/oldSelect/select.html','<div ng-controller="OldSelectpickerPanelCtrl as selectpickerVm"><div class="form-group"><select class="form-control selectpicker" selectpicker="" title="Standard Select" ng-model="selectpickerVm.standardSelected" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"></select></div><div class="form-group"><select class="form-control selectpicker with-search" data-live-search="true" title="Select With Search" selectpicker="" ng-model="selectpickerVm.searchSelectedItem" ng-options="item as item.label for item in selectpickerVm.selectWithSearchItems"></select></div><div class="form-group"><select class="form-control selectpicker" title="Option Types" selectpicker=""><option>Standard option</option><option data-subtext="option subtext">Option with subtext</option><option disabled="">Disabled Option</option><option data-icon="glyphicon-heart">Option with cion</option></select></div><div class="form-group"><select class="form-control selectpicker" disabled="" title="Disabled Select" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="row"><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Select with Option Groups" selectpicker="" ng-model="selectpickerVm.groupedSelectedItem" ng-options="item as item.label group by item.group for item in selectpickerVm.groupedSelectItems"></select></div></div><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Select with Divider" selectpicker=""><option>Group 1 - Option 1</option><option>Group 1 - Option 2</option><option data-divider="true"></option><option>Group 2 - Option 1</option><option>Group 2 - Option 2</option></select></div></div></div><div class="form-group"><select class="form-control" title="Multiple Select" multiple="" selectpicker="" ng-model="selectpickerVm.multipleSelectedItems" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="form-group"><select class="form-control" title="Multiple Select with Limit" multiple="" data-max-options="2" selectpicker="" ng-model="selectpickerVm.multipleSelectedItems2" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="row"><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Primary Select" data-style="btn-success" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Success Select" data-style="btn-success" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Warning Select" data-style="btn-warning" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Info Select" data-style="btn-info" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Danger Select" data-style="btn-danger" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Inverse Select" data-style="btn-inverse" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/oldSwitches/switch.html','<div ng-controller="OldSwitchPanelCtrl as switchPanelVm" class="switches clearfix"><switch color="primary" ng-model="switchPanelVm.switcherValues.primary"></switch><switch color="warning" ng-model="switchPanelVm.switcherValues.warning"></switch><switch color="danger" ng-model="switchPanelVm.switcherValues.danger"></switch><switch color="info" ng-model="switchPanelVm.switcherValues.info"></switch><switch color="success" ng-model="switchPanelVm.switcherValues.success"></switch></div>');
$templateCache.put('app/pages/form/inputs/widgets/select/select.html','<div class="ng-cloak" ng-controller="SelectpickerPanelCtrl as selectpickerVm"><div class="form-group"><ui-select ng-model="selectpickerVm.selectedItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Standard Select"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="standardItem in selectpickerVm.standardSelectItems | filter: $select.search"><span ng-bind-html="standardItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.withSearchItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Search">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="withSearchItem in selectpickerVm.selectWithSearchItems | filter: $select.search"><span ng-bind-html="withSearchItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.disableItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="true" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Disabled Selection"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="disableItem in selectpickerVm.disableItems | filter: $select.search"><span ng-bind-html="disableItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.groupedItems.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Option Groups">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="groupedItems in selectpickerVm.groupedSelectItems | groupSelectpickerOptions: {label: $select.search}" group-by="\'group\'"><span ng-bind-html="groupedItems.label | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.groupedByItems.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Option Groups Function">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="groupedByItems in selectpickerVm.groupedBySelectItems | filter: $select.search" group-by="selectpickerVm.someGroupFn"><span ng-bind-html="groupedByItems.name | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select multiple="" ng-model="selectpickerVm.multipleItem.selected" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control"><ui-select-match placeholder="Multiple Select">{{$item.label}}</ui-select-match><ui-select-choices repeat="multipleItem in selectpickerVm.multipleSelectItems | filter: $select.search">{{multipleItem.label}}</ui-select-choices></ui-select></div><div class="form-group"><div class="input-group"><ui-select multiple="" ng-model="selectpickerVm.withDeleteItem.selected" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control form-control"><ui-select-match placeholder="Select With Clear Button">{{$item.label}}</ui-select-match><ui-select-choices repeat="withDeleteItem in selectpickerVm.withDeleteSelectItems | filter: $select.search">{{withDeleteItem.label}}</ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="selectpickerVm.withDeleteItem.selected = undefined" class="btn btn-danger"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/switches/switch.html','<div ng-controller="SwitchDemoPanelCtrl as vm"><ba-switcher switcher-style="primary" switcher-value="vm.switches.s1"></ba-switcher><ba-switcher switcher-style="success" switcher-value="vm.switches.s2"></ba-switcher><ba-switcher switcher-style="warning" switcher-value="vm.switches.s3"></ba-switcher><ba-switcher switcher-style="danger" switcher-value="vm.switches.s4"></ba-switcher><ba-switcher switcher-style="info" switcher-value="vm.switches.s5"></ba-switcher></div>');
$templateCache.put('app/pages/form/inputs/widgets/tagsInput/tagsInput.html','<div class="form-group"><div class="form-group"><input type="text" tag-input="primary" value="Amsterdam,Washington,Sydney,Beijing,Cairo" data-role="tagsinput" placeholder="Add Tag"></div><div class="form-group"><input type="text" tag-input="warning" value="Minsk,Prague,Vilnius,Warsaw" data-role="tagsinput" placeholder="Add Tag"></div><div class="form-group"><input type="text" tag-input="danger" value="London,Berlin,Paris,Rome,Munich" data-role="tagsinput" placeholder="Add Tag"></div></div>');}]);